// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../img/icons/right-arrow.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../img/banner/banner_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../img/banner/banner_bg02.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../img/banner/h2_banner_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../img/banner/h4_banner_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../img/bg/about_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../img/images/mask_img.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../img/images/overview_shape.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../img/images/mask_img02.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../img/bg/features_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../img/bg/choose_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../img/bg/services_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../img/bg/services_bg02.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../img/bg/inner_services_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../img/bg/cta_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../img/bg/cta_bg02.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../img/bg/cta_bg03.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../img/bg/counter_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../img/bg/project_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../img/bg/project_bg02.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../img/images/faq_shape01.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../img/bg/request_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../img/bg/team_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../img/bg/testimonial_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../img/bg/h2_testimonial_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../img/bg/h3_testimonial_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../img/bg/h4_testimonial_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../img/bg/contact_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../img/bg/blog_bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../img/bg/h2_blog_bg.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
  Theme Name: Hospitality Leadership Network
  Description: Premium Hospitality Owners & Industry Leadership Platform
  Version: 2.0
*/

/* CSS Index
============================
01. Variable CSS
02. Header
03. Mobile Menu
04. Search
05. OffCanvas
06. Slider
07. Banner
08. Breadcrumb
09. About
10. Overview
11. Features
12. Choose
13. Services
14. Cta
15. Counter
16. Estimate
17. Project
18. Faq
19. Request
20. Team
21. Testimonial
22. Pricing
23. Contact
24. Blog
25. Brand
26. Error
27. Footer
28. Preloader
============================
*/

/*=============================
	1. Google Fonts
===============================*/

/*=============================
	01. Variable CSS
===============================*/
:root {
  --tg-body-font-family: "Inter", sans-serif;
  --tg-heading-font-family: "Cormorant Garamond", serif;
  --tg-primary-color: #0A1628;
  --tg-secondary-color: #1C2A3A;
  --tg-body-font-color: #4A5568;
  --tg-heading-font-color: #0A1628;
  --tg-paragraph-color: #4A5568;
  --tg-section-background: #FFFFFF;
  --tg-body-font-size: 16px;
  --tg-body-font-weight: 400;
  --tg-heading-font-weight: 600;
  --tg-body-line-height: 1.7;
  --tg-heading-line-height: 1.15;
  --tg-text-transform: none;
  --tg-accent-color: #C6A962;
  --tg-accent-light: #E8D5A3;
  --tg-accent-dark: #A68B3E;
  --tg-blue: #1A365D;
  --tg-metallic-blue: #2D4A6F;
  --tg-cornflower-blue: #7BA0CC;
  --tg-steel-blue: #8DA4BE;
  --tg-lavender: #EDE8E0;
  --tg-indigo: #3C366B;
  --tg-purple: #553C9A;
  --tg-pink: #B83280;
  --tg-red: #C53030;
  --tg-orange: #C05621;
  --tg-yellow: #C6A962;
  --tg-green: #276749;
  --tg-teal: #285E61;
  --tg-cyan: #2B6CB0;
  --tg-white: #FFFFFF;
  --tg-black: #0A1628;
  --tg-gray: #FFFFFF;
  --tg-gray-two: #EDE8E0;
  --tg-gray-three: #8B8178;
  --tg-gray-four: #6B6058;
  --tg-border-color: #E2DDD5;
  --facebook: #3b5998;
  --twitter: #1DA1F2;
  --linkedin: #0A66C2;
  --pinterest: #E60023;
  --youtube: #FF0000;
  --skype: #00AFF0;
}
body {
  font-family: var(--tg-body-font-family);
  font-weight: var(--tg-body-font-weight);
  font-size: var(--tg-body-font-size);
  line-height: var(--tg-body-line-height);
  color: var(--tg-body-font-color);
  font-style: normal;
  background: #FFFFFF;
}
img,
.img {
  max-width: 100%;
  transition: all 0.3s ease-out 0s;
}
.f-left {
  float: left;
}
.f-right {
  float: right;
}
.fix {
  overflow: hidden;
}
a,
button {
  transition: all 0.3s ease-out 0s;
  text-decoration: none;
}
a:focus,
.btn:focus,
button:focus {
  text-decoration: none;
  outline: none;
  box-shadow: none;
}

a:hover,
.portfolio-cat a:hover,
.footer -menu li a:hover {
  color: var(--tg-primary-color);
  text-decoration: none;
}
a,
button {
  color: var(--tg-primary-color);
  outline: medium none;
  text-decoration: none;
}
.btn:focus,
button:focus,
input:focus,
input:focus,
textarea,
textarea:focus {
  outline: 0;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: var(--tg-heading-font-family);
  color: var(--tg-heading-font-color);
  margin-top: 0px;
  margin-bottom: 0.7rem;
  font-style: normal;
  line-height: var(--tg-heading-line-height);
  font-weight: var(--tg-heading-font-weight);
}
h1 a,
h2 a,
h3 a,
h4 a,
h5 a,
h6 a {
  color: inherit;
}
h1 {
  font-size: 2.5rem;
}
h2 {
  font-size: 2rem;
}
h3 {
  font-size: 1.75rem;
}
h4 {
  font-size: 1.5rem;
}
h5 {
  font-size: 1.25rem;
}
h6 {
  font-size: 1rem;
}
.list-wrap {
  margin: 0px;
  padding: 0px;
}
.list-wrap li {
  list-style: none;
}
p {
  font-size: var(--tg-body-font-size);
  font-weight: var(--tg-body-font-weight);
  line-height: var(--tg-body-line-height);
  color: var(--tg-paragraph-color);
  text-transform: var(--tg-text-transform);
  margin-bottom: 15px;
}
hr {
  border-bottom: 1px solid var(--tg-primary-color);
  border-top: 0 none;
  margin: 30px 0;
  padding: 0;
}
label {
  color: var(--tg-body-font-color);
  cursor: pointer;
  font-size: 16px;
  font-weight: 400;
}
::selection {
  background: var(--tg-primary-color);
  color: var(--tg-white);
  text-shadow: none;
}
*::placeholder {
  color: var(--tg-body-font-color);
  font-size: var(--tg-body-font-size);
  opacity: 1;
}
.theme-overlay {
  position: relative;
}
.theme-overlay::before {
  background: var(--tg-primary-color) none repeat scroll 0 0;
  content: "";
  height: 100%;
  left: 0;
  opacity: 0.6;
  position: absolute;
  top: 0;
  width: 100%;
}
.separator {
  border-top: 1px solid var(--tg-primary-color);
}

/* Bootstrap 5 */
.container {
  padding-left: 15px;
  padding-right: 15px;
}
.row {
  --bs-gutter-x: 30px;
}
.row.g-0 {
  --bs-gutter-x: 0;
}
.gutter-y-30 {
  --bs-gutter-y: 30px;
}

/*=============================
	1. Button style
===============================*/
.btn {
  -webkit-user-select: none;
          user-select: none;
  -moz-user-select: none;
  background: var(--tg-accent-color) none repeat scroll 0 0;
  border: medium none;
  border-radius: 0;
  color: var(--tg-primary-color);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1.5px;
  line-height: 1;
  margin-bottom: 0;
  padding: 16px 32px;
  text-align: center;
  text-transform: uppercase;
  touch-action: manipulation;
  transition: all 0.4s ease 0s;
  vertical-align: middle;
  white-space: nowrap;
  border: 2px solid var(--tg-accent-color);
  position: relative;
  z-index: 1;
  font-family: var(--tg-body-font-family);
}
.btn::after {
  content: "";
  display: none;
}
.btn::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 100%;
  background: var(--tg-primary-color);
  z-index: -1;
  transition: all 0.4s ease 0s;
}
.btn:hover::before {
  width: 100%;
}
.btn:hover {
  color: var(--tg-white);
  border-color: var(--tg-primary-color);
}
.btn.btn-two {
  background: var(--tg-primary-color);
  color: var(--tg-white);
  border-color: var(--tg-primary-color);
}
.btn.btn-two::after {
  display: none;
}
.btn.btn-two:hover {
  background: var(--tg-accent-color);
  color: var(--tg-primary-color);
  border-color: var(--tg-accent-color);
}
.transparent-btn {
  border: 2px solid var(--tg-accent-color);
  background: transparent;
  color: var(--tg-accent-color);
  border-radius: 0;
}
.btn-three {
  padding: 19px 30px;
}
.transparent-btn-two::before,
.btn-three::before {
  display: none;
}
.transparent-btn-two::after,
.btn-three::after {
  content: "";
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  filter: brightness(0) invert(1);
  width: 18px;
  height: 12px;
  margin-left: 12px;
}
.btn-three:hover {
  background: var(--tg-secondary-color);
}
.transparent-btn-two {
  border: 2px solid var(--tg-primary-color);
  color: var(--tg-primary-color);
  background: transparent;
  padding: 17px 30px;
}
.transparent-btn-two::after {
  filter: none;
  transition: all 0.3s ease 0s;
}
.transparent-btn-two:hover {
  background: var(--tg-primary-color);
}
.transparent-btn-two:hover::after {
  filter: brightness(0) invert(1);
}
.breadcrumb > .active {
  color: var(--tg-primary-color);
}

/* scrollUp */
.scroll-top {
  width: 35px;
  height: 35px;
  line-height: 35px;
  position: fixed;
  bottom: -10%;
  right: 30px;
  font-size: var(--tg-body-font-size);
  border-radius: 6px;
  z-index: 99;
  color: var(--tg-white);
  text-align: center;
  cursor: pointer;
  background: var(--tg-primary-color);
  transition: 1s ease;
  border: none;
}
.scroll-top.open {
  bottom: 30px;
}
.scroll-top::after {
  position: absolute;
  z-index: -1;
  content: "";
  top: 100%;
  left: 5%;
  height: 10px;
  width: 90%;
  opacity: 1;
  background: radial-gradient(
    ellipse at center,
    rgba(0, 0, 0, 0.25) 0%,
    rgba(0, 0, 0, 0) 80%
  );
}
.scroll-top:hover {
  background: var(--tg-secondary-color);
}

/*=============================
	02. Header
===============================*/
.custom-container {
  max-width: 1310px;
}
.custom-container-two {
  max-width: 1360px;
}
.custom-container-three {
  max-width: 1800px;
}
/* ── Base header (shared) ── */
.transparent-header {
  left: 0;
  top: 0;
  width: 100%;
  height: auto;
}

/* ── Static header (all pages except home) ── */
.transparent-header.header-static {
  position: fixed;
  z-index: 99;
  background: var(--tg-white);
  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);
}
.header-spacer {
  height: 100px;
}
/* Static: dark nav links on white bg */
.header-static .menu-area:not(.sticky-menu) .navbar-wrap > ul > li > a {
  color: var(--tg-secondary-color);
}
.header-static .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.active > a,
.header-static .menu-area:not(.sticky-menu) .navbar-wrap > ul > li:hover > a {
  color: #C6A962;
}
.header-static .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.menu-item-has-children > a::after {
  color: var(--tg-paragraph-color);
}
.header-static .menu-area:not(.sticky-menu) .header-search a,
.header-static .menu-area:not(.sticky-menu) .mobile-nav-toggler {
  color: var(--tg-secondary-color);
}
.header-static .menu-area:not(.sticky-menu) .header-action .transparent-btn {
  border-color: var(--tg-accent-color);
  color: var(--tg-accent-color);
}
.header-static .menu-area:not(.sticky-menu) .header-action .transparent-btn:hover {
  border-color: var(--tg-primary-color);
  color: var(--tg-primary-color);
}
/* Static: always dark logo */
.header-static .logo .logo-dark {
  display: none !important;
}
.header-static .logo .logo-light {
  display: inline-block !important;
}

/* ── Overlay header (home page only) — sits over dark hero ── */
.transparent-header.header-overlay {
  position: absolute;
  z-index: 9;
  background: transparent;
  box-shadow: none;
}
.header-overlay .heder-top-wrap {
  background: transparent !important;
  border-bottom: 1px solid rgba(255,255,255,0.1);
}
.header-static .heder-top-wrap {
  background: var(--tg-secondary-color);
}
/* Overlay: white nav links over dark hero */
.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li > a {
  color: #FFFFFF;
}
.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.active > a,
.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li:hover > a {
  color: #C6A962;
}
.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.menu-item-has-children > a::after {
  color: #FFFFFF;
}
.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.menu-item-has-children:hover > a::after,
.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.menu-item-has-children.active > a::after {
  color: #C6A962;
}
.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap ul li .sub-menu li a {
  color: var(--tg-secondary-color);
}
.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap ul li .sub-menu li a:hover,
.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap ul li .sub-menu > li.active > a {
  color: var(--tg-primary-color);
}
.header-overlay .menu-area:not(.sticky-menu) .header-search a,
.header-overlay .menu-area:not(.sticky-menu) .mobile-nav-toggler {
  color: #FFFFFF;
}
.header-overlay .menu-area:not(.sticky-menu) .header-action .transparent-btn {
  border-color: rgba(255,255,255,0.4);
  color: #FFFFFF;
}
.header-overlay .menu-area:not(.sticky-menu) .header-action .transparent-btn:hover {
  border-color: #C6A962;
  color: #C6A962;
}
.header-overlay .menu-area:not(.sticky-menu) .header-action .btn:not(.transparent-btn):hover {
  background: #FFFFFF;
  color: #0A1628;
  border-color: #FFFFFF;
}
.header-overlay .menu-area:not(.sticky-menu) .header-action .btn:not(.transparent-btn):hover::before {
  background: #FFFFFF;
}
/* Overlay: profile name, logout, signin text white on dark hero */
.header-profile-name {
  /* Was \`fontSize: 13px\`, which is JS spelling and so was dropped outright. */
  font-size: 13px;
  font-weight: 600;
  /* A long name is elided rather than allowed to push Logout off the row. */
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.header-overlay .menu-area:not(.sticky-menu) .header-profile-name {
  color: #FFFFFF;
}
.header-static .menu-area:not(.sticky-menu) .header-profile-name,
.sticky-menu .header-profile-name {
  color: var(--tg-secondary-color);
}
.header-overlay .menu-area:not(.sticky-menu) .header-logout-btn {
  border: 1px solid rgba(255,255,255,0.4) !important;
  color: #FFFFFF !important;
}
.header-overlay .menu-area:not(.sticky-menu) .header-logout-btn:hover {
  border-color: #C6A962 !important;
  color: #C6A962 !important;
}
.header-static .menu-area:not(.sticky-menu) .header-logout-btn {
  border: 1px solid var(--tg-border-color) !important;
  color: var(--tg-body-font-color) !important;
}
.sticky-menu .header-logout-btn {
  border: 1px solid var(--tg-border-color) !important;
  color: var(--tg-body-font-color) !important;
}
.header-overlay .menu-area:not(.sticky-menu) .header-signin-btn {
  border-color: rgba(255,255,255,0.4) !important;
  color: #FFFFFF !important;
}
.header-overlay .menu-area:not(.sticky-menu) .header-signin-btn:hover {
  border-color: #C6A962 !important;
  color: #C6A962 !important;
}

/* Overlay: light logo (for dark bg) initially, swap on sticky */
.header-overlay .menu-area:not(.sticky-menu) .logo .logo-dark {
  display: inline-block !important;
}
.header-overlay .menu-area:not(.sticky-menu) .logo .logo-light {
  display: none !important;
}
/* Join Network button visible hover */
.header-join-btn {
  transition: all 0.3s ease !important;
}
.header-static .header-join-btn:hover {
  background: var(--tg-primary-color) !important;
  color: #FFFFFF !important;
  border-color: var(--tg-primary-color) !important;
  box-shadow: 0 8px 25px rgba(198,169,98,0.3);
  transform: translateY(-2px);
}
.header-static .header-join-btn:hover::before {
  background: var(--tg-primary-color) !important;
}
.header-overlay .menu-area:not(.sticky-menu) .header-join-btn:hover {
  background: #FFFFFF !important;
  color: #0A1628 !important;
  border-color: #FFFFFF !important;
  box-shadow: 0 8px 25px rgba(198,169,98,0.3);
  transform: translateY(-2px);
}
.header-overlay .menu-area:not(.sticky-menu) .header-join-btn:hover::before {
  background: #FFFFFF !important;
}
.header-signin-btn:hover {
  color: #C6A962 !important;
  border-color: #C6A962 !important;
}
#header-fixed-height.active-height {
  display: block;
  height: 96px;
}
.heder-top-wrap {
  background: var(--tg-secondary-color);
  overflow: hidden;
  padding: 9px 0;
}
.header-top-left .list-wrap {
  display: flex;
  align-items: center;
  gap: 10px 35px;
}
.header-top-left .list-wrap li {
  font-size: 14px;
  color: var(--tg-lavender);
  display: flex;
  align-items: center;
  line-height: 1.28;
  position: relative;
}
.header-top-left .list-wrap li::before {
  content: "";
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 100%;
  background: var(--tg-metallic-blue);
}
.header-top-left .list-wrap li:last-child::before {
  display: none;
}
.header-top-left .list-wrap li i {
  font-size: 20px;
  margin-right: 8px;
  line-height: 0;
  color: var(--tg-cornflower-blue);
}
.header-top-left .list-wrap li a {
  color: var(--tg-lavender);
}
.header-top-left .list-wrap li a:hover {
  color: var(--tg-primary-color);
}
.header-top-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.header-contact {
  position: relative;
  margin-right: 35px;
}
.header-contact::before {
  content: "";
  position: absolute;
  right: -16px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 500%;
  background: var(--tg-metallic-blue);
}
.header-contact a {
  font-size: 14px;
  line-height: 1.28;
  color: var(--tg-lavender);
  display: flex;
  align-items: center;
}
.header-contact a i {
  font-size: 20px;
  margin-right: 8px;
}
.header-contact a:hover {
  color: var(--tg-primary-color);
}
.header-social .list-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.header-social .list-wrap li a {
  font-size: 15px;
  color: var(--tg-lavender);
}
.header-social .list-wrap li a:hover {
  color: var(--tg-primary-color);
}
/*
  Logo | nav | account controls, all on one row.

  This used to be \`flex-wrap: wrap\` with \`justify-content: flex-start\`, so as
  soon as the row ran out of width the account block (search, avatar, name,
  Logout) dropped onto a second line and started again at the left edge, under
  the logo. That happens as soon as somebody signs in, because the avatar and
  the member's full name are far wider than the Sign In / Join buttons the
  width was budgeted for.

  Nothing wraps now: the nav is the part allowed to give up width, and the
  account block is pinned to the right by \`margin-left: auto\` so it lines up
  with the nav above it whatever the viewport.
*/
.menu-nav {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: flex-start;
}
.menu-nav > .logo {
  flex-shrink: 0;
}
.logo img,
.f-logo img,
.fw-logo img {
  max-height: 45px;
}
/* Sticky menu: always show dark logo on white bg */
.sticky-menu .logo .logo-dark {
  display: none !important;
}
.sticky-menu .logo .logo-light {
  display: inline-block !important;
}
.navbar-wrap {
  display: flex;
  flex-grow: 1;
  /* Without this a flex item refuses to shrink below its content width, which
     is what forced the overflow that made the row wrap. */
  min-width: 0;
}
.navbar-wrap ul {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  padding: 0 0;
  margin: 0 0 0 auto;
}
.navbar-wrap ul li {
  list-style: none;
  display: block;
  position: relative;
}
.navbar-wrap ul li a {
  font-size: 16px;
  font-weight: 500;
  text-transform: capitalize;
  color: var(--tg-secondary-color);
  padding: 20px 15px;
  display: block;
  line-height: 1;
  position: relative;
  z-index: 1;
}
.navbar-wrap > ul > li.active > a,
.navbar-wrap > ul > li:hover > a {
  color: #C6A962;
}
.navbar-wrap > ul > li.menu-item-has-children > a::after {
  content: "\\f107";
  font-weight: 700;
  font-family: "Font Awesome 5 Free";
  color: var(--tg-paragraph-color);
  margin-left: 8px;
  transition: all 0.3s ease-out 0s;
}
.navbar-wrap > ul > li.menu-item-has-children:hover > a::after,
.navbar-wrap > ul > li.menu-item-has-children.active > a::after {
  color: var(--tg-primary-color);
}
.main-menu .navigation li.menu-item-has-children .dropdown-btn {
  display: none;
}
.header-action {
  margin-left: auto;
  flex-shrink: 0;
}
.header-action > ul {
  display: flex;
  align-items: center;
  margin-left: 25px;
}
.header-action > ul li {
  position: relative;
  margin-left: 25px;
}
.header-action ul li:first-child {
  margin-left: 0;
}
.header-action ul li a {
  color: var(--tg-heading-font-color);
  font-size: 14px;
}
.header-action ul li.header-search {
  line-height: 0;
}
.header-action ul li.header-search a {
  color: #334770;
  font-size: 22px;
  line-height: 0;
  transition: all 0.3s ease-out 0s;
}
.header-action ul li.header-search a:hover {
  color: var(--tg-primary-color);
}
.header-action .header-btn .btn {
  color: var(--tg-white);
  font-size: 15px;
  padding: 16px 33px;
  border: 2px solid transparent;
}
.header-action .header-btn .btn::before {
  display: none;
}
.header-action .header-btn .btn:hover {
  background: transparent;
  border-color: var(--tg-primary-color);
  color: var(--tg-primary-color);
}
/*
  The signed-in bar carries an avatar, a name and two buttons where the signed-
  out one carries two links, and the container tops out at 1250px. At the old
  spacing that row measured wider than the container on every desktop width,
  which is what pushed it onto a second line. These are the millimetres that
  buy it back; the bar is unchanged for a signed-out visitor, who has the room.
*/
@media (min-width: 992px) {
  .header-action > ul {
    margin-left: 15px;
  }
  .header-action > ul li {
    margin-left: 16px;
  }
  .navbar-wrap ul li a {
    padding: 20px 11px;
  }
  .header-action .header-profile-link a {
    padding: 8px;
  }
  .header-action .header-btn .btn {
    padding: 10px 14px;
    font-size: 11px;
  }
}
.navbar-wrap ul li .sub-menu {
  position: absolute;
  left: 0;
  right: 0;
  top: 100%;
  min-width: 230px;
  border: 1px solid #f5f5f5;
  background: var(--tg-white);
  margin: 0 0;
  transform: scale(1, 0);
  transform-origin: 0 0;
  transition: all 0.3s ease-in-out;
  box-shadow: 0px 30px 70px 0px rgba(137, 139, 142, 0.15);
  border-radius: 5px;
  padding: 18px 0;
  display: block;
  visibility: hidden;
  opacity: 0;
  z-index: 9;
}
.navbar-wrap ul li .sub-menu .sub-menu {
  right: auto;
  left: 100%;
  top: 0;
}
.navbar-wrap ul li .sub-menu li {
  margin-left: 0;
  text-align: left;
  display: block;
}
.navbar-wrap ul li .sub-menu li a {
  padding: 9px 15px 9px 25px;
  line-height: 1.4;
  font-size: 16px;
  font-weight: 500;
  color: var(--tg-secondary-color);
  text-transform: capitalize;
  transition: all 0.3s ease-in-out;
  display: flex;
  align-items: center;
  gap: 5px;
}
.navbar-wrap ul li .sub-menu li a::before {
  content: "";
  display: block;
  width: 0;
  height: 2px;
  border-radius: 2px;
  background: var(--tg-primary-color);
  transition: 0.3s ease-in-out;
}
.navbar-wrap ul li .sub-menu > li.active > a,
.navbar-wrap ul li .sub-menu li a:hover {
  color: var(--tg-primary-color);
}
.navbar-wrap ul li .sub-menu > li.active > a::before,
.navbar-wrap ul li .sub-menu li a:hover::before {
  width: 10px;
}
.navbar-wrap ul li:hover > .sub-menu {
  opacity: 1;
  visibility: visible;
  transform: scale(1);
}
.sticky-menu {
  position: fixed;
  left: 0;
  margin: auto;
  top: 0;
  width: 100%;
  z-index: 99;
  background: var(--tg-white);
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  animation: 300ms ease-in-out 0s normal none 1 running fadeInDown;
}
/* Hide top bar and fix colors when sticky on white bg */
.sticky-menu .heder-top-wrap {
  display: none;
}
.sticky-menu .navbar-wrap > ul > li > a {
  color: var(--tg-secondary-color);
}
.sticky-menu .navbar-wrap > ul > li.active > a,
.sticky-menu .navbar-wrap > ul > li:hover > a {
  color: #C6A962;
}
.sticky-menu .navbar-wrap > ul > li.menu-item-has-children > a::after {
  color: var(--tg-paragraph-color);
}
.sticky-menu .header-search a,
.sticky-menu .mobile-nav-toggler {
  color: var(--tg-secondary-color);
}
.sticky-menu .header-action .transparent-btn {
  border-color: var(--tg-accent-color);
  color: var(--tg-accent-color);
}
.sticky-menu .header-action .transparent-btn:hover {
  border-color: var(--tg-primary-color);
  color: var(--tg-primary-color);
}

/* header-two */
.header-style-two .heder-top-wrap {
  padding: 0;
}
.header-style-two .header-top-left {
  padding-left: 25px;
}
.header-style-two .header-top-right {
  gap: 20px;
}
.header-top-btn a {
  font-weight: 700;
  font-size: 14px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  line-height: 0;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  padding: 17px 25px;
}
.header-top-btn a i {
  font-size: 16px;
  margin-right: 10px;
}
.header-top-btn a:hover {
  background: var(--tg-blue);
}
.header-style-two .menu-area {
  box-shadow: 0px 2px 50px rgba(0, 0, 0, 0.05);
  background: var(--tg-white);
  padding: 0 0 0 30px;
}
.header-style-two .navbar-wrap ul {
  margin: 0 0 0 60px;
}
.header-style-two .navbar-wrap ul li a {
  padding: 32px 15px;
}
.header-contact-two {
  display: flex;
  align-items: center;
  margin-right: 30px;
}
.header-contact-two .icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  line-height: 0;
  border-radius: 50%;
  font-size: 20px;
  margin-right: 7px;
}
.header-contact-two .content span {
  display: block;
  font-weight: 500;
  font-size: 12px;
  color: var(--tg-paragraph-color);
  line-height: 1;
  margin-bottom: 5px;
}
.header-contact-two .content a {
  font-weight: 700;
  font-size: 16px;
  display: block;
  line-height: 1;
  color: var(--tg-secondary-color);
}
.header-contact-two .content a:hover {
  color: var(--tg-primary-color);
}
.header-style-two .header-action ul > li > a {
  padding: 29px 29px;
  display: block;
  min-height: 80px;
  display: flex;
  align-items: center;
}
.header-action .offcanvas-menu a {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  min-width: 26px;
  padding: 29px 29px;
  justify-content: center;
}
.header-action .offcanvas-menu a span {
  width: 26px;
  height: 2px;
  border-radius: 2px;
  background: var(--tg-paragraph-color);
  transition: 0.3s linear;
}
.header-action .offcanvas-menu a span:nth-child(2) {
  width: 23px;
}
.header-action .offcanvas-menu a span:nth-child(3) {
  width: 15px;
}
.header-style-two .header-action .offcanvas-menu a:hover span {
  background: var(--tg-primary-color);
}
.header-style-two .header-action > ul li {
  margin-left: 0;
}
.header-style-two .header-action > ul li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 100%;
  background: #d9d9d9;
}
.header-style-two .header-action > ul li:first-child::before {
  display: none;
}
.header-style-two.sticky-menu .heder-top-wrap {
  display: none;
}
.header-style-two.sticky-menu .menu-area {
  box-shadow: none;
}

/* header-three */
.header-action .offcanvas-menu.offcanvas-menu-two a {
  padding: 0 0;
}
.header-style-three .header-action > ul li {
  margin-left: 20px;
}
.header-style-three .header-action > ul li:first-child {
  margin-left: 0;
}
.header-style-three .header-action > ul {
  margin-left: 50px;
}

/* header-four */
.header-style-four .heder-top-wrap {
  padding: 0;
}
.header-style-four .header-top-right {
  gap: 20px;
}
.header-style-four .menu-area {
  background: var(--tg-white);
  box-shadow: 0px 2px 50px rgba(0, 0, 0, 0.05);
}

.header-style-five .header-btn .btn {
  text-transform: capitalize;
}

.header-style-six .menu-area {
  background: var(--tg-white);
}

/*=============================
	03. Mobile Menu
===============================*/
.nav-outer .mobile-nav-toggler {
  position: relative;
  float: right;
  font-size: 40px;
  line-height: 50px;
  cursor: pointer;
  display: none;
  color: var(--tg-white);
  margin-right: 30px;
  top: 15px;
}
.nav-logo img {
  max-width: 135px;
}
.mobile-search {
  padding: 0 20px 25px 25px;
}
.mobile-search form {
  position: relative;
}
.mobile-search input {
  display: block;
  width: 100%;
  border: none;
  padding: 10px 45px 10px 20px;
  font-size: 14px;
  font-weight: 500;
  height: 45px;
  background: var(--tg-gray);
  color: var(--tg-secondary-color);
}
.mobile-search input::placeholder {
  font-size: 14px;
  font-weight: 500;
  color: var(--tg-heading-font-color);
}
.mobile-search button {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  padding: 0;
  right: 20px;
  line-height: 1;
  background: transparent;
  color: var(--tg-secondary-color);
}
.mobile-menu {
  position: fixed;
  right: 0;
  top: 0;
  width: 320px;
  padding-right: 30px;
  max-width: 100%;
  height: 100%;
  z-index: 99;
  border-radius: 0px;
  transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  -moz-transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  -webkit-transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  -ms-transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86) e;
  -o-transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86);
  transform: translateX(101%);
}
.mobile-menu .navbar-collapse {
  display: block !important;
}
.mobile-menu .nav-logo {
  position: relative;
  padding: 30px 25px;
  text-align: left;
}
.mobile-menu-visible {
  overflow: hidden;
}
.mobile-menu-visible .mobile-menu {
  transform: translateX(0%);
}
.mobile-menu .navigation li.current > a:before {
  height: 100%;
}
.menu-backdrop {
  position: fixed;
  right: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  transition: all 700ms ease;
  -moz-transition: all 700ms ease;
  -webkit-transition: all 700ms ease;
  -ms-transition: all 700ms ease;
  -o-transition: all 700ms ease;
  opacity: 0;
  visibility: hidden;
  background: rgba(0, 0, 0, 0.5);
}
.mobile-menu-visible .menu-backdrop {
  opacity: 1;
  visibility: visible;
}
.mobile-menu .menu-box {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  background: var(--tg-white);
  padding: 0px 0px;
  z-index: 5;
  box-shadow: -9px 0 14px 0px rgb(0 0 0 / 6%);
}
.mobile-menu-visible .mobile-menu .menu-box {
  opacity: 1;
  visibility: visible;
}
.mobile-menu .close-btn {
  position: absolute;
  right: 15px;
  top: 28px;
  line-height: 30px;
  width: 35px;
  text-align: center;
  font-size: 20px;
  color: #292b37;
  cursor: pointer;
  z-index: 10;
  transition: all 0.9s ease;
}
.mobile-menu-visible .mobile-menu .close-btn {
  transform: rotate(360deg);
}
.mobile-menu .navigation {
  position: relative;
  display: block;
  width: 100%;
  float: none;
  margin: 0;
  padding: 0;
}
.mobile-menu .navigation ul {
  padding: 0;
  margin: 0;
}
.mobile-menu .navigation li {
  position: relative;
  display: block;
  border-top: 1px solid rgb(0 0 0 / 10%);
}
.mobile-menu .navigation:last-child {
  border-bottom: 1px solid rgb(0 0 0 / 10%);
}
.mobile-menu .navigation li > ul > li:first-child {
  border-top: 1px solid rgb(0 0 0 / 10%);
}
.mobile-menu .navigation li > a {
  position: relative;
  display: block;
  line-height: 24px;
  padding: 10px 60px 10px 25px;
  font-size: 16px;
  font-weight: 700;
  color: var(--tg-heading-font-color);
  text-transform: capitalize;
  transition: all 500ms ease;
  border: none;
}
.mobile-menu .navigation li ul li > a {
  font-size: 16px;
  margin-left: 20px;
  text-transform: capitalize;
}
.mobile-menu .navigation li ul li ul li a {
  margin-left: 40px;
}
.mobile-menu .navigation li ul li ul li ul li a {
  margin-left: 60px;
}
.mobile-menu .navigation li > a:before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  height: 0;
  transition: all 500ms ease;
}
.mobile-menu .navigation li.menu-item-has-children .dropdown-btn {
  position: absolute;
  right: 15px;
  top: 6px;
  width: 32px;
  height: 32px;
  text-align: center;
  font-size: 16px;
  line-height: 32px;
  color: #292b37;
  background: var(--tg-gray);
  cursor: pointer;
  border-radius: 2px;
  transition: all 500ms ease;
  z-index: 5;
}
.mobile-menu .navigation li.menu-item-has-children .dropdown-btn i {
  transition: all 500ms ease;
}
.mobile-menu .navigation li.menu-item-has-children .dropdown-btn.open i {
  transform: rotate(45deg);
  color: var(--tg-primary-color);
}
.mobile-menu .navigation li > ul,
.mobile-menu .navigation li > ul > li > ul {
  display: none;
}
.mobile-menu .social-links ul {
  display: flex;
  position: relative;
  text-align: center;
  padding: 30px 20px 20px;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.mobile-menu .social-links li {
  position: relative;
  display: inline-block;
  margin: 0px 6px 10px;
}
.mobile-menu .social-links li a {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  position: relative;
  line-height: 32px;
  font-size: 16px;
  color: var(--tg-heading-font-color);
  transition: all 500ms ease;
  border: 1px solid var(--tg-gray);
  border-radius: 3px;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  -ms-border-radius: 3px;
  -o-border-radius: 3px;
}
.mobile-menu .social-links li a:hover {
  border-color: var(--tg-primary-color);
  background: var(--tg-primary-color);
  color: var(--tg-white);
}
.menu-area .mobile-nav-toggler {
  position: relative;
  float: right;
  font-size: 27px;
  cursor: pointer;
  line-height: 1;
  color: var(--tg-primary-color);
  display: none;
  margin-top: 6px;
  padding: 5px 10px;
  border: 2px solid var(--tg-primary-color);
}

/*=============================
	04. Search
===============================*/
.search-popup-wrap {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.9);
  height: 100%;
  width: 100%;
  z-index: 99;
  padding: 100px 0;
  display: none;
}
.search-wrap {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
.search-wrap .title {
  font-size: 47px;
  margin: 0 0 70px 0;
  font-weight: 700;
}
.search-form {
  position: relative;
}
.search-form input {
  width: 100%;
  border: none;
  border-bottom: 1px solid var(--tg-primary-color);
  padding: 10px 50px 20px;
  text-align: center;
  font-weight: 500;
  font-size: 30px;
  background: transparent;
  color: var(--tg-heading-font-color);
}
.search-form input::placeholder {
  font-size: 30px;
  color: var(--tg-heading-font-color);
  opacity: 0.5;
}
.search-btn {
  position: absolute;
  right: 20px;
  background: transparent;
  border: 0;
  font-size: 25px;
  color: var(--tg-primary-color);
  top: 50%;
  transform: translateY(-50%);
}
.search-close {
  position: absolute;
  top: 5%;
  right: 5%;
  font-size: 30px;
  color: var(--tg-primary-color);
  cursor: pointer;
}

/*=============================
	05. OffCanvas
===============================*/
.extra-info {
  background: var(--tg-white) none repeat scroll 0 0;
  height: 100%;
  padding: 30px;
  position: fixed;
  right: 0;
  top: 0;
  transition: all 0.7s ease 0s;
  width: 340px;
  z-index: 999;
  overflow-y: scroll;
  transform: translateX(100%);
}
.extra-info.active {
  transform: translateX(0);
}
.close-icon {
  margin-top: -16px;
  text-align: right;
}
.close-icon > button {
  background: transparent;
  border: 0 none;
  color: var(--tg-primary-color);
  cursor: pointer;
  font-size: 20px;
  padding: 0;
}
.extra-info .logo-side img {
  max-width: 151px;
}
.side-info {
  border-top: 1px solid var(--tg-primary-color);
  padding-top: 25px;
}
.contact-list h4 {
  color: var(--tg-heading-font-color);
  font-weight: 700;
  font-size: 18px;
}
.contact-list p {
  color: var(--tg-paragraph-color);
  margin: 0;
  margin-bottom: 2px;
  line-height: 26px;
}
.side-instagram {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  margin: -5px;
}
.side-instagram li {
  width: 33.3333%;
  flex: 0 0 33.3333%;
  padding: 5px;
}
.side-instagram li > a {
  display: block;
}
.side-instagram img {
  width: 100%;
  border-radius: 5px;
}
.social-icon-right > a {
  color: var(--tg-primary-color);
  display: inline-block;
  margin-right: 20px;
  text-align: center;
}
.social-icon-right > a:hover {
  color: var(--tg-secondary-color);
}
.offcanvas-overly {
  position: fixed;
  background: var(--tg-black);
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  z-index: 99;
  opacity: 0;
  visibility: hidden;
  transition: 0.3s;
}
.offcanvas-overly.active {
  opacity: 0.5;
  visibility: visible;
}

/*=============================
	06. Slider
===============================*/
.slider-bg.one {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: cover;
  background-position: center;
}
.slider-bg.two {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-size: cover;
  background-position: center;
}
.slider-bg {
  background-size: cover;
  background-position: center;
  min-height: 872px;
  display: flex !important;
  align-items: center;
  padding: 200px 0 120px;
  position: relative;
  z-index: 1;
  overflow: hidden;
  cursor: grab;
}
.slider-content .sub-title {
  letter-spacing: 0.06em;
  text-transform: uppercase;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  display: block;
  color: var(--tg-primary-color);
  padding-top: 18px;
  margin-bottom: 10px;
}
.slider-content .sub-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 4px;
  border-radius: 4px;
  background: var(--tg-primary-color);
}
.slider-content .title {
  font-weight: 800;
  font-size: 60px;
  margin-bottom: 20px;
  line-height: 1;
}
.slider-content p {
  color: var(--tg-paragraph-color);
  margin-bottom: 45px;
  width: 85%;
}
.slider-shape {
  position: absolute;
  left: 15%;
  bottom: 23%;
  animation: alltuchtopdown 8s infinite linear;
}

/*=============================
	07. Banner
===============================*/
.banner-bg-two {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  background-size: cover;
  background-position: center;
  min-height: 770px;
  display: flex;
  align-items: flex-end;
  padding: 170px 0 0;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.banner-content-two {
  width: 85%;
}
.banner-content-two .sub-title {
  font-weight: 600;
  font-size: 13px;
  letter-spacing: 0.1em;
  text-transform: uppercase;
  color: var(--tg-primary-color);
  background: var(--tg-lavender);
  border-radius: 50px;
  display: inline-block;
  padding: 4px 13px;
  margin-bottom: 15px;
}
.banner-content-two .title {
  font-weight: 800;
  font-size: 60px;
  margin-bottom: 20px;
  line-height: 1;
}
.banner-content-two p {
  margin-bottom: 30px;
  color: var(--tg-paragraph-color);
}
.banner-content-two .banner-btn {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.banner-content-two .banner-btn .play-btn {
  display: flex;
  align-items: center;
  color: var(--tg-secondary-color);
}
.banner-content-two .banner-btn .play-btn span {
  text-decoration: underline;
}
.banner-content-two .banner-btn .play-btn i {
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-white);
  border-radius: 50%;
  color: var(--tg-primary-color);
  font-size: 18px;
  margin-right: 12px;
}
.banner-content-two .banner-btn .play-btn:hover {
  color: var(--tg-primary-color);
}
.banner-shape-wrap img {
  position: absolute;
  z-index: -1;
}
.banner-shape-wrap img:nth-child(1) {
  left: 47%;
  bottom: 47%;
  animation: float-bob-x 4s infinite linear;
}
.banner-shape-wrap img:nth-child(2) {
  right: 45%;
  bottom: 22%;
  animation: alltuchtopdown 8s infinite linear;
}
.banner-shape-wrap img:nth-child(3) {
  right: 26%;
  bottom: 0;
  z-index: -2;
}
@keyframes float-bob-x {
  0% {
    transform: translateX(-30px);
  }

  50% {
    transform: translateX(-10px);
  }

  100% {
    transform: translateX(-30px);
  }
}

/* banner-three */
.banner-area-three {
  padding: 200px 0 60px;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.banner-area-three::after,
.banner-area-three::before {
  content: "";
  position: absolute;
  left: 30px;
  top: 60px;
  width: 550px;
  height: 550px;
  background: #cef0ff;
  opacity: 0.3;
  filter: blur(75px);
  border-radius: 50%;
  z-index: -3;
}
.banner-area-three::after {
  background: #e4ceff;
  top: -105px;
  left: auto;
  right: 30%;
}
.banner-content-three {
  margin-top: 60px;
}
.banner-content-three .title {
  font-weight: 800;
  font-size: 60px;
  margin-bottom: 25px;
  line-height: 1.06;
}
.banner-content-three p {
  margin-bottom: 15px;
  color: var(--tg-paragraph-color);
}
.banner-content-three .banner-form {
  position: relative;
  width: 93%;
}
.banner-content-three .banner-form input {
  width: 100%;
  border: 1px solid #d7dff0;
  border-radius: 30px;
  background: var(--tg-white);
  font-size: 16px;
  font-weight: 400;
  color: var(--tg-secondary-color);
  padding: 16px 70px 16px 28px;
  height: 60px;
}
.banner-content-three .banner-form input::placeholder {
  font-size: 16px;
  color: var(--tg-paragraph-color);
  font-weight: 400;
}
.banner-content-three .banner-form button {
  position: absolute;
  top: 4px;
  bottom: 4px;
  right: 5px;
  width: 52px;
  height: 52px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  border: none;
  border-radius: 50%;
  font-size: 24px;
  line-height: 0;
}
.banner-content-three .banner-form button:hover {
  background: var(--tg-secondary-color);
}
.ball {
  opacity: 1;
  z-index: -2;
  position: absolute;
  border-radius: 50%;
}
.banner-img-three {
  position: relative;
  text-align: right;
  padding-right: 80px;
}
.banner-img-three img.main-img {
  clip-path: polygon(0 0, 85% 0, 100% 15%, 100% 100%, 15% 100%, 0 85%);
  border-radius: 5px;
}
.banner-img-three img:not(.main-img) {
  position: absolute;
}
.banner-img-three img.img-two {
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  left: 6%;
  bottom: 24%;
}
.banner-img-three img.img-three {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  right: -4%;
  top: 21%;
}
.banner-shape-wrap-three img {
  position: absolute;
  z-index: -1;
}
.banner-shape-wrap-three img:nth-child(1) {
  right: 47.5%;
  bottom: 41%;
  animation: ribbonRotate 6s infinite linear;
}
.banner-shape-wrap-three img:nth-child(2) {
  right: 18%;
  bottom: 3%;
  animation: alltuchtopdown 8s infinite linear;
}
@keyframes ribbonRotate {
  0%,
  100% {
    transform: rotate(0);
  }

  25%,
  75% {
    transform: rotate(15deg);
  }

  50% {
    transform: rotate(30deg);
  }
}

/* banner-four */
.banner-bg-four {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  background-size: cover;
  background-position: center;
  padding: 65px 0 0;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.banner-content-four {
  margin-top: 105px;
}
.banner-content-four .sub-title {
  font-weight: 600;
  font-size: 13px;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  display: inline-block;
  background: var(--tg-lavender);
  color: var(--tg-primary-color);
  border-radius: 30px;
  padding: 4px 13px;
  margin-bottom: 20px;
}
.banner-content-four .title {
  margin-bottom: 15px;
  font-weight: 800;
  font-size: 60px;
  line-height: 1.1;
}
.banner-content-four p {
  margin-bottom: 35px;
  color: var(--tg-paragraph-color);
  width: 90%;
}
.banner-shape-wrap-four img {
  position: absolute;
  z-index: -1;
}
.banner-shape-wrap-four img:nth-child(1) {
  left: 15%;
  bottom: 25%;
  animation: alltuchtopdown 8s infinite linear;
}
.banner-shape-wrap-four img:nth-child(2) {
  right: 46%;
  bottom: 39%;
}
.banner-shape-wrap-four img:nth-child(3) {
  right: 15%;
  top: 0;
}

/* banner-five */
.banner-area-five {
  position: relative;
  background: #f2f7ff;
  padding: 140px 0 100px;
  z-index: 1;
  overflow: hidden;
}
.banner-area-five::before {
  content: "";
  position: absolute;
  left: 17%;
  top: -100px;
  width: 460px;
  height: 460px;
  background: #fbedff;
  filter: blur(200px);
  z-index: -1;
}
.banner-area-five::after {
  content: "";
  position: absolute;
  right: -10%;
  top: -15%;
  width: 1100px;
  height: 600px;
  background: linear-gradient(
    88.44deg,
    #e0faf3 0.58%,
    rgba(239, 247, 255, 0) 67.54%
  );
  border-radius: 326.687px;
  transform: rotate(-42.01deg);
  z-index: -1;
}
.banner-content-five .title {
  margin-bottom: 20px;
  font-weight: 800;
  font-size: 50px;
}
.banner-content-five .title span {
  position: relative;
  z-index: 1;
}
.banner-content-five .title span svg {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: -4px;
  z-index: -1;
}
.has-animation.active-animation .banner-content-five .title span svg path {
  stroke-dasharray: 1000;
  stroke-dashoffset: 1000;
  animation: dash_animation 10s linear forwards;
}
@keyframes dash_animation {
  to {
    stroke-dashoffset: 0;
  }
}
.banner-content-five p {
  margin-bottom: 25px;
  color: var(--tg-black);
}
.banner-img-five {
  position: relative;
  margin-left: 90px;
  z-index: 1;
}
.banner-img-five img:not(.main-img) {
  position: absolute;
}
.banner-img-five .main-img {
  max-width: unset;
}
.banner-img-five .shape-one {
  right: -19%;
  bottom: 12%;
}
.banner-img-five .shape-two {
  left: 35%;
  top: 38%;
  animation: float-bob-x 4s infinite linear;
}
.banner-img-five .shape-three {
  right: 5%;
  top: 23%;
  animation: alltuchtopdown 8s infinite linear;
}

/*=============================
	08. Breadcrumb
===============================*/
.breadcrumb-bg {
  background: #0A1628;
  padding: 120px 0 130px;
  position: relative;
  z-index: 1;
}
.breadcrumb-shape-wrap img {
  position: absolute;
  z-index: -1;
}
.breadcrumb-shape-wrap img:nth-child(1) {
  left: 0;
  top: 0;
}
.breadcrumb-shape-wrap img:nth-child(2) {
  right: 10%;
  top: 0;
}
.breadcrumb-content {
  text-align: center;
}
.breadcrumb-content .title {
  margin-bottom: 12px;
  color: var(--tg-white);
  font-size: 44px;
  line-height: 1.1;
  text-transform: capitalize;
}
.breadcrumb-content .breadcrumb {
  justify-content: center;
  margin-bottom: 0;
}
.breadcrumb-content .breadcrumb-item {
  color: var(--tg-primary-color);
  font-weight: 500;
  font-size: 14px;
  text-transform: capitalize;
}
.breadcrumb-content .breadcrumb-item a {
  color: #9fa9be;
}
.breadcrumb-content .breadcrumb-item a:hover {
  color: var(--tg-primary-color);
}
.breadcrumb-content .breadcrumb-item + .breadcrumb-item::before {
  padding-right: 10px;
  color: #9fa9be;
  content: "\\f054";
  font-family: "Font Awesome 5 Free";
  font-weight: 700;
  font-size: 12px;
  line-height: 1;
  margin-top: 7px;
}
.breadcrumb-content .breadcrumb-item + .breadcrumb-item {
  padding-left: 10px;
}

/*=============================
	09. About
===============================*/
.about-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  background-size: cover;
  background-position: center;
  padding: 140px 0 200px;
}
.about-img-wrap {
  position: relative;
  text-align: center;
  z-index: 1;
  padding-bottom: 15px;
  margin-top: 16px;
}
.about-img-wrap img:not(.main-img) {
  position: absolute;
  z-index: -1;
}
.about-img-wrap img:nth-child(2) {
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
}
.about-img-wrap img.main-img {
  border-radius: 50%;
  width: 314px;
  object-fit: cover;
  height: 314px;
  border: 5px solid var(--tg-white);
}
.about-img-wrap img:nth-child(3) {
  right: 19%;
  top: -10%;
  animation: alltuchtopdown 8s infinite linear;
}
.about-content {
  width: 88%;
}
.section-title .sub-title {
  letter-spacing: 0.06em;
  text-transform: uppercase;
  display: inline-block;
  font-size: 15px;
  font-weight: 600;
  color: var(--tg-primary-color);
  position: relative;
  padding-top: 18px;
  margin-bottom: 10px;
}
.section-title .sub-title::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 30px;
  height: 4px;
  background: var(--tg-primary-color);
  border-radius: 4px;
}
.section-title .title {
  font-size: 40px;
  margin-bottom: 0;
}
.about-content p {
  margin-bottom: 0;
  color: var(--tg-paragraph-color);
}

/* about-two */
.about-area-two {
  position: relative;
}
.about-area-two::before {
  content: "";
  position: absolute;
  left: 13%;
  top: 0;
  width: 630px;
  height: 630px;
  background: linear-gradient(154.68deg, #8894ff 11.62%, #ff8585 90.47%);
  opacity: 0.1;
  filter: blur(75px);
  z-index: -1;
}
.about-content-two p {
  margin-bottom: 20px;
  color: var(--tg-paragraph-color);
}
.about-list .list-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px 0;
  margin-bottom: 30px;
}
.about-list .list-wrap li {
  font-family: var(--tg-heading-font-family);
  color: var(--tg-paragraph-color);
  font-size: 18px;
  font-weight: 600;
  text-transform: capitalize;
  width: 50%;
  line-height: 1.3;
  display: flex;
  align-items: flex-start;
}
.about-list .list-wrap li img {
  margin-right: 10px;
}
.success-wrap .list-wrap {
  display: flex;
  align-items: center;
  border-top: 1px solid #d9d9d9;
  padding-top: 30px;
  margin-bottom: 40px;
}
.success-wrap .list-wrap li {
  width: 50%;
}
.success-wrap .list-wrap li .count {
  font-weight: 800;
  font-size: 36px;
  margin-bottom: 8px;
  letter-spacing: 2px;
  line-height: 0.8;
}
.success-wrap .list-wrap li p {
  margin-bottom: 0;
  font-size: 14px;
  line-height: 1;
}
.about-content-two .btn {
  background: transparent;
  border-color: var(--tg-primary-color);
  color: var(--tg-primary-color);
}
.about-content-two .btn::after {
  color: var(--tg-white);
}
.about-content-two .btn:hover {
  color: var(--tg-white);
}
.about-img-two {
  position: relative;
  padding-left: 218px;
}
.about-img-two .main-img {
  position: relative;
  text-align: right;
}
.about-img-two .main-img img {
  border-radius: 15px;
  border: 9px solid var(--tg-white);
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);
}
.about-img-two .main-img .play-btn {
  position: absolute;
  width: 82px;
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0 85 255 / 80%);
  border-radius: 50%;
  box-shadow: -8px -1px 10px rgba(255, 255, 255, 0.1);
  color: var(--tg-white);
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 25px;
}
.about-img-two .main-img .play-btn::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  border: 1px solid var(--tg-white);
  border-radius: 50%;
  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
  animation: pulse-border 1500ms ease-out infinite;
}
.about-img-two img:nth-child(2) {
  border: 9px solid #ffffff;
  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);
  border-radius: 15px;
  transform: rotate(-2.71deg);
  position: absolute;
  left: 40px;
  bottom: 70px;
}
.about-shape-wrap img {
  position: absolute;
  z-index: -1;
}
.about-shape-wrap img:nth-child(1) {
  right: 41%;
  top: 13%;
  animation: alltuchtopdown 8s infinite linear;
}
.about-shape-wrap img:nth-child(2) {
  right: 0;
  bottom: 0;
}
@keyframes pulse-border {
  0% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
    opacity: 1;
  }
  100% {
    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);
    opacity: 0;
  }
}
@keyframes alltuchtopdown {
  0% {
    transform: rotateX(0deg) translateY(0px);
  }
  50% {
    transform: rotateX(0deg) translateY(-50px);
  }
  100% {
    transform: rotateX(0deg) translateY(0px);
  }
}

/* about-three */
.about-area-three {
  position: relative;
  padding: 80px 0;
}
.about-img-wrap-three {
  position: relative;
  text-align: center;
  padding-bottom: 90px;
}
.about-img-wrap-three img:nth-child(1) {
  border-radius: 100px 0 0 0;
}
.about-img-wrap-three img:nth-child(2) {
  border-radius: 0 50px 0 0;
  border: 8px solid var(--tg-white);
  position: absolute;
  right: 0;
  bottom: 25px;
  z-index: 2;
}
.about-img-wrap-three .experience-wrap {
  width: 506px;
  display: flex;
  align-items: center;
  text-align: left;
  background: var(--tg-primary-color);
  border-radius: 0px 0px 0px 60px;
  padding: 40px 195px 50px 45px;
  position: absolute;
  left: 0;
  bottom: 0;
}
.about-img-wrap-three .experience-wrap .title {
  margin-bottom: 0;
  text-align: center;
  font-size: 64px;
  line-height: 0.8;
  color: var(--tg-white);
  position: relative;
  padding-right: 13px;
  margin-right: 13px;
}
.about-img-wrap-three .experience-wrap .title span {
  display: block;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: 0.1em;
  margin-top: 5px;
}
.about-img-wrap-three .experience-wrap .title::before {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 2px;
  height: 100%;
  background: var(--tg-white);
}
.about-img-wrap-three .experience-wrap p {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 0;
  color: var(--tg-white);
  line-height: 1.4;
  font-family: var(--tg-heading-font-family);
}
.section-title-two span {
  letter-spacing: 0.1em;
  text-transform: uppercase;
  font-size: 13px;
  font-weight: 600;
  display: inline-block;
  color: var(--tg-primary-color);
  background: var(--tg-lavender);
  border-radius: 50px;
  padding: 4px 13px;
  margin-bottom: 12px;
}
.section-title-two .title {
  font-weight: 800;
  font-size: 40px;
  margin-bottom: 0;
}
.about-content-three p {
  margin-bottom: 0;
  color: var(--tg-paragraph-color);
  width: 90%;
}
.about-content-three p.info-one {
  margin-bottom: 25px;
}
.about-list-two .list-wrap {
  margin-bottom: 20px;
}
.about-list-two .list-wrap li {
  font-weight: 600;
  font-size: 18px;
  display: flex;
  align-items: baseline;
  text-transform: capitalize;
  color: var(--tg-secondary-color);
  margin-bottom: 14px;
}
.about-list-two .list-wrap li:last-child {
  margin-bottom: 0;
}
.about-list-two .list-wrap li i {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  border-radius: 50%;
  font-size: 12px;
  margin-right: 8px;
  flex: 0 0 auto;
}
.about-author-info {
  display: flex;
  align-items: center;
  margin-top: 35px;
}
.about-author-info .thumb {
  border-radius: 50%;
  border: 3px solid var(--tg-white);
  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.25);
  width: 70px;
  flex: 0 0 auto;
  margin-right: 15px;
}
.about-author-info .content .title {
  font-size: 20px;
  margin-bottom: 5px;
}
.about-author-info .content span {
  font-weight: 500;
  font-size: 14px;
  display: block;
  line-height: 1;
}
.about-author-info .signature {
  margin-left: 20px;
}
.about-shape-wrap-two img {
  position: absolute;
  z-index: -1;
}
.about-shape-wrap-two img:nth-child(1) {
  left: 15%;
  bottom: 27%;
  animation: alltuchtopdown 8s infinite linear;
}
.about-shape-wrap-two img:nth-child(2) {
  left: 40%;
  top: 5%;
}
.about-shape-wrap-two img:nth-child(3) {
  right: 0;
  bottom: 0;
}

/* about-four */
.about-content-four > p {
  color: var(--tg-paragraph-color);
  margin-bottom: 35px;
}
.about-list-three .list-wrap li {
  display: flex;
  align-items: center;
  margin-bottom: 40px;
  padding-left: 13px;
}
.about-list-three .list-wrap li:last-child {
  margin-bottom: 0;
}
.about-list-three .list-wrap li .icon {
  position: relative;
  font-size: 50px;
  line-height: 0;
  color: var(--tg-primary-color);
  margin-right: 15px;
}
.about-list-three .list-wrap li .icon::before {
  content: "";
  position: absolute;
  left: -13px;
  top: -15px;
  width: 46px;
  height: 46px;
  background: var(--tg-lavender);
  border-radius: 50%;
  z-index: -1;
}
.about-list-three .list-wrap li .icon i {
  transform: rotateY(0);
  transition: 0.3s linear;
  display: block;
}
.about-list-three .list-wrap li:hover .icon i {
  transform: rotateY(180deg);
}
.about-list-three .content .title {
  font-size: 20px;
  margin-bottom: 10px;
}
.about-list-three .content p {
  margin-bottom: 0;
  width: 75%;
  color: var(--tg-paragraph-color);
}
.about-img-wrap-four {
  position: relative;
  margin-right: -30px;
}
.mask-img-wrap {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  mask-size: 100%;
  mask-repeat: no-repeat;
  mask-position: center;
  z-index: -1;
  height: 558px;
  width: 633px;
  margin-left: auto;
}
.mask-img-wrap img {
  max-width: unset;
}
.about-img-wrap-four .img-two {
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  position: absolute;
  left: 10%;
  bottom: 14%;
}
.about-shape-wrap-three img {
  position: absolute;
  z-index: -1;
}
.about-shape-wrap-three img:nth-child(1) {
  left: 0;
  top: 6%;
  animation: ribbonRotate 15s infinite linear;
}
.about-shape-wrap-three img:nth-child(2) {
  left: 4%;
  bottom: 7%;
  animation: alltuchtopdown 8s infinite linear;
}
.about-shape-wrap-three img:nth-child(3) {
  right: 23%;
  top: -2%;
  animation: rotateme 8s infinite linear;
}
.about-img-wrap-four .icon {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 8%;
  top: 21%;
  border-radius: 50%;
  background: var(--tg-pink);
  border: 5px solid var(--tg-white);
  color: var(--tg-white);
  font-size: 50px;
  line-height: 0;
}
@keyframes rotateme {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* about-five */
.about-area-five {
  position: relative;
  padding: 120px 0;
}
.about-img-wrap-five {
  position: relative;
  padding-bottom: 30px;
}
.about-img-wrap-five::before {
  content: "";
  position: absolute;
  right: 0;
  bottom: 0;
  height: 40px;
  width: 380px;
  background: var(--tg-primary-color);
  z-index: -1;
}
.about-img-wrap-five img:nth-child(1) {
  clip-path: polygon(0 0, 85% 0, 100% 15%, 100% 100%, 0% 100%, 0 100%);
}
.about-img-wrap-five img:nth-child(2) {
  border-radius: 10px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  position: absolute;
  left: -25%;
  top: 14%;
}
.about-img-wrap-five .experience-wrap {
  background: var(--tg-primary-color);
  max-width: 200px;
  padding: 36px 20px;
  position: absolute;
  right: 0;
  bottom: 0;
}
.about-img-wrap-five .experience-wrap .title {
  margin-bottom: 0;
  color: var(--tg-white);
  font-size: 60px;
  text-align: center;
  line-height: 1;
}
.about-img-wrap-five .experience-wrap .title span {
  display: block;
  font-weight: 500;
  font-size: 24px;
}
.about-content-five > p {
  margin-bottom: 50px;
  color: var(--tg-paragraph-color);
  width: 85%;
}
.about-content-five {
  margin-left: 55px;
  width: 85%;
}
.about-content-five .about-list {
  width: 60%;
  flex: 0 0 auto;
}
.about-content-five .about-list .list-wrap {
  gap: 25px 0;
  margin-bottom: 0;
}
.about-content-five .about-list .list-wrap li {
  color: var(--tg-secondary-color);
  width: 100%;
}
.about-content-five .about-list .list-wrap li i {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  border-radius: 50%;
  font-size: 12px;
  margin-right: 8px;
  flex: 0 0 auto;
}
.about-content-five .about-content-bottom {
  display: flex;
  align-items: center;
}
.about-success-wrap .list-wrap li {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.about-success-wrap .list-wrap li:last-child {
  margin-bottom: 0;
}
.about-success-wrap .list-wrap li .icon {
  font-size: 60px;
  line-height: 0;
  color: var(--tg-primary-color);
  flex: 0 0 auto;
  margin-right: 20px;
}
.about-success-wrap .list-wrap li .content .count {
  font-weight: 800;
  font-size: 50px;
  line-height: 0.8;
  margin-bottom: 5px;
}
.about-success-wrap .list-wrap li .content p {
  font-weight: 600;
  font-size: 18px;
  margin-bottom: 0;
  color: var(--tg-secondary-color);
  font-family: var(--tg-heading-font-family);
  line-height: 1;
}
.about-shape-five img {
  position: absolute;
  left: 41%;
  bottom: 35%;
  z-index: -1;
  animation: alltuchtopdown 8s infinite linear;
}

/* about-six */
.about-area-six {
  padding: 0 0 120px;
  position: relative;
  overflow: hidden;
}
.about-area-six::before {
  content: "";
  position: absolute;
  width: 310px;
  height: 310px;
  background: #fae7ff;
  filter: blur(200px);
  right: 26%;
  top: 16%;
  z-index: -1;
}
.about-img-six {
  margin-left: -75px;
  position: relative;
  padding-top: 40px;
}
.about-img-six img:nth-child(1) {
  max-width: unset;
  position: unset;
}
.about-img-six img {
  position: absolute;
  z-index: -1;
}
.about-img-six img:nth-child(2) {
  left: 0;
  bottom: -40px;
}
.about-img-six img:nth-child(3) {
  left: 19%;
  top: 14%;
  animation: alltuchtopdown 8s infinite linear;
}
.about-content-six {
  width: 88%;
}
.about-content-six p {
  margin-bottom: 30px;
}
.about-content-six .about-list .list-wrap {
  margin-bottom: 45px;
}
.about-content-six .about-list .list-wrap li {
  color: var(--tg-secondary-color);
}
.about-content-six .about-list .list-wrap li i {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  border-radius: 50%;
  font-size: 12px;
  margin-right: 8px;
  flex: 0 0 auto;
}

/* about-seven */
.about-content-seven {
  width: 88%;
}
.about-content-seven > p {
  margin-bottom: 25px;
}
.success-wrap-two {
  margin-bottom: 25px;
}
.success-wrap-two .list-wrap {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.success-wrap-two .list-wrap li {
  background: var(--tg-lavender);
  border-radius: 10px;
  position: relative;
  display: flex;
  align-items: center;
  padding: 30px 25px;
  min-width: 240px;
  transition: 0.3s;
}
.success-wrap-two .list-wrap li::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 28px;
  border-radius: 3px;
  background: var(--tg-primary-color);
}
.success-wrap-two .list-wrap li:hover {
  transform: translateY(-5px);
}
.success-wrap-two .list-wrap li .icon {
  font-size: 50px;
  flex: 0 0 auto;
  line-height: 0;
  color: var(--tg-primary-color);
  margin-right: 18px;
}
.success-wrap-two .list-wrap li .content .count {
  font-weight: 800;
  font-size: 36px;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
  line-height: 0.8;
}
.success-wrap-two .list-wrap li .content p {
  margin-bottom: 0;
  line-height: 1;
}
.about-img-seven-wrap {
  position: relative;
  padding-bottom: 90px;
}
.about-img-seven-wrap img:nth-child(1) {
  border-radius: 10px;
}
.about-img-seven-wrap img:nth-child(2) {
  position: absolute;
  right: 50px;
  bottom: 0;
  border: 8px solid var(--tg-white);
  border-radius: 10px;
  z-index: 3;
}
.about-img-seven-wrap .shape {
  position: absolute;
  left: 33%;
  bottom: -8%;
  z-index: -1;
  animation: alltuchtopdown 8s infinite linear;
}
.about-img-seven-wrap .experience-wrap {
  position: absolute;
  right: 0;
  bottom: 0;
  border: 8px solid #ffffff;
  border-radius: 19px 63px 24px 0px;
  max-width: 197px;
  min-height: 384px;
  background: var(--tg-primary-color);
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 25px 20px;
  text-align: center;
}
.about-img-seven-wrap .experience-wrap .title {
  color: var(--tg-white);
  margin-bottom: 10px;
  font-size: 60px;
  line-height: 0.8;
}
.about-img-seven-wrap .experience-wrap p {
  margin-bottom: 0;
  color: var(--tg-white);
  font-family: var(--tg-heading-font-family);
  font-size: 24px;
  font-weight: 600;
  line-height: 1.2;
}

/* about-eight */
.about-img-eight img {
  border-radius: 15px;
}
.about-content-eight > p {
  margin-bottom: 35px;
}
.about-content-eight .about-content-inner {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 60px;
}
.about-content-eight .about-content-inner .list-wrap {
  width: 58%;
}
.about-content-eight .about-content-inner .list-wrap li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 50px;
}
.about-content-eight .about-content-inner .list-wrap li:last-child {
  margin-bottom: 0;
}
.about-content-eight .about-content-inner .list-wrap li .icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-lavender);
  color: var(--tg-primary-color);
  font-size: 40px;
  line-height: 0;
  position: relative;
  border-radius: 15px;
  flex: 0 0 auto;
  margin-right: 20px;
}
.about-content-eight .about-content-inner .list-wrap li .icon::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 16px;
  height: 3px;
  background: var(--tg-primary-color);
  border-radius: 3px;
}
.about-content-eight .about-content-inner .content .title {
  font-size: 20px;
  margin-bottom: 8px;
}
.about-content-eight .about-content-inner .content p {
  margin-bottom: 0;
}
.about-content-eight .right-slide-img {
  margin-left: auto;
}
.about-content-eight .right-slide-img img {
  border-radius: 10px;
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
}
.about-content-eight .about-content-bottom {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 30px 40px;
}
.about-content-eight .about-content-bottom .about-author-info {
  margin-top: 0;
}

/* about-ten */
.about-area-ten {
  padding: 120px 0;
  position: relative;
}
.about-img-wrap-ten {
  padding-left: 120px;
}
.about-img-wrap-ten img:nth-child(2) {
  left: 0;
}
.about-area-ten .about-shape-five img {
  left: 46%;
}
.about-content-five.about-content-ten {
  margin-left: 80px;
  width: auto;
  margin-right: 30px;
}
.about-content-ten .about-success-wrap .list-wrap {
  display: flex;
  align-items: center;
  gap: 30px;
  margin-top: 45px;
}
.about-content-ten .about-success-wrap .list-wrap li {
  margin-bottom: 0;
}
.about-content-five.about-content-ten > p {
  margin-bottom: 20px;
  width: 100%;
}

/* about-eleven */
.about-area-eleven {
  position: relative;
  padding: 120px 0 0;
}
.about-area-eleven::before {
  content: "";
  position: absolute;
  left: 20%;
  top: 32%;
  width: 300px;
  height: 300px;
  background: #fae7ff;
  filter: blur(200px);
  z-index: -1;
}
.about-content-eleven {
  width: 85%;
}
.about-content-eleven p {
  margin-bottom: 25px;
}
.about-content-eleven .about-list-two .list-wrap {
  margin-bottom: 40px;
}
.about-img-wrap-eleven {
  position: relative;
  text-align: center;
  padding-bottom: 30px;
}
.about-img-wrap-eleven .shape-one {
  position: absolute;
  left: -5%;
  top: -2%;
  z-index: -1;
  animation: alltuchtopdown 8s infinite linear;
}
.about-img-wrap-eleven .shape-two {
  position: absolute;
  left: -20px;
  bottom: 0;
  z-index: -2;
  max-width: unset;
}

/* about-twelve */
.about-area-twelve {
  padding: 140px 0 140px;
}
.about-img-six.about-img-twelve img:nth-child(2) {
  bottom: -50px;
}

/*=============================
	10. Overview
===============================*/
.overview-area {
  position: relative;
  overflow: hidden;
}
.overview-area::before {
  content: "";
  position: absolute;
  width: 480px;
  height: 480px;
  opacity: 0.2;
  filter: blur(75px);
  border-radius: 50%;
  background: #d5ceff;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  z-index: -1;
}
.overview-shape {
  right: 0;
  top: 0;
  width: 424px;
  height: 342px;
  position: absolute;
  z-index: -1;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
}
.overview-img-wrap {
  text-align: center;
  position: relative;
}
.overview-img-wrap img:nth-child(1) {
  border-radius: 280px;
}
.overview-img-wrap img:nth-child(2) {
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  position: absolute;
  left: 0;
  bottom: 30px;
}
.overview-img-wrap img:nth-child(3) {
  position: absolute;
  left: -50px;
  bottom: 32%;
  z-index: -1;
  animation: alltuchtopdown 8s infinite linear;
}
.overview-img-wrap .icon {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-primary-color);
  position: absolute;
  right: 90px;
  top: 20px;
  border-radius: 50%;
  font-size: 50px;
  line-height: 0;
  color: var(--tg-white);
  border: 5px solid var(--tg-white);
}
.overview-content {
  width: 90%;
}
.overview-content > p {
  margin-bottom: 0;
  color: var(--tg-paragraph-color);
}
.overview-content .info-one {
  margin-bottom: 15px;
}
.overview-content .info-two {
  margin-bottom: 30px;
}
.overview-content .content-bottom .list-wrap {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}
.overview-content .content-bottom .list-wrap li {
  border: 1.2px solid #d4dced;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 28px 20px 28px 30px;
  min-width: 256px;
}
.overview-content .content-bottom .list-wrap li .icon {
  font-size: 50px;
  line-height: 0;
  color: var(--tg-primary-color);
  position: relative;
  margin-right: 40px;
}
.overview-content .content-bottom .list-wrap li .icon::before {
  content: "";
  position: absolute;
  width: 40px;
  height: 40px;
  background: var(--tg-lavender);
  left: -10px;
  top: -12px;
  border-radius: 50%;
  z-index: -1;
}
.overview-content .content-bottom .list-wrap li .icon::after {
  content: "";
  position: absolute;
  width: 2px;
  height: 38px;
  background: var(--tg-lavender);
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 50%;
  z-index: -1;
}
.overview-content .content-bottom .list-wrap li .content .count {
  font-size: 36px;
  margin-bottom: 3px;
  line-height: 0.8;
  display: flex;
  align-items: center;
}
.overview-content .content-bottom .list-wrap li .content p {
  margin-bottom: 0;
}

/* overview-two */
.overview-area-two {
  position: relative;
  padding: 0 0 120px;
}
.overview-area-two::before {
  content: "";
  position: absolute;
  left: 114px;
  top: 0;
  width: 600px;
  height: 600px;
  background: #d5ceff;
  opacity: 0.2;
  filter: blur(75px);
  z-index: -1;
}
.overview-img-two {
  position: relative;
}
.mask-img-two {
  mask-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  mask-size: 100%;
  mask-repeat: no-repeat;
  mask-position: center;
  z-index: -1;
  height: 534px;
  width: 556px;
}
.mask-img-two img {
  max-width: unset;
}
.overview-img-two .img-two {
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  position: absolute;
  left: -13%;
  bottom: 21%;
}
.overview-shape-wrap img {
  position: absolute;
  z-index: -1;
}
.overview-shape-wrap img:nth-child(1) {
  right: 7%;
  top: 15%;
  animation: float-bob-x 4s infinite linear;
}
.overview-shape-wrap img:nth-child(2) {
  right: 6%;
  top: 25%;
}
.overview-content-two {
  margin-left: 45px;
}
.overview-content-two p {
  margin-bottom: 30px;
  color: var(--tg-paragraph-color);
}

/*=============================
	11. Features
===============================*/
.features-area {
  margin-top: -100px;
  position: relative;
  z-index: 1;
}
.features-item {
  border: 1px solid var(--tg-steel-blue);
  border-radius: 10px;
  padding: 35px 50px;
  margin-bottom: 40px;
  background: var(--tg-white);
  position: relative;
}
.features-item::before {
  content: "";
  position: absolute;
  left: 5px;
  right: 5px;
  bottom: -5px;
  background: var(--tg-gray);
  border: 1px solid var(--tg-steel-blue);
  border-radius: 8px;
  height: 70px;
  z-index: -1;
  transition: 0.3s ease-in;
}
.features-item::after {
  content: "";
  position: absolute;
  left: 12px;
  right: 12px;
  bottom: -10px;
  background: #dfe5f0;
  border: 1px solid var(--tg-steel-blue);
  border-radius: 8px;
  height: 70px;
  z-index: -2;
  transition: 0.3s ease-in;
}
.features-item:hover::after,
.features-item:hover::before {
  bottom: 3px;
}
.features-content .content-top {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.features-content .content-top .icon {
  font-size: 50px;
  line-height: 0;
  position: relative;
  color: var(--tg-primary-color);
  z-index: 1;
  margin-right: 15px;
}
.features-content .content-top .icon::before {
  content: "";
  position: absolute;
  left: -13px;
  top: -15px;
  width: 46px;
  height: 46px;
  background: var(--tg-lavender);
  z-index: -1;
  border-radius: 50%;
  transition: 0.3s ease-in;
}
.features-item:hover .features-content .content-top .icon::before {
  left: 0;
  top: 0;
}
.features-content .content-top .title {
  font-size: 22px;
  margin-bottom: 0;
}
.features-content p {
  margin-bottom: 0;
  color: var(--tg-gray-four);
}

/* features-two */
.features-item-wrap {
  border-bottom: 1px solid var(--tg-lavender);
  padding-bottom: 50px;
}
.features-item-two {
  display: flex;
  align-items: flex-start;
  margin-bottom: 30px;
}
.features-icon-three,
.features-icon-two {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px;
  background: var(--tg-lavender);
  flex: 0 0 auto;
  color: var(--tg-primary-color);
  font-size: 40px;
  line-height: 0;
  position: relative;
  margin-right: 20px;
}
.features-icon-three::before,
.features-icon-two::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  background: var(--tg-primary-color);
  top: 0;
  width: 16px;
  height: 3px;
  border-radius: 3px;
}
.features-icon-two i {
  transform: rotateY(0);
  transition: 0.3s linear;
}
.features-item-two:hover .features-icon-two i {
  transform: rotateY(180deg);
}
.features-content-two .title {
  font-size: 20px;
  margin-bottom: 10px;
}
.features-content-two p {
  margin-bottom: 0;
  color: var(--tg-paragraph-color);
  width: 80%;
}

/* features-three */
.features-area-three {
  position: relative;
  padding: 120px 0 90px;
  overflow: hidden;
}
.features-area-three::before {
  content: "";
  position: absolute;
  left: -127px;
  top: 90px;
  width: 530px;
  height: 530px;
  background: #cc3de3;
  opacity: 0.05;
  filter: blur(75px);
  border-radius: 50%;
  z-index: -1;
}
.features-area-three::after {
  content: "";
  position: absolute;
  right: -120px;
  top: 80px;
  width: 530px;
  height: 530px;
  background: #5e3de3;
  opacity: 0.05;
  filter: blur(75px);
  z-index: -1;
}
.features-item-three {
  background: var(--tg-white);
  border: 1px solid var(--tg-border-color);
  border-radius: 10px;
  padding: 30px 30px 35px;
  position: relative;
  transition: 0.3s linear;
  z-index: 1;
  margin-bottom: 30px;
}
.features-item-three:hover {
  background: var(--tg-primary-color);
  border-color: var(--tg-primary-color);
  box-shadow: 0px 20px 50px rgba(3, 74, 218, 0.29);
}
.features-item-three .features-icon-three {
  margin-right: 0;
  margin-bottom: 25px;
  transition: 0.3s;
  width: 65px;
  height: 65px;
}
.features-item-three:hover .features-icon-three {
  background: var(--tg-white);
}
.features-content-three .title {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 15px;
  transition: 0.3s;
}
.features-content-three p {
  margin-bottom: 17px;
  color: var(--tg-paragraph-color);
  transition: 0.3s;
}
.features-item-three:hover .features-content-three p,
.features-item-three:hover .features-content-three .title {
  color: var(--tg-white);
}
.features-content-three .link-btn {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  font-size: 14px;
  letter-spacing: 0.02em;
  color: var(--tg-paragraph-color);
}
.features-content-three .link-btn img {
  margin-left: 10px;
  transition: 0.3s;
}
.features-item-three:hover .features-content-three .link-btn {
  color: var(--tg-white);
}
.features-item-three:hover .features-content-three .link-btn img {
  filter: brightness(0) invert(1);
}
.features-item-wrap-two
  .row
  [class*="col-"]:nth-child(even)
  .features-item-three {
  margin-top: 20px;
}

/* features-four */
.features-item-wrap-four {
  background: var(--tg-white);
  box-shadow: 0px 4px 50px rgba(233, 233, 243, 0.5);
  border-radius: 10px;
  padding: 65px 50px 30px;
  margin-top: -90px;
  position: relative;
  z-index: 1;
}
.features-item-four {
  display: flex;
  align-items: center;
  margin-bottom: 30px;
}
.features-icon-four {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 auto;
  margin-right: 20px;
  color: var(--tg-primary-color);
  font-size: 40px;
  position: relative;
  line-height: 0;
  border-radius: 14px;
  background: var(--tg-lavender);
}
.features-icon-four::before {
  content: "";
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 16px;
  background: var(--tg-primary-color);
  border-radius: 2px;
}
.features-icon-four i {
  transition: 0.3s linear;
  transform: rotateY(0);
}
.features-item-four:hover .features-icon-four i {
  transform: rotateY(180deg);
}
.features-content-four .title {
  font-weight: 700;
  font-size: 20px;
  margin-bottom: 10px;
}
.features-content-four p {
  margin-bottom: 0;
  color: var(--tg-paragraph-color);
}

/* features-five */
.features-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_9___});
  background-size: cover;
  background-position: center;
  padding: 120px 0 80px;
  z-index: 1;
  position: relative;
  overflow: hidden;
}
.features-shape-wrap img {
  position: absolute;
  z-index: -1;
}
.features-shape-wrap img:nth-child(1) {
  right: 9%;
  top: 10%;
  animation: float-bob-x 4s infinite linear;
}
.features-shape-wrap img:nth-child(2) {
  left: 8%;
  bottom: 10%;
  animation: animationFramesOne 18s linear infinite;
}

/* features-six */
.features-item-wrap-six {
  margin-top: 0;
  border: 1px solid #e7eaf1;
  z-index: 3;
  position: relative;
}

/* features-seven */
.features-area-seven {
  background: var(--tg-section-background);
  padding: 230px 0 120px;
  margin-top: -110px;
  position: relative;
  z-index: 1;
}
.features-area-seven::before {
  content: "";
  position: absolute;
  left: 40%;
  bottom: 70px;
  width: 390px;
  height: 390px;
  background: #ff6ae7;
  opacity: 0.1;
  filter: blur(75px);
  z-index: -1;
}
.features-content-seven {
  width: 90%;
}
.features-content-seven p {
  margin-bottom: 0;
}
.features-progress-wrap {
  width: 90%;
}
.inner-features-shape {
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}

/*=============================
	12. Choose
===============================*/
.choose-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  background-size: cover;
  background-position: center;
  padding: 120px 0;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.choose-bg::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #001641;
  opacity: 0.8;
  z-index: -1;
}
.choose-shape {
  z-index: -1;
  position: absolute;
  left: 0;
  bottom: 0;
}
.section-title-two.white-title .title {
  color: var(--tg-white);
}
.choose-content {
  width: 90%;
}
.choose-content p {
  margin-bottom: 40px;
  color: #d0d0dd;
}
.choose-content .play-btn {
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  font-size: 18px;
  color: var(--tg-white);
  font-family: var(--tg-heading-font-family);
}
.choose-content .play-btn:hover {
  color: var(--tg-primary-color);
}
.choose-content .play-btn i {
  width: 82px;
  height: 82px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  border-radius: 50%;
  font-size: 20px;
  margin-right: 35px;
  position: relative;
}
.choose-content .play-btn i::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  border: 1px solid var(--tg-white);
  border-radius: 50%;
  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
  animation: pulse-border 1500ms ease-out infinite;
}
.skill-wrap {
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  padding: 70px 60px;
  background: var(--tg-white);
  margin-left: 100px;
}
.skill-wrap .section-title-two .title {
  font-size: 36px;
}
.skill-wrap > p {
  margin-bottom: 25px;
  color: var(--tg-paragraph-color);
}
.progress-wrap {
  overflow: hidden;
  padding-top: 5px;
}
.progress-item {
  margin-bottom: 25px;
}
.progress-item:last-child {
  margin-bottom: 0;
}
.progress-item .title {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 10px;
  color: var(--tg-paragraph-color);
}
.progress-item .progress {
  height: 8px;
  background-color: var(--tg-lavender);
  border-radius: 8px;
  overflow: inherit;
}
.progress-item .progress-bar {
  background-color: var(--tg-primary-color);
  position: relative;
  overflow: inherit;
  border-radius: 8px;
}
.progress-item .progress-bar span {
  display: block;
  position: absolute;
  right: 3px;
  bottom: 20px;
  color: var(--tg-white);
  line-height: 1;
  font-family: var(--tg-heading-font-family);
  font-weight: 700;
  font-size: 11px;
  border-radius: 2px;
  background: var(--tg-primary-color);
  padding: 4px 7px;
}
.progress-item .progress-bar span::before {
  content: "";
  position: absolute;
  right: 0;
  bottom: -5px;
  width: 8px;
  height: 8px;
  background: var(--tg-primary-color);
  clip-path: polygon(100% 0, 0 0, 100% 100%);
}

/* choose-two */
.choose-area-two {
  background: #001641;
  padding: 120px 0 205px;
  position: relative;
  z-index: 1;
}
.choose-img-two {
  position: relative;
  z-index: 1;
}
.choose-img-two img:nth-child(2) {
  position: absolute;
  right: 18%;
  top: 10%;
  z-index: -1;
}
.choose-img-two img:nth-child(3) {
  position: absolute;
  right: 14%;
  top: 19%;
  z-index: -2;
}
.choose-content-two {
  width: 90%;
}
.choose-content-two > p {
  color: #d0d0dd;
  margin-bottom: 30px;
  width: 90%;
}
.choose-circle-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
}
.circle-item {
  position: relative;
  width: 160px;
}
.circle-content {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  padding: 20px;
}
.circle-content .percentage {
  display: block;
  font-weight: 800;
  font-size: 36px;
  line-height: 1;
  font-family: var(--tg-heading-font-family);
  color: var(--tg-white);
  margin-bottom: 5px;
}
.circle-content p {
  margin-bottom: 0;
  font-weight: 500;
  font-size: 15px;
  color: var(--tg-white);
  line-height: 1.2;
}

/* choose-three */
.choose-area-three {
  background: var(--tg-secondary-color);
  position: relative;
  padding: 120px 0;
  overflow: hidden;
}
.choose-content-three {
  margin-right: 65px;
}
.choose-content-three > p {
  margin-bottom: 35px;
  color: var(--tg-lavender);
}
.accordion-wrap-two .accordion-item {
  border-radius: 5px;
  background: var(--tg-primary-color);
  border: none;
  margin-bottom: 10px;
  overflow: hidden;
}
.accordion-wrap-two .accordion-item:last-child {
  margin-bottom: 0;
}
.accordion-wrap-two .accordion-item:first-of-type {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.accordion-wrap-two .accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.accordion-wrap-two .accordion-item:last-of-type .accordion-button.collapsed {
  border-bottom-right-radius: 5px;
  border-bottom-left-radius: 5px;
}
.accordion-wrap-two .accordion-button {
  padding: 16px 60px 16px 22px;
  font-weight: 600;
  font-size: 20px;
  color: var(--tg-white);
  background: #052462;
  position: relative;
}
.accordion-wrap-two .accordion-button:focus {
  box-shadow: none;
}
.accordion-wrap-two .accordion-button:not(.collapsed) {
  color: var(--tg-white);
  background-color: #1a66ff;
  box-shadow: none;
}
.accordion-wrap-two .accordion-button::after {
  content: "\\f102";
  width: auto;
  height: auto;
  background-image: none;
  font-family: "flaticon";
  font-size: 16px;
  position: absolute;
  right: 25px;
  top: 18px;
  color: var(--tg-primary-color);
}
.accordion-wrap-two .accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: rotate(-180deg);
  color: var(--tg-white);
}
.accordion-wrap-two .accordion-body {
  padding: 20px 40px 30px 22px;
}
.accordion-wrap-two .accordion-body p {
  margin-bottom: 0;
  color: var(--tg-white);
}
.choose-img-three {
  position: absolute;
  width: 50%;
  height: 100%;
  top: 0;
  right: 0;
}
.choose-img-three img {
  width: 100%;
  object-fit: cover;
  height: 100%;
}

/*=============================
	13. Services
===============================*/
.section-title.white-title .sub-title {
  color: var(--tg-lavender);
}
.section-title.text-center .sub-title::before {
  left: 50%;
  transform: translateX(-50%);
}
.section-title.white-title .title {
  color: var(--tg-white);
}
.section-title p {
  margin-bottom: 0;
  margin-top: 16px;
  color: var(--tg-gray-four);
}
.section-title.white-title p {
  color: var(--tg-lavender);
}
.services-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_11___});
  background-size: cover;
  background-position: center;
  padding: 120px 0;
}
.services-item {
  background: var(--tg-white);
  border-radius: 10px;
  padding: 25px 35px 35px;
  margin-bottom: 30px;
}
.services-content .content-top {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.services-content .content-top .icon {
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--tg-lavender);
  font-size: 30px;
  color: var(--tg-primary-color);
  line-height: 0;
  margin-right: 15px;
  transition: 0.3s ease-in;
}
.services-item:hover .services-content .content-top .icon {
  background: var(--tg-primary-color);
  color: var(--tg-white);
}
.services-content .content-top .title {
  margin-bottom: 0;
  font-size: 24px;
}
.services-thumb {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  margin-bottom: 25px;
}
.services-thumb::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--tg-primary-color);
  opacity: 0;
  transition: 0.3s linear;
}
.services-item:hover .services-thumb::before {
  opacity: 0.8;
}
.services-thumb .btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: transparent;
  border-color: var(--tg-white);
  margin-top: -100px;
  opacity: 0;
  visibility: hidden;
  color: var(--tg-white);
}
.services-thumb .btn::before {
  background: var(--tg-white);
}
.services-thumb .btn::after {
  color: var(--tg-primary-color);
}
.services-thumb .btn:hover {
  color: var(--tg-primary-color);
}
.services-item:hover .services-thumb .btn {
  opacity: 1;
  visibility: visible;
  margin-top: 0;
}
.services-content .list-wrap li {
  text-transform: capitalize;
  color: var(--tg-paragraph-color);
  display: flex;
  align-items: center;
  margin-bottom: 5px;
}
.services-content .list-wrap li:last-child {
  margin-bottom: 0;
}
.services-content .list-wrap li::before {
  content: "";
  width: 6px;
  height: 6px;
  background: var(--tg-paragraph-color);
  border-radius: 50px;
  margin-right: 10px;
  flex: 0 0 auto;
}
.services-active [class*="col-"] {
  padding: 0 15px;
}
.services-active .slick-dots {
  display: flex;
  padding: 0;
  margin: 0;
  justify-content: center;
  gap: 10px;
  margin-top: 15px;
}
.services-active .slick-dots li {
  list-style: none;
  line-height: 0;
}
.services-active .slick-dots li button {
  text-indent: -9999999999px;
  padding: 0;
  border: 2px solid var(--tg-lavender);
  border-radius: 50%;
  width: 15px;
  height: 15px;
  background: transparent;
}
.services-active .slick-dots li.slick-active button {
  border-color: var(--tg-primary-color);
  background: var(--tg-primary-color);
}

/* services-two */
.services-bg-two {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_12___});
  background-size: cover;
  background-position: center;
  padding: 120px 0 90px;
}
.services-item-two {
  position: relative;
  margin-bottom: 30px;
  overflow: hidden;
}
.services-thumb-two {
  position: relative;
  border-radius: 8px;
  border: 7px solid var(--tg-white);
  box-shadow: 0px 10px 30px #ced2dd;
  overflow: hidden;
  z-index: 1;
}
.services-thumb-two::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    360deg,
    #00194c 11.66%,
    rgba(0, 25, 76, 0) 65.89%
  );
}
.services-thumb-two::after {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    360deg,
    rgb(0 25 76 / 55%) 52.77%,
    rgba(0, 25, 76, 0) 100%,
    #00194c 100%
  );
  transition: 0.3s linear;
  opacity: 0;
}
.services-item-two:hover .services-thumb-two::after {
  opacity: 1;
}
.services-thumb-two img {
  width: 100%;
}
.services-thumb-two .item-shape {
  position: absolute;
  right: 0;
  top: 0;
  margin-top: -50px;
  transition: 0.3s linear;
  opacity: 0;
}
.services-item-two:hover .services-thumb-two .item-shape {
  margin-top: 0;
  opacity: 1;
}
.services-content-two {
  position: absolute;
  left: 30px;
  right: 30px;
  bottom: -45px;
  z-index: 2;
  transition: all 0.3s linear;
}
.services-content-two .icon {
  width: 55px;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 36px;
  line-height: 0;
  background: rgb(255 255 255 / 20%);
  border-radius: 8px;
  color: var(--tg-white);
  margin-bottom: 15px;
  transition: 0.3s linear;
}
.services-item-two:hover .services-content-two .icon {
  background: var(--tg-primary-color);
}
.services-content-two .title {
  margin-bottom: 10px;
  font-size: 24px;
  color: var(--tg-white);
}
.services-content-two p {
  margin-bottom: 5px;
  color: var(--tg-lavender);
  opacity: 0;
  transition: opacity 0.3s linear;
}
.services-item-two:hover .services-content-two {
  bottom: 25px;
}
.services-item-two:hover .services-content-two p {
  opacity: 1;
}

/* services-three */
.services-area-three {
  background: var(--tg-section-background);
  position: relative;
  z-index: 1;
  padding: 120px 0 90px;
}
.services-item-three {
  position: relative;
  margin-bottom: 30px;
  overflow: hidden;
}
.services-thumb-three {
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}
.services-thumb-three img {
  transform: scale(1);
  transition: 0.3s ease-in-out;
  width: 100%;
}
.services-item-three:hover .services-thumb-three img {
  transform: scale(1.1);
}
.services-content-three {
  position: relative;
  background: var(--tg-white);
  border-radius: 0 0 10px 10px;
  padding: 60px 30px 50px;
}
.services-content-three .services-icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-primary-color);
  box-shadow: 0px 10px 15px rgba(0, 85, 255, 0.2);
  border-radius: 15px;
  color: var(--tg-white);
  font-size: 40px;
  line-height: 0;
  position: absolute;
  left: 30px;
  top: -35px;
}
.services-content-three .services-icon i {
  transition: 0.3s linear;
}
.services-item-three:hover .services-icon i {
  transform: rotateY(180deg);
}
.services-content-three .title {
  font-size: 22px;
  margin-bottom: 10px;
}
.services-content-three p {
  margin-bottom: 0;
}
.overlay-icon {
  position: absolute;
  font-size: 60px;
  right: 30px;
  bottom: -5px;
  line-height: 0;
  color: var(--tg-lavender);
}
.services-shape-four {
  top: 2%;
  position: absolute;
  right: 0;
  z-index: -1;
  opacity: 0.5;
}

/* services-four */
.services-area-four {
  padding: 120px 0 90px;
  position: relative;
  overflow: hidden;
}
.services-area-four::before {
  content: "";
  position: absolute;
  left: -30px;
  bottom: 8%;
  width: 390px;
  height: 390px;
  background: #e7f9ff;
  filter: blur(200px);
  z-index: -1;
}
.services-area-four::after {
  content: "";
  position: absolute;
  right: 80px;
  top: 12%;
  width: 350px;
  height: 350px;
  background: #f7e7ff;
  filter: blur(200px);
  z-index: -1;
}
.section-title-three .sub-title {
  font-size: 14px;
}
.section-title-three .title {
  font-size: 36px;
  font-weight: 800;
}
.section-title-three p {
  color: var(--tg-paragraph-color);
  width: 90%;
  margin: 12px auto 0;
}
.services-item-four {
  background: var(--tg-white);
  border: 1px solid #dde5f6;
  border-radius: 30px;
  text-align: center;
  padding: 55px 50px 65px;
  margin-bottom: 30px;
  transition: 0.3s linear;
}
.services-item-four:hover {
  filter: drop-shadow(0px 14px 200px #e1e5ed);
}
.services-icon-four {
  width: 100px;
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 35px;
  border-radius: 50%;
  line-height: 0;
  background: var(--tg-lavender);
  color: var(--tg-primary-color);
  font-size: 50px;
  transition: 0.3s linear;
}
.services-item-four:hover .services-icon-four {
  background: var(--tg-primary-color);
  color: var(--tg-white);
  box-shadow: 0px 10px 15px rgba(0, 85, 255, 0.2);
}
.services-content-four .title {
  font-weight: 800;
  font-size: 22px;
  margin-bottom: 15px;
}
.services-content-four p {
  margin-bottom: 25px;
}

/* services-five */
.inner-services-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_13___});
  background-size: cover;
  background-position: center;
  padding: 120px 0 90px;
}

/* services-six */
.services-area-six {
  background: var(--tg-section-background);
  padding: 120px 0 90px;
}

/* services-seven */
.services-area-seven {
  background: var(--tg-section-background);
}

/* services-details */
.services-details-area .row .col-71 {
  width: 71%;
  flex: 0 0 auto;
}
.services-details-area .row .col-29 {
  width: 29%;
  flex: 0 0 auto;
}
.services-details-thumb {
  margin-bottom: 20px;
}
.services-details-thumb img {
  border-radius: 10px;
  width: 100%;
}
.services-details-content .title {
  font-weight: 800;
  font-size: 36px;
  text-transform: capitalize;
  margin-bottom: 20px;
}
.services-details-content > p {
  margin-bottom: 15px;
}
.sd-inner-wrap {
  margin-top: 30px;
  margin-bottom: 25px;
}
.sd-inner-wrap .row .col-56 {
  width: 56.5%;
  flex: 0 0 auto;
}
.sd-inner-wrap .row .col-44 {
  width: 43.5%;
  flex: 0 0 auto;
}
.services-details-content .title-two {
  font-size: 30px;
  margin-bottom: 15px;
  text-transform: capitalize;
}
.sd-inner-wrap .content p {
  margin-bottom: 30px;
}
.sd-inner-wrap .content .list-wrap {
  display: flex;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 15px 0;
}
.sd-inner-wrap .content .list-wrap li {
  display: flex;
  align-items: flex-start;
  line-height: 1.3;
  font-weight: 600;
  font-size: 18px;
  font-family: var(--tg-heading-font-family);
  width: 50%;
}
.sd-inner-wrap .content .list-wrap li img {
  margin-right: 10px;
}
.sd-inner-wrap .thumb {
  position: relative;
}
.sd-inner-wrap .thumb img {
  width: 100%;
  border-radius: 10px;
}
.sd-inner-wrap .thumb .play-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-white);
  border-radius: 50%;
}
.sd-inner-wrap .thumb .play-btn::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  border: 1px solid var(--tg-white);
  border-radius: 50%;
  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
  animation: pulse-border 1500ms ease-out infinite;
}
.company-benefit-wrap {
  margin-top: 40px;
}
.company-benefit-wrap p {
  margin-bottom: 25px;
}
.accordion-wrap-three .accordion-item {
  background-color: transparent;
  border: none;
  border-radius: 4px;
  overflow: hidden;
  margin-bottom: 10px;
}
.accordion-wrap-three .accordion-item:last-child {
  margin-bottom: 0;
}
.accordion-wrap-three .accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.accordion-wrap-three .accordion-button {
  position: relative;
  padding: 16px 50px 16px 25px;
  font-weight: 600;
  font-size: 20px;
  color: var(--tg-secondary-color);
  text-align: left;
  background-color: var(--tg-gray-two);
  font-family: var(--tg-heading-font-family);
  border: none;
}
.accordion-wrap-three .accordion-button:not(.collapsed) {
  color: var(--tg-white);
  background: var(--tg-primary-color);
}
.accordion-wrap-three .accordion-button::after {
  content: "\\f102";
  width: auto;
  height: auto;
  background-image: none;
  font-family: "flaticon";
  font-size: 16px;
  position: absolute;
  right: 25px;
  top: 18px;
  color: var(--tg-primary-color);
}
.accordion-wrap-three .accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: rotate(-180deg);
  color: var(--tg-white);
}
.accordion-wrap-three .accordion-body {
  padding: 20px 40px 30px 30px;
  border: 1px solid #dfdfdf;
  border-top: none !important;
  border-radius: 0 0 4px 4px;
  margin-top: -1px;
}
.accordion-wrap-three .accordion-body p {
  margin-bottom: 0;
}
.accordion-wrap-three .accordion-button:focus {
  border-color: #dfdfdf;
  box-shadow: none;
}
.sd-inner-wrap-two {
  margin-top: 35px;
  margin-bottom: 50px;
}
.sd-inner-wrap-two .row .col-58 {
  width: 58.4%;
  flex: 0 0 auto;
}
.sd-inner-wrap-two .row .col-42 {
  width: 41.6%;
  flex: 0 0 auto;
}
.sd-inner-wrap-two .thumb img {
  border-radius: 10px;
}
.services-details-list .list-wrap li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 40px;
}
.services-details-list .list-wrap li:last-child {
  margin-bottom: 0;
}
.services-details-list .list-wrap li .icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-lavender);
  color: var(--tg-primary-color);
  border-radius: 14px;
  position: relative;
  font-size: 40px;
  line-height: 0;
  flex: 0 0 auto;
  margin-right: 20px;
}
.services-details-list .list-wrap li .icon::before {
  content: "";
  position: absolute;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
  width: 16px;
  height: 3px;
  background: var(--tg-primary-color);
  border-radius: 3px;
}
.services-details-list .list-wrap li .content .title {
  margin-bottom: 8px;
  font-size: 20px;
  text-transform: capitalize;
}
.services-details-list .list-wrap li .content p {
  margin-bottom: 0;
}
.industrial-working-wrap p {
  margin-bottom: 25px;
}
.industrial-working-wrap .info-two {
  margin-bottom: 0;
}
.industrial-working-wrap img {
  border-radius: 10px;
  margin-bottom: 25px;
}
.services-details-list-two {
  margin-right: 15px;
}
.services-details-list-two .list-wrap li {
  border: 1px solid #dadfee;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  padding: 25px 30px;
  background: var(--tg-white);
  margin-bottom: 20px;
}
.services-details-list-two .list-wrap li:last-child {
  margin-bottom: 0;
}
.services-details-list-two .list-wrap li .icon {
  font-size: 35px;
  line-height: 0;
  color: var(--tg-primary-color);
  flex: 0 0 auto;
  margin-right: 10px;
  line-height: 0;
}
.services-details-list-two .list-wrap li .content .title {
  font-size: 22px;
  margin-bottom: 10px;
}
.services-details-list-two .list-wrap li .content p {
  margin-bottom: 0;
}
.sd-inner-wrap-three .col-43 {
  width: 43%;
  flex: 0 0 auto;
}
.sd-inner-wrap-three .col-57 {
  width: 57%;
  flex: 0 0 auto;
}
.sd-inner-wrap-three {
  margin-bottom: 50px;
  margin-top: 40px;
}
.sd-inner-wrap-four .row .col-55 {
  width: 55%;
  flex: 0 0 auto;
}
.sd-inner-wrap-four .row .col-45 {
  width: 45%;
  flex: 0 0 auto;
}
.sd-inner-wrap-four .thumb img {
  border-radius: 10px;
}
.sd-inner-wrap-four .content .list-wrap li {
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  font-size: 18px;
  line-height: 1.3;
  text-transform: capitalize;
  font-family: var(--tg-heading-font-family);
  margin-bottom: 15px;
}
.sd-inner-wrap-four .content .list-wrap li:last-child {
  margin-bottom: 0;
}
.sd-inner-wrap-four .content .list-wrap li img {
  margin-right: 10px;
}
.sd-inner-wrap-four {
  margin-bottom: 40px;
}
.services-details-list-three .list-wrap {
  display: flex;
  align-items: center;
  gap: 25px;
}
.services-details-list-three .list-wrap li {
  display: flex;
  align-items: flex-start;
  border: 1px solid #dadfee;
  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  background: var(--tg-white);
  padding: 25px 30px;
}
.services-details-list-three .list-wrap li .icon {
  font-size: 50px;
  line-height: 0;
  color: var(--tg-primary-color);
  margin-right: 15px;
}
.services-details-list-three .list-wrap li .content .title {
  font-size: 22px;
  margin-bottom: 10px;
}
.services-details-list-three .list-wrap li .content p {
  margin-bottom: 0;
}
.services-details-list-three {
  margin-bottom: 30px;
}
.services-details-thumb-two {
  margin-bottom: 20px;
  margin-top: 25px;
}
.services-details-thumb-two img {
  border-radius: 10px;
}
.speed-optimized-wrap {
  margin-top: 50px;
  margin-bottom: 45px;
}
.speed-optimized-wrap p {
  margin-bottom: 0;
}
.sd-inner-wrap-five .row .col-50 {
  width: 50%;
  flex: 0 0 auto;
}
.sd-inner-wrap-five .left-side-content {
  margin-right: 30px;
}
.sd-inner-wrap-five .left-side-content p {
  margin-bottom: 0;
}
.sd-inner-wrap-five .right-side-content p {
  margin-bottom: 15px;
}
.sd-inner-wrap-five .right-side-content .list-wrap li {
  display: flex;
  align-items: flex-start;
  line-height: 1.3;
  font-weight: 600;
  font-size: 18px;
  color: var(--tg-secondary-color);
  font-family: var(--tg-heading-font-family);
  margin-bottom: 15px;
}
.sd-inner-wrap-five .right-side-content .list-wrap li:last-child {
  margin-bottom: 0;
}
.sd-inner-wrap-five .right-side-content .list-wrap li img {
  margin-right: 10px;
}

/* services-sidebar */
.services-sidebar {
  padding-right: 20px;
}
.services-cat-list .list-wrap li {
  margin-bottom: 10px;
}
.services-cat-list .list-wrap li:last-child {
  margin-bottom: 0;
}
.services-cat-list .list-wrap li a {
  border: 1px solid #e0e6f2;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 22px;
  background: var(--tg-white);
  font-weight: 600;
  font-size: 18px;
  font-family: var(--tg-heading-font-family);
  color: var(--tg-secondary-color);
  text-transform: capitalize;
}
.services-cat-list .list-wrap li a i {
  margin-left: 10px;
  font-size: 22px;
  line-height: 0;
  color: var(--tg-gray-four);
  transition: all 0.3s ease-out 0s;
}
.services-cat-list .list-wrap li.active a,
.services-cat-list .list-wrap li a:hover {
  background: var(--tg-primary-color);
  color: var(--tg-white);
  border-color: var(--tg-primary-color);
}
.services-cat-list .list-wrap li.active a i,
.services-cat-list .list-wrap li a:hover i {
  color: var(--tg-white);
}
.services-widget {
  background: var(--tg-section-background);
  border-radius: 10px;
  padding: 30px 30px 35px;
  margin-bottom: 30px;
}
.services-widget:last-child {
  margin-bottom: 0;
}
.services-widget .sw-title {
  margin-bottom: 15px;
  position: relative;
  font-size: 24px;
  text-transform: capitalize;
  padding-bottom: 10px;
}
.services-widget .sw-title::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  background: var(--tg-primary-color);
  border-radius: 4px;
}
.services-brochure-wrap p {
  margin-bottom: 15px;
}
.services-brochure-wrap .download-btn {
  display: flex;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  color: var(--tg-secondary-color);
  border: 1px solid #e0e6f2;
  border-radius: 5px;
  background: var(--tg-white);
  padding: 13px 20px;
  margin-bottom: 10px;
}
.services-brochure-wrap .download-btn i {
  font-size: 16px;
  color: var(--tg-primary-color);
  margin-right: 10px;
  transition: all 0.3s ease-out 0s;
}
.services-brochure-wrap .download-btn:hover {
  color: var(--tg-white);
  background: var(--tg-primary-color);
  border-color: var(--tg-primary-color);
}
.services-brochure-wrap .download-btn:hover i {
  color: var(--tg-white);
}
.services-brochure-wrap .download-btn:last-child {
  margin-bottom: 0;
}
.services-widget-form .form-grp {
  margin-bottom: 10px;
}
.services-widget-form .form-grp textarea,
.services-widget-form .form-grp input {
  width: 100%;
  border: 1px solid #e0e6f2;
  border-radius: 5px;
  background: var(--tg-white);
  padding: 13px 16px;
  font-weight: 500;
  font-size: 14px;
  color: var(--tg-paragraph-color);
  height: 50px;
  display: block;
}
.services-widget-form .form-grp textarea::placeholder,
.services-widget-form .form-grp input::placeholder {
  font-weight: 500;
  font-size: 14px;
  color: var(--tg-gray-four);
}
.services-widget-form .form-grp textarea {
  min-height: 120px;
  max-height: 120px;
}
.submit-btn {
  border: none;
  background: var(--tg-primary-color);
  width: 100%;
  font-weight: 700;
  font-size: 16px;
  color: var(--tg-white);
  text-transform: capitalize;
  border-radius: 5px;
  padding: 13px 20px;
  height: 50px;
}
.submit-btn:hover {
  background: var(--tg-secondary-color);
}
.services-sidebar-contact {
  background: var(--tg-paragraph-color);
  text-align: center;
}
.services-sidebar-contact .title {
  margin-bottom: 30px;
  color: var(--tg-white);
  font-size: 22px;
}
.services-sidebar-contact a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-primary-color);
  border-radius: 6px;
  color: var(--tg-white);
  font-weight: 600;
  font-size: 18px;
  padding: 9px 22px;
}
.services-sidebar-contact a i {
  line-height: 0;
  margin-right: 5px;
}
.services-sidebar-contact a:hover {
  background: var(--tg-secondary-color);
}
.services-cat-list-two .list-wrap li a {
  position: relative;
  z-index: 1;
  background: #f8f8fa;
}
.services-cat-list-two .list-wrap li a::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 30px;
  border-radius: 3px;
  background: var(--tg-primary-color);
  z-index: -1;
}

/*=============================
	14. Cta
===============================*/
.cta-area {
  margin-top: -105px;
}
.cta-inner-wrap-two,
.cta-inner-wrap {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_14___});
  background-size: cover;
  background-position: center;
  padding: 70px;
  border-radius: 10px;
}
.cta-inner-wrap-two {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_15___});
}
.cta-content {
  display: flex;
  align-items: center;
}
.cta-info-wrap {
  display: flex;
  align-items: center;
  width: 46%;
  flex: 0 0 auto;
  position: relative;
}
.cta-info-wrap::before {
  content: "";
  position: absolute;
  right: 50px;
  top: 50%;
  transform: translateY(-50%);
  width: 3px;
  height: 74px;
  background: var(--tg-primary-color);
}
.cta-info-wrap .icon {
  font-size: 50px;
  color: var(--tg-white);
  line-height: 0;
  margin-right: 15px;
}
.cta-info-wrap .content span {
  display: block;
  font-weight: 600;
  font-size: 18px;
  font-family: var(--tg-heading-font-family);
  color: var(--tg-white);
  line-height: 1;
  margin-bottom: 10px;
}
.cta-info-wrap .content a {
  font-weight: 700;
  font-size: 30px;
  display: inline-block;
  line-height: 1;
  color: var(--tg-white);
  font-family: var(--tg-heading-font-family);
}
.cta-info-wrap .content a:hover {
  color: var(--tg-primary-color);
}
.cta-content .title {
  font-weight: 800;
  font-size: 30px;
  margin-bottom: 0;
  color: var(--tg-white);
  line-height: 1.13;
}

/* cta-two */
.cta-inner-wrap-two .cta-info-wrap::before {
  background: var(--tg-white);
}
.cta-inner-wrap-two .cta-info-wrap a:hover {
  color: var(--tg-secondary-color);
}
.cta-inner-wrap-two .cta-btn .btn {
  border: 2px solid var(--tg-white);
  background: transparent;
  padding: 16px 30px;
}
.cta-inner-wrap-two .cta-btn .btn:hover {
  background: var(--tg-blue);
  border-color: var(--tg-blue);
}

/* cta-three */
.cta-area-three {
  background: #f8f8fa;
}
.cta-inner-wrap-three {
  margin-top: -85px;
  position: relative;
  z-index: 1;
}
.cta-info-wrap.cta-info-wrap-two .icon {
  width: 70px;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0px 24px 50px rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  background: var(--tg-white);
  font-size: 35px;
  color: var(--tg-primary-color);
  line-height: 0;
  margin-right: 15px;
}
.cta-info-wrap.cta-info-wrap-two .content a {
  font-size: 24px;
}
.cta-info-wrap.cta-info-wrap-two::before {
  display: none;
}
.cta-inner-wrap-three {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  background-size: cover;
  background-position: center;
  padding: 50px 45px;
  border-radius: 10px;
}
.cta-inner-wrap-three .btn-three {
  background: var(--tg-white);
  color: var(--tg-primary-color);
}
.cta-inner-wrap-three .btn-three::after {
  filter: unset;
}
.cta-inner-wrap-three .btn-three:hover {
  background: var(--tg-secondary-color);
  color: var(--tg-white);
}
.cta-inner-wrap-three .btn-three:hover::after {
  filter: brightness(0) invert(1);
}

.cta-area-four {
  margin-top: -100px;
}
.cta-area-five {
  position: relative;
  z-index: 3;
}

/*=============================
	15. Counter
===============================*/
.counter-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_17___});
  background-size: cover;
  background-position: center;
  padding: 120px 0 90px;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.counter-item {
  text-align: center;
  margin-bottom: 30px;
}
.counter-item .count {
  margin-bottom: 5px;
  font-weight: 800;
  font-size: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0.8;
}
.counter-item p {
  margin-bottom: 0;
}
.counter-shape-wrap img {
  position: absolute;
  z-index: -1;
}
.counter-shape-wrap img:nth-child(1) {
  left: 10%;
  top: 25%;
  animation: animationFramesOne 15s linear infinite;
}
.counter-shape-wrap img:nth-child(2) {
  right: 10%;
  top: 45%;
  animation: animationFramesOne 20s linear infinite;
}
@keyframes animationFramesOne {
  0% {
    transform: translate(0px, 0px) rotate(0deg);
  }
  20% {
    transform: translate(73px, -1px) rotate(36deg);
  }
  40% {
    transform: translate(141px, 72px) rotate(72deg);
  }
  60% {
    transform: translate(83px, 122px) rotate(108deg);
  }
  80% {
    transform: translate(-40px, 72px) rotate(144deg);
  }
  100% {
    transform: translate(0px, 0px) rotate(0deg);
  }
}
.animationFramesOne {
  animation: animationFramesOne 12s linear infinite;
}

/* counter-two */
.counter-area-two {
  background: #f8f8fa;
  padding: 75px 0 45px;
}
.counter-item-two {
  text-align: center;
  position: relative;
  margin-bottom: 30px;
}
.counter-item-two::before {
  content: "";
  position: absolute;
  right: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 1px;
  height: 95px;
  background: #d5ddec;
}
.counter-item-wrap .row [class*="col-"]:last-child .counter-item-two::before {
  display: none;
}
.counter-item-two .count {
  font-weight: 800;
  font-size: 60px;
  display: inline-flex;
  align-items: center;
  line-height: 0.8;
  margin-bottom: 5px;
  justify-content: center;
  position: relative;
  z-index: 1;
}
.counter-item-two .count::before {
  content: "";
  position: absolute;
  left: -24px;
  top: -18px;
  width: 50px;
  height: 50px;
  background: #dce7ff;
  border-radius: 50%;
  z-index: -1;
}
.counter-item-two p {
  margin-bottom: 0;
}

/* counter-three */
.counter-item-three {
  border: 1.2px solid #d4dced;
  border-radius: 10px;
  display: flex;
  align-items: center;
  padding: 28px 30px;
  margin-bottom: 30px;
  transform: translateY(0);
  transition: 0.3s linear;
}
.counter-item-three:hover {
  transform: translateY(-5px);
}
.counter-icon {
  font-size: 60px;
  line-height: 0;
  position: relative;
  color: var(--tg-primary-color);
  margin-right: 40px;
}
.counter-icon::before {
  content: "";
  position: absolute;
  left: -14px;
  top: -15px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: var(--tg-lavender);
  z-index: -1;
  transition: 0.3s linear;
}
.counter-icon::after {
  content: "";
  position: absolute;
  right: -20px;
  top: 50%;
  transform: translateY(-50%);
  width: 2px;
  height: 38px;
  background: var(--tg-lavender);
}
.counter-item-three:hover .counter-icon::before {
  left: 0;
  top: 0;
}
.counter-content .count {
  font-size: 36px;
  margin-bottom: 10px;
  line-height: 0.8;
  display: flex;
  align-items: center;
}
.counter-content p {
  margin-bottom: 0;
  line-height: 1.2;
  color: var(--tg-gray-four);
}

/* counter-four */
.counter-area-four {
  background: var(--tg-section-background);
  position: relative;
  padding: 220px 0 120px;
  overflow: hidden;
  z-index: 1;
  margin-top: -100px;
}
.counter-area-four::before {
  content: "";
  position: absolute;
  right: 38%;
  bottom: 60px;
  width: 390px;
  height: 390px;
  background: #5e3de3;
  opacity: 0.07;
  filter: blur(75px);
  z-index: -1;
}
.counter-content-four {
  width: 90%;
}
.counter-content-four p {
  margin-bottom: 0;
}
.counter-item-wrap-four .list-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin: 0 -12px;
  gap: 24px 0;
}
.counter-item-wrap-four .list-wrap li {
  padding: 0 12px;
  width: 50%;
}
.counter-item-wrap-four .list-wrap li .counter-item-three {
  background: var(--tg-white);
  margin-bottom: 0;
}
.inner-counter-shape {
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}

/*=============================
	16. Estimate
===============================*/
.estimate-area {
  background: #f8f8fa;
  padding: 120px 0 0;
  position: relative;
  z-index: 1;
}
.estimate-content {
  padding: 0 40px 0 80px;
}
.estimate-tab-wrap .nav-tabs {
  border-bottom: none;
  gap: 5px;
  margin-bottom: 20px;
}
.estimate-tab-wrap .nav-tabs .nav-link {
  margin-bottom: 0;
  background: var(--tg-gray-four);
  border: none;
  border-radius: 6px;
  font-size: 16px;
  font-weight: 600;
  color: var(--tg-white);
  padding: 7px 20px;
}
.estimate-tab-wrap .nav-tabs .nav-link.active {
  background: var(--tg-primary-color);
}
.estimate-form-wrap .form-grp {
  margin-bottom: 10px;
}
.estimate-form-wrap .form-grp input {
  border: 1px solid #d0d6e1;
  border-radius: 5px;
  width: 100%;
  padding: 15px 20px;
  font-weight: 500;
  font-size: 14px;
  color: var(--tg-secondary-color);
  height: 50px;
  background: var(--tg-white);
}
.estimate-form-wrap .form-grp input::placeholder {
  font-weight: 500;
  font-size: 14px;
  color: var(--tg-gray-four);
}
.range-slider-wrap {
  margin-bottom: 30px;
}
.range-slider-wrap .content-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-top: 20px;
  margin-bottom: 15px;
}
.range-slider-wrap .content-top p {
  font-weight: 600;
  font-size: 16px;
  margin-bottom: 0;
}
.range-slider-wrap .content-top span {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: var(--tg-secondary-color);
}
.range-slider-wrap .content-top span strong {
  font-weight: 600;
  font-size: 16px;
}
.range-slider-wrap input {
  width: 100%;
  height: 15px;
  appearance: none;
  -webkit-appearance: none;
  background: #d9d9d9;
  outline: none;
  border-radius: 10px;
  overflow: hidden;
}
.range-slider-wrap .range::-webkit-slider-thumb {
  -webkit-appearance: none;
  width: 15px;
  height: 15px;
  border-radius: 50%;
  background: var(--tg-primary-color);
  cursor: pointer;
  border: none;
  box-shadow: -807px 0 0 800px #6699ff;
}
.estimate-form-wrap .btn.btn-three::after {
  display: none;
}
.estimate-shape {
  position: absolute;
  z-index: -1;
  top: 0;
  right: 0;
}

/*=============================
	17. Project
===============================*/
.project-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_18___});
  background-size: cover;
  background-position: center;
  padding: 120px 0 90px;
  overflow: hidden;
}
.project-top-content {
  margin-left: 40px;
  margin-bottom: 50px;
}
.project-top-content p {
  margin-bottom: 0;
  color: var(--tg-paragraph-color);
}
.project-item {
  margin-bottom: 30px;
}
.project-thumb {
  border-radius: 10px;
  overflow: hidden;
}
.project-thumb img {
  filter: grayscale(0);
}
.project-item:hover .project-thumb img {
  filter: grayscale(100%);
}
.project-content {
  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);
  border-radius: 9px;
  margin: -85px 18px 0;
  padding: 22px 80px 22px 30px;
  position: relative;
  overflow: hidden;
  background: var(--tg-white);
}
.project-content .tag {
  font-weight: 500;
  font-size: 15px;
  display: inline-block;
  text-transform: capitalize;
  margin-bottom: 5px;
}
.project-content .tag:hover {
  color: var(--tg-secondary-color);
}
.project-content .title {
  font-size: 22px;
  margin-bottom: 0;
}
.project-content .link-arrow {
  width: 113px;
  height: 113px;
  display: block;
  border-radius: 50%;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  font-size: 22px;
  line-height: 0;
  padding: 24px 32px;
  position: absolute;
  right: -38px;
  bottom: -51px;
  transform: translateY(50px);
  opacity: 0;
  visibility: hidden;
}
.project-item:hover .project-content .link-arrow {
  transform: translateY(0);
  opacity: 1;
  visibility: visible;
}
.project-content .link-arrow:hover {
  background: var(--tg-secondary-color);
}
.swiper-container.project-active {
  overflow: hidden;
  margin-right: -422px;
}

/* project-two */
.project-bg-two {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_19___});
  background-size: cover;
  background-position: center;
  padding: 120px 0 200px;
}
.project-content-top {
  margin-bottom: 30px;
}
.project-content-top p {
  margin-bottom: 0;
  width: 90%;
  margin-left: auto;
}
.project-item-two {
  position: relative;
  margin-bottom: 30px;
}
.project-thumb-two img {
  border-radius: 10px;
  transition: 0.3s linear;
}
.project-item-two:hover .project-thumb-two img {
  filter: grayscale(100%);
}
.project-content-two {
  position: absolute;
  left: 10px;
  right: 10px;
  top: 10px;
  bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background: rgba(0 85 255 / 80%);
  border-radius: 10px;
  padding: 30px;
  transition: 0.3s linear;
  opacity: 0;
  transform: scale(0.8);
  visibility: hidden;
}
.project-item-two:hover .project-content-two {
  opacity: 1;
  transform: scale(1);
  visibility: visible;
}
.project-content-two .title {
  font-weight: 700;
  font-size: 30px;
  margin-bottom: 10px;
  color: var(--tg-white);
}
.project-content-two .title a:hover {
  color: var(--tg-white);
}
.project-content-two span {
  display: block;
  line-height: 1;
  color: var(--tg-white);
}
.project-content-two .link-btn {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--tg-white);
  color: var(--tg-secondary-color);
  font-size: 18px;
  position: absolute;
  right: 28px;
  bottom: 28px;
}
.project-content-two .link-btn:hover {
  background: var(--tg-secondary-color);
  color: var(--tg-white);
}

/* project-three */
.project-item-three {
  margin-bottom: 30px;
}
.project-thumb-three {
  overflow: hidden;
}
.project-thumb-three img {
  transform: scale(1);
  transition: 0.3s linear;
}
.project-item-three:hover .project-thumb-three img {
  transform: scale(1.1);
}

/* project-four */
.project-area-four {
  background: var(--tg-section-background);
  padding: 120px 0 190px;
}
.project-item-four {
  margin-bottom: 30px;
}
.project-thumb-four {
  position: relative;
  margin-bottom: 20px;
}
.project-thumb-four::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: var(--tg-primary-color);
  opacity: 0.9;
  opacity: 0;
  transition: 0.3s linear;
}
.project-thumb-four .project-link {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 50px;
  width: 50px;
  opacity: 0;
  visibility: hidden;
  line-height: 0;
}
.project-item-four:hover .project-thumb-four::before {
  opacity: 0.9;
}
.project-item-four:hover .project-thumb-four .project-link {
  opacity: 1;
  visibility: visible;
}
.project-content-four .title {
  font-size: 24px;
  margin-bottom: 5px;
}
.project-content-four span {
  font-weight: 400;
  display: block;
  line-height: 1;
  color: var(--tg-gray-four);
}

/* project-details */
.project-details-wrap .row .col-71 {
  width: 71%;
  flex: 0 0 auto;
}
.project-details-wrap .row .col-29 {
  width: 29%;
  flex: 0 0 auto;
}
.project-details-thumb {
  margin-bottom: 30px;
}
.project-details-thumb img {
  border-radius: 10px;
}
.project-details-info {
  border: 1px solid #e0e6f2;
  border-radius: 5px;
  padding: 25px 35px 28px;
  margin-bottom: 30px;
}
.project-details-info .title {
  font-size: 24px;
  position: relative;
  margin-bottom: 15px;
  padding-bottom: 12px;
}
.project-details-info .title::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  background: var(--tg-primary-color);
  border-radius: 4px;
}
.project-details-info > .list-wrap > li {
  font-weight: 500;
  font-size: 16px;
  color: var(--tg-gray-four);
  border-bottom: 1px solid #dfe3e7;
  display: flex;
  align-items: center;
  font-family: var(--tg-heading-font-family);
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.project-details-info > .list-wrap > li:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border: none;
}
.project-details-info > .list-wrap > li span {
  font-weight: 700;
  font-size: 18px;
  color: var(--tg-paragraph-color);
  width: 40%;
  flex: 0 0 auto;
}
.project-details-info > .list-wrap > li.social .list-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.project-details-info > .list-wrap > li.social .list-wrap li a {
  color: var(--tg-gray-four);
}
.project-details-info > .list-wrap > li.social .list-wrap li a:hover {
  color: var(--tg-primary-color);
}
.project-details-content .title {
  font-weight: 800;
  font-size: 36px;
  margin-bottom: 20px;
}
.project-details-content > p {
  margin-bottom: 15px;
}
.project-details-content .title-two {
  margin-bottom: 15px;
  font-size: 30px;
  text-transform: capitalize;
}
.pd-optimized-wrap {
  margin-top: 50px;
  margin-bottom: 60px;
}
.pd-optimized-wrap p {
  margin-bottom: 0;
}
.pd-inner-wrap .row .col-41 {
  width: 41.3%;
  flex: 0 0 auto;
}
.pd-inner-wrap .row .col-59 {
  width: 58.7%;
  flex: 0 0 auto;
}
.pd-inner-wrap .content {
  margin-right: 20px;
}
.pd-inner-wrap .content p {
  margin-bottom: 0;
}
.pd-inner-wrap .content .info-one {
  margin-bottom: 30px;
}
.pd-inner-wrap .content .list-wrap {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  gap: 18px 0;
  margin-bottom: 25px;
}
.pd-inner-wrap .content .list-wrap li {
  display: flex;
  align-items: flex-start;
  line-height: 1.3;
  font-weight: 600;
  font-size: 18px;
  font-family: var(--tg-heading-font-family);
  color: var(--tg-paragraph-color);
  width: 50%;
}
.pd-inner-wrap .content .list-wrap li img {
  margin-right: 10px;
}
.pd-inner-wrap .thumb {
  position: relative;
}
.pd-inner-wrap .thumb img {
  border-radius: 10px;
}
.pd-inner-wrap .thumb .play-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-white);
  border-radius: 50%;
}
.pd-inner-wrap .thumb .play-btn::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  border: 1px solid var(--tg-white);
  border-radius: 50%;
  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
  animation: pulse-border 1500ms ease-out infinite;
}

/*=============================
	18. Faq
===============================*/
.faq-area {
  position: relative;
  z-index: 1;
  padding: 0 0 120px;
}
.faq-bg-shape {
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
  width: 40.3%;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_20___});
  background-size: cover;
  background-position: center;
  z-index: -1;
}
.faq-shape-wrap img {
  position: absolute;
  z-index: -1;
}
.faq-shape-wrap img:nth-child(1) {
  right: 0;
  bottom: 0;
}
.faq-shape-wrap img:nth-child(2) {
  left: 14%;
  bottom: 12%;
  animation: alltuchtopdown 8s infinite linear;
}
.faq-img-wrap {
  text-align: right;
  position: relative;
  margin-right: 45px;
}
.faq-img-wrap img:nth-child(1) {
  box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
  border: 8px solid var(--tg-white);
}
.faq-img-wrap img:nth-child(2) {
  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  position: absolute;
  left: 0;
  bottom: 20%;
}
.faq-content > p {
  margin-bottom: 30px;
  width: 85%;
}
.faq-content .accordion-wrap {
  width: 90%;
}
.faq-content .accordion-item:first-of-type .accordion-button {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.faq-content .accordion-item {
  background-color: transparent;
  border: none;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 10px;
}
.faq-content .accordion-item:last-child {
  margin-bottom: 0;
}
.faq-content .accordion-button {
  position: relative;
  padding: 17px 50px 17px 30px;
  font-weight: 700;
  font-size: 18px;
  color: var(--tg-secondary-color);
  text-align: left;
  background-color: var(--tg-gray-two);
  font-family: var(--tg-heading-font-family);
  border: 1px solid #dfdfdf;
}
.faq-content .accordion-button.collapsed {
  border: transparent;
}
.faq-content .accordion-button:not(.collapsed) {
  color: var(--tg-primary-color);
  background-color: transparent;
  box-shadow: none;
}
.faq-content .accordion-button:focus {
  border-color: #dfdfdf;
  box-shadow: none;
}
.faq-content .accordion-body {
  padding: 20px 30px 30px;
  border: 1px solid #dfdfdf;
  border-top: none;
}
.faq-content .accordion-body p {
  margin-bottom: 0;
  color: var(--tg-gray-four);
}
.faq-content .accordion-button::after {
  content: "\\f102";
  width: auto;
  height: auto;
  background-image: none;
  font-family: "flaticon";
  font-size: 16px;
  position: absolute;
  right: 25px;
  top: 18px;
  color: var(--tg-primary-color);
}
.faq-content .accordion-button:not(.collapsed)::after {
  background-image: none;
  transform: rotate(-180deg);
}

/*=============================
	19. Request
===============================*/
.request-area.request-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_21___});
  background-position: center;
  background-size: cover;
  padding: 80px 0;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.request-content .title {
  font-size: 32px;
  margin-bottom: 0;
  color: var(--tg-white);
  font-weight: 800;
}
.request-content-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 20px;
}
.request-contact {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.1);
  border-radius: 30px;
  padding: 5px 22px;
}
.request-contact .icon {
  font-size: 30px;
  line-height: 0;
  color: var(--tg-white);
  margin-right: 10px;
}
.request-contact .content span {
  display: block;
  line-height: 1;
  font-size: 13px;
  color: var(--tg-white);
  margin-bottom: 2px;
}
.request-contact .content a {
  display: inline-block;
  font-size: 18px;
  font-weight: 600;
  font-family: var(--tg-heading-font-family);
  color: var(--tg-white);
  line-height: 1;
}
.request-contact .content a:hover {
  color: var(--tg-primary-color);
}
.request-shape {
  position: absolute;
  left: 6%;
  top: 10%;
  animation: animationFramesOne 15s linear infinite;
  z-index: -1;
}

/* request-two */
.request-area-two {
  background: var(--tg-secondary-color);
  padding: 120px 0;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.request-shape-wrap img {
  position: absolute;
  z-index: -1;
}
.request-shape-wrap img:nth-child(1) {
  left: 13%;
  top: 45%;
  animation: alltuchtopdown 8s infinite linear;
}
.request-shape-wrap img:nth-child(2) {
  right: 0;
  top: 0;
}
.request-content-two p {
  margin-bottom: 0;
  color: #d0d0dd;
  width: 90%;
}
.request-form-wrap .form-grp input {
  width: 100%;
  border: none;
  font-weight: 500;
  font-size: 13px;
  color: var(--tg-secondary-color);
  padding: 15px 20px;
  border-radius: 4px;
  background: var(--tg-white);
  height: 50px;
}
.request-form-wrap .form-grp input::placeholder {
  font-weight: 500;
  font-size: 13px;
  color: var(--tg-paragraph-color);
}
.request-form-wrap .row {
  gap: 15px 0;
  margin: 0 -7px;
}
.request-form-wrap .row [class*="col-"] {
  padding: 0 7px;
}
.request-form-wrap button {
  font-weight: 800;
  font-size: 16px;
  text-transform: uppercase;
  border: none;
  width: 100%;
  text-align: center;
  padding: 10px 20px;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  border-radius: 4px;
  height: 50px;
}
.request-form-wrap button:hover {
  background: var(--tg-white);
  color: var(--tg-primary-color);
}

/*=============================
	20. Team
===============================*/
.team-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  background-size: cover;
  background-position: center;
  padding: 120px 0 90px;
}
.team-item {
  border: 1px solid #dfe3ec;
  border-radius: 10px;
  background: var(--tg-white);
  margin-bottom: 30px;
  transition: 0.3s linear;
}
.team-item:hover {
  filter: drop-shadow(0px 14px 30px #dde1eb);
  border-color: var(--tg-white);
}
.team-thumb {
  position: relative;
}
.team-thumb img {
  border-radius: 8px 8px 180px;
}
.team-social .list-wrap {
  display: flex;
  flex-direction: column-reverse;
  position: absolute;
  border-radius: 0px 0px 50px 50px;
  background: var(--tg-paragraph-color);
  right: 17px;
  top: 0;
  padding: 16px 13px;
  transition: 0.3s linear;
}
.team-social .list-wrap li a {
  display: block;
  transform: rotate(-90deg);
  color: var(--tg-white);
  font-size: 16px;
}
.team-item:hover .team-social .list-wrap {
  background: var(--tg-primary-color);
}
.team-content {
  padding: 20px 25px 25px;
}
.team-content .title {
  font-weight: 600;
  font-size: 22px;
  margin-bottom: 3px;
}
.team-content span {
  font-size: 13px;
  display: block;
  position: relative;
  padding-bottom: 15px;
  color: var(--tg-gray-four);
}
.team-content span::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  border-radius: 4px;
  background: var(--tg-primary-color);
}

/* team-two */
.team-area-two {
  padding: 120px 0 90px;
  position: relative;
  overflow: hidden;
}
.team-shape {
  position: absolute;
  left: 0;
  top: 30%;
  z-index: -1;
}
.section-top-content p {
  margin-bottom: 0;
  width: 90%;
  margin-left: auto;
  color: var(--tg-paragraph-color);
}
.team-item-two {
  position: relative;
  margin-bottom: 30px;
  transition: 0.3s;
}
.team-item-two:hover {
  transform: translateY(-5px);
}
.team-thumb-two {
  position: relative;
}
.team-thumb-two img {
  border-radius: 10px;
}
.team-social-two .list-wrap {
  display: flex;
  flex-direction: column-reverse;
  background: #0045ce;
  position: absolute;
  left: 30px;
  bottom: 25px;
  border-radius: 50px;
  padding: 16px 13px;
}
.team-social-two .list-wrap li a {
  display: block;
  transform: rotate(-90deg);
  color: var(--tg-white);
  font-size: 16px;
  transition: 0.3s;
}
.team-social-two .list-wrap li a:hover {
  transform: rotate(0);
}
.team-content-two {
  position: absolute;
  left: 30px;
  top: 25px;
  right: 30px;
}
.team-content-two .title {
  font-size: 24px;
  margin-bottom: 5px;
  color: var(--tg-white);
}
.team-content-two .title a:hover {
  color: var(--tg-secondary-color);
}
.team-content-two span {
  font-weight: 500;
  font-size: 14px;
  display: block;
  color: var(--tg-lavender);
  position: relative;
}
.team-content-two span::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -10px;
  width: 30px;
  height: 4px;
  background: var(--tg-white);
  border-radius: 2px;
}

/* team-three */
.team-area-three {
  position: relative;
  padding: 120px 0 90px;
  overflow: hidden;
}
.team-area-three::before {
  content: "";
  position: absolute;
  left: 50px;
  bottom: 0;
  width: 600px;
  height: 600px;
  background: #ced0ff;
  opacity: 0.2;
  filter: blur(75px);
  z-index: -1;
}
.team-item-three {
  background: var(--tg-section-background);
  margin-bottom: 30px;
  border-radius: 10px;
  overflow: hidden;
}
.team-thumb-three {
  position: relative;
  z-index: 1;
  padding-top: 25px;
}
.team-thumb-three::before {
  content: "";
  position: absolute;
  width: 230px;
  height: 450px;
  background: var(--tg-lavender);
  right: -68px;
  bottom: -31px;
  z-index: -1;
  border-radius: 115px;
  transform: rotate(45deg);
  transition: 0.3s ease-in-out;
}
.team-item-three:hover .team-thumb-three::before {
  background: var(--tg-primary-color);
}
.team-content-three {
  padding: 20px 30px 25px;
}
.team-content-three .title {
  margin-bottom: 8px;
  font-size: 24px;
}
.team-content-three span {
  display: block;
  color: var(--tg-primary-color);
}
.team-social-three {
  position: absolute;
  left: 20px;
  top: 20px;
  background: var(--tg-lavender);
  border-radius: 30px;
  transition: all 0.3s;
}
.team-social-three .list-wrap {
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 5px;
  padding: 0 0 15px;
  /* display: none; */
  text-align: center;
  transition: all 0.3s;
}
.team-social-three .social-toggle-icon {
  width: 50px;
  height: 50px;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  color: var(--tg-primary-color);
  font-size: 20px;
  line-height: 0;
  cursor: pointer;
  transition: all 0.3s ease-out 0s;
}
.team-social-three .list-wrap a {
  font-size: 18px;
}
.team-social-three .list-wrap a:hover {
  color: var(--tg-secondary-color);
}

/* team-four */
.team-item-four {
  margin-bottom: 30px;
}
.team-thumb-four {
  position: relative;
  margin-bottom: 20px;
}
.team-thumb-four img {
  border-radius: 10px;
}
.team-content-four .title {
  font-size: 24px;
  margin-bottom: 5px;
}
.team-content-four span {
  display: block;
  font-weight: 500;
  font-size: 14px;
  color: var(--tg-primary-color);
}
.team-item-four .team-social-three {
  right: 20px;
  bottom: 20px;
  top: auto;
  left: auto;
  display: flex;
  flex-direction: column-reverse;
}
.team-item-four .team-social-three .list-wrap {
  padding: 15px 0 0;
}

/* team-five */
.team-item-five {
  border: 1px solid #d4dced;
  border-radius: 30px;
  text-align: center;
  margin-bottom: 30px;
  padding: 40px 40px 50px;
}
.team-thumb-five {
  margin-bottom: 20px;
}
.team-thumb-five img {
  border-radius: 50%;
}
.team-content-five .title {
  font-size: 22px;
  margin-bottom: 5px;
}
.team-content-five span {
  display: block;
  color: var(--tg-gray-four);
  position: relative;
  padding-bottom: 15px;
  margin-bottom: 15px;
}
.team-content-five span::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 0;
  width: 30px;
  height: 5px;
  border-radius: 5px;
  background: var(--tg-primary-color);
}
.team-social-four .list-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.team-social-four .list-wrap li a {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: var(--tg-lavender);
  font-size: 15px;
}
.team-social-four .list-wrap li a:hover {
  color: var(--tg-white);
  background: var(--tg-primary-color);
}

/* team-six */
.team-area-six {
  background: var(--tg-section-background);
  padding: 220px 0 90px;
  margin-top: -100px;
}

/* team-details */
.team-details-info-wrap {
  margin-right: 30px;
}
.team-details-thumb {
  margin-bottom: 30px;
}
.team-details-thumb img {
  border-radius: 10px;
}
.team-details-info .list-wrap {
  margin-bottom: 30px;
}
.team-details-info .list-wrap li {
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  font-size: 18px;
  font-family: var(--tg-heading-font-family);
  margin-bottom: 10px;
}
.team-details-info .list-wrap li:last-child {
  margin-bottom: 0;
}
.team-details-info .list-wrap li i {
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  line-height: 0;
  color: var(--tg-primary-color);
  font-size: 20px;
  background: var(--tg-lavender);
  transform: translateY(-4px);
  margin-right: 10px;
}
.td-info-bottom {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.td-info-bottom .share-btn {
  background: var(--tg-lavender);
  border-radius: 30px;
  text-transform: uppercase;
  padding: 13px 24px;
  display: block;
  height: 52px;
}
.td-info-bottom .share-btn img {
  margin-right: 10px;
  transition: all 0.3s ease-out 0s;
}
.td-info-bottom .share-btn:hover {
  background: var(--tg-primary-color);
  color: var(--tg-white);
}
.td-info-bottom .share-btn:hover img {
  filter: brightness(0) invert(1);
}
.team-details-content > .title {
  margin-bottom: 8px;
  font-size: 36px;
  text-transform: capitalize;
}
.team-details-content > span {
  display: block;
  line-height: 1;
  color: var(--tg-gray-four);
  position: relative;
  padding-bottom: 20px;
  margin-bottom: 25px;
}
.team-details-content > span::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  border-radius: 4px;
  background: var(--tg-primary-color);
}
.team-details-content p {
  margin-bottom: 0;
}
.team-skill-wrap {
  margin-top: 45px;
}
.team-skill-wrap > .title-two {
  margin-bottom: 15px;
  font-size: 30px;
  text-transform: capitalize;
  position: relative;
  padding-bottom: 20px;
}
.team-skill-wrap > .title-two::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  border-radius: 4px;
  background: var(--tg-primary-color);
}
.team-skill-wrap p {
  margin-bottom: 0;
}
.team-skill-wrap .progress-wrap {
  margin: 25px 0 40px;
}

/*=============================
	21. Testimonial
===============================*/
.testimonial-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_23___});
  background-size: cover;
  background-position: left center;
  padding: 120px 0;
}
.testimonial-img {
  position: relative;
  text-align: center;
}
.testimonial-img > img {
  border-radius: 30px 85px 30px 95px;
  border: 6px solid var(--tg-white);
  box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.25);
}
.testimonial-img .review-wrap {
  background: var(--tg-white);
  max-width: 180px;
  border-radius: 20px;
  padding: 20px 25px 20px;
  position: absolute;
  left: -30px;
  bottom: 17%;
}
.testimonial-img .review-wrap img {
  margin-bottom: 15px;
}
.testimonial-img .review-wrap .content {
  display: flex;
  align-items: center;
}
.testimonial-img .review-wrap .content .title {
  margin-bottom: 0;
  font-size: 40px;
  font-weight: 800;
  line-height: 1;
  color: var(--tg-primary-color);
  margin-right: 10px;
}
.testimonial-img .review-wrap .content p {
  margin-bottom: 0;
  font-weight: 600;
  font-size: 13px;
  color: var(--tg-secondary-color);
  line-height: 1.2;
}
.testimonial-content {
  width: 82%;
}
.testimonial-content .content-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.testimonial-content .content-top .rating {
  display: flex;
  align-items: center;
  color: var(--tg-yellow);
  font-size: 20px;
  gap: 5px;
}
.testimonial-content p {
  font-style: italic;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 25px;
  color: var(--tg-white);
  font-family: var(--tg-heading-font-family);
}
.testimonial-info .title {
  color: var(--tg-white);
  font-size: 22px;
  margin-bottom: 8px;
}
.testimonial-info span {
  display: block;
  font-family: var(--tg-heading-font-family);
  color: var(--tg-lavender);
  position: relative;
  padding-bottom: 16px;
  line-height: 1;
}
.testimonial-info span::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 40px;
  height: 4px;
  border-radius: 4px;
  background: var(--tg-primary-color);
}
.testimonial-nav {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 40px;
  position: absolute;
  bottom: 0;
}
.testimonial-nav button {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: #0f2d6a !important;
  color: var(--tg-white) !important;
  font-size: 22px;
  line-height: 0;
  border-radius: 50%;
}
.testimonial-nav button.slick-prev {
  transform: rotate(-180deg);
}
.testimonial-nav-prev {
  transform: translate(25px, 50px);
}
.testimonial-nav-next {
  transform: translate(85px, 75px);
}
.testimonial-nav .slick-arrow::before {
  content: "";
}
.testimonial-nav button:hover {
  background: var(--tg-primary-color);
}

/* testimonial-two */
.testimonial-bg-two {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_24___});
  background-size: cover;
  background-position: center;
  padding: 120px 0;
}
.section-title-two.white-title .sub-title {
  background: #1e376a;
  color: var(--tg-white);
}
.testimonial-item-wrap-two {
  padding: 0 30px;
  position: relative;
}
.testimonial-item-two {
  background: var(--tg-white);
  border-radius: 10px;
  padding: 40px 40px;
}
.testimonial-content-two .rating {
  display: flex;
  align-items: center;
  color: var(--tg-yellow);
  font-size: 20px;
  gap: 5px;
  margin-bottom: 20px;
}
.testimonial-content-two > p {
  font-style: italic;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 20px;
  color: var(--tg-paragraph-color);
  font-family: var(--tg-heading-font-family);
  line-height: 1.5;
}
.testimonial-avatar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.testimonial-avatar .avatar-thumb {
  width: 65px;
  flex: 0 0 auto;
  margin-right: 30px;
}
.testimonial-avatar .avatar-thumb img {
  border-radius: 50%;
}
.testimonial-avatar .avatar-info {
  position: relative;
}
.testimonial-avatar .avatar-info::before {
  content: "";
  position: absolute;
  left: -15px;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 36px;
  border-radius: 2px;
  background: var(--tg-primary-color);
}
.testimonial-avatar .avatar-info .title {
  font-size: 22px;
  margin-bottom: 5px;
  color: var(--tg-paragraph-color);
}
.testimonial-avatar .avatar-info span {
  font-family: var(--tg-heading-font-family);
  line-height: 1;
  display: block;
  font-weight: 400;
}
.testimonial-active-two [class*="col-"] {
  padding: 0 15px;
}
.testimonial-nav-two .slick-arrow {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  border-radius: 50px;
  line-height: 0;
  color: var(--tg-white);
  font-size: 22px;
  background: #0f2d6a;
  position: absolute;
  left: -40px;
  top: 50%;
  transform: translateY(-50%);
}
.testimonial-nav-two .slick-arrow::before {
  content: "";
}
.testimonial-nav-two .slick-arrow.slick-next {
  left: auto;
  right: -40px;
}
.testimonial-nav-two .slick-arrow.slick-prev i {
  transform: rotate(-180deg);
}
.testimonial-nav-two .slick-arrow:hover {
  color: #0f2d6a;
  background: var(--tg-white);
}

/* testimonial-three */
.testimonial-area-three .row .col-37 {
  width: 37%;
  flex: 0 0 auto;
}
.testimonial-area-three .row .col-63 {
  width: 63%;
  flex: 0 0 auto;
}
.testimonial-img-three img {
  clip-path: polygon(0 0, 85% 0, 100% 15%, 100% 100%, 15% 100%, 0 85%);
  width: 100%;
}
.testimonial-item-wrap-three {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_25___}),
    var(--tg-section-background);
  border-radius: 10px;
  padding: 100px 80px;
  background-size: cover;
  background-position: center;
  position: relative;
}
.testimonial-content-three .rating {
  display: flex;
  align-items: center;
  font-size: 20px;
  gap: 5px;
  color: var(--tg-yellow);
  margin-bottom: 30px;
}
.testimonial-content-three p {
  font-weight: 600;
  font-size: 20px;
  color: var(--tg-secondary-color);
  font-style: italic;
  font-family: var(--tg-heading-font-family);
  line-height: 1.5;
  margin-bottom: 35px;
}
.testimonial-content-three .testimonial-info .title {
  color: var(--tg-secondary-color);
}
.testimonial-content-three .testimonial-info span {
  color: var(--tg-paragraph-color);
}
.testimonial-nav-three {
  position: absolute;
  display: flex;
  align-items: center;
  left: 45%;
  bottom: 25%;
  gap: 10px;
}
.testimonial-nav-three-prev {
  /* left: 45%; */
}
.testimonial-nav-three-next {
  transform: translate(62px, 25px) !important;
}
.testimonial-nav-three .slick-arrow {
  border: none;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-white);
  background: var(--tg-secondary-color);
  line-height: 0;
  font-size: 22px;
  z-index: 1;
}
.testimonial-nav-three .slick-arrow::before {
  content: "";
}
.testimonial-nav-three .slick-arrow:hover {
  background: var(--tg-primary-color);
}
.testimonial-nav-three .slick-arrow.slick-prev {
  transform: rotate(-180deg);
}

/* testimonial-four */
.testimonial-bg-four {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_26___});
  background-size: cover;
  background-position: center;
  padding: 120px 0;
  position: relative;
  z-index: 1;
  overflow: hidden;
}
.testimonial-img-four {
  position: relative;
  z-index: 1;
  padding-left: 42px;
}
.testimonial-img-four::before {
  content: "";
  position: absolute;
  width: 335px;
  height: 335px;
  left: 10.2%;
  bottom: 1px;
  background: #fff9e4;
  border-radius: 50%;
  z-index: -1;
}
.testimonial-img-four .icon {
  position: absolute;
  left: 7%;
  top: 18%;
  width: 80px;
  height: 80px;
  background: var(--tg-primary-color);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 59% 41% 28% 72% / 38% 37% 63% 62%;
}
.testimonial-img-four .shape {
  position: absolute;
  left: 0;
  bottom: -20px;
  z-index: -2;
}
.testimonial-item-wrap-four {
  position: relative;
  padding-right: 125px;
}
.testimonial-content-four .rating {
  display: flex;
  align-items: center;
  color: var(--tg-yellow);
  gap: 5px;
  margin-bottom: 35px;
}
.testimonial-content-four > p {
  font-weight: 500;
  font-size: 22px;
  margin-bottom: 30px;
  font-style: italic;
  color: var(--tg-white);
  font-family: var(--tg-heading-font-family);
}
.testimonial-content-four .testimonial-info span::before {
  display: none;
}
.testimonial-content-four .testimonial-info span {
  padding-bottom: 0;
}
.testimonial-content-four .testimonial-info {
  position: relative;
  padding-left: 16px;
}
.testimonial-content-four .testimonial-info::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 40px;
  border-radius: 4px;
  background: var(--tg-primary-color);
}
.testimonial-nav-four {
  display: flex;
  flex-direction: column;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translate(60px, -50%);
  gap: 15px;
}
.testimonial-nav-four-prev {
  transform: translate(60px, 40px);
}
.testimonial-nav-four .slick-arrow {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0f2d6a;
  border: none;
  border-radius: 50%;
  color: var(--tg-white);
  font-size: 22px;
  line-height: 0;
}
.testimonial-nav-four .slick-arrow::before {
  content: "";
}
.testimonial-nav-four .slick-arrow:hover {
  background: var(--tg-primary-color);
}
.testimonial-nav-four .slick-arrow.slick-prev {
  transform: rotate(180deg);
}
.testimonial-shape-wrap-four img {
  position: absolute;
  z-index: -1;
}
.testimonial-shape-wrap-four img:nth-child(1) {
  left: 0;
  bottom: 0;
}
.testimonial-shape-wrap-four img:nth-child(2) {
  right: 0;
  top: 0;
}

/* testimonial-five */
.testimonial-area-five {
  position: relative;
  padding: 120px 0;
  overflow: hidden;
}
.testimonial-area-five::before {
  content: "";
  position: absolute;
  right: 22%;
  bottom: 22%;
  width: 350px;
  height: 350px;
  background: #fae7ff;
  filter: blur(200px);
  z-index: -1;
  border-radius: 50%;
}
.testimonial-img-five {
  position: relative;
  text-align: center;
}
.testimonial-img-five img:not(:nth-child(1)) {
  position: absolute;
  z-index: -1;
}
.testimonial-img-five .shape-one {
  left: 3%;
  bottom: 7px;
}
.testimonial-img-five .shape-two {
  left: 17%;
  top: 35%;
  animation: alltuchtopdown 8s infinite linear;
}
.testimonial-img-five .shape-three {
  left: 11%;
  bottom: 12%;
  animation: rotateme 8s infinite linear;
}
.testimonial-content-five {
  padding-right: 112px;
}
.testimonial-item-wrap-five {
  position: relative;
}
.testimonial-item-wrap-five .testimonial-content p {
  color: var(--tg-paragraph-color);
}
.testimonial-item-wrap-five .testimonial-content {
  width: 100%;
}
.testimonial-item-wrap-five .testimonial-quote img {
  opacity: 0.4;
}
.testimonial-active-five {
  margin: -15px 0;
}
.testimonial-active-five .testimonial-item {
  padding: 15px 0;
}
.testimonial-nav-five {
  display: flex;
  align-items: center;
  flex-direction: column;
  position: absolute;
  right: -120px;
  top: 50%;
  transform: translateY(-50%) translateX(-50px);
  justify-content: center;
  gap: 15px;
}
.testimonial-nav-five-prev {
  transform: translateY(-70px) translateX(-50px);
}
.testimonial-nav-five .slick-arrow {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #c2c2c2;
  transform: rotate(-90deg);
  color: var(--tg-primary-color);
  font-size: 20px;
  line-height: 0;
  background: transparent;
  border-radius: 50%;
}
.testimonial-nav-five .slick-arrow::before {
  content: "";
}
.testimonial-nav-five .slick-arrow.slick-next {
  transform: rotate(90deg);
}
.testimonial-nav-five .slick-arrow:hover {
  background: var(--tg-primary-color);
  color: var(--tg-white);
  border-color: var(--tg-primary-color);
}

/*=============================
	22. Pricing
===============================*/
.pricing-area {
  position: relative;
  overflow: hidden;
  padding: 120px 0 90px;
}
.pricing-area::before {
  content: "";
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  top: -35%;
  width: 760px;
  height: 760px;
  background: linear-gradient(154.68deg, #8894ff 11.62%, #ff8585 90.47%);
  opacity: 0.1;
  filter: blur(75px);
  border-radius: 50%;
  z-index: -1;
}
.pricing-item-wrap .pricing-tab {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 40px;
}
.pricing-item-wrap .pricing-tab .tab-btn {
  cursor: pointer;
  color: var(--tg-paragraph-color);
  font-weight: 600;
  font-size: 18px;
  -webkit-user-select: none;
          user-select: none;
  font-family: var(--tg-heading-font-family);
  transition: 0.3s;
}
.pricing-item-wrap .pricing-tab .tab-btn.monthly_tab_title {
  color: var(--tg-primary-color);
}
.pricing-item-wrap .pricing-tab .tab-btn.monthly_tab_title.active {
  color: var(--tg-paragraph-color);
}
.pricing-item-wrap .pricing-tab .annual_tab_title.active {
  color: var(--tg-primary-color);
}
.pricing-tab .pricing-tab-switcher {
  height: 30px;
  width: 70px;
  display: inline-block;
  border-radius: 30px;
  position: relative;
  margin: 0 15px;
  transform: translateY(0px);
  cursor: pointer;
  background: var(--tg-primary-color);
}
.pricing-tab .pricing-tab-switcher:before {
  content: "";
  position: absolute;
  left: 2px;
  top: 2px;
  bottom: 2px;
  width: 26px;
  border-radius: 50%;
  background: var(--tg-white);
  transition: 0.3s;
}
.pricing-tab .pricing-tab-switcher.active:before {
  left: calc(100% - 28px);
}
.pricing-price.change-subs-duration .monthly_price {
  display: none;
}
.pricing-price.change-subs-duration .annual_price {
  display: flex;
}
.pricing-box {
  border: 1px solid #e1e1e9;
  border-radius: 10px;
  text-align: center;
  padding: 40px 40px;
  background: var(--tg-white);
  margin-bottom: 30px;
  position: relative;
  margin-top: 16px;
}
.pricing-box .popular-tag {
  display: inline-block;
  font-weight: 600;
  font-size: 15px;
  background: var(--tg-red);
  color: var(--tg-white);
  line-height: 1.2;
  padding: 7px 18px;
  border-radius: 30px;
  position: absolute;
  top: -16px;
  left: 50%;
  transform: translateX(-50%);
}
.pricing-head .title {
  font-size: 24px;
  margin-bottom: 10px;
}
.pricing-head p {
  margin-bottom: 24px;
  color: var(--tg-gray-four);
}
.pricing-price {
  margin-bottom: 25px;
}
.pricing-price .price {
  margin-bottom: 0;
  font-size: 30px;
  line-height: 1;
  display: flex;
  justify-content: center;
  align-items: flex-end;
  background: #f3f6fe;
  border-radius: 30px;
  padding: 15px 20px;
}
.pricing-price .price strong {
  font-weight: 500;
  font-size: 16px;
  font-family: var(--tg-body-font-family);
  margin: 4px 3px auto 0;
}
.pricing-price .price span {
  color: #798eb9;
  text-transform: lowercase;
  font-weight: 500;
  font-size: 13px;
  font-family: var(--tg-body-font-family);
  margin-left: 5px;
  margin-bottom: 7px;
}
.pricing-price .annual_price {
  /* display: none; */
}
.pricing-list .list-wrap {
  margin-bottom: 25px;
}
.pricing-list .list-wrap li {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-paragraph-color);
  margin-bottom: 15px;
}
.pricing-list .list-wrap li:last-child {
  margin-bottom: 0;
}
.pricing-list .list-wrap li img {
  margin-right: 10px;
}
.pricing-btn .btn {
  background: var(--tg-lavender);
  color: var(--tg-primary-color);
}
.pricing-btn .btn::before {
  background: var(--tg-cornflower-blue);
}
.pricing-box.active .pricing-btn .btn {
  background: var(--tg-primary-color);
  color: var(--tg-white);
}
.pricing-box.active .pricing-btn .btn::before {
  background: var(--tg-blue);
}

/* pricing-two */
.pricing-area-two {
  position: relative;
  padding: 120px 0 90px;
  overflow: hidden;
}
.pricing-shape {
  position: absolute;
  right: 0;
  top: 0;
  z-index: -1;
}
.pricing-box-two {
  border: 1px solid #e1e1e9;
  border-radius: 10px;
  margin-bottom: 30px;
  position: relative;
}
.pricing-box-two .popular {
  font-weight: 600;
  font-size: 15px;
  background: var(--tg-red);
  color: var(--tg-white);
  display: block;
  line-height: 1;
  position: absolute;
  right: 0;
  top: 80px;
  border-radius: 30px 0 0 30px;
  padding: 8px 18px;
  z-index: -1;
}
.pricing-head-two {
  padding: 50px 50px 40px;
  border-bottom: 1px solid #e1e1e9;
}
.pricing-head-two .title {
  font-weight: 600;
  font-size: 20px;
  margin-bottom: 10px;
}
.pricing-price-two .price {
  font-weight: 800;
  font-size: 40px;
  margin-bottom: 0;
  display: flex;
  align-items: flex-end;
  line-height: 1;
}
.pricing-price-two .price strong {
  font-weight: 600;
  font-size: 20px;
  margin: 4px 3px auto 0;
}
.pricing-price-two .price span {
  color: #798eb9;
  text-transform: lowercase;
  font-weight: 500;
  font-size: 13px;
  font-family: var(--tg-body-font-family);
  margin-left: 2px;
  margin-bottom: 7px;
}
/* .pricing-price-two .annual_price {
  display: none;
} */
.pricing-price-two.change-subs-duration .annual_price {
  display: flex;
}
.pricing-price-two.change-subs-duration .monthly_price {
  /* display: none; */
}
.pricing-bottom {
  padding: 30px 50px 50px;
}
.pricing-box-two .pricing-list .list-wrap {
  margin-bottom: 30px;
}
.pricing-box-two .pricing-list .list-wrap li {
  justify-content: left;
}
.pricing-btn-two {
  text-align: center;
}

/* pricing-three */
.pricing-area-three {
  position: relative;
  padding: 120px 0 90px;
  overflow: hidden;
  background: #f8f8fa;
  z-index: 1;
}
.pricing-box-three {
  border: 1px solid #e1e1e9;
  border-radius: 20px;
  padding: 50px 50px 60px;
  text-align: center;
  background: var(--tg-white);
  margin-bottom: 30px;
}
.pricing-box-three .pricing-icon {
  font-size: 65px;
  line-height: 0;
  color: var(--tg-primary-color);
  margin-bottom: 20px;
}
.pricing-box-three .pricing-plan .title {
  color: var(--tg-gray-four);
  margin-bottom: 20px;
  font-weight: 500;
  font-size: 20px;
}
.pricing-box-three .pricing-price-two {
  margin-bottom: 30px;
}
.pricing-box-three .pricing-price-two .price {
  justify-content: center;
}
.pricing-box-three .pricing-list .list-wrap {
  margin-bottom: 35px;
}

/*=============================
	23. Contact
===============================*/
.contact-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_27___});
  background-size: cover;
  background-position: center;
  padding: 120px 0;
  position: relative;
  z-index: 1;
}
.contact-content p {
  margin-bottom: 0;
}
.contact-form {
  margin: 0 30px 0 80px;
}
.contact-form .form-grp {
  margin-bottom: 15px;
}
.contact-form .form-grp textarea,
.contact-form .form-grp input {
  width: 100%;
  border: 1px solid #d5dae4;
  border-radius: 4px;
  background: var(--tg-white);
  color: var(--tg-secondary-color);
  font-weight: 500;
  font-size: 13px;
  padding: 14px 18px;
  height: 50px;
  display: block;
}
.contact-form .form-grp textarea::placeholder,
.contact-form .form-grp input::placeholder {
  color: var(--tg-paragraph-color);
  font-weight: 500;
  font-size: 13px;
}
.contact-form .form-grp textarea {
  min-height: 96px;
  max-height: 96px;
}
.contact-form form button {
  border: none;
  width: 100%;
  text-align: center;
  font-weight: 600;
  font-size: 16px;
  color: var(--tg-white);
  text-transform: uppercase;
  background: var(--tg-primary-color);
  border-radius: 30px;
  padding: 14px 20px;
}
.contact-form form button:hover {
  background: var(--tg-secondary-color);
}
.contact-shape {
  position: absolute;
  z-index: -1;
  top: 10%;
  left: 31%;
  animation: animationFramesOne 15s linear infinite;
}

/* inner-contact */
.inner-contact-info {
  padding-left: 80px;
}
.inner-contact-info .title {
  margin-bottom: 25px;
  position: relative;
  font-weight: 800;
  font-size: 36px;
  padding-bottom: 20px;
}
.inner-contact-info .title::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  background: var(--tg-primary-color);
  border-radius: 4px;
}
.contact-info-item {
  margin-bottom: 50px;
}
.contact-info-item:last-child {
  margin-bottom: 0;
}
.contact-info-item .title-two {
  font-size: 24px;
  margin-bottom: 20px;
}
.contact-info-item .list-wrap li {
  font-size: 18px;
  margin-bottom: 10px;
  line-height: 1.33;
  font-family: var(--tg-heading-font-family);
}
.contact-info-item .list-wrap li:last-child {
  margin-bottom: 0;
}
.contact-map {
  width: 100%;
  height: 500px;
}
.contact-map iframe {
  width: 100%;
  height: 100%;
  mix-blend-mode: luminosity;
}

/*=============================
	24. Blog
===============================*/
.blog-post-area {
  position: relative;
  z-index: 1;
  padding: 120px 0 90px;
}
.blog-post-area .blog-bg {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
}
.blog-post-area .blog-bg {
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 62%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}
.blog-post-item {
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  background: var(--tg-white);
  border-radius: 10px;
  margin-bottom: 30px;
}
.blog-post-thumb {
  position: relative;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}
.blog-post-thumb img {
  width: 100%;
  transform: scale(1);
}
.blog-post-item:hover .blog-post-thumb img {
  transform: scale(1.1);
}
.blog-post-thumb .date {
  background: var(--tg-primary-color);
  display: block;
  font-weight: 500;
  font-size: 16px;
  color: var(--tg-white);
  line-height: 1;
  position: absolute;
  left: 30px;
  top: 0;
  padding: 15px 20px;
  border-radius: 0 0 30px 30px;
  text-align: center;
}
.blog-post-thumb .date strong {
  font-weight: 700;
  font-size: 24px;
  font-family: var(--tg-heading-font-family);
  display: block;
  line-height: 1;
}
.blog-post-content {
  padding: 25px 30px 30px;
  border-radius: 0 0 10px 10px;
}
.blog-post-content .tag {
  font-size: 14px;
  display: inline-block;
  margin-bottom: 8px;
}
.blog-post-content .tag:hover {
  color: var(--tg-secondary-color);
}
.blog-post-content .title {
  font-size: 24px;
  margin-bottom: 10px;
}
.blog-post-content p {
  margin-bottom: 20px;
}
.blog-post-content .link-btn {
  letter-spacing: 0.02em;
  text-transform: uppercase;
  display: inline-flex;
  align-items: center;
  color: var(--tg-paragraph-color);
}
.blog-post-content .link-btn i {
  line-height: 0;
  font-size: 22px;
  margin-left: 10px;
  color: var(--tg-primary-color);
}
.blog-post-content .link-btn:hover {
  color: var(--tg-primary-color);
}

/* blog-two */
.blog-bg-two {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_29___});
  background-size: cover;
  background-position: center;
  padding: 120px 0 90px;
}
.section-title-two p {
  color: var(--tg-paragraph-color);
  width: 90%;
  margin: 15px auto 0;
}
.blog-post-item-two {
  margin-bottom: 30px;
}
.blog-post-thumb-two {
  position: relative;
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}
.blog-post-thumb-two img {
  transition: 0.3s linear;
  width: 100%;
  min-height: 275px;
}
.blog-post-item-two:hover .blog-post-thumb-two img {
  transform: scale(1.1);
}
.blog-post-thumb-two .tag {
  position: absolute;
  left: 0;
  bottom: 0;
  font-weight: 700;
  font-size: 14px;
  color: var(--tg-white);
  background: var(--tg-primary-color);
  padding: 9px 16px;
  display: block;
}
.blog-post-thumb-two .tag:hover {
  background: var(--tg-secondary-color);
}
.blog-post-content-two {
  border: 1px solid #e7e7e7;
  border-top: none;
  border-radius: 0 0 10px 10px;
  padding: 35px 30px;
  background: var(--tg-white);
}
.blog-post-content-two .title {
  font-size: 24px;
  margin-bottom: 10px;
}
.blog-post-content-two p {
  margin-bottom: 25px;
}
.blog-meta .list-wrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 15px 10px;
}
.blog-meta .list-wrap li {
  color: var(--tg-paragraph-color);
  font-size: 13px;
  display: flex;
  align-items: center;
}
.blog-meta .list-wrap li i {
  font-size: 20px;
  color: var(--tg-primary-color);
  margin-right: 8px;
}
.blog-meta .list-wrap li a {
  color: var(--tg-paragraph-color);
  font-size: 16px;
}
.blog-meta .list-wrap li a:hover {
  color: var(--tg-primary-color);
}
.blog-meta .list-wrap li a img {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
  flex: 0 0 auto;
}

/* blog-three */
.blog-post-thumb-two .tag-two {
  position: absolute;
  left: 30px;
  top: 25px;
  bottom: auto;
  font-weight: 500;
  font-size: 14px;
  color: var(--tg-white);
  background: var(--tg-primary-color);
  padding: 6px 16px;
  display: block;
  border-radius: 30px;
}
.blog-post-thumb-two .tag-two:hover {
  background: var(--tg-secondary-color);
}

/* blog-four */
.blog-post-thumb-four {
  border-radius: 10px 10px 0 0;
  overflow: hidden;
}
.blog-post-thumb-four img {
  width: 100%;
}
.blog-post-content-four {
  border: 1px solid #e7e7e7;
  border-radius: 0 0 10px 10px;
  border-top: none;
  padding: 40px 35px 35px;
  position: relative;
  margin-bottom: 30px;
}
.blog-post-content-four .tag {
  font-size: 14px;
  font-weight: 700;
  display: block;
  text-transform: capitalize;
  background: var(--tg-primary-color);
  color: var(--tg-white);
  position: absolute;
  left: 30px;
  top: -18px;
  padding: 8px 16px;
  border-radius: 30px;
}
.blog-post-content-four .tag:hover {
  background: var(--tg-secondary-color);
}
.blog-meta-two .list-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px 25px;
  margin-bottom: 20px;
}
.blog-meta-two .list-wrap li {
  font-weight: 600;
  font-size: 13px;
  text-transform: capitalize;
  display: flex;
  align-items: center;
}
.blog-meta-two .list-wrap li i {
  font-size: 20px;
  margin-right: 8px;
  color: var(--tg-primary-color);
}
.blog-meta-two .list-wrap li a {
  color: var(--tg-paragraph-color);
  margin-left: 5px;
}
.blog-meta-two .list-wrap li a:hover {
  color: var(--tg-primary-color);
}
.blog-post-content-four .title {
  font-size: 24px;
  margin-bottom: 15px;
}
.blog-post-content-four .link-btn {
  display: inline-flex;
  align-items: center;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: var(--tg-paragraph-color);
}
.blog-post-content-four .link-btn i {
  line-height: 0;
  font-size: 20px;
  color: var(--tg-primary-color);
  margin-left: 10px;
}
.blog-post-content-four .link-btn:hover {
  color: var(--tg-primary-color);
}

/* inner-blog */
.inner-blog-wrap .row .col-71 {
  width: 71%;
  flex: 0 0 auto;
}
.inner-blog-wrap .row .col-29 {
  width: 29%;
  flex: 0 0 auto;
}
.pagination-wrap .pagination {
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
}
.pagination-wrap .pagination .page-link {
  margin-left: 0;
  padding: 0 0;
  color: var(--tg-gray-four);
  font-weight: 500;
  font-size: 20px;
  line-height: 1;
  width: 52px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  border: 1px solid #e0e0e0;
  border-radius: 3px;
  background: transparent;
  font-family: var(--tg-heading-font-family);
}
.pagination-wrap .pagination .page-item.active .page-link,
.pagination-wrap .pagination .page-link:hover {
  background: var(--tg-primary-color);
  border-color: var(--tg-primary-color);
  color: var(--tg-white);
}
.pagination-wrap .pagination .page-link:focus {
  color: var(--tg-white);
  background-color: var(--tg-primary-color);
  border-color: var(--tg-primary-color);
  outline: 0;
  box-shadow: none;
}
.blog-sidebar {
  margin-left: 15px;
}
.sidebar-search {
  margin-bottom: 30px;
}
.sidebar-search form {
  position: relative;
}
.sidebar-search form input {
  width: 100%;
  background: transparent;
  border: 1px solid #e0e6f2;
  border-radius: 10px;
  padding: 20px 55px 20px 28px;
  font-weight: 400;
  font-size: 14px;
  color: var(--tg-paragraph-color);
  height: 65px;
}
.sidebar-search form input::placeholder {
  font-weight: 400;
  font-size: 14px;
  color: var(--tg-gray-four);
}
.sidebar-search form button {
  position: absolute;
  right: 24px;
  top: 50%;
  transform: translateY(-50%);
  border: none;
  background: transparent;
  padding: 0;
  font-size: 24px;
  color: var(--tg-primary-color);
  line-height: 0;
}
.blog-widget {
  border: 1px solid #e0e6f2;
  border-radius: 10px;
  padding: 25px 30px 30px;
  margin-bottom: 30px;
}
.blog-widget:last-child {
  margin-bottom: 0;
}
.blog-widget .bw-title {
  margin-bottom: 25px;
  font-size: 22px;
  position: relative;
  padding-bottom: 12px;
}
.blog-widget .bw-title::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  border-radius: 4px;
  background: var(--tg-primary-color);
}
.bs-cat-list .list-wrap li {
  border-bottom: 1px solid #d9d9d9;
  margin-bottom: 15px;
  padding-bottom: 12px;
}
.bs-cat-list .list-wrap li:last-child {
  margin-bottom: 0;
  padding-bottom: 0;
  border: none;
}
.bs-cat-list .list-wrap li a {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-weight: 500;
  font-size: 16px;
  color: var(--tg-paragraph-color);
}
.bs-cat-list .list-wrap li a span {
  font-size: 14px;
  color: var(--tg-gray-four);
  transition: all 0.3s ease-out 0s;
}
.bs-cat-list .list-wrap li a:hover span,
.bs-cat-list .list-wrap li a:hover {
  color: var(--tg-primary-color);
}
.rc-post-item {
  display: flex;
  align-items: center;
  margin-bottom: 25px;
}
.rc-post-item:last-child {
  margin-bottom: 0;
}
.rc-post-item .thumb {
  width: 75px;
  flex: 0 0 auto;
  margin-right: 15px;
}
.rc-post-item .thumb img {
  border-radius: 8px;
}
.rc-post-item .content .date {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 13px;
  color: var(--tg-gray-four);
  margin-bottom: 8px;
}
.rc-post-item .content .date i {
  margin-right: 8px;
  color: var(--tg-primary-color);
  font-size: 20px;
}
.rc-post-item .content .title {
  margin-bottom: 0;
  font-weight: 600;
  font-size: 16px;
  text-transform: capitalize;
  color: var(--tg-paragraph-color);
}
.bs-tag-list .list-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.bs-tag-list .list-wrap li a {
  font-weight: 500;
  font-size: 16px;
  background: var(--tg-lavender);
  display: block;
  border-radius: 4px;
  padding: 5px 15px;
}
.bs-tag-list .list-wrap li a:hover {
  color: var(--tg-white);
  background: var(--tg-primary-color);
}

/* blog-details */
.blog-details-wrap .row .col-71 {
  width: 71%;
  flex: 0 0 auto;
}
.blog-details-wrap .row .col-29 {
  width: 29%;
  flex: 0 0 auto;
}
.blog-details-thumb {
  margin-bottom: 30px;
}
.blog-details-thumb img {
  border-radius: 10px;
}
.blog-details-content > .title {
  font-size: 36px;
  margin-bottom: 20px;
  text-transform: capitalize;
}
.blog-meta-three .list-wrap {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 20px;
  margin-bottom: 25px;
}
.blog-meta-three .list-wrap li {
  display: flex;
  align-items: center;
  font-weight: 600;
  font-size: 16px;
  color: var(--tg-paragraph-color);
  gap: 5px;
}
.blog-meta-three .list-wrap li i {
  line-height: 0;
  color: var(--tg-primary-color);
  font-size: 20px;
  margin-right: 5px;
}
.blog-meta-three .list-wrap li img {
  border-radius: 50%;
  margin-right: 5px;
}
.blog-meta-three .list-wrap li a {
  color: var(--tg-paragraph-color);
}
.blog-meta-three .list-wrap li a:hover {
  color: var(--tg-primary-color);
}
.blog-details-content > p {
  margin-bottom: 15px;
}
.blog-details-content blockquote {
  margin: 50px 50px 60px;
  background: var(--tg-section-background);
  padding: 50px 120px 50px 50px;
  position: relative;
  z-index: 1;
}
.blog-details-content blockquote::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  width: 6px;
  height: 100%;
  background: var(--tg-primary-color);
}
.blog-details-content blockquote::after {
  content: "\\f10e";
  font-weight: 700;
  font-size: 52px;
  color: #e2e5f7;
  line-height: 1;
  font-family: "Font Awesome 5 Free";
  position: absolute;
  right: 33px;
  top: 27px;
  z-index: -1;
}
.blog-details-content blockquote p {
  margin-bottom: 0;
  font-style: italic;
  font-weight: 500;
  font-size: 20px;
  font-family: var(--tg-heading-font-family);
}
.blog-details-content .title-two {
  font-size: 30px;
  margin-bottom: 20px;
  text-transform: capitalize;
}
.bd-inner-wrap {
  margin: 35px 0;
}
.bd-inner-wrap .row .col-46 {
  width: 46%;
  flex: 0 0 auto;
}
.bd-inner-wrap .row .col-54 {
  width: 54%;
  flex: 0 0 auto;
}
.bd-inner-wrap .thumb {
  position: relative;
}
.bd-inner-wrap .thumb img {
  width: 100%;
  border-radius: 10px;
}
.bd-inner-wrap .thumb .play-btn {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 62px;
  height: 62px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--tg-white);
  border-radius: 50%;
}
.bd-inner-wrap .thumb .play-btn::after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  border: 1px solid var(--tg-white);
  border-radius: 50%;
  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);
  animation: pulse-border 1500ms ease-out infinite;
}
.bd-inner-wrap .content p {
  margin-bottom: 15px;
}
.bd-inner-wrap .content .list-wrap li {
  display: flex;
  align-items: flex-start;
  font-weight: 600;
  font-size: 18px;
  font-family: var(--tg-heading-font-family);
  color: var(--tg-secondary-color);
  line-height: 1.3;
  margin-bottom: 15px;
}
.bd-inner-wrap .content .list-wrap li:last-child {
  margin-bottom: 0;
}
.bd-inner-wrap .content .list-wrap li img {
  margin-right: 10px;
}
.bd-content-bottom {
  border-top: 1px solid #e7e7e7;
  border-bottom: 1px solid #e7e7e7;
  padding: 15px 0;
  margin-top: 40px;
  margin-bottom: 70px;
}
.bd-content-bottom .post-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}
.bd-content-bottom .post-tags .title {
  margin-bottom: 0;
  font-size: 18px;
  color: var(--tg-paragraph-color);
}
.bd-content-bottom .post-tags .list-wrap {
  display: flex;
  align-items: center;
  gap: 5px;
}
.bd-content-bottom .post-tags .list-wrap li a {
  background: var(--tg-lavender);
  padding: 9px 22px;
  display: block;
  border-radius: 4px;
}
.bd-content-bottom .post-tags .list-wrap li a:hover {
  background: var(--tg-primary-color);
  color: var(--tg-white);
}
.bd-content-bottom .blog-post-share {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}
.bd-content-bottom .blog-post-share .title {
  margin-bottom: 0;
  font-size: 18px;
  color: var(--tg-paragraph-color);
}
.bd-content-bottom .blog-post-share .list-wrap {
  display: flex;
  align-items: center;
  gap: 12px;
}
.bd-content-bottom .blog-post-share .list-wrap li a {
  color: var(--tg-gray-four);
}
.bd-content-bottom .blog-post-share .list-wrap li a:hover {
  color: var(--tg-primary-color);
}
.blog-avatar-wrap {
  border: 1px solid #e6eeff;
  border-radius: 6px;
  display: flex;
  align-items: flex-start;
  padding: 42px 42px;
  background: var(--tg-section-background);
}
.blog-avatar-img {
  width: 115px;
  flex: 0 0 auto;
  margin-right: 30px;
}
.blog-avatar-img img {
  border-radius: 50%;
}
.blog-avatar-info .designation {
  display: block;
  font-weight: 500;
  font-size: 15px;
  color: var(--tg-primary-color);
  line-height: 1;
  margin-bottom: 10px;
}
.blog-avatar-info .name {
  margin-bottom: 10px;
  font-size: 20px;
}
.blog-avatar-info p {
  margin-bottom: 0;
}
.latest-comments {
  margin-bottom: 80px;
}
.comments-wrap-title {
  font-size: 24px;
  margin-bottom: 25px;
}
.comments-box {
  display: flex;
  align-items: flex-start;
  border-bottom: 1px solid #d6dce9;
  padding-bottom: 30px;
  margin-bottom: 35px;
}
.latest-comments .children {
  margin: 0 0 0 45px;
  padding: 0;
}
.comments-avatar {
  width: 115px;
  flex: 0 0 auto;
  margin-right: 25px;
}
.comments-avatar img {
  border-radius: 50%;
}
.comments-text .avatar-name {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.comments-text .avatar-name .name {
  margin-bottom: 0;
  font-size: 20px;
  font-weight: 600;
}
.comments-text .avatar-name span {
  font-weight: 500;
  font-size: 15px;
  display: block;
  color: var(--tg-primary-color);
}
.comments-text p {
  margin-bottom: 15px;
}
.comments-text .reply-btn {
  background: var(--tg-lavender);
  font-weight: 500;
  font-size: 14px;
  display: inline-block;
  padding: 6px 17px;
  text-transform: uppercase;
  border-radius: 5px;
}
.comments-text .reply-btn:hover {
  background: var(--tg-primary-color);
  color: var(--tg-white);
}
.comment-respond {
  border: 1px solid #b3ccff;
  border-radius: 8px;
  padding: 35px 40px 50px;
  background: var(--tg-section-background);
}
.comment-reply-title {
  font-size: 24px;
  margin-bottom: 10px;
}
.comment-form .comment-notes {
  margin-bottom: 15px;
}
.comment-form .form-grp {
  margin-bottom: 15px;
}
.comment-form .form-grp textarea,
.comment-form .form-grp input {
  width: 100%;
  border: 1px solid var(--tg-lavender);
  background: var(--tg-white);
  font-weight: 400;
  font-size: 15px;
  color: var(--tg-paragraph-color);
  padding: 12px 15px;
  height: 50px;
  display: block;
  border-radius: 5px;
}
.comment-form .form-grp textarea::placeholder,
.comment-form .form-grp input::placeholder {
  font-weight: 400;
  font-size: 15px;
  color: var(--tg-gray-four);
}
.comment-form .form-grp textarea {
  min-height: 130px;
  max-height: 130px;
}
.comment-form .checkbox-grp {
  display: flex;
  align-items: center;
  margin: 25px 0;
}
.comment-form .checkbox-grp input {
  width: 22px;
  margin-right: 9px;
  height: 22px;
  cursor: pointer;
}
.comment-form .checkbox-grp label {
  font-weight: 400;
  font-size: 14px;
  color: var(--tg-paragraph-color);
  -webkit-user-select: none;
          user-select: none;
}
.comment-form .submit-btn {
  width: auto;
  text-transform: uppercase;
  border-radius: 30px;
  letter-spacing: 0.02em;
  padding: 13px 25px;
}
.comment-form .row {
  margin: 0 -10px;
}
.comment-form .row [class*="col-"] {
  padding: 0 10px;
}

/*=============================
	25. Brand
===============================*/
.brand-active [class*="col-"] {
  padding: 0 15px;
}
.brand-item {
  min-height: 86px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.brand-item img {
  cursor: pointer;
  filter: grayscale(100%);
  opacity: 0.5;
}
.brand-item:hover img {
  filter: grayscale(0);
  opacity: 1;
}

/* brand-two */
.brand-item-wrap {
  border-bottom: 1px solid #dee4f0;
  padding-bottom: 40px;
}
.brand-item-wrap .title {
  font-weight: 600;
  font-size: 13px;
  margin-bottom: 25px;
  color: var(--tg-paragraph-color);
  font-family: var(--tg-body-font-family);
}

.brand-item-wrap-two {
  border-top: 1px solid #dee4f0;
  padding: 70px 0;
}

.brand-area-seven {
  border-top: 1px solid #dee4f0;
  padding: 70px 0;
}

/*=============================
	26. Error
===============================*/
.error-area {
  padding: 210px 0;
}
.error-content {
  text-align: center;
}
.error-content .error-404 {
  font-size: 400px;
  margin-bottom: 50px;
  line-height: 0.74;
  font-weight: 800;
}
.error-content .error-404 span {
  color: var(--tg-primary-color);
}
.error-content .title {
  margin-bottom: 20px;
  font-weight: 600;
  font-size: 36px;
  text-transform: capitalize;
}
.error-content p {
  margin-bottom: 35px;
  color: var(--tg-gray-four);
  font-weight: 400;
}

/*=============================
	27. Footer
===============================*/
.footer-bg {
  background: #0A1628;
}
.footer-top {
  padding: 100px 0 40px;
}
.footer-widget {
  margin-bottom: 40px;
}
.footer-widget .fw-title {
  font-size: 24px;
  margin-bottom: 0;
  color: var(--tg-white);
  position: relative;
  padding-bottom: 18px;
  margin-bottom: 16px;
}
.footer-widget .fw-title::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: 0;
  width: 30px;
  height: 4px;
  border-radius: 4px;
  background: var(--tg-accent-color);
}
.footer-info .list-wrap li {
  display: flex;
  align-items: flex-start;
  margin-bottom: 25px;
}
.footer-info .list-wrap li:last-child {
  margin-bottom: 0;
}
.footer-info .list-wrap li .icon {
  font-size: 22px;
  line-height: 0;
  color: var(--tg-lavender);
  margin-top: 3px;
  margin-right: 12px;
}
.footer-info .list-wrap li .content a,
.footer-info .list-wrap li .content p {
  color: var(--tg-gray-three);
  margin-bottom: 0;
}
.footer-info .list-wrap li .content p span {
  font-weight: 700;
  color: var(--tg-white);
}
.footer-info .list-wrap li .content a:hover {
  color: var(--tg-white);
}
.footer-link .list-wrap li {
  margin-bottom: 10px;
}
.footer-link .list-wrap li:last-child {
  margin-bottom: 0;
}
.footer-link .list-wrap li a {
  color: var(--tg-gray-three);
  position: relative;
}
.footer-link .list-wrap li a:hover {
  color: var(--tg-white);
}
.footer-link .list-wrap li a::before {
  content: "";
  position: absolute;
  left: 0;
  bottom: -1px;
  width: 100%;
  height: 1px;
  background: var(--tg-white);
  transform-origin: right top;
  transform: scale(0, 1);
  transition: transform 0.4s cubic-bezier(0.74, 0.72, 0.27, 0.24);
}
.footer-link .list-wrap li a:hover::before {
  transform-origin: left top;
  transform: scale(1, 1);
}
.footer-top .row [class*="col-"]:nth-child(3) .footer-widget {
  margin-left: 40px;
}
.footer-newsletter p {
  margin-bottom: 20px;
  color: var(--tg-gray-three);
  width: 90%;
}
.footer-newsletter form {
  position: relative;
  margin-bottom: 15px;
}
.footer-newsletter form input {
  width: 100%;
  border: none;
  background: #1e2e4e;
  font-weight: 500;
  font-size: 14px;
  color: var(--tg-white);
  border-radius: 30px;
  padding: 12px 125px 12px 22px;
  height: 46px;
}
.footer-newsletter form input::placeholder {
  font-weight: 500;
  font-size: 14px;
  color: var(--tg-white);
  text-transform: capitalize;
}
.footer-newsletter form button {
  border: none;
  background: var(--tg-accent-color);
  color: var(--tg-primary-color);
  font-weight: 700;
  font-size: 14px;
  border-radius: 30px;
  position: absolute;
  right: 0;
  top: 0;
  padding: 12px 23px;
  height: 46px;
  transition: all 0.3s ease;
}
.footer-newsletter form button:hover {
  background: var(--tg-accent-light);
}
.footer-newsletter span {
  display: block;
  color: var(--tg-gray-three);
  font-size: 15px;
}
.footer-bottom {
  border-top: 1px solid #253352;
  padding: 48px 0;
}
.footer-bottom .f-logo {
  margin-bottom: 10px;
}
.copyright-text p {
  margin-bottom: 0px;
  font-size: 14px;
  color: #7c8db1;
}
.footer-social .list-wrap {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
}
.footer-social .list-wrap li a {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1a2948;
  border-radius: 50%;
  color: var(--tg-white);
  font-size: 20px;
}
.footer-social .list-wrap li a:hover {
  background: var(--tg-primary-color);
}

/* footer-two */
.footer-bg-two {
  background: #0A1628;
}
.footer-top-two {
  padding: 100px 0 40px;
}
.footer-top-two .fw-logo {
  margin-bottom: 30px;
}
.footer-content > p {
  margin-bottom: 20px;
  width: 90%;
}
.footer-top-two .footer-info .list-wrap li .icon {
  color: var(--tg-primary-color);
}
.footer-top-two .footer-info .list-wrap li .content a,
.footer-top-two .footer-info .list-wrap li .content p {
  color: var(--tg-paragraph-color);
}
.footer-top-two .footer-info .list-wrap li .content a:hover {
  color: var(--tg-primary-color);
}
.footer-top-two .footer-info .list-wrap li .content p span {
  color: var(--tg-primary-color);
}
.footer-top-two .footer-widget .fw-title {
  color: var(--tg-secondary-color);
}
.footer-top-two .footer-link .list-wrap li a {
  color: var(--tg-paragraph-color);
}
.footer-top-two .footer-link .list-wrap li a:hover {
  color: var(--tg-primary-color);
}
.footer-top-two .footer-link .list-wrap li a::before {
  background: var(--tg-primary-color);
}
.footer-top-two .footer-newsletter p {
  color: var(--tg-paragraph-color);
}
.footer-top-two .footer-newsletter form input {
  background: #eef1f5;
  color: var(--tg-paragraph-color);
}
.footer-top-two .footer-newsletter form input::placeholder {
  color: var(--tg-paragraph-color);
}
.footer-top-two .footer-newsletter form {
  margin-bottom: 20px;
}
.footer-social.footer-social-two .list-wrap {
  justify-content: flex-start;
}
.footer-social.footer-social-two .list-wrap li a {
  background: #f1f1f1;
  color: var(--tg-paragraph-color);
}
.footer-social.footer-social-two .list-wrap li a:hover {
  background: var(--tg-paragraph-color);
  color: var(--tg-white);
}
.footer-bottom-two {
  border-top: 1px solid #eaeaea;
  padding: 27px 0;
}
.copyright-text-two p {
  margin-bottom: 0;
  font-size: 14px;
}

/* footer-three */
.footer-area-three {
  background: #051433;
}
.footer-top-three {
  padding: 100px 0 55px;
}
.footer-top-three .fw-logo {
  margin-bottom: 30px;
}
.footer-top-three .footer-content > p {
  color: #96a1b8;
}
.footer-social.footer-social-three .list-wrap {
  justify-content: flex-start;
}
.footer-bottom-three {
  border-top: 1px solid #1a264f;
  padding: 27px 0;
}

/*=============================
	28. Preloader
===============================*/
#preloader {
  background-color: var(--tg-white);
  height: 100%;
  width: 100%;
  position: fixed;
  margin-top: 0px;
  top: 0px;
  z-index: 999;
}
#loading-center {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.loader {
  position: relative;
  width: 60px;
  height: 60px;
  border-radius: 50%;
  margin: 75px;
  display: inline-block;
  vertical-align: middle;
}
.loader .loader-outter {
  position: absolute;
  border: 4px solid var(--tg-primary-color);
  border-left-color: transparent;
  border-bottom: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  animation: loader-outter 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite;
}
.loader .loader-inner {
  position: absolute;
  border: 4px solid var(--tg-primary-color);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  left: calc(50% - 20px);
  top: calc(50% - 20px);
  border-right: 0;
  border-top-color: transparent;
  animation: loader-inner 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite;
}

@keyframes loader-outter {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@keyframes loader-inner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/style.css"],"names":[],"mappings":"AAAA;;;;CAIC;;AAED;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CA+BC;;AAED;;gCAEgC;;AAGhC;;gCAEgC;AAChC;EACE,0CAA0C;EAC1C,qDAAqD;EACrD,2BAA2B;EAC3B,6BAA6B;EAC7B,6BAA6B;EAC7B,gCAAgC;EAChC,6BAA6B;EAC7B,gCAAgC;EAChC,yBAAyB;EACzB,0BAA0B;EAC1B,6BAA6B;EAC7B,0BAA0B;EAC1B,8BAA8B;EAC9B,yBAAyB;EACzB,0BAA0B;EAC1B,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,6BAA6B;EAC7B,wBAAwB;EACxB,sBAAsB;EACtB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;EACxB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,uCAAuC;EACvC,uCAAuC;EACvC,mCAAmC;EACnC,uCAAuC;EACvC,gCAAgC;EAChC,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;;EAME,gCAAgC;EAChC,qBAAqB;AACvB;AACA;;;EAGE,qBAAqB;EACrB,aAAa;EACb,gBAAgB;AAClB;;AAEA;;;EAGE,8BAA8B;EAC9B,qBAAqB;AACvB;AACA;;EAEE,8BAA8B;EAC9B,oBAAoB;EACpB,qBAAqB;AACvB;AACA;;;;;;EAME,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,0BAA0B;AAC5B;AACA;;;;;;EAME,0CAA0C;EAC1C,mCAAmC;EACnC,eAAe;EACf,qBAAqB;EACrB,kBAAkB;EAClB,0CAA0C;EAC1C,0CAA0C;AAC5C;AACA;;;;;;EAME,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mCAAmC;EACnC,uCAAuC;EACvC,uCAAuC;EACvC,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,gDAAgD;EAChD,kBAAkB;EAClB,cAAc;EACd,UAAU;AACZ;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AAWA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,iBAAiB;AACnB;AAMA;EACE,gCAAgC;EAChC,mCAAmC;EACnC,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,0DAA0D;EAC1D,WAAW;EACX,YAAY;EACZ,OAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,MAAM;EACN,WAAW;AACb;AACA;EACE,6CAA6C;AAC/C;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;;gCAEgC;AAChC;EACE,yBAAiB;UAAjB,iBAAiB;EACjB,sBAAsB;EACtB,yDAAyD;EACzD,mBAAmB;EACnB,gBAAgB;EAChB,8BAA8B;EAC9B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,yBAAyB;EACzB,0BAA0B;EAC1B,4BAA4B;EAC5B,sBAAsB;EACtB,mBAAmB;EACnB,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,uCAAuC;AACzC;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,QAAQ;EACR,YAAY;EACZ,mCAAmC;EACnC,WAAW;EACX,4BAA4B;AAC9B;AACA;EACE,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,qCAAqC;AACvC;AACA;EACE,aAAa;AACf;AACA;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,oCAAoC;AACtC;AACA;EACE,wCAAwC;EACxC,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,WAAW;EACX,yDAAmD;EACnD,+BAA+B;EAC/B,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yCAAyC;EACzC,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,+BAA+B;AACjC;AACA;EACE,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,UAAU;EACV;;;;GAIC;AACH;AACA;EACE,qCAAqC;AACvC;;AAEA;;gCAEgC;AAChC;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA,+BAA+B;AAC/B;EACE,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;AACd;;AAEA,gDAAgD;AAChD;EACE,eAAe;EACf,WAAW;EACX,2BAA2B;EAC3B,yCAAyC;AAC3C;AACA;EACE,aAAa;AACf;AACA,uCAAuC;AACvC;EACE,gCAAgC;AAClC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;AACA,6BAA6B;AAC7B;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;;AAEA,gEAAgE;AAChE;EACE,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;AACA;EACE,qCAAqC;AACvC;AACA,4CAA4C;AAC5C;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA,kEAAkE;AAClE;EACE,4EAA4E;EAC5E,eAAe;EACf,gBAAgB;EAChB,0EAA0E;EAC1E,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,kDAAkD;EAClD,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;AACA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;AACA;EACE,mDAAmD;EACnD,2CAA2C;AAC7C;AACA;EACE,8CAA8C;EAC9C,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA,gEAAgE;AAChE;EACE,gCAAgC;AAClC;AACA;EACE,wBAAwB;AAC1B;AACA,sCAAsC;AACtC;EACE,oCAAoC;AACtC;AACA;EACE,8CAA8C;EAC9C,yBAAyB;EACzB,gDAAgD;EAChD,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE,8CAA8C;AAChD;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gCAAgC;EAChC,2CAA2C;EAC3C,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,8BAA8B;AAChC;AACA;;;;;;;;;;;;;CAaC;AACD;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,2BAA2B;AAC7B;AACA;EACE,cAAc;AAChB;AACA;;;EAGE,gBAAgB;AAClB;AACA,mDAAmD;AACnD;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,YAAY;EACZ;0DACwD;EACxD,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kCAAkC;EAClC,gCAAgC;EAChC,gBAAgB;EAChB,gCAAgC;AAClC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,6BAA6B;AAC/B;AACA;EACE,aAAa;AACf;AACA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,8BAA8B;AAChC;AACA;;;;;;CAMC;AACD;EACE;IACE,iBAAiB;EACnB;EACA;IACE,iBAAiB;EACnB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,YAAY;EACd;EACA;IACE,kBAAkB;IAClB,eAAe;EACjB;AACF;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gBAAgB;EAChB,yBAAyB;EACzB,2BAA2B;EAC3B,WAAW;EACX,sBAAsB;EACtB,qBAAqB;EAKrB,gCAAgC;EAGhC,uDAAuD;EACvD,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,WAAW;EACX,UAAU;EACV,MAAM;AACR;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,0BAA0B;EAK1B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,WAAW;EACX,cAAc;EACd,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,mCAAmC;EACnC,4BAA4B;AAC9B;AACA;;EAEE,8BAA8B;AAChC;AACA;;EAEE,WAAW;AACb;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,OAAO;EACP,YAAY;EACZ,MAAM;EACN,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,0CAA0C;EAE1C,gEAAgE;AAClE;AACA,wDAAwD;AACxD;EACE,aAAa;AACf;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,cAAc;AAChB;AACA;EACE,gCAAgC;AAClC;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,oCAAoC;EACpC,6BAA6B;AAC/B;AACA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,4CAA4C;EAC5C,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,uBAAuB;AACzB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;AACA;EACE,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;;AAEA,gBAAgB;AAChB;EACE,UAAU;AACZ;AACA;EACE,SAAS;AACX;AACA;EACE,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;;gCAEgC;AAChC;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,mCAAmC;AACrC;AACA;EACE,kBAAkB;EAClB,QAAQ;EAKR,2BAA2B;EAC3B,YAAY;EACZ,UAAU;EACV,WAAW;EACX,cAAc;EACd,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,2DAA2D;EAC3D,gEAAgE;EAChE,mEAAmE;EACnE,iEAAiE;EACjE,8DAA8D;EAG9D,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EAGE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;EACf,QAAQ;EACR,MAAM;EACN,WAAW;EACX,YAAY;EACZ,UAAU;EACV,0BAA0B;EAC1B,+BAA+B;EAC/B,kCAAkC;EAClC,8BAA8B;EAC9B,6BAA6B;EAC7B,UAAU;EACV,kBAAkB;EAClB,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,UAAU;EACV,2CAA2C;AAC7C;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,eAAe;EACf,WAAW;EAGX,yBAAyB;AAC3B;AACA;EAGE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,WAAW;EACX,SAAS;EACT,UAAU;AACZ;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,sCAAsC;AACxC;AACA;EACE,yCAAyC;AAC3C;AACA;EACE,sCAAsC;AACxC;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,0BAA0B;EAG1B,0BAA0B;EAC1B,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,0BAA0B;AAC5B;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EAGT,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,kBAAkB;EAGlB,0BAA0B;EAC1B,UAAU;AACZ;AACA;EAGE,0BAA0B;AAC5B;AACA;EAGE,wBAAwB;EACxB,8BAA8B;AAChC;AACA;;EAEE,aAAa;AACf;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,mCAAmC;EAGnC,0BAA0B;EAC1B,gCAAgC;EAChC,kBAAkB;EAClB,0BAA0B;EAC1B,uBAAuB;EACvB,sBAAsB;EACtB,qBAAqB;AACvB;AACA;EACE,qCAAqC;EACrC,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;;gCAEgC;AAChC;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,oCAAoC;EACpC,YAAY;EACZ,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gDAAgD;EAChD,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,mCAAmC;EACnC,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,eAAe;AACjB;;AAEA;;gCAEgC;AAChC;EACE,kDAAkD;EAClD,YAAY;EACZ,aAAa;EACb,eAAe;EACf,QAAQ;EACR,MAAM;EACN,4BAA4B;EAC5B,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,uBAAuB;EACvB,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,eAAe;EACf,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,6CAA6C;EAC7C,iBAAiB;AACnB;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gCAAgC;EAChC,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,YAAY;AACd;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,2BAA2B;EAC3B,MAAM;EACN,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;gCAEgC;AAChC;EACE,mDAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,mDAAgD;EAChD,sBAAsB;EACtB,2BAA2B;AAC7B;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;;AAEA;;gCAEgC;AAChC;EACE,mDAAiD;EACjD,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,4CAA4C;EAC5C,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,WAAW;EACX,yCAAyC;AAC3C;AACA;EACE,UAAU;EACV,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,UAAU;EACV,SAAS;EACT,WAAW;AACb;AACA;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,4BAA4B;EAC9B;AACF;;AAEA,iBAAiB;AACjB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,UAAU;EACV,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,4BAA4B;EAC5B,YAAY;AACd;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,oEAAoE;EACpE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,UAAU;EACV,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;EACZ,WAAW;EACX,0CAA0C;AAC5C;AACA;EACE,UAAU;EACV,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE;;IAGE,oBAAoB;EACtB;;EAEA;;IAGE,wBAAwB;EAC1B;;EAEA;IAEE,wBAAwB;EAC1B;AACF;;AAEA,gBAAgB;AAChB;EACE,mDAAiD;EACjD,sBAAsB;EACtB,2BAA2B;EAC3B,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;EACrB,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,UAAU;EACV,MAAM;AACR;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,aAAa;EACb,aAAa;EACb;;;;GAIC;EACD,wBAAwB;EACxB,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,YAAY;EACZ,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,uBAAuB;EAEvB,6CAA6C;AAC/C;AAMA;EACE;IACE,oBAAoB;EACtB;AACF;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,WAAW;AACb;AACA;EACE,SAAS;EACT,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE,SAAS;EACT,QAAQ;EACR,4CAA4C;AAC9C;;AAEA;;gCAEgC;AAChC;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,OAAO;EACP,MAAM;AACR;AACA;EACE,UAAU;EACV,MAAM;AACR;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;EAChB,kCAAkC;EAClC,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;;AAEA;;gCAEgC;AAChC;EACE,mDAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,2BAA2B;EAC3B,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,iCAAiC;AACnC;AACA;EACE,UAAU;EACV,SAAS;EACT,4CAA4C;AAC9C;AACA;EACE,UAAU;AACZ;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,YAAY;EACZ,aAAa;EACb,sEAAsE;EACtE,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,0CAA0C;EAC1C,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,2CAA2C;AAC7C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,kBAAkB;EAClB,mDAAmD;EACnD,sBAAsB;EACtB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,mEAAmE;EACnE,gDAAgD;AAClD;AACA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;EACV,QAAQ;EACR,4CAA4C;AAC9C;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE;IACE,mEAAmE;IACnE,UAAU;EACZ;EACA;IACE,qEAAqE;IACrE,UAAU;EACZ;AACF;AAWA;EACE;IACE,wCAAwC;EAC1C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,wCAAwC;EAC1C;AACF;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,yBAAyB;EACzB,iCAAiC;EACjC,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;AACZ;AACA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,mCAAmC;EACnC,+BAA+B;EAC/B,6BAA6B;EAC7B,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,0CAA0C;AAC5C;AACA;EACE,qBAAqB;EACrB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,6CAA6C;EAC7C,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,OAAO;AACT;AACA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA,eAAe;AACf;EACE,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EAEE,mDAA6C;EAE7C,eAAe;EAEf,sBAAsB;EAEtB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,OAAO;EACP,OAAO;EACP,2CAA2C;AAC7C;AACA;EACE,QAAQ;EACR,UAAU;EACV,4CAA4C;AAC9C;AACA;EACE,UAAU;EACV,QAAQ;EACR,sCAAsC;AACxC;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,kBAAkB;EAClB,0BAA0B;EAC1B,iCAAiC;EACjC,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;AACA;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,yBAAyB;EAC3B;AACF;;AAUA,eAAe;AACf;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,mCAAmC;EACnC,WAAW;AACb;AACA;EACE,oEAAoE;AACtE;AACA;EACE,mBAAmB;EACnB,2CAA2C;EAC3C,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;AACA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,WAAW;AACb;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gCAAgC;EAChC,0CAA0C;EAC1C,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,4CAA4C;AAC9C;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,UAAU;EACV,QAAQ;EACR,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,OAAO;EACP,aAAa;AACf;AACA;EACE,SAAS;EACT,QAAQ;EACR,4CAA4C;AAC9C;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,iCAAiC;EACjC,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,iCAAiC;EACjC,gBAAgB;EAChB,iBAAiB;EACjB,mCAAmC;EACnC,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,0CAA0C;EAC1C,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;AACf;;AAEA,cAAc;AACd;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,OAAO;AACT;AACA;EACE,SAAS;AACX;AACA;EACE,iBAAiB;EACjB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;;AAEA;;gCAEgC;AAChC;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,QAAQ;EACR,MAAM;EACN,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,WAAW;EACX,mDAAmD;AACrD;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,iCAAiC;AACnC;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EAEE,mDAA6C;EAE7C,eAAe;EAEf,sBAAsB;EAEtB,qBAAqB;EACrB,WAAW;EACX,aAAa;EACb,YAAY;AACd;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE,SAAS;EACT,QAAQ;AACV;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;;gCAEgC;AAChC;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,sCAAsC;EACtC,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,YAAY;EACZ,0BAA0B;EAC1B,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,sCAAsC;EACtC,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,wBAAwB;AAC1B;AACA;;EAEE,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,OAAO;EACP,MAAM;AACR;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,2CAA2C;EAC3C,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,MAAM;EACN,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,2BAA2B;EAC3B,wCAAwC;EACxC,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,uBAAuB;EACvB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,gDAAgD;AAClD;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;AACA;;;;EAIE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,iDAAiD;EACjD,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,uBAAuB;EACvB,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,kBAAkB;AAClB;EACE,mDAA4C;EAC5C,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,QAAQ;EACR,yCAAyC;AAC3C;AACA;EACE,QAAQ;EACR,WAAW;EACX,iDAAiD;AACnD;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,yBAAyB;EACzB,UAAU;EACV,kBAAkB;AACpB;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;EACxC,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;;gCAEgC;AAChC;EACE,oDAA0C;EAC1C,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;AACX;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,mEAAmE;EACnE,gDAAgD;AAClD;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,oCAAoC;EACpC,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,yCAAyC;EACzC,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,UAAU;EACV,WAAW;EACX,mCAAmC;EACnC,0CAA0C;AAC5C;;AAEA,eAAe;AACf;EACE,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,qCAAqC;EACrC,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,+BAA+B;EAC/B,8BAA8B;AAChC;AACA;EACE,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,MAAM;EACN,QAAQ;AACV;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;;AAEA;;gCAEgC;AAChC;EACE,yBAAyB;AAC3B;AACA;EACE,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,oDAA4C;EAC5C,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,aAAa;AACf;AACA;EACE,0BAA0B;EAC1B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,UAAU;EACV,WAAW;EACX,qCAAqC;EACrC,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,UAAU;EACV,oCAAoC;EACpC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,qCAAqC;EACrC,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,oDAA8C;EAC9C,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iCAAiC;EACjC,iCAAiC;EACjC,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ;;;;GAIC;AACH;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ;;;;;GAKC;EACD,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;AACZ;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,aAAa;EACb,UAAU;EACV,2BAA2B;AAC7B;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,UAAU;EACV,+BAA+B;AACjC;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;EACxC,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,+CAA+C;EAC/C,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,UAAU;AACZ;AACA;EACE,uBAAuB;AACzB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,YAAY;EACZ,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,OAAO;EACP,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gCAAgC;EAChC,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,8BAA8B;EAC9B,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,+CAA+C;AACjD;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,oDAAkD;EAClD,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,wCAAwC;EACxC,qBAAqB;AACvB;;AAEA,mBAAmB;AACnB;EACE,wCAAwC;AAC1C;;AAEA,qBAAqB;AACrB;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,eAAe;EACf,WAAW;AACb;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,mEAAmE;EACnE,gDAAgD;AAClD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;EAC9B,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,MAAM;EACN,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;EAC1B,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,gCAAgC;EAChC,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,cAAc;EACd,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;;EAEE,mCAAmC;EACnC,sBAAsB;EACtB,qCAAqC;AACvC;AACA;;EAEE,sBAAsB;AACxB;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,0BAA0B;EAC1B,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,sBAAsB;EACtB,mCAAmC;EACnC,qCAAqC;AACvC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,mCAAmC;EACnC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,0BAA0B;EAC1B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,qCAAqC;AACvC;AACA;EACE,qCAAqC;EACrC,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,WAAW;AACb;;AAEA;;gCAEgC;AAChC;EACE,kBAAkB;AACpB;AACA;;EAEE,oDAAuC;EACvC,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oDAAyC;AAC3C;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA,YAAY;AACZ;EACE,2BAA2B;AAC7B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;EACjC,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,4CAA4C;EAC5C,kBAAkB;EAClB,2BAA2B;EAC3B,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,oDAAyC;EACzC,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;AACA;EACE,aAAa;AACf;AACA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;gCAEgC;AAChC;EACE,oDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,QAAQ;EACR,iDAAiD;AACnD;AACA;EACE,UAAU;EACV,QAAQ;EACR,iDAAiD;AACnD;AACA;EACE;IACE,2CAA2C;EAC7C;EACA;IACE,8CAA8C;EAChD;EACA;IACE,+CAA+C;EACjD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,gDAAgD;EAClD;EACA;IACE,2CAA2C;EAC7C;AACF;AAsBA;EAEE,iDAAiD;AACnD;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA,kBAAkB;AAClB;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,uBAAuB;AACzB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,8BAA8B;EAC9B,WAAW;EACX,uBAAuB;AACzB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,8BAA8B;AAChC;AACA;EACE,OAAO;EACP,MAAM;AACR;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA,iBAAiB;AACjB;EACE,wCAAwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,WAAW;AACb;AACA;EACE,eAAe;EACf,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;;AAEA;;gCAEgC;AAChC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,MAAM;EACN,QAAQ;AACV;;AAEA;;gCAEgC;AAChC;EACE,oDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,oBAAoB;EACpB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;EACtB,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,2BAA2B;EAC3B,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,wBAAwB;EACxB,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,gBAAgB;AAChB;EACE,oDAA6C;EAC7C,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;EAChC,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,wCAAwC;EACxC,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,YAAY;EACZ,UAAU;EACV,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,eAAe;EACf,WAAW;EACX,UAAU;EACV,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,0BAA0B;AAC5B;;AAEA,oBAAoB;AACpB;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,UAAU;EACV,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,YAAY;EACZ,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,uBAAuB;EACvB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,gCAAgC;EAChC,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,mEAAmE;EACnE,gDAAgD;AAClD;;AAEA;;gCAEgC;AAChC;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,oDAAgD;EAChD,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,QAAQ;EACR,SAAS;AACX;AACA;EACE,SAAS;EACT,WAAW;EACX,4CAA4C;AAC9C;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,4CAA4C;EAC5C,mBAAmB;EACnB,iCAAiC;AACnC;AACA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;AACA;EACE,6BAA6B;EAC7B,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,oCAAoC;EACpC,0CAA0C;EAC1C,yBAAyB;AAC3B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;AACA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,8BAA8B;AAChC;AACA;EACE,sBAAsB;EACtB,0BAA0B;AAC5B;;AAEA;;gCAEgC;AAChC;EACE,oDAA2C;EAC3C,2BAA2B;EAC3B,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,0CAA0C;EAC1C,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,iDAAiD;EACjD,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,qCAAqC;EACrC,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,SAAS;EACT,QAAQ;EACR,4CAA4C;AAC9C;AACA;EACE,QAAQ;EACR,MAAM;AACR;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,UAAU;AACZ;AACA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;;gCAEgC;AAChC;EACE,oDAAwC;EACxC,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,0CAA0C;EAC1C,6BAA6B;AAC/B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,qCAAqC;EACrC,WAAW;EACX,MAAM;EACN,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;AAC5B;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,UAAU;EACV,iBAAiB;EACjB,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,WAAW;AACb;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,WAAW;EACX,WAAW;EACX,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,WAAW;EACX,oBAAoB;EACpB,wBAAwB;EACxB,4BAA4B;AAC9B;AACA;EACE,mCAAmC;AACrC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,eAAe;AACjB;AACA;EACE,gCAAgC;AAClC;;AAEA,cAAc;AACd;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,UAAU;EACV,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,iBAAiB;AACnB;;AAEA,cAAc;AACd;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,aAAa;AACb;EACE,wCAAwC;EACxC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,8BAA8B;EAC9B,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,8BAA8B;EAC9B,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,cAAc;EACd,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;;AAEA;;gCAEgC;AAChC;EACE,oDAA+C;EAC/C,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kCAAkC;EAClC,iCAAiC;EACjC,6CAA6C;AAC/C;AACA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;AACV;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,sBAAsB;EACtB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,0CAA0C;EAC1C,yBAAyB;EACzB,kBAAkB;EAClB,oBAAoB;EACpB,cAAc;AAChB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,mCAAmC;AACrC;;AAEA,oBAAoB;AACpB;EACE,oDAAkD;EAClD,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,gCAAgC;AAClC;AACA;EACE,0CAA0C;EAC1C,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;AACA;EACE,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,cAAc;EACd,2BAA2B;AAC7B;;AAEA,sBAAsB;AACtB;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,oEAAoE;EACpE,WAAW;AACb;AACA;EACE;gCAC8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,sBAAsB;EACtB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,0CAA0C;EAC1C,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,SAAS;AACX;AACA;EACE,eAAe;AACjB;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,mCAAmC;AACrC;AACA;EACE,0BAA0B;AAC5B;;AAEA,qBAAqB;AACrB;EACE,oDAAkD;EAClD,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gDAAgD;AAClD;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,aAAa;EACb,WAAW;AACb;AACA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,0CAA0C;AAC5C;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,YAAY;EACZ,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,gCAAgC;EAChC,SAAS;AACX;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,OAAO;EACP,SAAS;AACX;AACA;EACE,QAAQ;EACR,MAAM;AACR;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,QAAQ;EACR,WAAW;AACb;AACA;EACE,SAAS;EACT,QAAQ;EACR,4CAA4C;AAC9C;AACA;EACE,SAAS;EACT,WAAW;EACX,sCAAsC;AACxC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,6CAA6C;EAC7C,uBAAuB;EACvB,SAAS;AACX;AACA;EACE,8CAA8C;AAChD;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,yBAAyB;EACzB,8BAA8B;EAC9B,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,kBAAkB;AACpB;AACA;EACE,WAAW;AACb;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,mCAAmC;EACnC,sBAAsB;EACtB,qCAAqC;AACvC;;AAEA;;gCAEgC;AAChC;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,SAAS;EACT,YAAY;EACZ,aAAa;EACb,sEAAsE;EACtE,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,yBAAiB;UAAjB,iBAAiB;EACjB,0CAA0C;EAC1C,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,YAAY;EACZ,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EAGd,0BAA0B;EAC1B,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gCAAgC;EAChC,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,8BAA8B;EAC9B,8BAA8B;AAChC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,0BAA0B;AAC5B;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,cAAc;EACd,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,4BAA4B;EAC5B,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,uCAAuC;EACvC,gBAAgB;EAChB,kBAAkB;AACpB;AACA;;GAEG;AACH;EACE,aAAa;AACf;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,cAAc;EACd,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;;AAEA;;gCAEgC;AAChC;EACE,oDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,gBAAgB;AAClB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,2BAA2B;EAC3B,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,cAAc;AAChB;AACA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,SAAS;EACT,iDAAiD;AACnD;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,mCAAmC;EACnC,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,0CAA0C;AAC5C;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,aAAa;AACf;AACA;EACE,WAAW;EACX,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;;gCAEgC;AAChC;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;AACvB;AACA;EACE,oDAAwC;AAC1C;AACA;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;AACb;AACA;EACE,2CAA2C;EAC3C,2BAA2B;EAC3B,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mCAAmC;EACnC,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,MAAM;EACN,kBAAkB;EAClB,4BAA4B;EAC5B,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,cAAc;EACd,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,qBAAqB;EACrB,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;;AAEA,aAAa;AACb;EACE,oDAA2C;EAC3C,sBAAsB;EACtB,2BAA2B;EAC3B,qBAAqB;AACvB;AACA;EACE,gCAAgC;EAChC,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,4BAA4B;EAC5B,kBAAkB;EAClB,2BAA2B;AAC7B;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,cAAc;AAChB;AACA;EACE,gCAAgC;EAChC,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,gCAAgC;EAChC,eAAe;AACjB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mCAAmC;EACnC,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;;AAEA,cAAc;AACd;EACE,4BAA4B;EAC5B,gBAAgB;AAClB;AACA;EACE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,mCAAmC;EACnC,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,qCAAqC;AACvC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;AACA;EACE,gCAAgC;EAChC,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,8BAA8B;AAChC;;AAEA,eAAe;AACf;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,SAAS;EACT,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,cAAc;EACd,YAAY;EACZ,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;AAC5C;AACA;;EAEE,mCAAmC;EACnC,qCAAqC;EACrC,sBAAsB;AACxB;AACA;EACE,sBAAsB;EACtB,yCAAyC;EACzC,qCAAqC;EACrC,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,4BAA4B;EAC5B,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,mCAAmC;AACrC;AACA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;;EAEE,8BAA8B;AAChC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,sBAAsB;EACtB,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,QAAQ;AACV;AACA;EACE,cAAc;EACd,8BAA8B;EAC9B,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,sBAAsB;EACtB,wCAAwC;EACxC,6BAA6B;EAC7B,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,UAAU;EACV,YAAY;EACZ,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,cAAc;EACd,kCAAkC;EAClC,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;AAC5C;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,UAAU;EACV,cAAc;AAChB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,kBAAkB;EAClB,mEAAmE;EACnE,gDAAgD;AAClD;AACA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,0CAA0C;EAC1C,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,8BAA8B;AAChC;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,8BAA8B;EAC9B,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,gCAAgC;EAChC,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,8BAA8B;AAChC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,sBAAsB;AACxB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,uBAAuB;EACvB,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;;EAEE,WAAW;EACX,oCAAoC;EACpC,2BAA2B;EAC3B,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;AACA;;EAEE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,yBAAiB;UAAjB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;;AAEA;;gCAEgC;AAChC;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,oBAAoB;EACpB,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,gCAAgC;EAChC,oBAAoB;AACtB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,gCAAgC;EAChC,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;gCAEgC;AAChC;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;AACA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,gBAAgB;AAClB;;AAEA;;gCAEgC;AAChC;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,SAAS;EACT,WAAW;EACX,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;AACA;;EAEE,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,YAAY;EACZ,WAAW;EACX,WAAW;EACX,2BAA2B;EAG3B,2BAA2B;EAG3B,sBAAsB;EACtB,+DAA+D;AACjE;AACA;EAGE,0BAA0B;EAG1B,sBAAsB;AACxB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,UAAU;AACZ;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,6BAA6B;EAC7B,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,kCAAkC;EAClC,8BAA8B;EAC9B,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;EACR,MAAM;EACN,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,cAAc;EACd,2BAA2B;EAC3B,eAAe;AACjB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,mCAAmC;AACrC;;AAEA,eAAe;AACf;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,UAAU;AACZ;AACA;EACE,8BAA8B;AAChC;AACA;;EAEE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;AACA;EACE,qCAAqC;EACrC,sBAAsB;AACxB;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,6BAA6B;EAC7B,eAAe;AACjB;;AAEA;;gCAEgC;AAChC;EACE,iCAAiC;EACjC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,eAAe;EACf,QAAQ;EACR,YAAY;AACd;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,8BAA8B;EAC9B,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAGlB,yEAAyE;AAC3E;AACA;EACE,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,eAAe;EACf,6BAA6B;EAG7B,wEAAwE;AAC1E;;AAYA;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,yBAAyB;EAC3B;AACF;;AAaA;EACE;IAEE,uBAAuB;EACzB;EACA;IAEE,0BAA0B;EAC5B;AACF","sourcesContent":["/*\n  Theme Name: Hospitality Leadership Network\n  Description: Premium Hospitality Owners & Industry Leadership Platform\n  Version: 2.0\n*/\n\n/* CSS Index\n============================\n01. Variable CSS\n02. Header\n03. Mobile Menu\n04. Search\n05. OffCanvas\n06. Slider\n07. Banner\n08. Breadcrumb\n09. About\n10. Overview\n11. Features\n12. Choose\n13. Services\n14. Cta\n15. Counter\n16. Estimate\n17. Project\n18. Faq\n19. Request\n20. Team\n21. Testimonial\n22. Pricing\n23. Contact\n24. Blog\n25. Brand\n26. Error\n27. Footer\n28. Preloader\n============================\n*/\n\n/*=============================\n\t1. Google Fonts\n===============================*/\n@import url(\"https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@400;500;600;700&family=Inter:wght@300;400;500;600;700&display=swap\");\n\n/*=============================\n\t01. Variable CSS\n===============================*/\n:root {\n  --tg-body-font-family: \"Inter\", sans-serif;\n  --tg-heading-font-family: \"Cormorant Garamond\", serif;\n  --tg-primary-color: #0A1628;\n  --tg-secondary-color: #1C2A3A;\n  --tg-body-font-color: #4A5568;\n  --tg-heading-font-color: #0A1628;\n  --tg-paragraph-color: #4A5568;\n  --tg-section-background: #FFFFFF;\n  --tg-body-font-size: 16px;\n  --tg-body-font-weight: 400;\n  --tg-heading-font-weight: 600;\n  --tg-body-line-height: 1.7;\n  --tg-heading-line-height: 1.15;\n  --tg-text-transform: none;\n  --tg-accent-color: #C6A962;\n  --tg-accent-light: #E8D5A3;\n  --tg-accent-dark: #A68B3E;\n  --tg-blue: #1A365D;\n  --tg-metallic-blue: #2D4A6F;\n  --tg-cornflower-blue: #7BA0CC;\n  --tg-steel-blue: #8DA4BE;\n  --tg-lavender: #EDE8E0;\n  --tg-indigo: #3C366B;\n  --tg-purple: #553C9A;\n  --tg-pink: #B83280;\n  --tg-red: #C53030;\n  --tg-orange: #C05621;\n  --tg-yellow: #C6A962;\n  --tg-green: #276749;\n  --tg-teal: #285E61;\n  --tg-cyan: #2B6CB0;\n  --tg-white: #FFFFFF;\n  --tg-black: #0A1628;\n  --tg-gray: #FFFFFF;\n  --tg-gray-two: #EDE8E0;\n  --tg-gray-three: #8B8178;\n  --tg-gray-four: #6B6058;\n  --tg-border-color: #E2DDD5;\n  --facebook: #3b5998;\n  --twitter: #1DA1F2;\n  --linkedin: #0A66C2;\n  --pinterest: #E60023;\n  --youtube: #FF0000;\n  --skype: #00AFF0;\n}\nbody {\n  font-family: var(--tg-body-font-family);\n  font-weight: var(--tg-body-font-weight);\n  font-size: var(--tg-body-font-size);\n  line-height: var(--tg-body-line-height);\n  color: var(--tg-body-font-color);\n  font-style: normal;\n  background: #FFFFFF;\n}\nimg,\n.img {\n  max-width: 100%;\n  transition: all 0.3s ease-out 0s;\n}\n.f-left {\n  float: left;\n}\n.f-right {\n  float: right;\n}\n.fix {\n  overflow: hidden;\n}\na,\nbutton {\n  -webkit-transition: all 0.3s ease-out 0s;\n  -moz-transition: all 0.3s ease-out 0s;\n  -ms-transition: all 0.3s ease-out 0s;\n  -o-transition: all 0.3s ease-out 0s;\n  transition: all 0.3s ease-out 0s;\n  text-decoration: none;\n}\na:focus,\n.btn:focus,\nbutton:focus {\n  text-decoration: none;\n  outline: none;\n  box-shadow: none;\n}\n\na:hover,\n.portfolio-cat a:hover,\n.footer -menu li a:hover {\n  color: var(--tg-primary-color);\n  text-decoration: none;\n}\na,\nbutton {\n  color: var(--tg-primary-color);\n  outline: medium none;\n  text-decoration: none;\n}\n.btn:focus,\nbutton:focus,\ninput:focus,\ninput:focus,\ntextarea,\ntextarea:focus {\n  outline: 0;\n}\n.uppercase {\n  text-transform: uppercase;\n}\n.capitalize {\n  text-transform: capitalize;\n}\nh1,\nh2,\nh3,\nh4,\nh5,\nh6 {\n  font-family: var(--tg-heading-font-family);\n  color: var(--tg-heading-font-color);\n  margin-top: 0px;\n  margin-bottom: 0.7rem;\n  font-style: normal;\n  line-height: var(--tg-heading-line-height);\n  font-weight: var(--tg-heading-font-weight);\n}\nh1 a,\nh2 a,\nh3 a,\nh4 a,\nh5 a,\nh6 a {\n  color: inherit;\n}\nh1 {\n  font-size: 2.5rem;\n}\nh2 {\n  font-size: 2rem;\n}\nh3 {\n  font-size: 1.75rem;\n}\nh4 {\n  font-size: 1.5rem;\n}\nh5 {\n  font-size: 1.25rem;\n}\nh6 {\n  font-size: 1rem;\n}\n.list-wrap {\n  margin: 0px;\n  padding: 0px;\n}\n.list-wrap li {\n  list-style: none;\n}\np {\n  font-size: var(--tg-body-font-size);\n  font-weight: var(--tg-body-font-weight);\n  line-height: var(--tg-body-line-height);\n  color: var(--tg-paragraph-color);\n  text-transform: var(--tg-text-transform);\n  margin-bottom: 15px;\n}\nhr {\n  border-bottom: 1px solid var(--tg-primary-color);\n  border-top: 0 none;\n  margin: 30px 0;\n  padding: 0;\n}\nlabel {\n  color: var(--tg-body-font-color);\n  cursor: pointer;\n  font-size: 16px;\n  font-weight: 400;\n}\n*::-moz-selection {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  text-shadow: none;\n}\n::-moz-selection {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  text-shadow: none;\n}\n::selection {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  text-shadow: none;\n}\n*::-moz-placeholder {\n  color: var(--tg-body-font-color);\n  font-size: var(--tg-body-font-size);\n  opacity: 1;\n}\n*::placeholder {\n  color: var(--tg-body-font-color);\n  font-size: var(--tg-body-font-size);\n  opacity: 1;\n}\n.theme-overlay {\n  position: relative;\n}\n.theme-overlay::before {\n  background: var(--tg-primary-color) none repeat scroll 0 0;\n  content: \"\";\n  height: 100%;\n  left: 0;\n  opacity: 0.6;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.separator {\n  border-top: 1px solid var(--tg-primary-color);\n}\n\n/* Bootstrap 5 */\n.container {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.row {\n  --bs-gutter-x: 30px;\n}\n.row.g-0 {\n  --bs-gutter-x: 0;\n}\n.gutter-y-30 {\n  --bs-gutter-y: 30px;\n}\n\n/*=============================\n\t1. Button style\n===============================*/\n.btn {\n  user-select: none;\n  -moz-user-select: none;\n  background: var(--tg-accent-color) none repeat scroll 0 0;\n  border: medium none;\n  border-radius: 0;\n  color: var(--tg-primary-color);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 1.5px;\n  line-height: 1;\n  margin-bottom: 0;\n  padding: 16px 32px;\n  text-align: center;\n  text-transform: uppercase;\n  touch-action: manipulation;\n  transition: all 0.4s ease 0s;\n  vertical-align: middle;\n  white-space: nowrap;\n  border: 2px solid var(--tg-accent-color);\n  position: relative;\n  z-index: 1;\n  font-family: var(--tg-body-font-family);\n}\n.btn::after {\n  content: \"\";\n  display: none;\n}\n.btn::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 0;\n  height: 100%;\n  background: var(--tg-primary-color);\n  z-index: -1;\n  transition: all 0.4s ease 0s;\n}\n.btn:hover::before {\n  width: 100%;\n}\n.btn:hover {\n  color: var(--tg-white);\n  border-color: var(--tg-primary-color);\n}\n.btn.btn-two {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  border-color: var(--tg-primary-color);\n}\n.btn.btn-two::after {\n  display: none;\n}\n.btn.btn-two:hover {\n  background: var(--tg-accent-color);\n  color: var(--tg-primary-color);\n  border-color: var(--tg-accent-color);\n}\n.transparent-btn {\n  border: 2px solid var(--tg-accent-color);\n  background: transparent;\n  color: var(--tg-accent-color);\n  border-radius: 0;\n}\n.btn-three {\n  padding: 19px 30px;\n}\n.transparent-btn-two::before,\n.btn-three::before {\n  display: none;\n}\n.transparent-btn-two::after,\n.btn-three::after {\n  content: \"\";\n  background-image: url(../img/icons/right-arrow.svg);\n  filter: brightness(0) invert(1);\n  width: 18px;\n  height: 12px;\n  margin-left: 12px;\n}\n.btn-three:hover {\n  background: var(--tg-secondary-color);\n}\n.transparent-btn-two {\n  border: 2px solid var(--tg-primary-color);\n  color: var(--tg-primary-color);\n  background: transparent;\n  padding: 17px 30px;\n}\n.transparent-btn-two::after {\n  filter: none;\n  transition: all 0.3s ease 0s;\n}\n.transparent-btn-two:hover {\n  background: var(--tg-primary-color);\n}\n.transparent-btn-two:hover::after {\n  filter: brightness(0) invert(1);\n}\n.breadcrumb > .active {\n  color: var(--tg-primary-color);\n}\n\n/* scrollUp */\n.scroll-top {\n  width: 35px;\n  height: 35px;\n  line-height: 35px;\n  position: fixed;\n  bottom: -10%;\n  right: 30px;\n  font-size: var(--tg-body-font-size);\n  border-radius: 6px;\n  z-index: 99;\n  color: var(--tg-white);\n  text-align: center;\n  cursor: pointer;\n  background: var(--tg-primary-color);\n  transition: 1s ease;\n  border: none;\n}\n.scroll-top.open {\n  bottom: 30px;\n}\n.scroll-top::after {\n  position: absolute;\n  z-index: -1;\n  content: \"\";\n  top: 100%;\n  left: 5%;\n  height: 10px;\n  width: 90%;\n  opacity: 1;\n  background: radial-gradient(\n    ellipse at center,\n    rgba(0, 0, 0, 0.25) 0%,\n    rgba(0, 0, 0, 0) 80%\n  );\n}\n.scroll-top:hover {\n  background: var(--tg-secondary-color);\n}\n\n/*=============================\n\t02. Header\n===============================*/\n.custom-container {\n  max-width: 1310px;\n}\n.custom-container-two {\n  max-width: 1360px;\n}\n.custom-container-three {\n  max-width: 1800px;\n}\n/* ── Base header (shared) ── */\n.transparent-header {\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: auto;\n}\n\n/* ── Static header (all pages except home) ── */\n.transparent-header.header-static {\n  position: fixed;\n  z-index: 99;\n  background: var(--tg-white);\n  box-shadow: 0 1px 8px rgba(0, 0, 0, 0.06);\n}\n.header-spacer {\n  height: 100px;\n}\n/* Static: dark nav links on white bg */\n.header-static .menu-area:not(.sticky-menu) .navbar-wrap > ul > li > a {\n  color: var(--tg-secondary-color);\n}\n.header-static .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.active > a,\n.header-static .menu-area:not(.sticky-menu) .navbar-wrap > ul > li:hover > a {\n  color: #C6A962;\n}\n.header-static .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.menu-item-has-children > a::after {\n  color: var(--tg-paragraph-color);\n}\n.header-static .menu-area:not(.sticky-menu) .header-search a,\n.header-static .menu-area:not(.sticky-menu) .mobile-nav-toggler {\n  color: var(--tg-secondary-color);\n}\n.header-static .menu-area:not(.sticky-menu) .header-action .transparent-btn {\n  border-color: var(--tg-accent-color);\n  color: var(--tg-accent-color);\n}\n.header-static .menu-area:not(.sticky-menu) .header-action .transparent-btn:hover {\n  border-color: var(--tg-primary-color);\n  color: var(--tg-primary-color);\n}\n/* Static: always dark logo */\n.header-static .logo .logo-dark {\n  display: none !important;\n}\n.header-static .logo .logo-light {\n  display: inline-block !important;\n}\n\n/* ── Overlay header (home page only) — sits over dark hero ── */\n.transparent-header.header-overlay {\n  position: absolute;\n  z-index: 9;\n  background: transparent;\n  box-shadow: none;\n}\n.header-overlay .heder-top-wrap {\n  background: transparent !important;\n  border-bottom: 1px solid rgba(255,255,255,0.1);\n}\n.header-static .heder-top-wrap {\n  background: var(--tg-secondary-color);\n}\n/* Overlay: white nav links over dark hero */\n.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li > a {\n  color: #FFFFFF;\n}\n.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.active > a,\n.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li:hover > a {\n  color: #C6A962;\n}\n.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.menu-item-has-children > a::after {\n  color: #FFFFFF;\n}\n.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.menu-item-has-children:hover > a::after,\n.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap > ul > li.menu-item-has-children.active > a::after {\n  color: #C6A962;\n}\n.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap ul li .sub-menu li a {\n  color: var(--tg-secondary-color);\n}\n.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap ul li .sub-menu li a:hover,\n.header-overlay .menu-area:not(.sticky-menu) .navbar-wrap ul li .sub-menu > li.active > a {\n  color: var(--tg-primary-color);\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-search a,\n.header-overlay .menu-area:not(.sticky-menu) .mobile-nav-toggler {\n  color: #FFFFFF;\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-action .transparent-btn {\n  border-color: rgba(255,255,255,0.4);\n  color: #FFFFFF;\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-action .transparent-btn:hover {\n  border-color: #C6A962;\n  color: #C6A962;\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-action .btn:not(.transparent-btn):hover {\n  background: #FFFFFF;\n  color: #0A1628;\n  border-color: #FFFFFF;\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-action .btn:not(.transparent-btn):hover::before {\n  background: #FFFFFF;\n}\n/* Overlay: profile name, logout, signin text white on dark hero */\n.header-profile-name {\n  /* Was `fontSize: 13px`, which is JS spelling and so was dropped outright. */\n  font-size: 13px;\n  font-weight: 600;\n  /* A long name is elided rather than allowed to push Logout off the row. */\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-profile-name {\n  color: #FFFFFF;\n}\n.header-static .menu-area:not(.sticky-menu) .header-profile-name,\n.sticky-menu .header-profile-name {\n  color: var(--tg-secondary-color);\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-logout-btn {\n  border: 1px solid rgba(255,255,255,0.4) !important;\n  color: #FFFFFF !important;\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-logout-btn:hover {\n  border-color: #C6A962 !important;\n  color: #C6A962 !important;\n}\n.header-static .menu-area:not(.sticky-menu) .header-logout-btn {\n  border: 1px solid var(--tg-border-color) !important;\n  color: var(--tg-body-font-color) !important;\n}\n.sticky-menu .header-logout-btn {\n  border: 1px solid var(--tg-border-color) !important;\n  color: var(--tg-body-font-color) !important;\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-signin-btn {\n  border-color: rgba(255,255,255,0.4) !important;\n  color: #FFFFFF !important;\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-signin-btn:hover {\n  border-color: #C6A962 !important;\n  color: #C6A962 !important;\n}\n\n/* Overlay: light logo (for dark bg) initially, swap on sticky */\n.header-overlay .menu-area:not(.sticky-menu) .logo .logo-dark {\n  display: inline-block !important;\n}\n.header-overlay .menu-area:not(.sticky-menu) .logo .logo-light {\n  display: none !important;\n}\n/* Join Network button visible hover */\n.header-join-btn {\n  transition: all 0.3s ease !important;\n}\n.header-static .header-join-btn:hover {\n  background: var(--tg-primary-color) !important;\n  color: #FFFFFF !important;\n  border-color: var(--tg-primary-color) !important;\n  box-shadow: 0 8px 25px rgba(198,169,98,0.3);\n  transform: translateY(-2px);\n}\n.header-static .header-join-btn:hover::before {\n  background: var(--tg-primary-color) !important;\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-join-btn:hover {\n  background: #FFFFFF !important;\n  color: #0A1628 !important;\n  border-color: #FFFFFF !important;\n  box-shadow: 0 8px 25px rgba(198,169,98,0.3);\n  transform: translateY(-2px);\n}\n.header-overlay .menu-area:not(.sticky-menu) .header-join-btn:hover::before {\n  background: #FFFFFF !important;\n}\n.header-signin-btn:hover {\n  color: #C6A962 !important;\n  border-color: #C6A962 !important;\n}\n#header-fixed-height.active-height {\n  display: block;\n  height: 96px;\n}\n.heder-top-wrap {\n  background: var(--tg-secondary-color);\n  overflow: hidden;\n  padding: 9px 0;\n}\n.header-top-left .list-wrap {\n  display: flex;\n  align-items: center;\n  gap: 10px 35px;\n}\n.header-top-left .list-wrap li {\n  font-size: 14px;\n  color: var(--tg-lavender);\n  display: flex;\n  align-items: center;\n  line-height: 1.28;\n  position: relative;\n}\n.header-top-left .list-wrap li::before {\n  content: \"\";\n  position: absolute;\n  right: -16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1px;\n  height: 100%;\n  background: var(--tg-metallic-blue);\n}\n.header-top-left .list-wrap li:last-child::before {\n  display: none;\n}\n.header-top-left .list-wrap li i {\n  font-size: 20px;\n  margin-right: 8px;\n  line-height: 0;\n  color: var(--tg-cornflower-blue);\n}\n.header-top-left .list-wrap li a {\n  color: var(--tg-lavender);\n}\n.header-top-left .list-wrap li a:hover {\n  color: var(--tg-primary-color);\n}\n.header-top-right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n}\n.header-contact {\n  position: relative;\n  margin-right: 35px;\n}\n.header-contact::before {\n  content: \"\";\n  position: absolute;\n  right: -16px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1px;\n  height: 500%;\n  background: var(--tg-metallic-blue);\n}\n.header-contact a {\n  font-size: 14px;\n  line-height: 1.28;\n  color: var(--tg-lavender);\n  display: flex;\n  align-items: center;\n}\n.header-contact a i {\n  font-size: 20px;\n  margin-right: 8px;\n}\n.header-contact a:hover {\n  color: var(--tg-primary-color);\n}\n.header-social .list-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.header-social .list-wrap li a {\n  font-size: 15px;\n  color: var(--tg-lavender);\n}\n.header-social .list-wrap li a:hover {\n  color: var(--tg-primary-color);\n}\n/*\n  Logo | nav | account controls, all on one row.\n\n  This used to be `flex-wrap: wrap` with `justify-content: flex-start`, so as\n  soon as the row ran out of width the account block (search, avatar, name,\n  Logout) dropped onto a second line and started again at the left edge, under\n  the logo. That happens as soon as somebody signs in, because the avatar and\n  the member's full name are far wider than the Sign In / Join buttons the\n  width was budgeted for.\n\n  Nothing wraps now: the nav is the part allowed to give up width, and the\n  account block is pinned to the right by `margin-left: auto` so it lines up\n  with the nav above it whatever the viewport.\n*/\n.menu-nav {\n  display: flex;\n  align-items: center;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n}\n.menu-nav > .logo {\n  flex-shrink: 0;\n}\n.logo img,\n.f-logo img,\n.fw-logo img {\n  max-height: 45px;\n}\n/* Sticky menu: always show dark logo on white bg */\n.sticky-menu .logo .logo-dark {\n  display: none !important;\n}\n.sticky-menu .logo .logo-light {\n  display: inline-block !important;\n}\n.navbar-wrap {\n  display: flex;\n  flex-grow: 1;\n  /* Without this a flex item refuses to shrink below its content width, which\n     is what forced the overflow that made the row wrap. */\n  min-width: 0;\n}\n.navbar-wrap ul {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  padding: 0 0;\n  margin: 0 0 0 auto;\n}\n.navbar-wrap ul li {\n  list-style: none;\n  display: block;\n  position: relative;\n}\n.navbar-wrap ul li a {\n  font-size: 16px;\n  font-weight: 500;\n  text-transform: capitalize;\n  color: var(--tg-secondary-color);\n  padding: 20px 15px;\n  display: block;\n  line-height: 1;\n  position: relative;\n  z-index: 1;\n}\n.navbar-wrap > ul > li.active > a,\n.navbar-wrap > ul > li:hover > a {\n  color: #C6A962;\n}\n.navbar-wrap > ul > li.menu-item-has-children > a::after {\n  content: \"\\f107\";\n  font-weight: 700;\n  font-family: \"Font Awesome 5 Free\";\n  color: var(--tg-paragraph-color);\n  margin-left: 8px;\n  transition: all 0.3s ease-out 0s;\n}\n.navbar-wrap > ul > li.menu-item-has-children:hover > a::after,\n.navbar-wrap > ul > li.menu-item-has-children.active > a::after {\n  color: var(--tg-primary-color);\n}\n.main-menu .navigation li.menu-item-has-children .dropdown-btn {\n  display: none;\n}\n.header-action {\n  margin-left: auto;\n  flex-shrink: 0;\n}\n.header-action > ul {\n  display: flex;\n  align-items: center;\n  margin-left: 25px;\n}\n.header-action > ul li {\n  position: relative;\n  margin-left: 25px;\n}\n.header-action ul li:first-child {\n  margin-left: 0;\n}\n.header-action ul li a {\n  color: var(--tg-heading-font-color);\n  font-size: 14px;\n}\n.header-action ul li.header-search {\n  line-height: 0;\n}\n.header-action ul li.header-search a {\n  color: #334770;\n  font-size: 22px;\n  line-height: 0;\n  transition: all 0.3s ease-out 0s;\n}\n.header-action ul li.header-search a:hover {\n  color: var(--tg-primary-color);\n}\n.header-action .header-btn .btn {\n  color: var(--tg-white);\n  font-size: 15px;\n  padding: 16px 33px;\n  border: 2px solid transparent;\n}\n.header-action .header-btn .btn::before {\n  display: none;\n}\n.header-action .header-btn .btn:hover {\n  background: transparent;\n  border-color: var(--tg-primary-color);\n  color: var(--tg-primary-color);\n}\n/*\n  The signed-in bar carries an avatar, a name and two buttons where the signed-\n  out one carries two links, and the container tops out at 1250px. At the old\n  spacing that row measured wider than the container on every desktop width,\n  which is what pushed it onto a second line. These are the millimetres that\n  buy it back; the bar is unchanged for a signed-out visitor, who has the room.\n*/\n@media (min-width: 992px) {\n  .header-action > ul {\n    margin-left: 15px;\n  }\n  .header-action > ul li {\n    margin-left: 16px;\n  }\n  .navbar-wrap ul li a {\n    padding: 20px 11px;\n  }\n  .header-action .header-profile-link a {\n    padding: 8px;\n  }\n  .header-action .header-btn .btn {\n    padding: 10px 14px;\n    font-size: 11px;\n  }\n}\n.navbar-wrap ul li .sub-menu {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 100%;\n  min-width: 230px;\n  border: 1px solid #f5f5f5;\n  background: var(--tg-white);\n  margin: 0 0;\n  transform: scale(1, 0);\n  transform-origin: 0 0;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  -webkit-box-shadow: 0px 30px 70px 0px rgba(137, 139, 142, 0.15);\n  -moz-box-shadow: 0px 30px 70px 0px rgba(137, 139, 142, 0.15);\n  box-shadow: 0px 30px 70px 0px rgba(137, 139, 142, 0.15);\n  border-radius: 5px;\n  padding: 18px 0;\n  display: block;\n  visibility: hidden;\n  opacity: 0;\n  z-index: 9;\n}\n.navbar-wrap ul li .sub-menu .sub-menu {\n  right: auto;\n  left: 100%;\n  top: 0;\n}\n.navbar-wrap ul li .sub-menu li {\n  margin-left: 0;\n  text-align: left;\n  display: block;\n}\n.navbar-wrap ul li .sub-menu li a {\n  padding: 9px 15px 9px 25px;\n  line-height: 1.4;\n  font-size: 16px;\n  font-weight: 500;\n  color: var(--tg-secondary-color);\n  text-transform: capitalize;\n  -webkit-transition: all 0.3s ease-in-out;\n  -moz-transition: all 0.3s ease-in-out;\n  -ms-transition: all 0.3s ease-in-out;\n  -o-transition: all 0.3s ease-in-out;\n  transition: all 0.3s ease-in-out;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.navbar-wrap ul li .sub-menu li a::before {\n  content: \"\";\n  display: block;\n  width: 0;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--tg-primary-color);\n  transition: 0.3s ease-in-out;\n}\n.navbar-wrap ul li .sub-menu > li.active > a,\n.navbar-wrap ul li .sub-menu li a:hover {\n  color: var(--tg-primary-color);\n}\n.navbar-wrap ul li .sub-menu > li.active > a::before,\n.navbar-wrap ul li .sub-menu li a:hover::before {\n  width: 10px;\n}\n.navbar-wrap ul li:hover > .sub-menu {\n  opacity: 1;\n  visibility: visible;\n  transform: scale(1);\n}\n.sticky-menu {\n  position: fixed;\n  left: 0;\n  margin: auto;\n  top: 0;\n  width: 100%;\n  z-index: 99;\n  background: var(--tg-white);\n  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n  -webkit-animation: 300ms ease-in-out 0s normal none 1 running fadeInDown;\n  animation: 300ms ease-in-out 0s normal none 1 running fadeInDown;\n}\n/* Hide top bar and fix colors when sticky on white bg */\n.sticky-menu .heder-top-wrap {\n  display: none;\n}\n.sticky-menu .navbar-wrap > ul > li > a {\n  color: var(--tg-secondary-color);\n}\n.sticky-menu .navbar-wrap > ul > li.active > a,\n.sticky-menu .navbar-wrap > ul > li:hover > a {\n  color: #C6A962;\n}\n.sticky-menu .navbar-wrap > ul > li.menu-item-has-children > a::after {\n  color: var(--tg-paragraph-color);\n}\n.sticky-menu .header-search a,\n.sticky-menu .mobile-nav-toggler {\n  color: var(--tg-secondary-color);\n}\n.sticky-menu .header-action .transparent-btn {\n  border-color: var(--tg-accent-color);\n  color: var(--tg-accent-color);\n}\n.sticky-menu .header-action .transparent-btn:hover {\n  border-color: var(--tg-primary-color);\n  color: var(--tg-primary-color);\n}\n\n/* header-two */\n.header-style-two .heder-top-wrap {\n  padding: 0;\n}\n.header-style-two .header-top-left {\n  padding-left: 25px;\n}\n.header-style-two .header-top-right {\n  gap: 20px;\n}\n.header-top-btn a {\n  font-weight: 700;\n  font-size: 14px;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  display: flex;\n  align-items: center;\n  line-height: 0;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  padding: 17px 25px;\n}\n.header-top-btn a i {\n  font-size: 16px;\n  margin-right: 10px;\n}\n.header-top-btn a:hover {\n  background: var(--tg-blue);\n}\n.header-style-two .menu-area {\n  box-shadow: 0px 2px 50px rgba(0, 0, 0, 0.05);\n  background: var(--tg-white);\n  padding: 0 0 0 30px;\n}\n.header-style-two .navbar-wrap ul {\n  margin: 0 0 0 60px;\n}\n.header-style-two .navbar-wrap ul li a {\n  padding: 32px 15px;\n}\n.header-contact-two {\n  display: flex;\n  align-items: center;\n  margin-right: 30px;\n}\n.header-contact-two .icon {\n  width: 40px;\n  height: 40px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  line-height: 0;\n  border-radius: 50%;\n  font-size: 20px;\n  margin-right: 7px;\n}\n.header-contact-two .content span {\n  display: block;\n  font-weight: 500;\n  font-size: 12px;\n  color: var(--tg-paragraph-color);\n  line-height: 1;\n  margin-bottom: 5px;\n}\n.header-contact-two .content a {\n  font-weight: 700;\n  font-size: 16px;\n  display: block;\n  line-height: 1;\n  color: var(--tg-secondary-color);\n}\n.header-contact-two .content a:hover {\n  color: var(--tg-primary-color);\n}\n.header-style-two .header-action ul > li > a {\n  padding: 29px 29px;\n  display: block;\n  min-height: 80px;\n  display: flex;\n  align-items: center;\n}\n.header-action .offcanvas-menu a {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  min-width: 26px;\n  padding: 29px 29px;\n  justify-content: center;\n}\n.header-action .offcanvas-menu a span {\n  width: 26px;\n  height: 2px;\n  border-radius: 2px;\n  background: var(--tg-paragraph-color);\n  transition: 0.3s linear;\n}\n.header-action .offcanvas-menu a span:nth-child(2) {\n  width: 23px;\n}\n.header-action .offcanvas-menu a span:nth-child(3) {\n  width: 15px;\n}\n.header-style-two .header-action .offcanvas-menu a:hover span {\n  background: var(--tg-primary-color);\n}\n.header-style-two .header-action > ul li {\n  margin-left: 0;\n}\n.header-style-two .header-action > ul li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1px;\n  height: 100%;\n  background: #d9d9d9;\n}\n.header-style-two .header-action > ul li:first-child::before {\n  display: none;\n}\n.header-style-two.sticky-menu .heder-top-wrap {\n  display: none;\n}\n.header-style-two.sticky-menu .menu-area {\n  box-shadow: none;\n}\n\n/* header-three */\n.header-action .offcanvas-menu.offcanvas-menu-two a {\n  padding: 0 0;\n}\n.header-style-three .header-action > ul li {\n  margin-left: 20px;\n}\n.header-style-three .header-action > ul li:first-child {\n  margin-left: 0;\n}\n.header-style-three .header-action > ul {\n  margin-left: 50px;\n}\n\n/* header-four */\n.header-style-four .heder-top-wrap {\n  padding: 0;\n}\n.header-style-four .header-top-right {\n  gap: 20px;\n}\n.header-style-four .menu-area {\n  background: var(--tg-white);\n  box-shadow: 0px 2px 50px rgba(0, 0, 0, 0.05);\n}\n\n.header-style-five .header-btn .btn {\n  text-transform: capitalize;\n}\n\n.header-style-six .menu-area {\n  background: var(--tg-white);\n}\n\n/*=============================\n\t03. Mobile Menu\n===============================*/\n.nav-outer .mobile-nav-toggler {\n  position: relative;\n  float: right;\n  font-size: 40px;\n  line-height: 50px;\n  cursor: pointer;\n  display: none;\n  color: var(--tg-white);\n  margin-right: 30px;\n  top: 15px;\n}\n.nav-logo img {\n  max-width: 135px;\n}\n.mobile-search {\n  padding: 0 20px 25px 25px;\n}\n.mobile-search form {\n  position: relative;\n}\n.mobile-search input {\n  display: block;\n  width: 100%;\n  border: none;\n  padding: 10px 45px 10px 20px;\n  font-size: 14px;\n  font-weight: 500;\n  height: 45px;\n  background: var(--tg-gray);\n  color: var(--tg-secondary-color);\n}\n.mobile-search input::placeholder {\n  font-size: 14px;\n  font-weight: 500;\n  color: var(--tg-heading-font-color);\n}\n.mobile-search button {\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n  -moz-transform: translateY(-50%);\n  -ms-transform: translateY(-50%);\n  -o-transform: translateY(-50%);\n  transform: translateY(-50%);\n  border: none;\n  padding: 0;\n  right: 20px;\n  line-height: 1;\n  background: transparent;\n  color: var(--tg-secondary-color);\n}\n.mobile-menu {\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 320px;\n  padding-right: 30px;\n  max-width: 100%;\n  height: 100%;\n  z-index: 99;\n  border-radius: 0px;\n  transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86);\n  -moz-transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86);\n  -webkit-transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86);\n  -ms-transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86) e;\n  -o-transition: all 0.3s cubic-bezier(0.785, 0.135, 0.15, 0.86);\n  -webkit-transform: translateX(101%);\n  -ms-transform: translateX(101%);\n  transform: translateX(101%);\n}\n.mobile-menu .navbar-collapse {\n  display: block !important;\n}\n.mobile-menu .nav-logo {\n  position: relative;\n  padding: 30px 25px;\n  text-align: left;\n}\n.mobile-menu-visible {\n  overflow: hidden;\n}\n.mobile-menu-visible .mobile-menu {\n  -webkit-transform: translateX(0%);\n  -ms-transform: translateX(0%);\n  transform: translateX(0%);\n}\n.mobile-menu .navigation li.current > a:before {\n  height: 100%;\n}\n.menu-backdrop {\n  position: fixed;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 2;\n  transition: all 700ms ease;\n  -moz-transition: all 700ms ease;\n  -webkit-transition: all 700ms ease;\n  -ms-transition: all 700ms ease;\n  -o-transition: all 700ms ease;\n  opacity: 0;\n  visibility: hidden;\n  background: rgba(0, 0, 0, 0.5);\n}\n.mobile-menu-visible .menu-backdrop {\n  opacity: 1;\n  visibility: visible;\n}\n.mobile-menu .menu-box {\n  position: absolute;\n  left: 0px;\n  top: 0px;\n  width: 100%;\n  height: 100%;\n  max-height: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  background: var(--tg-white);\n  padding: 0px 0px;\n  z-index: 5;\n  box-shadow: -9px 0 14px 0px rgb(0 0 0 / 6%);\n}\n.mobile-menu-visible .mobile-menu .menu-box {\n  opacity: 1;\n  visibility: visible;\n}\n.mobile-menu .close-btn {\n  position: absolute;\n  right: 15px;\n  top: 28px;\n  line-height: 30px;\n  width: 35px;\n  text-align: center;\n  font-size: 20px;\n  color: #292b37;\n  cursor: pointer;\n  z-index: 10;\n  -webkit-transition: all 0.9s ease;\n  -o-transition: all 0.9s ease;\n  transition: all 0.9s ease;\n}\n.mobile-menu-visible .mobile-menu .close-btn {\n  -webkit-transform: rotate(360deg);\n  -ms-transform: rotate(360deg);\n  transform: rotate(360deg);\n}\n.mobile-menu .navigation {\n  position: relative;\n  display: block;\n  width: 100%;\n  float: none;\n  margin: 0;\n  padding: 0;\n}\n.mobile-menu .navigation ul {\n  padding: 0;\n  margin: 0;\n}\n.mobile-menu .navigation li {\n  position: relative;\n  display: block;\n  border-top: 1px solid rgb(0 0 0 / 10%);\n}\n.mobile-menu .navigation:last-child {\n  border-bottom: 1px solid rgb(0 0 0 / 10%);\n}\n.mobile-menu .navigation li > ul > li:first-child {\n  border-top: 1px solid rgb(0 0 0 / 10%);\n}\n.mobile-menu .navigation li > a {\n  position: relative;\n  display: block;\n  line-height: 24px;\n  padding: 10px 60px 10px 25px;\n  font-size: 16px;\n  font-weight: 700;\n  color: var(--tg-heading-font-color);\n  text-transform: capitalize;\n  -webkit-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n  border: none;\n}\n.mobile-menu .navigation li ul li > a {\n  font-size: 16px;\n  margin-left: 20px;\n  text-transform: capitalize;\n}\n.mobile-menu .navigation li ul li ul li a {\n  margin-left: 40px;\n}\n.mobile-menu .navigation li ul li ul li ul li a {\n  margin-left: 60px;\n}\n.mobile-menu .navigation li > a:before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 0;\n  -webkit-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n}\n.mobile-menu .navigation li.menu-item-has-children .dropdown-btn {\n  position: absolute;\n  right: 15px;\n  top: 6px;\n  width: 32px;\n  height: 32px;\n  text-align: center;\n  font-size: 16px;\n  line-height: 32px;\n  color: #292b37;\n  background: var(--tg-gray);\n  cursor: pointer;\n  border-radius: 2px;\n  -webkit-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n  z-index: 5;\n}\n.mobile-menu .navigation li.menu-item-has-children .dropdown-btn i {\n  -webkit-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n}\n.mobile-menu .navigation li.menu-item-has-children .dropdown-btn.open i {\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n  color: var(--tg-primary-color);\n}\n.mobile-menu .navigation li > ul,\n.mobile-menu .navigation li > ul > li > ul {\n  display: none;\n}\n.mobile-menu .social-links ul {\n  display: flex;\n  position: relative;\n  text-align: center;\n  padding: 30px 20px 20px;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.mobile-menu .social-links li {\n  position: relative;\n  display: inline-block;\n  margin: 0px 6px 10px;\n}\n.mobile-menu .social-links li a {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  position: relative;\n  line-height: 32px;\n  font-size: 16px;\n  color: var(--tg-heading-font-color);\n  -webkit-transition: all 500ms ease;\n  -o-transition: all 500ms ease;\n  transition: all 500ms ease;\n  border: 1px solid var(--tg-gray);\n  border-radius: 3px;\n  -webkit-border-radius: 3px;\n  -moz-border-radius: 3px;\n  -ms-border-radius: 3px;\n  -o-border-radius: 3px;\n}\n.mobile-menu .social-links li a:hover {\n  border-color: var(--tg-primary-color);\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n}\n.menu-area .mobile-nav-toggler {\n  position: relative;\n  float: right;\n  font-size: 27px;\n  cursor: pointer;\n  line-height: 1;\n  color: var(--tg-primary-color);\n  display: none;\n  margin-top: 6px;\n  padding: 5px 10px;\n  border: 2px solid var(--tg-primary-color);\n}\n\n/*=============================\n\t04. Search\n===============================*/\n.search-popup-wrap {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(255, 255, 255, 0.9);\n  height: 100%;\n  width: 100%;\n  z-index: 99;\n  padding: 100px 0;\n  display: none;\n}\n.search-wrap {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n}\n.search-wrap .title {\n  font-size: 47px;\n  margin: 0 0 70px 0;\n  font-weight: 700;\n}\n.search-form {\n  position: relative;\n}\n.search-form input {\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid var(--tg-primary-color);\n  padding: 10px 50px 20px;\n  text-align: center;\n  font-weight: 500;\n  font-size: 30px;\n  background: transparent;\n  color: var(--tg-heading-font-color);\n}\n.search-form input::placeholder {\n  font-size: 30px;\n  color: var(--tg-heading-font-color);\n  opacity: 0.5;\n}\n.search-btn {\n  position: absolute;\n  right: 20px;\n  background: transparent;\n  border: 0;\n  font-size: 25px;\n  color: var(--tg-primary-color);\n  top: 50%;\n  transform: translateY(-50%);\n}\n.search-close {\n  position: absolute;\n  top: 5%;\n  right: 5%;\n  font-size: 30px;\n  color: var(--tg-primary-color);\n  cursor: pointer;\n}\n\n/*=============================\n\t05. OffCanvas\n===============================*/\n.extra-info {\n  background: var(--tg-white) none repeat scroll 0 0;\n  height: 100%;\n  padding: 30px;\n  position: fixed;\n  right: 0;\n  top: 0;\n  transition: all 0.7s ease 0s;\n  width: 340px;\n  z-index: 999;\n  overflow-y: scroll;\n  transform: translateX(100%);\n}\n.extra-info.active {\n  transform: translateX(0);\n}\n.close-icon {\n  margin-top: -16px;\n  text-align: right;\n}\n.close-icon > button {\n  background: transparent;\n  border: 0 none;\n  color: var(--tg-primary-color);\n  cursor: pointer;\n  font-size: 20px;\n  padding: 0;\n}\n.extra-info .logo-side img {\n  max-width: 151px;\n}\n.side-info {\n  border-top: 1px solid var(--tg-primary-color);\n  padding-top: 25px;\n}\n.contact-list h4 {\n  color: var(--tg-heading-font-color);\n  font-weight: 700;\n  font-size: 18px;\n}\n.contact-list p {\n  color: var(--tg-paragraph-color);\n  margin: 0;\n  margin-bottom: 2px;\n  line-height: 26px;\n}\n.side-instagram {\n  overflow: hidden;\n  display: flex;\n  flex-wrap: wrap;\n  margin: -5px;\n}\n.side-instagram li {\n  width: 33.3333%;\n  flex: 0 0 33.3333%;\n  padding: 5px;\n}\n.side-instagram li > a {\n  display: block;\n}\n.side-instagram img {\n  width: 100%;\n  border-radius: 5px;\n}\n.social-icon-right > a {\n  color: var(--tg-primary-color);\n  display: inline-block;\n  margin-right: 20px;\n  text-align: center;\n}\n.social-icon-right > a:hover {\n  color: var(--tg-secondary-color);\n}\n.offcanvas-overly {\n  position: fixed;\n  background: var(--tg-black);\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  z-index: 99;\n  opacity: 0;\n  visibility: hidden;\n  transition: 0.3s;\n}\n.offcanvas-overly.active {\n  opacity: 0.5;\n  visibility: visible;\n}\n\n/*=============================\n\t06. Slider\n===============================*/\n.slider-bg.one {\n  background: url(\"../img/banner/banner_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n}\n.slider-bg.two {\n  background: url(\"../img/banner/banner_bg02.jpg\");\n  background-size: cover;\n  background-position: center;\n}\n.slider-bg {\n  background-size: cover;\n  background-position: center;\n  min-height: 872px;\n  display: flex !important;\n  align-items: center;\n  padding: 200px 0 120px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n  cursor: grab;\n}\n.slider-content .sub-title {\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  font-size: 14px;\n  font-weight: 600;\n  position: relative;\n  display: block;\n  color: var(--tg-primary-color);\n  padding-top: 18px;\n  margin-bottom: 10px;\n}\n.slider-content .sub-title::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 30px;\n  height: 4px;\n  border-radius: 4px;\n  background: var(--tg-primary-color);\n}\n.slider-content .title {\n  font-weight: 800;\n  font-size: 60px;\n  margin-bottom: 20px;\n  line-height: 1;\n}\n.slider-content p {\n  color: var(--tg-paragraph-color);\n  margin-bottom: 45px;\n  width: 85%;\n}\n.slider-shape {\n  position: absolute;\n  left: 15%;\n  bottom: 23%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n\n/*=============================\n\t07. Banner\n===============================*/\n.banner-bg-two {\n  background: url(\"../img/banner/h2_banner_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  min-height: 770px;\n  display: flex;\n  align-items: flex-end;\n  padding: 170px 0 0;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.banner-content-two {\n  width: 85%;\n}\n.banner-content-two .sub-title {\n  font-weight: 600;\n  font-size: 13px;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  color: var(--tg-primary-color);\n  background: var(--tg-lavender);\n  border-radius: 50px;\n  display: inline-block;\n  padding: 4px 13px;\n  margin-bottom: 15px;\n}\n.banner-content-two .title {\n  font-weight: 800;\n  font-size: 60px;\n  margin-bottom: 20px;\n  line-height: 1;\n}\n.banner-content-two p {\n  margin-bottom: 30px;\n  color: var(--tg-paragraph-color);\n}\n.banner-content-two .banner-btn {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n.banner-content-two .banner-btn .play-btn {\n  display: flex;\n  align-items: center;\n  color: var(--tg-secondary-color);\n}\n.banner-content-two .banner-btn .play-btn span {\n  text-decoration: underline;\n}\n.banner-content-two .banner-btn .play-btn i {\n  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.1);\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-white);\n  border-radius: 50%;\n  color: var(--tg-primary-color);\n  font-size: 18px;\n  margin-right: 12px;\n}\n.banner-content-two .banner-btn .play-btn:hover {\n  color: var(--tg-primary-color);\n}\n.banner-shape-wrap img {\n  position: absolute;\n  z-index: -1;\n}\n.banner-shape-wrap img:nth-child(1) {\n  left: 47%;\n  bottom: 47%;\n  animation: float-bob-x 4s infinite linear;\n}\n.banner-shape-wrap img:nth-child(2) {\n  right: 45%;\n  bottom: 22%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.banner-shape-wrap img:nth-child(3) {\n  right: 26%;\n  bottom: 0;\n  z-index: -2;\n}\n@keyframes float-bob-x {\n  0% {\n    transform: translateX(-30px);\n  }\n\n  50% {\n    transform: translateX(-10px);\n  }\n\n  100% {\n    transform: translateX(-30px);\n  }\n}\n\n/* banner-three */\n.banner-area-three {\n  padding: 200px 0 60px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.banner-area-three::after,\n.banner-area-three::before {\n  content: \"\";\n  position: absolute;\n  left: 30px;\n  top: 60px;\n  width: 550px;\n  height: 550px;\n  background: #cef0ff;\n  opacity: 0.3;\n  filter: blur(75px);\n  border-radius: 50%;\n  z-index: -3;\n}\n.banner-area-three::after {\n  background: #e4ceff;\n  top: -105px;\n  left: auto;\n  right: 30%;\n}\n.banner-content-three {\n  margin-top: 60px;\n}\n.banner-content-three .title {\n  font-weight: 800;\n  font-size: 60px;\n  margin-bottom: 25px;\n  line-height: 1.06;\n}\n.banner-content-three p {\n  margin-bottom: 15px;\n  color: var(--tg-paragraph-color);\n}\n.banner-content-three .banner-form {\n  position: relative;\n  width: 93%;\n}\n.banner-content-three .banner-form input {\n  width: 100%;\n  border: 1px solid #d7dff0;\n  border-radius: 30px;\n  background: var(--tg-white);\n  font-size: 16px;\n  font-weight: 400;\n  color: var(--tg-secondary-color);\n  padding: 16px 70px 16px 28px;\n  height: 60px;\n}\n.banner-content-three .banner-form input::placeholder {\n  font-size: 16px;\n  color: var(--tg-paragraph-color);\n  font-weight: 400;\n}\n.banner-content-three .banner-form button {\n  position: absolute;\n  top: 4px;\n  bottom: 4px;\n  right: 5px;\n  width: 52px;\n  height: 52px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  border: none;\n  border-radius: 50%;\n  font-size: 24px;\n  line-height: 0;\n}\n.banner-content-three .banner-form button:hover {\n  background: var(--tg-secondary-color);\n}\n.ball {\n  opacity: 1;\n  z-index: -2;\n  position: absolute;\n  border-radius: 50%;\n}\n.banner-img-three {\n  position: relative;\n  text-align: right;\n  padding-right: 80px;\n}\n.banner-img-three img.main-img {\n  clip-path: polygon(0 0, 85% 0, 100% 15%, 100% 100%, 15% 100%, 0 85%);\n  border-radius: 5px;\n}\n.banner-img-three img:not(.main-img) {\n  position: absolute;\n}\n.banner-img-three img.img-two {\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n  left: 6%;\n  bottom: 24%;\n}\n.banner-img-three img.img-three {\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  right: -4%;\n  top: 21%;\n}\n.banner-shape-wrap-three img {\n  position: absolute;\n  z-index: -1;\n}\n.banner-shape-wrap-three img:nth-child(1) {\n  right: 47.5%;\n  bottom: 41%;\n  animation: ribbonRotate 6s infinite linear;\n}\n.banner-shape-wrap-three img:nth-child(2) {\n  right: 18%;\n  bottom: 3%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n@keyframes ribbonRotate {\n  0%,\n  100% {\n    -webkit-transform: rotate(0);\n    transform: rotate(0);\n  }\n\n  25%,\n  75% {\n    -webkit-transform: rotate(15deg);\n    transform: rotate(15deg);\n  }\n\n  50% {\n    -webkit-transform: rotate(30deg);\n    transform: rotate(30deg);\n  }\n}\n\n/* banner-four */\n.banner-bg-four {\n  background: url(\"../img/banner/h4_banner_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 65px 0 0;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.banner-content-four {\n  margin-top: 105px;\n}\n.banner-content-four .sub-title {\n  font-weight: 600;\n  font-size: 13px;\n  text-transform: uppercase;\n  letter-spacing: 0.1em;\n  display: inline-block;\n  background: var(--tg-lavender);\n  color: var(--tg-primary-color);\n  border-radius: 30px;\n  padding: 4px 13px;\n  margin-bottom: 20px;\n}\n.banner-content-four .title {\n  margin-bottom: 15px;\n  font-weight: 800;\n  font-size: 60px;\n  line-height: 1.1;\n}\n.banner-content-four p {\n  margin-bottom: 35px;\n  color: var(--tg-paragraph-color);\n  width: 90%;\n}\n.banner-shape-wrap-four img {\n  position: absolute;\n  z-index: -1;\n}\n.banner-shape-wrap-four img:nth-child(1) {\n  left: 15%;\n  bottom: 25%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.banner-shape-wrap-four img:nth-child(2) {\n  right: 46%;\n  bottom: 39%;\n}\n.banner-shape-wrap-four img:nth-child(3) {\n  right: 15%;\n  top: 0;\n}\n\n/* banner-five */\n.banner-area-five {\n  position: relative;\n  background: #f2f7ff;\n  padding: 140px 0 100px;\n  z-index: 1;\n  overflow: hidden;\n}\n.banner-area-five::before {\n  content: \"\";\n  position: absolute;\n  left: 17%;\n  top: -100px;\n  width: 460px;\n  height: 460px;\n  background: #fbedff;\n  filter: blur(200px);\n  z-index: -1;\n}\n.banner-area-five::after {\n  content: \"\";\n  position: absolute;\n  right: -10%;\n  top: -15%;\n  width: 1100px;\n  height: 600px;\n  background: linear-gradient(\n    88.44deg,\n    #e0faf3 0.58%,\n    rgba(239, 247, 255, 0) 67.54%\n  );\n  border-radius: 326.687px;\n  transform: rotate(-42.01deg);\n  z-index: -1;\n}\n.banner-content-five .title {\n  margin-bottom: 20px;\n  font-weight: 800;\n  font-size: 50px;\n}\n.banner-content-five .title span {\n  position: relative;\n  z-index: 1;\n}\n.banner-content-five .title span svg {\n  position: absolute;\n  width: 100%;\n  left: 0;\n  bottom: -4px;\n  z-index: -1;\n}\n.has-animation.active-animation .banner-content-five .title span svg path {\n  stroke-dasharray: 1000;\n  stroke-dashoffset: 1000;\n  -webkit-animation: dash_animation 10s linear forwards;\n  animation: dash_animation 10s linear forwards;\n}\n@-webkit-keyframes dash_animation {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n@keyframes dash_animation {\n  to {\n    stroke-dashoffset: 0;\n  }\n}\n.banner-content-five p {\n  margin-bottom: 25px;\n  color: var(--tg-black);\n}\n.banner-img-five {\n  position: relative;\n  margin-left: 90px;\n  z-index: 1;\n}\n.banner-img-five img:not(.main-img) {\n  position: absolute;\n}\n.banner-img-five .main-img {\n  max-width: unset;\n}\n.banner-img-five .shape-one {\n  right: -19%;\n  bottom: 12%;\n}\n.banner-img-five .shape-two {\n  left: 35%;\n  top: 38%;\n  animation: float-bob-x 4s infinite linear;\n}\n.banner-img-five .shape-three {\n  right: 5%;\n  top: 23%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n\n/*=============================\n\t08. Breadcrumb\n===============================*/\n.breadcrumb-bg {\n  background: #0A1628;\n  padding: 120px 0 130px;\n  position: relative;\n  z-index: 1;\n}\n.breadcrumb-shape-wrap img {\n  position: absolute;\n  z-index: -1;\n}\n.breadcrumb-shape-wrap img:nth-child(1) {\n  left: 0;\n  top: 0;\n}\n.breadcrumb-shape-wrap img:nth-child(2) {\n  right: 10%;\n  top: 0;\n}\n.breadcrumb-content {\n  text-align: center;\n}\n.breadcrumb-content .title {\n  margin-bottom: 12px;\n  color: var(--tg-white);\n  font-size: 44px;\n  line-height: 1.1;\n  text-transform: capitalize;\n}\n.breadcrumb-content .breadcrumb {\n  justify-content: center;\n  margin-bottom: 0;\n}\n.breadcrumb-content .breadcrumb-item {\n  color: var(--tg-primary-color);\n  font-weight: 500;\n  font-size: 14px;\n  text-transform: capitalize;\n}\n.breadcrumb-content .breadcrumb-item a {\n  color: #9fa9be;\n}\n.breadcrumb-content .breadcrumb-item a:hover {\n  color: var(--tg-primary-color);\n}\n.breadcrumb-content .breadcrumb-item + .breadcrumb-item::before {\n  padding-right: 10px;\n  color: #9fa9be;\n  content: \"\\f054\";\n  font-family: \"Font Awesome 5 Free\";\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 1;\n  margin-top: 7px;\n}\n.breadcrumb-content .breadcrumb-item + .breadcrumb-item {\n  padding-left: 10px;\n}\n\n/*=============================\n\t09. About\n===============================*/\n.about-bg {\n  background: url(\"../img/bg/about_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 140px 0 200px;\n}\n.about-img-wrap {\n  position: relative;\n  text-align: center;\n  z-index: 1;\n  padding-bottom: 15px;\n  margin-top: 16px;\n}\n.about-img-wrap img:not(.main-img) {\n  position: absolute;\n  z-index: -1;\n}\n.about-img-wrap img:nth-child(2) {\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 0;\n}\n.about-img-wrap img.main-img {\n  border-radius: 50%;\n  width: 314px;\n  object-fit: cover;\n  height: 314px;\n  border: 5px solid var(--tg-white);\n}\n.about-img-wrap img:nth-child(3) {\n  right: 19%;\n  top: -10%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.about-content {\n  width: 88%;\n}\n.section-title .sub-title {\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  display: inline-block;\n  font-size: 15px;\n  font-weight: 600;\n  color: var(--tg-primary-color);\n  position: relative;\n  padding-top: 18px;\n  margin-bottom: 10px;\n}\n.section-title .sub-title::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 30px;\n  height: 4px;\n  background: var(--tg-primary-color);\n  border-radius: 4px;\n}\n.section-title .title {\n  font-size: 40px;\n  margin-bottom: 0;\n}\n.about-content p {\n  margin-bottom: 0;\n  color: var(--tg-paragraph-color);\n}\n\n/* about-two */\n.about-area-two {\n  position: relative;\n}\n.about-area-two::before {\n  content: \"\";\n  position: absolute;\n  left: 13%;\n  top: 0;\n  width: 630px;\n  height: 630px;\n  background: linear-gradient(154.68deg, #8894ff 11.62%, #ff8585 90.47%);\n  opacity: 0.1;\n  filter: blur(75px);\n  z-index: -1;\n}\n.about-content-two p {\n  margin-bottom: 20px;\n  color: var(--tg-paragraph-color);\n}\n.about-list .list-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px 0;\n  margin-bottom: 30px;\n}\n.about-list .list-wrap li {\n  font-family: var(--tg-heading-font-family);\n  color: var(--tg-paragraph-color);\n  font-size: 18px;\n  font-weight: 600;\n  text-transform: capitalize;\n  width: 50%;\n  line-height: 1.3;\n  display: flex;\n  align-items: flex-start;\n}\n.about-list .list-wrap li img {\n  margin-right: 10px;\n}\n.success-wrap .list-wrap {\n  display: flex;\n  align-items: center;\n  border-top: 1px solid #d9d9d9;\n  padding-top: 30px;\n  margin-bottom: 40px;\n}\n.success-wrap .list-wrap li {\n  width: 50%;\n}\n.success-wrap .list-wrap li .count {\n  font-weight: 800;\n  font-size: 36px;\n  margin-bottom: 8px;\n  letter-spacing: 2px;\n  line-height: 0.8;\n}\n.success-wrap .list-wrap li p {\n  margin-bottom: 0;\n  font-size: 14px;\n  line-height: 1;\n}\n.about-content-two .btn {\n  background: transparent;\n  border-color: var(--tg-primary-color);\n  color: var(--tg-primary-color);\n}\n.about-content-two .btn::after {\n  color: var(--tg-white);\n}\n.about-content-two .btn:hover {\n  color: var(--tg-white);\n}\n.about-img-two {\n  position: relative;\n  padding-left: 218px;\n}\n.about-img-two .main-img {\n  position: relative;\n  text-align: right;\n}\n.about-img-two .main-img img {\n  border-radius: 15px;\n  border: 9px solid var(--tg-white);\n  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);\n}\n.about-img-two .main-img .play-btn {\n  position: absolute;\n  width: 82px;\n  height: 82px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0 85 255 / 80%);\n  border-radius: 50%;\n  box-shadow: -8px -1px 10px rgba(255, 255, 255, 0.1);\n  color: var(--tg-white);\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 25px;\n}\n.about-img-two .main-img .play-btn::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--tg-white);\n  border-radius: 50%;\n  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);\n  animation: pulse-border 1500ms ease-out infinite;\n}\n.about-img-two img:nth-child(2) {\n  border: 9px solid #ffffff;\n  box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.2);\n  border-radius: 15px;\n  transform: rotate(-2.71deg);\n  position: absolute;\n  left: 40px;\n  bottom: 70px;\n}\n.about-shape-wrap img {\n  position: absolute;\n  z-index: -1;\n}\n.about-shape-wrap img:nth-child(1) {\n  right: 41%;\n  top: 13%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.about-shape-wrap img:nth-child(2) {\n  right: 0;\n  bottom: 0;\n}\n@keyframes pulse-border {\n  0% {\n    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);\n    opacity: 0;\n  }\n}\n@-webkit-keyframes pulse-border {\n  0% {\n    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);\n    opacity: 1;\n  }\n  100% {\n    transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1.5);\n    opacity: 0;\n  }\n}\n@keyframes alltuchtopdown {\n  0% {\n    transform: rotateX(0deg) translateY(0px);\n  }\n  50% {\n    transform: rotateX(0deg) translateY(-50px);\n  }\n  100% {\n    transform: rotateX(0deg) translateY(0px);\n  }\n}\n\n/* about-three */\n.about-area-three {\n  position: relative;\n  padding: 80px 0;\n}\n.about-img-wrap-three {\n  position: relative;\n  text-align: center;\n  padding-bottom: 90px;\n}\n.about-img-wrap-three img:nth-child(1) {\n  border-radius: 100px 0 0 0;\n}\n.about-img-wrap-three img:nth-child(2) {\n  border-radius: 0 50px 0 0;\n  border: 8px solid var(--tg-white);\n  position: absolute;\n  right: 0;\n  bottom: 25px;\n  z-index: 2;\n}\n.about-img-wrap-three .experience-wrap {\n  width: 506px;\n  display: flex;\n  align-items: center;\n  text-align: left;\n  background: var(--tg-primary-color);\n  border-radius: 0px 0px 0px 60px;\n  padding: 40px 195px 50px 45px;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n}\n.about-img-wrap-three .experience-wrap .title {\n  margin-bottom: 0;\n  text-align: center;\n  font-size: 64px;\n  line-height: 0.8;\n  color: var(--tg-white);\n  position: relative;\n  padding-right: 13px;\n  margin-right: 13px;\n}\n.about-img-wrap-three .experience-wrap .title span {\n  display: block;\n  font-weight: 600;\n  font-size: 24px;\n  letter-spacing: 0.1em;\n  margin-top: 5px;\n}\n.about-img-wrap-three .experience-wrap .title::before {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 2px;\n  height: 100%;\n  background: var(--tg-white);\n}\n.about-img-wrap-three .experience-wrap p {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 0;\n  color: var(--tg-white);\n  line-height: 1.4;\n  font-family: var(--tg-heading-font-family);\n}\n.section-title-two span {\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n  font-size: 13px;\n  font-weight: 600;\n  display: inline-block;\n  color: var(--tg-primary-color);\n  background: var(--tg-lavender);\n  border-radius: 50px;\n  padding: 4px 13px;\n  margin-bottom: 12px;\n}\n.section-title-two .title {\n  font-weight: 800;\n  font-size: 40px;\n  margin-bottom: 0;\n}\n.about-content-three p {\n  margin-bottom: 0;\n  color: var(--tg-paragraph-color);\n  width: 90%;\n}\n.about-content-three p.info-one {\n  margin-bottom: 25px;\n}\n.about-list-two .list-wrap {\n  margin-bottom: 20px;\n}\n.about-list-two .list-wrap li {\n  font-weight: 600;\n  font-size: 18px;\n  display: flex;\n  align-items: baseline;\n  text-transform: capitalize;\n  color: var(--tg-secondary-color);\n  margin-bottom: 14px;\n}\n.about-list-two .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.about-list-two .list-wrap li i {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  border-radius: 50%;\n  font-size: 12px;\n  margin-right: 8px;\n  flex: 0 0 auto;\n}\n.about-author-info {\n  display: flex;\n  align-items: center;\n  margin-top: 35px;\n}\n.about-author-info .thumb {\n  border-radius: 50%;\n  border: 3px solid var(--tg-white);\n  box-shadow: 0px 10px 20px rgba(0, 0, 0, 0.25);\n  width: 70px;\n  flex: 0 0 auto;\n  margin-right: 15px;\n}\n.about-author-info .content .title {\n  font-size: 20px;\n  margin-bottom: 5px;\n}\n.about-author-info .content span {\n  font-weight: 500;\n  font-size: 14px;\n  display: block;\n  line-height: 1;\n}\n.about-author-info .signature {\n  margin-left: 20px;\n}\n.about-shape-wrap-two img {\n  position: absolute;\n  z-index: -1;\n}\n.about-shape-wrap-two img:nth-child(1) {\n  left: 15%;\n  bottom: 27%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.about-shape-wrap-two img:nth-child(2) {\n  left: 40%;\n  top: 5%;\n}\n.about-shape-wrap-two img:nth-child(3) {\n  right: 0;\n  bottom: 0;\n}\n\n/* about-four */\n.about-content-four > p {\n  color: var(--tg-paragraph-color);\n  margin-bottom: 35px;\n}\n.about-list-three .list-wrap li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 40px;\n  padding-left: 13px;\n}\n.about-list-three .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.about-list-three .list-wrap li .icon {\n  position: relative;\n  font-size: 50px;\n  line-height: 0;\n  color: var(--tg-primary-color);\n  margin-right: 15px;\n}\n.about-list-three .list-wrap li .icon::before {\n  content: \"\";\n  position: absolute;\n  left: -13px;\n  top: -15px;\n  width: 46px;\n  height: 46px;\n  background: var(--tg-lavender);\n  border-radius: 50%;\n  z-index: -1;\n}\n.about-list-three .list-wrap li .icon i {\n  transform: rotateY(0);\n  transition: 0.3s linear;\n  display: block;\n}\n.about-list-three .list-wrap li:hover .icon i {\n  transform: rotateY(180deg);\n}\n.about-list-three .content .title {\n  font-size: 20px;\n  margin-bottom: 10px;\n}\n.about-list-three .content p {\n  margin-bottom: 0;\n  width: 75%;\n  color: var(--tg-paragraph-color);\n}\n.about-img-wrap-four {\n  position: relative;\n  margin-right: -30px;\n}\n.mask-img-wrap {\n  -webkit-mask-image: url(\"../img/images/mask_img.png\");\n  mask-image: url(\"../img/images/mask_img.png\");\n  -webkit-mask-size: 100%;\n  mask-size: 100%;\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  mask-position: center;\n  z-index: -1;\n  height: 558px;\n  width: 633px;\n  margin-left: auto;\n}\n.mask-img-wrap img {\n  max-width: unset;\n}\n.about-img-wrap-four .img-two {\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  position: absolute;\n  left: 10%;\n  bottom: 14%;\n}\n.about-shape-wrap-three img {\n  position: absolute;\n  z-index: -1;\n}\n.about-shape-wrap-three img:nth-child(1) {\n  left: 0;\n  top: 6%;\n  animation: ribbonRotate 15s infinite linear;\n}\n.about-shape-wrap-three img:nth-child(2) {\n  left: 4%;\n  bottom: 7%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.about-shape-wrap-three img:nth-child(3) {\n  right: 23%;\n  top: -2%;\n  animation: rotateme 8s infinite linear;\n}\n.about-img-wrap-four .icon {\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  left: 8%;\n  top: 21%;\n  border-radius: 50%;\n  background: var(--tg-pink);\n  border: 5px solid var(--tg-white);\n  color: var(--tg-white);\n  font-size: 50px;\n  line-height: 0;\n}\n@keyframes rotateme {\n  from {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n@-webkit-keyframes rotateme {\n  from {\n    -webkit-transform: rotate(0deg);\n  }\n  to {\n    -webkit-transform: rotate(360deg);\n  }\n}\n\n/* about-five */\n.about-area-five {\n  position: relative;\n  padding: 120px 0;\n}\n.about-img-wrap-five {\n  position: relative;\n  padding-bottom: 30px;\n}\n.about-img-wrap-five::before {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  height: 40px;\n  width: 380px;\n  background: var(--tg-primary-color);\n  z-index: -1;\n}\n.about-img-wrap-five img:nth-child(1) {\n  clip-path: polygon(0 0, 85% 0, 100% 15%, 100% 100%, 0% 100%, 0 100%);\n}\n.about-img-wrap-five img:nth-child(2) {\n  border-radius: 10px;\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n  position: absolute;\n  left: -25%;\n  top: 14%;\n}\n.about-img-wrap-five .experience-wrap {\n  background: var(--tg-primary-color);\n  max-width: 200px;\n  padding: 36px 20px;\n  position: absolute;\n  right: 0;\n  bottom: 0;\n}\n.about-img-wrap-five .experience-wrap .title {\n  margin-bottom: 0;\n  color: var(--tg-white);\n  font-size: 60px;\n  text-align: center;\n  line-height: 1;\n}\n.about-img-wrap-five .experience-wrap .title span {\n  display: block;\n  font-weight: 500;\n  font-size: 24px;\n}\n.about-content-five > p {\n  margin-bottom: 50px;\n  color: var(--tg-paragraph-color);\n  width: 85%;\n}\n.about-content-five {\n  margin-left: 55px;\n  width: 85%;\n}\n.about-content-five .about-list {\n  width: 60%;\n  flex: 0 0 auto;\n}\n.about-content-five .about-list .list-wrap {\n  gap: 25px 0;\n  margin-bottom: 0;\n}\n.about-content-five .about-list .list-wrap li {\n  color: var(--tg-secondary-color);\n  width: 100%;\n}\n.about-content-five .about-list .list-wrap li i {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  border-radius: 50%;\n  font-size: 12px;\n  margin-right: 8px;\n  flex: 0 0 auto;\n}\n.about-content-five .about-content-bottom {\n  display: flex;\n  align-items: center;\n}\n.about-success-wrap .list-wrap li {\n  display: flex;\n  align-items: center;\n  margin-bottom: 30px;\n}\n.about-success-wrap .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.about-success-wrap .list-wrap li .icon {\n  font-size: 60px;\n  line-height: 0;\n  color: var(--tg-primary-color);\n  flex: 0 0 auto;\n  margin-right: 20px;\n}\n.about-success-wrap .list-wrap li .content .count {\n  font-weight: 800;\n  font-size: 50px;\n  line-height: 0.8;\n  margin-bottom: 5px;\n}\n.about-success-wrap .list-wrap li .content p {\n  font-weight: 600;\n  font-size: 18px;\n  margin-bottom: 0;\n  color: var(--tg-secondary-color);\n  font-family: var(--tg-heading-font-family);\n  line-height: 1;\n}\n.about-shape-five img {\n  position: absolute;\n  left: 41%;\n  bottom: 35%;\n  z-index: -1;\n  animation: alltuchtopdown 8s infinite linear;\n}\n\n/* about-six */\n.about-area-six {\n  padding: 0 0 120px;\n  position: relative;\n  overflow: hidden;\n}\n.about-area-six::before {\n  content: \"\";\n  position: absolute;\n  width: 310px;\n  height: 310px;\n  background: #fae7ff;\n  filter: blur(200px);\n  right: 26%;\n  top: 16%;\n  z-index: -1;\n}\n.about-img-six {\n  margin-left: -75px;\n  position: relative;\n  padding-top: 40px;\n}\n.about-img-six img:nth-child(1) {\n  max-width: unset;\n  position: unset;\n}\n.about-img-six img {\n  position: absolute;\n  z-index: -1;\n}\n.about-img-six img:nth-child(2) {\n  left: 0;\n  bottom: -40px;\n}\n.about-img-six img:nth-child(3) {\n  left: 19%;\n  top: 14%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.about-content-six {\n  width: 88%;\n}\n.about-content-six p {\n  margin-bottom: 30px;\n}\n.about-content-six .about-list .list-wrap {\n  margin-bottom: 45px;\n}\n.about-content-six .about-list .list-wrap li {\n  color: var(--tg-secondary-color);\n}\n.about-content-six .about-list .list-wrap li i {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  border-radius: 50%;\n  font-size: 12px;\n  margin-right: 8px;\n  flex: 0 0 auto;\n}\n\n/* about-seven */\n.about-content-seven {\n  width: 88%;\n}\n.about-content-seven > p {\n  margin-bottom: 25px;\n}\n.success-wrap-two {\n  margin-bottom: 25px;\n}\n.success-wrap-two .list-wrap {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n.success-wrap-two .list-wrap li {\n  background: var(--tg-lavender);\n  border-radius: 10px;\n  position: relative;\n  display: flex;\n  align-items: center;\n  padding: 30px 25px;\n  min-width: 240px;\n  transition: 0.3s;\n}\n.success-wrap-two .list-wrap li::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 28px;\n  border-radius: 3px;\n  background: var(--tg-primary-color);\n}\n.success-wrap-two .list-wrap li:hover {\n  transform: translateY(-5px);\n}\n.success-wrap-two .list-wrap li .icon {\n  font-size: 50px;\n  flex: 0 0 auto;\n  line-height: 0;\n  color: var(--tg-primary-color);\n  margin-right: 18px;\n}\n.success-wrap-two .list-wrap li .content .count {\n  font-weight: 800;\n  font-size: 36px;\n  display: flex;\n  align-items: center;\n  margin-bottom: 4px;\n  line-height: 0.8;\n}\n.success-wrap-two .list-wrap li .content p {\n  margin-bottom: 0;\n  line-height: 1;\n}\n.about-img-seven-wrap {\n  position: relative;\n  padding-bottom: 90px;\n}\n.about-img-seven-wrap img:nth-child(1) {\n  border-radius: 10px;\n}\n.about-img-seven-wrap img:nth-child(2) {\n  position: absolute;\n  right: 50px;\n  bottom: 0;\n  border: 8px solid var(--tg-white);\n  border-radius: 10px;\n  z-index: 3;\n}\n.about-img-seven-wrap .shape {\n  position: absolute;\n  left: 33%;\n  bottom: -8%;\n  z-index: -1;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.about-img-seven-wrap .experience-wrap {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  border: 8px solid #ffffff;\n  border-radius: 19px 63px 24px 0px;\n  max-width: 197px;\n  min-height: 384px;\n  background: var(--tg-primary-color);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 25px 20px;\n  text-align: center;\n}\n.about-img-seven-wrap .experience-wrap .title {\n  color: var(--tg-white);\n  margin-bottom: 10px;\n  font-size: 60px;\n  line-height: 0.8;\n}\n.about-img-seven-wrap .experience-wrap p {\n  margin-bottom: 0;\n  color: var(--tg-white);\n  font-family: var(--tg-heading-font-family);\n  font-size: 24px;\n  font-weight: 600;\n  line-height: 1.2;\n}\n\n/* about-eight */\n.about-img-eight img {\n  border-radius: 15px;\n}\n.about-content-eight > p {\n  margin-bottom: 35px;\n}\n.about-content-eight .about-content-inner {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin-bottom: 60px;\n}\n.about-content-eight .about-content-inner .list-wrap {\n  width: 58%;\n}\n.about-content-eight .about-content-inner .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 50px;\n}\n.about-content-eight .about-content-inner .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.about-content-eight .about-content-inner .list-wrap li .icon {\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-lavender);\n  color: var(--tg-primary-color);\n  font-size: 40px;\n  line-height: 0;\n  position: relative;\n  border-radius: 15px;\n  flex: 0 0 auto;\n  margin-right: 20px;\n}\n.about-content-eight .about-content-inner .list-wrap li .icon::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 0;\n  transform: translateX(-50%);\n  width: 16px;\n  height: 3px;\n  background: var(--tg-primary-color);\n  border-radius: 3px;\n}\n.about-content-eight .about-content-inner .content .title {\n  font-size: 20px;\n  margin-bottom: 8px;\n}\n.about-content-eight .about-content-inner .content p {\n  margin-bottom: 0;\n}\n.about-content-eight .right-slide-img {\n  margin-left: auto;\n}\n.about-content-eight .right-slide-img img {\n  border-radius: 10px;\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\n}\n.about-content-eight .about-content-bottom {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 30px 40px;\n}\n.about-content-eight .about-content-bottom .about-author-info {\n  margin-top: 0;\n}\n\n/* about-ten */\n.about-area-ten {\n  padding: 120px 0;\n  position: relative;\n}\n.about-img-wrap-ten {\n  padding-left: 120px;\n}\n.about-img-wrap-ten img:nth-child(2) {\n  left: 0;\n}\n.about-area-ten .about-shape-five img {\n  left: 46%;\n}\n.about-content-five.about-content-ten {\n  margin-left: 80px;\n  width: auto;\n  margin-right: 30px;\n}\n.about-content-ten .about-success-wrap .list-wrap {\n  display: flex;\n  align-items: center;\n  gap: 30px;\n  margin-top: 45px;\n}\n.about-content-ten .about-success-wrap .list-wrap li {\n  margin-bottom: 0;\n}\n.about-content-five.about-content-ten > p {\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n/* about-eleven */\n.about-area-eleven {\n  position: relative;\n  padding: 120px 0 0;\n}\n.about-area-eleven::before {\n  content: \"\";\n  position: absolute;\n  left: 20%;\n  top: 32%;\n  width: 300px;\n  height: 300px;\n  background: #fae7ff;\n  filter: blur(200px);\n  z-index: -1;\n}\n.about-content-eleven {\n  width: 85%;\n}\n.about-content-eleven p {\n  margin-bottom: 25px;\n}\n.about-content-eleven .about-list-two .list-wrap {\n  margin-bottom: 40px;\n}\n.about-img-wrap-eleven {\n  position: relative;\n  text-align: center;\n  padding-bottom: 30px;\n}\n.about-img-wrap-eleven .shape-one {\n  position: absolute;\n  left: -5%;\n  top: -2%;\n  z-index: -1;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.about-img-wrap-eleven .shape-two {\n  position: absolute;\n  left: -20px;\n  bottom: 0;\n  z-index: -2;\n  max-width: unset;\n}\n\n/* about-twelve */\n.about-area-twelve {\n  padding: 140px 0 140px;\n}\n.about-img-six.about-img-twelve img:nth-child(2) {\n  bottom: -50px;\n}\n\n/*=============================\n\t10. Overview\n===============================*/\n.overview-area {\n  position: relative;\n  overflow: hidden;\n}\n.overview-area::before {\n  content: \"\";\n  position: absolute;\n  width: 480px;\n  height: 480px;\n  opacity: 0.2;\n  filter: blur(75px);\n  border-radius: 50%;\n  background: #d5ceff;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: -1;\n}\n.overview-shape {\n  right: 0;\n  top: 0;\n  width: 424px;\n  height: 342px;\n  position: absolute;\n  z-index: -1;\n  background: url(\"../img/images/overview_shape.png\");\n}\n.overview-img-wrap {\n  text-align: center;\n  position: relative;\n}\n.overview-img-wrap img:nth-child(1) {\n  border-radius: 280px;\n}\n.overview-img-wrap img:nth-child(2) {\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  position: absolute;\n  left: 0;\n  bottom: 30px;\n}\n.overview-img-wrap img:nth-child(3) {\n  position: absolute;\n  left: -50px;\n  bottom: 32%;\n  z-index: -1;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.overview-img-wrap .icon {\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-primary-color);\n  position: absolute;\n  right: 90px;\n  top: 20px;\n  border-radius: 50%;\n  font-size: 50px;\n  line-height: 0;\n  color: var(--tg-white);\n  border: 5px solid var(--tg-white);\n}\n.overview-content {\n  width: 90%;\n}\n.overview-content > p {\n  margin-bottom: 0;\n  color: var(--tg-paragraph-color);\n}\n.overview-content .info-one {\n  margin-bottom: 15px;\n}\n.overview-content .info-two {\n  margin-bottom: 30px;\n}\n.overview-content .content-bottom .list-wrap {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n.overview-content .content-bottom .list-wrap li {\n  border: 1.2px solid #d4dced;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  padding: 28px 20px 28px 30px;\n  min-width: 256px;\n}\n.overview-content .content-bottom .list-wrap li .icon {\n  font-size: 50px;\n  line-height: 0;\n  color: var(--tg-primary-color);\n  position: relative;\n  margin-right: 40px;\n}\n.overview-content .content-bottom .list-wrap li .icon::before {\n  content: \"\";\n  position: absolute;\n  width: 40px;\n  height: 40px;\n  background: var(--tg-lavender);\n  left: -10px;\n  top: -12px;\n  border-radius: 50%;\n  z-index: -1;\n}\n.overview-content .content-bottom .list-wrap li .icon::after {\n  content: \"\";\n  position: absolute;\n  width: 2px;\n  height: 38px;\n  background: var(--tg-lavender);\n  right: -20px;\n  top: 50%;\n  transform: translateY(-50%);\n  border-radius: 50%;\n  z-index: -1;\n}\n.overview-content .content-bottom .list-wrap li .content .count {\n  font-size: 36px;\n  margin-bottom: 3px;\n  line-height: 0.8;\n  display: flex;\n  align-items: center;\n}\n.overview-content .content-bottom .list-wrap li .content p {\n  margin-bottom: 0;\n}\n\n/* overview-two */\n.overview-area-two {\n  position: relative;\n  padding: 0 0 120px;\n}\n.overview-area-two::before {\n  content: \"\";\n  position: absolute;\n  left: 114px;\n  top: 0;\n  width: 600px;\n  height: 600px;\n  background: #d5ceff;\n  opacity: 0.2;\n  filter: blur(75px);\n  z-index: -1;\n}\n.overview-img-two {\n  position: relative;\n}\n.mask-img-two {\n  -webkit-mask-image: url(../img/images/mask_img02.png);\n  mask-image: url(../img/images/mask_img02.png);\n  -webkit-mask-size: 100%;\n  mask-size: 100%;\n  -webkit-mask-repeat: no-repeat;\n  mask-repeat: no-repeat;\n  -webkit-mask-position: center;\n  mask-position: center;\n  z-index: -1;\n  height: 534px;\n  width: 556px;\n}\n.mask-img-two img {\n  max-width: unset;\n}\n.overview-img-two .img-two {\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  position: absolute;\n  left: -13%;\n  bottom: 21%;\n}\n.overview-shape-wrap img {\n  position: absolute;\n  z-index: -1;\n}\n.overview-shape-wrap img:nth-child(1) {\n  right: 7%;\n  top: 15%;\n  animation: float-bob-x 4s infinite linear;\n}\n.overview-shape-wrap img:nth-child(2) {\n  right: 6%;\n  top: 25%;\n}\n.overview-content-two {\n  margin-left: 45px;\n}\n.overview-content-two p {\n  margin-bottom: 30px;\n  color: var(--tg-paragraph-color);\n}\n\n/*=============================\n\t11. Features\n===============================*/\n.features-area {\n  margin-top: -100px;\n  position: relative;\n  z-index: 1;\n}\n.features-item {\n  border: 1px solid var(--tg-steel-blue);\n  border-radius: 10px;\n  padding: 35px 50px;\n  margin-bottom: 40px;\n  background: var(--tg-white);\n  position: relative;\n}\n.features-item::before {\n  content: \"\";\n  position: absolute;\n  left: 5px;\n  right: 5px;\n  bottom: -5px;\n  background: var(--tg-gray);\n  border: 1px solid var(--tg-steel-blue);\n  border-radius: 8px;\n  height: 70px;\n  z-index: -1;\n  transition: 0.3s ease-in;\n}\n.features-item::after {\n  content: \"\";\n  position: absolute;\n  left: 12px;\n  right: 12px;\n  bottom: -10px;\n  background: #dfe5f0;\n  border: 1px solid var(--tg-steel-blue);\n  border-radius: 8px;\n  height: 70px;\n  z-index: -2;\n  transition: 0.3s ease-in;\n}\n.features-item:hover::after,\n.features-item:hover::before {\n  bottom: 3px;\n}\n.features-content .content-top {\n  display: flex;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.features-content .content-top .icon {\n  font-size: 50px;\n  line-height: 0;\n  position: relative;\n  color: var(--tg-primary-color);\n  z-index: 1;\n  margin-right: 15px;\n}\n.features-content .content-top .icon::before {\n  content: \"\";\n  position: absolute;\n  left: -13px;\n  top: -15px;\n  width: 46px;\n  height: 46px;\n  background: var(--tg-lavender);\n  z-index: -1;\n  border-radius: 50%;\n  transition: 0.3s ease-in;\n}\n.features-item:hover .features-content .content-top .icon::before {\n  left: 0;\n  top: 0;\n}\n.features-content .content-top .title {\n  font-size: 22px;\n  margin-bottom: 0;\n}\n.features-content p {\n  margin-bottom: 0;\n  color: var(--tg-gray-four);\n}\n\n/* features-two */\n.features-item-wrap {\n  border-bottom: 1px solid var(--tg-lavender);\n  padding-bottom: 50px;\n}\n.features-item-two {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 30px;\n}\n.features-icon-three,\n.features-icon-two {\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 14px;\n  background: var(--tg-lavender);\n  flex: 0 0 auto;\n  color: var(--tg-primary-color);\n  font-size: 40px;\n  line-height: 0;\n  position: relative;\n  margin-right: 20px;\n}\n.features-icon-three::before,\n.features-icon-two::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  background: var(--tg-primary-color);\n  top: 0;\n  width: 16px;\n  height: 3px;\n  border-radius: 3px;\n}\n.features-icon-two i {\n  transform: rotateY(0);\n  transition: 0.3s linear;\n}\n.features-item-two:hover .features-icon-two i {\n  transform: rotateY(180deg);\n}\n.features-content-two .title {\n  font-size: 20px;\n  margin-bottom: 10px;\n}\n.features-content-two p {\n  margin-bottom: 0;\n  color: var(--tg-paragraph-color);\n  width: 80%;\n}\n\n/* features-three */\n.features-area-three {\n  position: relative;\n  padding: 120px 0 90px;\n  overflow: hidden;\n}\n.features-area-three::before {\n  content: \"\";\n  position: absolute;\n  left: -127px;\n  top: 90px;\n  width: 530px;\n  height: 530px;\n  background: #cc3de3;\n  opacity: 0.05;\n  filter: blur(75px);\n  border-radius: 50%;\n  z-index: -1;\n}\n.features-area-three::after {\n  content: \"\";\n  position: absolute;\n  right: -120px;\n  top: 80px;\n  width: 530px;\n  height: 530px;\n  background: #5e3de3;\n  opacity: 0.05;\n  filter: blur(75px);\n  z-index: -1;\n}\n.features-item-three {\n  background: var(--tg-white);\n  border: 1px solid var(--tg-border-color);\n  border-radius: 10px;\n  padding: 30px 30px 35px;\n  position: relative;\n  transition: 0.3s linear;\n  z-index: 1;\n  margin-bottom: 30px;\n}\n.features-item-three:hover {\n  background: var(--tg-primary-color);\n  border-color: var(--tg-primary-color);\n  box-shadow: 0px 20px 50px rgba(3, 74, 218, 0.29);\n}\n.features-item-three .features-icon-three {\n  margin-right: 0;\n  margin-bottom: 25px;\n  transition: 0.3s;\n  width: 65px;\n  height: 65px;\n}\n.features-item-three:hover .features-icon-three {\n  background: var(--tg-white);\n}\n.features-content-three .title {\n  font-weight: 700;\n  font-size: 20px;\n  margin-bottom: 15px;\n  transition: 0.3s;\n}\n.features-content-three p {\n  margin-bottom: 17px;\n  color: var(--tg-paragraph-color);\n  transition: 0.3s;\n}\n.features-item-three:hover .features-content-three p,\n.features-item-three:hover .features-content-three .title {\n  color: var(--tg-white);\n}\n.features-content-three .link-btn {\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 14px;\n  letter-spacing: 0.02em;\n  color: var(--tg-paragraph-color);\n}\n.features-content-three .link-btn img {\n  margin-left: 10px;\n  transition: 0.3s;\n}\n.features-item-three:hover .features-content-three .link-btn {\n  color: var(--tg-white);\n}\n.features-item-three:hover .features-content-three .link-btn img {\n  filter: brightness(0) invert(1);\n}\n.features-item-wrap-two\n  .row\n  [class*=\"col-\"]:nth-child(even)\n  .features-item-three {\n  margin-top: 20px;\n}\n\n/* features-four */\n.features-item-wrap-four {\n  background: var(--tg-white);\n  box-shadow: 0px 4px 50px rgba(233, 233, 243, 0.5);\n  border-radius: 10px;\n  padding: 65px 50px 30px;\n  margin-top: -90px;\n  position: relative;\n  z-index: 1;\n}\n.features-item-four {\n  display: flex;\n  align-items: center;\n  margin-bottom: 30px;\n}\n.features-icon-four {\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 0 0 auto;\n  margin-right: 20px;\n  color: var(--tg-primary-color);\n  font-size: 40px;\n  position: relative;\n  line-height: 0;\n  border-radius: 14px;\n  background: var(--tg-lavender);\n}\n.features-icon-four::before {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 16px;\n  background: var(--tg-primary-color);\n  border-radius: 2px;\n}\n.features-icon-four i {\n  transition: 0.3s linear;\n  transform: rotateY(0);\n}\n.features-item-four:hover .features-icon-four i {\n  transform: rotateY(180deg);\n}\n.features-content-four .title {\n  font-weight: 700;\n  font-size: 20px;\n  margin-bottom: 10px;\n}\n.features-content-four p {\n  margin-bottom: 0;\n  color: var(--tg-paragraph-color);\n}\n\n/* features-five */\n.features-bg {\n  background: url('../img/bg/features_bg.jpg');\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0 80px;\n  z-index: 1;\n  position: relative;\n  overflow: hidden;\n}\n.features-shape-wrap img {\n  position: absolute;\n  z-index: -1;\n}\n.features-shape-wrap img:nth-child(1) {\n  right: 9%;\n  top: 10%;\n  animation: float-bob-x 4s infinite linear;\n}\n.features-shape-wrap img:nth-child(2) {\n  left: 8%;\n  bottom: 10%;\n  animation: animationFramesOne 18s linear infinite;\n}\n\n/* features-six */\n.features-item-wrap-six {\n  margin-top: 0;\n  border: 1px solid #e7eaf1;\n  z-index: 3;\n  position: relative;\n}\n\n/* features-seven */\n.features-area-seven {\n  background: var(--tg-section-background);\n  padding: 230px 0 120px;\n  margin-top: -110px;\n  position: relative;\n  z-index: 1;\n}\n.features-area-seven::before {\n  content: \"\";\n  position: absolute;\n  left: 40%;\n  bottom: 70px;\n  width: 390px;\n  height: 390px;\n  background: #ff6ae7;\n  opacity: 0.1;\n  filter: blur(75px);\n  z-index: -1;\n}\n.features-content-seven {\n  width: 90%;\n}\n.features-content-seven p {\n  margin-bottom: 0;\n}\n.features-progress-wrap {\n  width: 90%;\n}\n.inner-features-shape {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: -1;\n}\n\n/*=============================\n\t12. Choose\n===============================*/\n.choose-bg {\n  background: url(\"../img/bg/choose_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.choose-bg::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: #001641;\n  opacity: 0.8;\n  z-index: -1;\n}\n.choose-shape {\n  z-index: -1;\n  position: absolute;\n  left: 0;\n  bottom: 0;\n}\n.section-title-two.white-title .title {\n  color: var(--tg-white);\n}\n.choose-content {\n  width: 90%;\n}\n.choose-content p {\n  margin-bottom: 40px;\n  color: #d0d0dd;\n}\n.choose-content .play-btn {\n  display: inline-flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 18px;\n  color: var(--tg-white);\n  font-family: var(--tg-heading-font-family);\n}\n.choose-content .play-btn:hover {\n  color: var(--tg-primary-color);\n}\n.choose-content .play-btn i {\n  width: 82px;\n  height: 82px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  border-radius: 50%;\n  font-size: 20px;\n  margin-right: 35px;\n  position: relative;\n}\n.choose-content .play-btn i::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--tg-white);\n  border-radius: 50%;\n  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);\n  animation: pulse-border 1500ms ease-out infinite;\n}\n.skill-wrap {\n  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  padding: 70px 60px;\n  background: var(--tg-white);\n  margin-left: 100px;\n}\n.skill-wrap .section-title-two .title {\n  font-size: 36px;\n}\n.skill-wrap > p {\n  margin-bottom: 25px;\n  color: var(--tg-paragraph-color);\n}\n.progress-wrap {\n  overflow: hidden;\n  padding-top: 5px;\n}\n.progress-item {\n  margin-bottom: 25px;\n}\n.progress-item:last-child {\n  margin-bottom: 0;\n}\n.progress-item .title {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 10px;\n  color: var(--tg-paragraph-color);\n}\n.progress-item .progress {\n  height: 8px;\n  background-color: var(--tg-lavender);\n  border-radius: 8px;\n  overflow: inherit;\n}\n.progress-item .progress-bar {\n  background-color: var(--tg-primary-color);\n  position: relative;\n  overflow: inherit;\n  border-radius: 8px;\n}\n.progress-item .progress-bar span {\n  display: block;\n  position: absolute;\n  right: 3px;\n  bottom: 20px;\n  color: var(--tg-white);\n  line-height: 1;\n  font-family: var(--tg-heading-font-family);\n  font-weight: 700;\n  font-size: 11px;\n  border-radius: 2px;\n  background: var(--tg-primary-color);\n  padding: 4px 7px;\n}\n.progress-item .progress-bar span::before {\n  content: \"\";\n  position: absolute;\n  right: 0;\n  bottom: -5px;\n  width: 8px;\n  height: 8px;\n  background: var(--tg-primary-color);\n  clip-path: polygon(100% 0, 0 0, 100% 100%);\n}\n\n/* choose-two */\n.choose-area-two {\n  background: #001641;\n  padding: 120px 0 205px;\n  position: relative;\n  z-index: 1;\n}\n.choose-img-two {\n  position: relative;\n  z-index: 1;\n}\n.choose-img-two img:nth-child(2) {\n  position: absolute;\n  right: 18%;\n  top: 10%;\n  z-index: -1;\n}\n.choose-img-two img:nth-child(3) {\n  position: absolute;\n  right: 14%;\n  top: 19%;\n  z-index: -2;\n}\n.choose-content-two {\n  width: 90%;\n}\n.choose-content-two > p {\n  color: #d0d0dd;\n  margin-bottom: 30px;\n  width: 90%;\n}\n.choose-circle-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n}\n.circle-item {\n  position: relative;\n  width: 160px;\n}\n.circle-content {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  padding: 20px;\n}\n.circle-content .percentage {\n  display: block;\n  font-weight: 800;\n  font-size: 36px;\n  line-height: 1;\n  font-family: var(--tg-heading-font-family);\n  color: var(--tg-white);\n  margin-bottom: 5px;\n}\n.circle-content p {\n  margin-bottom: 0;\n  font-weight: 500;\n  font-size: 15px;\n  color: var(--tg-white);\n  line-height: 1.2;\n}\n\n/* choose-three */\n.choose-area-three {\n  background: var(--tg-secondary-color);\n  position: relative;\n  padding: 120px 0;\n  overflow: hidden;\n}\n.choose-content-three {\n  margin-right: 65px;\n}\n.choose-content-three > p {\n  margin-bottom: 35px;\n  color: var(--tg-lavender);\n}\n.accordion-wrap-two .accordion-item {\n  border-radius: 5px;\n  background: var(--tg-primary-color);\n  border: none;\n  margin-bottom: 10px;\n  overflow: hidden;\n}\n.accordion-wrap-two .accordion-item:last-child {\n  margin-bottom: 0;\n}\n.accordion-wrap-two .accordion-item:first-of-type {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.accordion-wrap-two .accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n}\n.accordion-wrap-two .accordion-item:last-of-type .accordion-button.collapsed {\n  border-bottom-right-radius: 5px;\n  border-bottom-left-radius: 5px;\n}\n.accordion-wrap-two .accordion-button {\n  padding: 16px 60px 16px 22px;\n  font-weight: 600;\n  font-size: 20px;\n  color: var(--tg-white);\n  background: #052462;\n  position: relative;\n}\n.accordion-wrap-two .accordion-button:focus {\n  box-shadow: none;\n}\n.accordion-wrap-two .accordion-button:not(.collapsed) {\n  color: var(--tg-white);\n  background-color: #1a66ff;\n  box-shadow: none;\n}\n.accordion-wrap-two .accordion-button::after {\n  content: \"\\f102\";\n  width: auto;\n  height: auto;\n  background-image: none;\n  font-family: \"flaticon\";\n  font-size: 16px;\n  position: absolute;\n  right: 25px;\n  top: 18px;\n  color: var(--tg-primary-color);\n}\n.accordion-wrap-two .accordion-button:not(.collapsed)::after {\n  background-image: none;\n  transform: rotate(-180deg);\n  color: var(--tg-white);\n}\n.accordion-wrap-two .accordion-body {\n  padding: 20px 40px 30px 22px;\n}\n.accordion-wrap-two .accordion-body p {\n  margin-bottom: 0;\n  color: var(--tg-white);\n}\n.choose-img-three {\n  position: absolute;\n  width: 50%;\n  height: 100%;\n  top: 0;\n  right: 0;\n}\n.choose-img-three img {\n  width: 100%;\n  object-fit: cover;\n  height: 100%;\n}\n\n/*=============================\n\t13. Services\n===============================*/\n.section-title.white-title .sub-title {\n  color: var(--tg-lavender);\n}\n.section-title.text-center .sub-title::before {\n  left: 50%;\n  transform: translateX(-50%);\n}\n.section-title.white-title .title {\n  color: var(--tg-white);\n}\n.section-title p {\n  margin-bottom: 0;\n  margin-top: 16px;\n  color: var(--tg-gray-four);\n}\n.section-title.white-title p {\n  color: var(--tg-lavender);\n}\n.services-bg {\n  background: url(\"../img/bg/services_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0;\n}\n.services-item {\n  background: var(--tg-white);\n  border-radius: 10px;\n  padding: 25px 35px 35px;\n  margin-bottom: 30px;\n}\n.services-content .content-top {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n}\n.services-content .content-top .icon {\n  width: 60px;\n  height: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--tg-lavender);\n  font-size: 30px;\n  color: var(--tg-primary-color);\n  line-height: 0;\n  margin-right: 15px;\n  transition: 0.3s ease-in;\n}\n.services-item:hover .services-content .content-top .icon {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n}\n.services-content .content-top .title {\n  margin-bottom: 0;\n  font-size: 24px;\n}\n.services-thumb {\n  position: relative;\n  border-radius: 10px;\n  overflow: hidden;\n  margin-bottom: 25px;\n}\n.services-thumb::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--tg-primary-color);\n  opacity: 0;\n  transition: 0.3s linear;\n}\n.services-item:hover .services-thumb::before {\n  opacity: 0.8;\n}\n.services-thumb .btn {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: transparent;\n  border-color: var(--tg-white);\n  margin-top: -100px;\n  opacity: 0;\n  visibility: hidden;\n  color: var(--tg-white);\n}\n.services-thumb .btn::before {\n  background: var(--tg-white);\n}\n.services-thumb .btn::after {\n  color: var(--tg-primary-color);\n}\n.services-thumb .btn:hover {\n  color: var(--tg-primary-color);\n}\n.services-item:hover .services-thumb .btn {\n  opacity: 1;\n  visibility: visible;\n  margin-top: 0;\n}\n.services-content .list-wrap li {\n  text-transform: capitalize;\n  color: var(--tg-paragraph-color);\n  display: flex;\n  align-items: center;\n  margin-bottom: 5px;\n}\n.services-content .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.services-content .list-wrap li::before {\n  content: \"\";\n  width: 6px;\n  height: 6px;\n  background: var(--tg-paragraph-color);\n  border-radius: 50px;\n  margin-right: 10px;\n  flex: 0 0 auto;\n}\n.services-active [class*=\"col-\"] {\n  padding: 0 15px;\n}\n.services-active .slick-dots {\n  display: flex;\n  padding: 0;\n  margin: 0;\n  justify-content: center;\n  gap: 10px;\n  margin-top: 15px;\n}\n.services-active .slick-dots li {\n  list-style: none;\n  line-height: 0;\n}\n.services-active .slick-dots li button {\n  text-indent: -9999999999px;\n  padding: 0;\n  border: 2px solid var(--tg-lavender);\n  border-radius: 50%;\n  width: 15px;\n  height: 15px;\n  background: transparent;\n}\n.services-active .slick-dots li.slick-active button {\n  border-color: var(--tg-primary-color);\n  background: var(--tg-primary-color);\n}\n\n/* services-two */\n.services-bg-two {\n  background: url(\"../img/bg/services_bg02.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0 90px;\n}\n.services-item-two {\n  position: relative;\n  margin-bottom: 30px;\n  overflow: hidden;\n}\n.services-thumb-two {\n  position: relative;\n  border-radius: 8px;\n  border: 7px solid var(--tg-white);\n  box-shadow: 0px 10px 30px #ced2dd;\n  overflow: hidden;\n  z-index: 1;\n}\n.services-thumb-two::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    360deg,\n    #00194c 11.66%,\n    rgba(0, 25, 76, 0) 65.89%\n  );\n}\n.services-thumb-two::after {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(\n    360deg,\n    rgb(0 25 76 / 55%) 52.77%,\n    rgba(0, 25, 76, 0) 100%,\n    #00194c 100%\n  );\n  transition: 0.3s linear;\n  opacity: 0;\n}\n.services-item-two:hover .services-thumb-two::after {\n  opacity: 1;\n}\n.services-thumb-two img {\n  width: 100%;\n}\n.services-thumb-two .item-shape {\n  position: absolute;\n  right: 0;\n  top: 0;\n  margin-top: -50px;\n  transition: 0.3s linear;\n  opacity: 0;\n}\n.services-item-two:hover .services-thumb-two .item-shape {\n  margin-top: 0;\n  opacity: 1;\n}\n.services-content-two {\n  position: absolute;\n  left: 30px;\n  right: 30px;\n  bottom: -45px;\n  z-index: 2;\n  transition: all 0.3s linear;\n}\n.services-content-two .icon {\n  width: 55px;\n  height: 55px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 36px;\n  line-height: 0;\n  background: rgb(255 255 255 / 20%);\n  border-radius: 8px;\n  color: var(--tg-white);\n  margin-bottom: 15px;\n  transition: 0.3s linear;\n}\n.services-item-two:hover .services-content-two .icon {\n  background: var(--tg-primary-color);\n}\n.services-content-two .title {\n  margin-bottom: 10px;\n  font-size: 24px;\n  color: var(--tg-white);\n}\n.services-content-two p {\n  margin-bottom: 5px;\n  color: var(--tg-lavender);\n  opacity: 0;\n  transition: opacity 0.3s linear;\n}\n.services-item-two:hover .services-content-two {\n  bottom: 25px;\n}\n.services-item-two:hover .services-content-two p {\n  opacity: 1;\n}\n\n/* services-three */\n.services-area-three {\n  background: var(--tg-section-background);\n  position: relative;\n  z-index: 1;\n  padding: 120px 0 90px;\n}\n.services-item-three {\n  position: relative;\n  margin-bottom: 30px;\n  overflow: hidden;\n}\n.services-thumb-three {\n  border-radius: 10px 10px 0 0;\n  overflow: hidden;\n}\n.services-thumb-three img {\n  transform: scale(1);\n  transition: 0.3s ease-in-out;\n  width: 100%;\n}\n.services-item-three:hover .services-thumb-three img {\n  transform: scale(1.1);\n}\n.services-content-three {\n  position: relative;\n  background: var(--tg-white);\n  border-radius: 0 0 10px 10px;\n  padding: 60px 30px 50px;\n}\n.services-content-three .services-icon {\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-primary-color);\n  box-shadow: 0px 10px 15px rgba(0, 85, 255, 0.2);\n  border-radius: 15px;\n  color: var(--tg-white);\n  font-size: 40px;\n  line-height: 0;\n  position: absolute;\n  left: 30px;\n  top: -35px;\n}\n.services-content-three .services-icon i {\n  transition: 0.3s linear;\n}\n.services-item-three:hover .services-icon i {\n  transform: rotateY(180deg);\n}\n.services-content-three .title {\n  font-size: 22px;\n  margin-bottom: 10px;\n}\n.services-content-three p {\n  margin-bottom: 0;\n}\n.overlay-icon {\n  position: absolute;\n  font-size: 60px;\n  right: 30px;\n  bottom: -5px;\n  line-height: 0;\n  color: var(--tg-lavender);\n}\n.services-shape-four {\n  top: 2%;\n  position: absolute;\n  right: 0;\n  z-index: -1;\n  opacity: 0.5;\n}\n\n/* services-four */\n.services-area-four {\n  padding: 120px 0 90px;\n  position: relative;\n  overflow: hidden;\n}\n.services-area-four::before {\n  content: \"\";\n  position: absolute;\n  left: -30px;\n  bottom: 8%;\n  width: 390px;\n  height: 390px;\n  background: #e7f9ff;\n  filter: blur(200px);\n  z-index: -1;\n}\n.services-area-four::after {\n  content: \"\";\n  position: absolute;\n  right: 80px;\n  top: 12%;\n  width: 350px;\n  height: 350px;\n  background: #f7e7ff;\n  filter: blur(200px);\n  z-index: -1;\n}\n.section-title-three .sub-title {\n  font-size: 14px;\n}\n.section-title-three .title {\n  font-size: 36px;\n  font-weight: 800;\n}\n.section-title-three p {\n  color: var(--tg-paragraph-color);\n  width: 90%;\n  margin: 12px auto 0;\n}\n.services-item-four {\n  background: var(--tg-white);\n  border: 1px solid #dde5f6;\n  border-radius: 30px;\n  text-align: center;\n  padding: 55px 50px 65px;\n  margin-bottom: 30px;\n  transition: 0.3s linear;\n}\n.services-item-four:hover {\n  filter: drop-shadow(0px 14px 200px #e1e5ed);\n}\n.services-icon-four {\n  width: 100px;\n  height: 100px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0 auto 35px;\n  border-radius: 50%;\n  line-height: 0;\n  background: var(--tg-lavender);\n  color: var(--tg-primary-color);\n  font-size: 50px;\n  transition: 0.3s linear;\n}\n.services-item-four:hover .services-icon-four {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  box-shadow: 0px 10px 15px rgba(0, 85, 255, 0.2);\n}\n.services-content-four .title {\n  font-weight: 800;\n  font-size: 22px;\n  margin-bottom: 15px;\n}\n.services-content-four p {\n  margin-bottom: 25px;\n}\n\n/* services-five */\n.inner-services-bg {\n  background: url('../img/bg/inner_services_bg.jpg');\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0 90px;\n}\n\n/* services-six */\n.services-area-six {\n  background: var(--tg-section-background);\n  padding: 120px 0 90px;\n}\n\n/* services-seven */\n.services-area-seven {\n  background: var(--tg-section-background);\n}\n\n/* services-details */\n.services-details-area .row .col-71 {\n  width: 71%;\n  flex: 0 0 auto;\n}\n.services-details-area .row .col-29 {\n  width: 29%;\n  flex: 0 0 auto;\n}\n.services-details-thumb {\n  margin-bottom: 20px;\n}\n.services-details-thumb img {\n  border-radius: 10px;\n  width: 100%;\n}\n.services-details-content .title {\n  font-weight: 800;\n  font-size: 36px;\n  text-transform: capitalize;\n  margin-bottom: 20px;\n}\n.services-details-content > p {\n  margin-bottom: 15px;\n}\n.sd-inner-wrap {\n  margin-top: 30px;\n  margin-bottom: 25px;\n}\n.sd-inner-wrap .row .col-56 {\n  width: 56.5%;\n  flex: 0 0 auto;\n}\n.sd-inner-wrap .row .col-44 {\n  width: 43.5%;\n  flex: 0 0 auto;\n}\n.services-details-content .title-two {\n  font-size: 30px;\n  margin-bottom: 15px;\n  text-transform: capitalize;\n}\n.sd-inner-wrap .content p {\n  margin-bottom: 30px;\n}\n.sd-inner-wrap .content .list-wrap {\n  display: flex;\n  align-items: flex-start;\n  flex-wrap: wrap;\n  gap: 15px 0;\n}\n.sd-inner-wrap .content .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  line-height: 1.3;\n  font-weight: 600;\n  font-size: 18px;\n  font-family: var(--tg-heading-font-family);\n  width: 50%;\n}\n.sd-inner-wrap .content .list-wrap li img {\n  margin-right: 10px;\n}\n.sd-inner-wrap .thumb {\n  position: relative;\n}\n.sd-inner-wrap .thumb img {\n  width: 100%;\n  border-radius: 10px;\n}\n.sd-inner-wrap .thumb .play-btn {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 62px;\n  height: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-white);\n  border-radius: 50%;\n}\n.sd-inner-wrap .thumb .play-btn::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--tg-white);\n  border-radius: 50%;\n  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);\n  animation: pulse-border 1500ms ease-out infinite;\n}\n.company-benefit-wrap {\n  margin-top: 40px;\n}\n.company-benefit-wrap p {\n  margin-bottom: 25px;\n}\n.accordion-wrap-three .accordion-item {\n  background-color: transparent;\n  border: none;\n  border-radius: 4px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n.accordion-wrap-three .accordion-item:last-child {\n  margin-bottom: 0;\n}\n.accordion-wrap-three .accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.accordion-wrap-three .accordion-button {\n  position: relative;\n  padding: 16px 50px 16px 25px;\n  font-weight: 600;\n  font-size: 20px;\n  color: var(--tg-secondary-color);\n  text-align: left;\n  background-color: var(--tg-gray-two);\n  font-family: var(--tg-heading-font-family);\n  border: none;\n}\n.accordion-wrap-three .accordion-button:not(.collapsed) {\n  color: var(--tg-white);\n  background: var(--tg-primary-color);\n}\n.accordion-wrap-three .accordion-button::after {\n  content: \"\\f102\";\n  width: auto;\n  height: auto;\n  background-image: none;\n  font-family: \"flaticon\";\n  font-size: 16px;\n  position: absolute;\n  right: 25px;\n  top: 18px;\n  color: var(--tg-primary-color);\n}\n.accordion-wrap-three .accordion-button:not(.collapsed)::after {\n  background-image: none;\n  transform: rotate(-180deg);\n  color: var(--tg-white);\n}\n.accordion-wrap-three .accordion-body {\n  padding: 20px 40px 30px 30px;\n  border: 1px solid #dfdfdf;\n  border-top: none !important;\n  border-radius: 0 0 4px 4px;\n  margin-top: -1px;\n}\n.accordion-wrap-three .accordion-body p {\n  margin-bottom: 0;\n}\n.accordion-wrap-three .accordion-button:focus {\n  border-color: #dfdfdf;\n  box-shadow: none;\n}\n.sd-inner-wrap-two {\n  margin-top: 35px;\n  margin-bottom: 50px;\n}\n.sd-inner-wrap-two .row .col-58 {\n  width: 58.4%;\n  flex: 0 0 auto;\n}\n.sd-inner-wrap-two .row .col-42 {\n  width: 41.6%;\n  flex: 0 0 auto;\n}\n.sd-inner-wrap-two .thumb img {\n  border-radius: 10px;\n}\n.services-details-list .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 40px;\n}\n.services-details-list .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.services-details-list .list-wrap li .icon {\n  width: 80px;\n  height: 80px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-lavender);\n  color: var(--tg-primary-color);\n  border-radius: 14px;\n  position: relative;\n  font-size: 40px;\n  line-height: 0;\n  flex: 0 0 auto;\n  margin-right: 20px;\n}\n.services-details-list .list-wrap li .icon::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 0;\n  transform: translateX(-50%);\n  width: 16px;\n  height: 3px;\n  background: var(--tg-primary-color);\n  border-radius: 3px;\n}\n.services-details-list .list-wrap li .content .title {\n  margin-bottom: 8px;\n  font-size: 20px;\n  text-transform: capitalize;\n}\n.services-details-list .list-wrap li .content p {\n  margin-bottom: 0;\n}\n.industrial-working-wrap p {\n  margin-bottom: 25px;\n}\n.industrial-working-wrap .info-two {\n  margin-bottom: 0;\n}\n.industrial-working-wrap img {\n  border-radius: 10px;\n  margin-bottom: 25px;\n}\n.services-details-list-two {\n  margin-right: 15px;\n}\n.services-details-list-two .list-wrap li {\n  border: 1px solid #dadfee;\n  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);\n  border-radius: 6px;\n  display: flex;\n  align-items: flex-start;\n  padding: 25px 30px;\n  background: var(--tg-white);\n  margin-bottom: 20px;\n}\n.services-details-list-two .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.services-details-list-two .list-wrap li .icon {\n  font-size: 35px;\n  line-height: 0;\n  color: var(--tg-primary-color);\n  flex: 0 0 auto;\n  margin-right: 10px;\n  line-height: 0;\n}\n.services-details-list-two .list-wrap li .content .title {\n  font-size: 22px;\n  margin-bottom: 10px;\n}\n.services-details-list-two .list-wrap li .content p {\n  margin-bottom: 0;\n}\n.sd-inner-wrap-three .col-43 {\n  width: 43%;\n  flex: 0 0 auto;\n}\n.sd-inner-wrap-three .col-57 {\n  width: 57%;\n  flex: 0 0 auto;\n}\n.sd-inner-wrap-three {\n  margin-bottom: 50px;\n  margin-top: 40px;\n}\n.sd-inner-wrap-four .row .col-55 {\n  width: 55%;\n  flex: 0 0 auto;\n}\n.sd-inner-wrap-four .row .col-45 {\n  width: 45%;\n  flex: 0 0 auto;\n}\n.sd-inner-wrap-four .thumb img {\n  border-radius: 10px;\n}\n.sd-inner-wrap-four .content .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 1.3;\n  text-transform: capitalize;\n  font-family: var(--tg-heading-font-family);\n  margin-bottom: 15px;\n}\n.sd-inner-wrap-four .content .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.sd-inner-wrap-four .content .list-wrap li img {\n  margin-right: 10px;\n}\n.sd-inner-wrap-four {\n  margin-bottom: 40px;\n}\n.services-details-list-three .list-wrap {\n  display: flex;\n  align-items: center;\n  gap: 25px;\n}\n.services-details-list-three .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  border: 1px solid #dadfee;\n  box-shadow: 0px 0px 40px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  background: var(--tg-white);\n  padding: 25px 30px;\n}\n.services-details-list-three .list-wrap li .icon {\n  font-size: 50px;\n  line-height: 0;\n  color: var(--tg-primary-color);\n  margin-right: 15px;\n}\n.services-details-list-three .list-wrap li .content .title {\n  font-size: 22px;\n  margin-bottom: 10px;\n}\n.services-details-list-three .list-wrap li .content p {\n  margin-bottom: 0;\n}\n.services-details-list-three {\n  margin-bottom: 30px;\n}\n.services-details-thumb-two {\n  margin-bottom: 20px;\n  margin-top: 25px;\n}\n.services-details-thumb-two img {\n  border-radius: 10px;\n}\n.speed-optimized-wrap {\n  margin-top: 50px;\n  margin-bottom: 45px;\n}\n.speed-optimized-wrap p {\n  margin-bottom: 0;\n}\n.sd-inner-wrap-five .row .col-50 {\n  width: 50%;\n  flex: 0 0 auto;\n}\n.sd-inner-wrap-five .left-side-content {\n  margin-right: 30px;\n}\n.sd-inner-wrap-five .left-side-content p {\n  margin-bottom: 0;\n}\n.sd-inner-wrap-five .right-side-content p {\n  margin-bottom: 15px;\n}\n.sd-inner-wrap-five .right-side-content .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  line-height: 1.3;\n  font-weight: 600;\n  font-size: 18px;\n  color: var(--tg-secondary-color);\n  font-family: var(--tg-heading-font-family);\n  margin-bottom: 15px;\n}\n.sd-inner-wrap-five .right-side-content .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.sd-inner-wrap-five .right-side-content .list-wrap li img {\n  margin-right: 10px;\n}\n\n/* services-sidebar */\n.services-sidebar {\n  padding-right: 20px;\n}\n.services-cat-list .list-wrap li {\n  margin-bottom: 10px;\n}\n.services-cat-list .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.services-cat-list .list-wrap li a {\n  border: 1px solid #e0e6f2;\n  border-radius: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 15px 22px;\n  background: var(--tg-white);\n  font-weight: 600;\n  font-size: 18px;\n  font-family: var(--tg-heading-font-family);\n  color: var(--tg-secondary-color);\n  text-transform: capitalize;\n}\n.services-cat-list .list-wrap li a i {\n  margin-left: 10px;\n  font-size: 22px;\n  line-height: 0;\n  color: var(--tg-gray-four);\n  transition: all 0.3s ease-out 0s;\n}\n.services-cat-list .list-wrap li.active a,\n.services-cat-list .list-wrap li a:hover {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  border-color: var(--tg-primary-color);\n}\n.services-cat-list .list-wrap li.active a i,\n.services-cat-list .list-wrap li a:hover i {\n  color: var(--tg-white);\n}\n.services-widget {\n  background: var(--tg-section-background);\n  border-radius: 10px;\n  padding: 30px 30px 35px;\n  margin-bottom: 30px;\n}\n.services-widget:last-child {\n  margin-bottom: 0;\n}\n.services-widget .sw-title {\n  margin-bottom: 15px;\n  position: relative;\n  font-size: 24px;\n  text-transform: capitalize;\n  padding-bottom: 10px;\n}\n.services-widget .sw-title::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 30px;\n  height: 4px;\n  background: var(--tg-primary-color);\n  border-radius: 4px;\n}\n.services-brochure-wrap p {\n  margin-bottom: 15px;\n}\n.services-brochure-wrap .download-btn {\n  display: flex;\n  align-items: center;\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--tg-secondary-color);\n  border: 1px solid #e0e6f2;\n  border-radius: 5px;\n  background: var(--tg-white);\n  padding: 13px 20px;\n  margin-bottom: 10px;\n}\n.services-brochure-wrap .download-btn i {\n  font-size: 16px;\n  color: var(--tg-primary-color);\n  margin-right: 10px;\n  transition: all 0.3s ease-out 0s;\n}\n.services-brochure-wrap .download-btn:hover {\n  color: var(--tg-white);\n  background: var(--tg-primary-color);\n  border-color: var(--tg-primary-color);\n}\n.services-brochure-wrap .download-btn:hover i {\n  color: var(--tg-white);\n}\n.services-brochure-wrap .download-btn:last-child {\n  margin-bottom: 0;\n}\n.services-widget-form .form-grp {\n  margin-bottom: 10px;\n}\n.services-widget-form .form-grp textarea,\n.services-widget-form .form-grp input {\n  width: 100%;\n  border: 1px solid #e0e6f2;\n  border-radius: 5px;\n  background: var(--tg-white);\n  padding: 13px 16px;\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--tg-paragraph-color);\n  height: 50px;\n  display: block;\n}\n.services-widget-form .form-grp textarea::placeholder,\n.services-widget-form .form-grp input::placeholder {\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--tg-gray-four);\n}\n.services-widget-form .form-grp textarea {\n  min-height: 120px;\n  max-height: 120px;\n}\n.submit-btn {\n  border: none;\n  background: var(--tg-primary-color);\n  width: 100%;\n  font-weight: 700;\n  font-size: 16px;\n  color: var(--tg-white);\n  text-transform: capitalize;\n  border-radius: 5px;\n  padding: 13px 20px;\n  height: 50px;\n}\n.submit-btn:hover {\n  background: var(--tg-secondary-color);\n}\n.services-sidebar-contact {\n  background: var(--tg-paragraph-color);\n  text-align: center;\n}\n.services-sidebar-contact .title {\n  margin-bottom: 30px;\n  color: var(--tg-white);\n  font-size: 22px;\n}\n.services-sidebar-contact a {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-primary-color);\n  border-radius: 6px;\n  color: var(--tg-white);\n  font-weight: 600;\n  font-size: 18px;\n  padding: 9px 22px;\n}\n.services-sidebar-contact a i {\n  line-height: 0;\n  margin-right: 5px;\n}\n.services-sidebar-contact a:hover {\n  background: var(--tg-secondary-color);\n}\n.services-cat-list-two .list-wrap li a {\n  position: relative;\n  z-index: 1;\n  background: #f8f8fa;\n}\n.services-cat-list-two .list-wrap li a::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 30px;\n  border-radius: 3px;\n  background: var(--tg-primary-color);\n  z-index: -1;\n}\n\n/*=============================\n\t14. Cta\n===============================*/\n.cta-area {\n  margin-top: -105px;\n}\n.cta-inner-wrap-two,\n.cta-inner-wrap {\n  background: url(\"../img/bg/cta_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 70px;\n  border-radius: 10px;\n}\n.cta-inner-wrap-two {\n  background: url(\"../img/bg/cta_bg02.jpg\");\n}\n.cta-content {\n  display: flex;\n  align-items: center;\n}\n.cta-info-wrap {\n  display: flex;\n  align-items: center;\n  width: 46%;\n  flex: 0 0 auto;\n  position: relative;\n}\n.cta-info-wrap::before {\n  content: \"\";\n  position: absolute;\n  right: 50px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 3px;\n  height: 74px;\n  background: var(--tg-primary-color);\n}\n.cta-info-wrap .icon {\n  font-size: 50px;\n  color: var(--tg-white);\n  line-height: 0;\n  margin-right: 15px;\n}\n.cta-info-wrap .content span {\n  display: block;\n  font-weight: 600;\n  font-size: 18px;\n  font-family: var(--tg-heading-font-family);\n  color: var(--tg-white);\n  line-height: 1;\n  margin-bottom: 10px;\n}\n.cta-info-wrap .content a {\n  font-weight: 700;\n  font-size: 30px;\n  display: inline-block;\n  line-height: 1;\n  color: var(--tg-white);\n  font-family: var(--tg-heading-font-family);\n}\n.cta-info-wrap .content a:hover {\n  color: var(--tg-primary-color);\n}\n.cta-content .title {\n  font-weight: 800;\n  font-size: 30px;\n  margin-bottom: 0;\n  color: var(--tg-white);\n  line-height: 1.13;\n}\n\n/* cta-two */\n.cta-inner-wrap-two .cta-info-wrap::before {\n  background: var(--tg-white);\n}\n.cta-inner-wrap-two .cta-info-wrap a:hover {\n  color: var(--tg-secondary-color);\n}\n.cta-inner-wrap-two .cta-btn .btn {\n  border: 2px solid var(--tg-white);\n  background: transparent;\n  padding: 16px 30px;\n}\n.cta-inner-wrap-two .cta-btn .btn:hover {\n  background: var(--tg-blue);\n  border-color: var(--tg-blue);\n}\n\n/* cta-three */\n.cta-area-three {\n  background: #f8f8fa;\n}\n.cta-inner-wrap-three {\n  margin-top: -85px;\n  position: relative;\n  z-index: 1;\n}\n.cta-info-wrap.cta-info-wrap-two .icon {\n  width: 70px;\n  height: 70px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0px 24px 50px rgba(0, 0, 0, 0.3);\n  border-radius: 50%;\n  background: var(--tg-white);\n  font-size: 35px;\n  color: var(--tg-primary-color);\n  line-height: 0;\n  margin-right: 15px;\n}\n.cta-info-wrap.cta-info-wrap-two .content a {\n  font-size: 24px;\n}\n.cta-info-wrap.cta-info-wrap-two::before {\n  display: none;\n}\n.cta-inner-wrap-three {\n  background: url(\"../img/bg/cta_bg03.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 50px 45px;\n  border-radius: 10px;\n}\n.cta-inner-wrap-three .btn-three {\n  background: var(--tg-white);\n  color: var(--tg-primary-color);\n}\n.cta-inner-wrap-three .btn-three::after {\n  filter: unset;\n}\n.cta-inner-wrap-three .btn-three:hover {\n  background: var(--tg-secondary-color);\n  color: var(--tg-white);\n}\n.cta-inner-wrap-three .btn-three:hover::after {\n  filter: brightness(0) invert(1);\n}\n\n.cta-area-four {\n  margin-top: -100px;\n}\n.cta-area-five {\n  position: relative;\n  z-index: 3;\n}\n\n/*=============================\n\t15. Counter\n===============================*/\n.counter-bg {\n  background: url(\"../img/bg/counter_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0 90px;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.counter-item {\n  text-align: center;\n  margin-bottom: 30px;\n}\n.counter-item .count {\n  margin-bottom: 5px;\n  font-weight: 800;\n  font-size: 60px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  line-height: 0.8;\n}\n.counter-item p {\n  margin-bottom: 0;\n}\n.counter-shape-wrap img {\n  position: absolute;\n  z-index: -1;\n}\n.counter-shape-wrap img:nth-child(1) {\n  left: 10%;\n  top: 25%;\n  animation: animationFramesOne 15s linear infinite;\n}\n.counter-shape-wrap img:nth-child(2) {\n  right: 10%;\n  top: 45%;\n  animation: animationFramesOne 20s linear infinite;\n}\n@keyframes animationFramesOne {\n  0% {\n    transform: translate(0px, 0px) rotate(0deg);\n  }\n  20% {\n    transform: translate(73px, -1px) rotate(36deg);\n  }\n  40% {\n    transform: translate(141px, 72px) rotate(72deg);\n  }\n  60% {\n    transform: translate(83px, 122px) rotate(108deg);\n  }\n  80% {\n    transform: translate(-40px, 72px) rotate(144deg);\n  }\n  100% {\n    transform: translate(0px, 0px) rotate(0deg);\n  }\n}\n\n@-webkit-keyframes animationFramesOne {\n  0% {\n    -webkit-transform: translate(0px, 0px) rotate(0deg);\n  }\n  20% {\n    -webkit-transform: translate(73px, -1px) rotate(36deg);\n  }\n  40% {\n    -webkit-transform: translate(141px, 72px) rotate(72deg);\n  }\n  60% {\n    -webkit-transform: translate(83px, 122px) rotate(108deg);\n  }\n  80% {\n    -webkit-transform: translate(-40px, 72px) rotate(144deg);\n  }\n  100% {\n    -webkit-transform: translate(0px, 0px) rotate(0deg);\n  }\n}\n.animationFramesOne {\n  -webkit-animation: animationFramesOne 12s linear infinite;\n  animation: animationFramesOne 12s linear infinite;\n}\n\n/* counter-two */\n.counter-area-two {\n  background: #f8f8fa;\n  padding: 75px 0 45px;\n}\n.counter-item-two {\n  text-align: center;\n  position: relative;\n  margin-bottom: 30px;\n}\n.counter-item-two::before {\n  content: \"\";\n  position: absolute;\n  right: -15px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 1px;\n  height: 95px;\n  background: #d5ddec;\n}\n.counter-item-wrap .row [class*=\"col-\"]:last-child .counter-item-two::before {\n  display: none;\n}\n.counter-item-two .count {\n  font-weight: 800;\n  font-size: 60px;\n  display: inline-flex;\n  align-items: center;\n  line-height: 0.8;\n  margin-bottom: 5px;\n  justify-content: center;\n  position: relative;\n  z-index: 1;\n}\n.counter-item-two .count::before {\n  content: \"\";\n  position: absolute;\n  left: -24px;\n  top: -18px;\n  width: 50px;\n  height: 50px;\n  background: #dce7ff;\n  border-radius: 50%;\n  z-index: -1;\n}\n.counter-item-two p {\n  margin-bottom: 0;\n}\n\n/* counter-three */\n.counter-item-three {\n  border: 1.2px solid #d4dced;\n  border-radius: 10px;\n  display: flex;\n  align-items: center;\n  padding: 28px 30px;\n  margin-bottom: 30px;\n  transform: translateY(0);\n  transition: 0.3s linear;\n}\n.counter-item-three:hover {\n  transform: translateY(-5px);\n}\n.counter-icon {\n  font-size: 60px;\n  line-height: 0;\n  position: relative;\n  color: var(--tg-primary-color);\n  margin-right: 40px;\n}\n.counter-icon::before {\n  content: \"\";\n  position: absolute;\n  left: -14px;\n  top: -15px;\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  background: var(--tg-lavender);\n  z-index: -1;\n  transition: 0.3s linear;\n}\n.counter-icon::after {\n  content: \"\";\n  position: absolute;\n  right: -20px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 2px;\n  height: 38px;\n  background: var(--tg-lavender);\n}\n.counter-item-three:hover .counter-icon::before {\n  left: 0;\n  top: 0;\n}\n.counter-content .count {\n  font-size: 36px;\n  margin-bottom: 10px;\n  line-height: 0.8;\n  display: flex;\n  align-items: center;\n}\n.counter-content p {\n  margin-bottom: 0;\n  line-height: 1.2;\n  color: var(--tg-gray-four);\n}\n\n/* counter-four */\n.counter-area-four {\n  background: var(--tg-section-background);\n  position: relative;\n  padding: 220px 0 120px;\n  overflow: hidden;\n  z-index: 1;\n  margin-top: -100px;\n}\n.counter-area-four::before {\n  content: \"\";\n  position: absolute;\n  right: 38%;\n  bottom: 60px;\n  width: 390px;\n  height: 390px;\n  background: #5e3de3;\n  opacity: 0.07;\n  filter: blur(75px);\n  z-index: -1;\n}\n.counter-content-four {\n  width: 90%;\n}\n.counter-content-four p {\n  margin-bottom: 0;\n}\n.counter-item-wrap-four .list-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  margin: 0 -12px;\n  gap: 24px 0;\n}\n.counter-item-wrap-four .list-wrap li {\n  padding: 0 12px;\n  width: 50%;\n}\n.counter-item-wrap-four .list-wrap li .counter-item-three {\n  background: var(--tg-white);\n  margin-bottom: 0;\n}\n.inner-counter-shape {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: -1;\n}\n\n/*=============================\n\t16. Estimate\n===============================*/\n.estimate-area {\n  background: #f8f8fa;\n  padding: 120px 0 0;\n  position: relative;\n  z-index: 1;\n}\n.estimate-content {\n  padding: 0 40px 0 80px;\n}\n.estimate-tab-wrap .nav-tabs {\n  border-bottom: none;\n  gap: 5px;\n  margin-bottom: 20px;\n}\n.estimate-tab-wrap .nav-tabs .nav-link {\n  margin-bottom: 0;\n  background: var(--tg-gray-four);\n  border: none;\n  border-radius: 6px;\n  font-size: 16px;\n  font-weight: 600;\n  color: var(--tg-white);\n  padding: 7px 20px;\n}\n.estimate-tab-wrap .nav-tabs .nav-link.active {\n  background: var(--tg-primary-color);\n}\n.estimate-form-wrap .form-grp {\n  margin-bottom: 10px;\n}\n.estimate-form-wrap .form-grp input {\n  border: 1px solid #d0d6e1;\n  border-radius: 5px;\n  width: 100%;\n  padding: 15px 20px;\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--tg-secondary-color);\n  height: 50px;\n  background: var(--tg-white);\n}\n.estimate-form-wrap .form-grp input::placeholder {\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--tg-gray-four);\n}\n.range-slider-wrap {\n  margin-bottom: 30px;\n}\n.range-slider-wrap .content-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 20px;\n  margin-top: 20px;\n  margin-bottom: 15px;\n}\n.range-slider-wrap .content-top p {\n  font-weight: 600;\n  font-size: 16px;\n  margin-bottom: 0;\n}\n.range-slider-wrap .content-top span {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 16px;\n  color: var(--tg-secondary-color);\n}\n.range-slider-wrap .content-top span strong {\n  font-weight: 600;\n  font-size: 16px;\n}\n.range-slider-wrap input {\n  width: 100%;\n  height: 15px;\n  appearance: none;\n  -webkit-appearance: none;\n  background: #d9d9d9;\n  outline: none;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.range-slider-wrap .range::-webkit-slider-thumb {\n  -webkit-appearance: none;\n  width: 15px;\n  height: 15px;\n  border-radius: 50%;\n  background: var(--tg-primary-color);\n  cursor: pointer;\n  border: none;\n  box-shadow: -807px 0 0 800px #6699ff;\n}\n.estimate-form-wrap .btn.btn-three::after {\n  display: none;\n}\n.estimate-shape {\n  position: absolute;\n  z-index: -1;\n  top: 0;\n  right: 0;\n}\n\n/*=============================\n\t17. Project\n===============================*/\n.project-bg {\n  background: url(\"../img/bg/project_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0 90px;\n  overflow: hidden;\n}\n.project-top-content {\n  margin-left: 40px;\n  margin-bottom: 50px;\n}\n.project-top-content p {\n  margin-bottom: 0;\n  color: var(--tg-paragraph-color);\n}\n.project-item {\n  margin-bottom: 30px;\n}\n.project-thumb {\n  border-radius: 10px;\n  overflow: hidden;\n}\n.project-thumb img {\n  filter: grayscale(0);\n}\n.project-item:hover .project-thumb img {\n  filter: grayscale(100%);\n}\n.project-content {\n  box-shadow: 0px 4px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 9px;\n  margin: -85px 18px 0;\n  padding: 22px 80px 22px 30px;\n  position: relative;\n  overflow: hidden;\n  background: var(--tg-white);\n}\n.project-content .tag {\n  font-weight: 500;\n  font-size: 15px;\n  display: inline-block;\n  text-transform: capitalize;\n  margin-bottom: 5px;\n}\n.project-content .tag:hover {\n  color: var(--tg-secondary-color);\n}\n.project-content .title {\n  font-size: 22px;\n  margin-bottom: 0;\n}\n.project-content .link-arrow {\n  width: 113px;\n  height: 113px;\n  display: block;\n  border-radius: 50%;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  font-size: 22px;\n  line-height: 0;\n  padding: 24px 32px;\n  position: absolute;\n  right: -38px;\n  bottom: -51px;\n  transform: translateY(50px);\n  opacity: 0;\n  visibility: hidden;\n}\n.project-item:hover .project-content .link-arrow {\n  transform: translateY(0);\n  opacity: 1;\n  visibility: visible;\n}\n.project-content .link-arrow:hover {\n  background: var(--tg-secondary-color);\n}\n.swiper-container.project-active {\n  overflow: hidden;\n  margin-right: -422px;\n}\n\n/* project-two */\n.project-bg-two {\n  background: url(\"../img/bg/project_bg02.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0 200px;\n}\n.project-content-top {\n  margin-bottom: 30px;\n}\n.project-content-top p {\n  margin-bottom: 0;\n  width: 90%;\n  margin-left: auto;\n}\n.project-item-two {\n  position: relative;\n  margin-bottom: 30px;\n}\n.project-thumb-two img {\n  border-radius: 10px;\n  transition: 0.3s linear;\n}\n.project-item-two:hover .project-thumb-two img {\n  filter: grayscale(100%);\n}\n.project-content-two {\n  position: absolute;\n  left: 10px;\n  right: 10px;\n  top: 10px;\n  bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  background: rgba(0 85 255 / 80%);\n  border-radius: 10px;\n  padding: 30px;\n  transition: 0.3s linear;\n  opacity: 0;\n  transform: scale(0.8);\n  visibility: hidden;\n}\n.project-item-two:hover .project-content-two {\n  opacity: 1;\n  transform: scale(1);\n  visibility: visible;\n}\n.project-content-two .title {\n  font-weight: 700;\n  font-size: 30px;\n  margin-bottom: 10px;\n  color: var(--tg-white);\n}\n.project-content-two .title a:hover {\n  color: var(--tg-white);\n}\n.project-content-two span {\n  display: block;\n  line-height: 1;\n  color: var(--tg-white);\n}\n.project-content-two .link-btn {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--tg-white);\n  color: var(--tg-secondary-color);\n  font-size: 18px;\n  position: absolute;\n  right: 28px;\n  bottom: 28px;\n}\n.project-content-two .link-btn:hover {\n  background: var(--tg-secondary-color);\n  color: var(--tg-white);\n}\n\n/* project-three */\n.project-item-three {\n  margin-bottom: 30px;\n}\n.project-thumb-three {\n  overflow: hidden;\n}\n.project-thumb-three img {\n  transform: scale(1);\n  transition: 0.3s linear;\n}\n.project-item-three:hover .project-thumb-three img {\n  transform: scale(1.1);\n}\n\n/* project-four */\n.project-area-four {\n  background: var(--tg-section-background);\n  padding: 120px 0 190px;\n}\n.project-item-four {\n  margin-bottom: 30px;\n}\n.project-thumb-four {\n  position: relative;\n  margin-bottom: 20px;\n}\n.project-thumb-four::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  background: var(--tg-primary-color);\n  opacity: 0.9;\n  opacity: 0;\n  transition: 0.3s linear;\n}\n.project-thumb-four .project-link {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  font-size: 50px;\n  width: 50px;\n  opacity: 0;\n  visibility: hidden;\n  line-height: 0;\n}\n.project-item-four:hover .project-thumb-four::before {\n  opacity: 0.9;\n}\n.project-item-four:hover .project-thumb-four .project-link {\n  opacity: 1;\n  visibility: visible;\n}\n.project-content-four .title {\n  font-size: 24px;\n  margin-bottom: 5px;\n}\n.project-content-four span {\n  font-weight: 400;\n  display: block;\n  line-height: 1;\n  color: var(--tg-gray-four);\n}\n\n/* project-details */\n.project-details-wrap .row .col-71 {\n  width: 71%;\n  flex: 0 0 auto;\n}\n.project-details-wrap .row .col-29 {\n  width: 29%;\n  flex: 0 0 auto;\n}\n.project-details-thumb {\n  margin-bottom: 30px;\n}\n.project-details-thumb img {\n  border-radius: 10px;\n}\n.project-details-info {\n  border: 1px solid #e0e6f2;\n  border-radius: 5px;\n  padding: 25px 35px 28px;\n  margin-bottom: 30px;\n}\n.project-details-info .title {\n  font-size: 24px;\n  position: relative;\n  margin-bottom: 15px;\n  padding-bottom: 12px;\n}\n.project-details-info .title::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 30px;\n  height: 4px;\n  background: var(--tg-primary-color);\n  border-radius: 4px;\n}\n.project-details-info > .list-wrap > li {\n  font-weight: 500;\n  font-size: 16px;\n  color: var(--tg-gray-four);\n  border-bottom: 1px solid #dfe3e7;\n  display: flex;\n  align-items: center;\n  font-family: var(--tg-heading-font-family);\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n}\n.project-details-info > .list-wrap > li:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border: none;\n}\n.project-details-info > .list-wrap > li span {\n  font-weight: 700;\n  font-size: 18px;\n  color: var(--tg-paragraph-color);\n  width: 40%;\n  flex: 0 0 auto;\n}\n.project-details-info > .list-wrap > li.social .list-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.project-details-info > .list-wrap > li.social .list-wrap li a {\n  color: var(--tg-gray-four);\n}\n.project-details-info > .list-wrap > li.social .list-wrap li a:hover {\n  color: var(--tg-primary-color);\n}\n.project-details-content .title {\n  font-weight: 800;\n  font-size: 36px;\n  margin-bottom: 20px;\n}\n.project-details-content > p {\n  margin-bottom: 15px;\n}\n.project-details-content .title-two {\n  margin-bottom: 15px;\n  font-size: 30px;\n  text-transform: capitalize;\n}\n.pd-optimized-wrap {\n  margin-top: 50px;\n  margin-bottom: 60px;\n}\n.pd-optimized-wrap p {\n  margin-bottom: 0;\n}\n.pd-inner-wrap .row .col-41 {\n  width: 41.3%;\n  flex: 0 0 auto;\n}\n.pd-inner-wrap .row .col-59 {\n  width: 58.7%;\n  flex: 0 0 auto;\n}\n.pd-inner-wrap .content {\n  margin-right: 20px;\n}\n.pd-inner-wrap .content p {\n  margin-bottom: 0;\n}\n.pd-inner-wrap .content .info-one {\n  margin-bottom: 30px;\n}\n.pd-inner-wrap .content .list-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-start;\n  gap: 18px 0;\n  margin-bottom: 25px;\n}\n.pd-inner-wrap .content .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  line-height: 1.3;\n  font-weight: 600;\n  font-size: 18px;\n  font-family: var(--tg-heading-font-family);\n  color: var(--tg-paragraph-color);\n  width: 50%;\n}\n.pd-inner-wrap .content .list-wrap li img {\n  margin-right: 10px;\n}\n.pd-inner-wrap .thumb {\n  position: relative;\n}\n.pd-inner-wrap .thumb img {\n  border-radius: 10px;\n}\n.pd-inner-wrap .thumb .play-btn {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 62px;\n  height: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-white);\n  border-radius: 50%;\n}\n.pd-inner-wrap .thumb .play-btn::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--tg-white);\n  border-radius: 50%;\n  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);\n  animation: pulse-border 1500ms ease-out infinite;\n}\n\n/*=============================\n\t18. Faq\n===============================*/\n.faq-area {\n  position: relative;\n  z-index: 1;\n  padding: 0 0 120px;\n}\n.faq-bg-shape {\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  width: 40.3%;\n  background: url(\"../img/images/faq_shape01.png\");\n  background-size: cover;\n  background-position: center;\n  z-index: -1;\n}\n.faq-shape-wrap img {\n  position: absolute;\n  z-index: -1;\n}\n.faq-shape-wrap img:nth-child(1) {\n  right: 0;\n  bottom: 0;\n}\n.faq-shape-wrap img:nth-child(2) {\n  left: 14%;\n  bottom: 12%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.faq-img-wrap {\n  text-align: right;\n  position: relative;\n  margin-right: 45px;\n}\n.faq-img-wrap img:nth-child(1) {\n  box-shadow: 0px 0px 50px rgba(0, 0, 0, 0.15);\n  border-radius: 10px;\n  border: 8px solid var(--tg-white);\n}\n.faq-img-wrap img:nth-child(2) {\n  box-shadow: 0px 0px 30px rgba(0, 0, 0, 0.1);\n  border-radius: 10px;\n  position: absolute;\n  left: 0;\n  bottom: 20%;\n}\n.faq-content > p {\n  margin-bottom: 30px;\n  width: 85%;\n}\n.faq-content .accordion-wrap {\n  width: 90%;\n}\n.faq-content .accordion-item:first-of-type .accordion-button {\n  border-top-left-radius: 0;\n  border-top-right-radius: 0;\n}\n.faq-content .accordion-item {\n  background-color: transparent;\n  border: none;\n  border-radius: 6px;\n  overflow: hidden;\n  margin-bottom: 10px;\n}\n.faq-content .accordion-item:last-child {\n  margin-bottom: 0;\n}\n.faq-content .accordion-button {\n  position: relative;\n  padding: 17px 50px 17px 30px;\n  font-weight: 700;\n  font-size: 18px;\n  color: var(--tg-secondary-color);\n  text-align: left;\n  background-color: var(--tg-gray-two);\n  font-family: var(--tg-heading-font-family);\n  border: 1px solid #dfdfdf;\n}\n.faq-content .accordion-button.collapsed {\n  border: transparent;\n}\n.faq-content .accordion-button:not(.collapsed) {\n  color: var(--tg-primary-color);\n  background-color: transparent;\n  box-shadow: none;\n}\n.faq-content .accordion-button:focus {\n  border-color: #dfdfdf;\n  box-shadow: none;\n}\n.faq-content .accordion-body {\n  padding: 20px 30px 30px;\n  border: 1px solid #dfdfdf;\n  border-top: none;\n}\n.faq-content .accordion-body p {\n  margin-bottom: 0;\n  color: var(--tg-gray-four);\n}\n.faq-content .accordion-button::after {\n  content: \"\\f102\";\n  width: auto;\n  height: auto;\n  background-image: none;\n  font-family: \"flaticon\";\n  font-size: 16px;\n  position: absolute;\n  right: 25px;\n  top: 18px;\n  color: var(--tg-primary-color);\n}\n.faq-content .accordion-button:not(.collapsed)::after {\n  background-image: none;\n  transform: rotate(-180deg);\n}\n\n/*=============================\n\t19. Request\n===============================*/\n.request-area.request-bg {\n  background: url(\"../img/bg/request_bg.jpg\");\n  background-position: center;\n  background-size: cover;\n  padding: 80px 0;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.request-content .title {\n  font-size: 32px;\n  margin-bottom: 0;\n  color: var(--tg-white);\n  font-weight: 800;\n}\n.request-content-right {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 20px;\n}\n.request-contact {\n  display: flex;\n  align-items: center;\n  background: rgba(255, 255, 255, 0.1);\n  border-radius: 30px;\n  padding: 5px 22px;\n}\n.request-contact .icon {\n  font-size: 30px;\n  line-height: 0;\n  color: var(--tg-white);\n  margin-right: 10px;\n}\n.request-contact .content span {\n  display: block;\n  line-height: 1;\n  font-size: 13px;\n  color: var(--tg-white);\n  margin-bottom: 2px;\n}\n.request-contact .content a {\n  display: inline-block;\n  font-size: 18px;\n  font-weight: 600;\n  font-family: var(--tg-heading-font-family);\n  color: var(--tg-white);\n  line-height: 1;\n}\n.request-contact .content a:hover {\n  color: var(--tg-primary-color);\n}\n.request-shape {\n  position: absolute;\n  left: 6%;\n  top: 10%;\n  animation: animationFramesOne 15s linear infinite;\n  z-index: -1;\n}\n\n/* request-two */\n.request-area-two {\n  background: var(--tg-secondary-color);\n  padding: 120px 0;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.request-shape-wrap img {\n  position: absolute;\n  z-index: -1;\n}\n.request-shape-wrap img:nth-child(1) {\n  left: 13%;\n  top: 45%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.request-shape-wrap img:nth-child(2) {\n  right: 0;\n  top: 0;\n}\n.request-content-two p {\n  margin-bottom: 0;\n  color: #d0d0dd;\n  width: 90%;\n}\n.request-form-wrap .form-grp input {\n  width: 100%;\n  border: none;\n  font-weight: 500;\n  font-size: 13px;\n  color: var(--tg-secondary-color);\n  padding: 15px 20px;\n  border-radius: 4px;\n  background: var(--tg-white);\n  height: 50px;\n}\n.request-form-wrap .form-grp input::placeholder {\n  font-weight: 500;\n  font-size: 13px;\n  color: var(--tg-paragraph-color);\n}\n.request-form-wrap .row {\n  gap: 15px 0;\n  margin: 0 -7px;\n}\n.request-form-wrap .row [class*=\"col-\"] {\n  padding: 0 7px;\n}\n.request-form-wrap button {\n  font-weight: 800;\n  font-size: 16px;\n  text-transform: uppercase;\n  border: none;\n  width: 100%;\n  text-align: center;\n  padding: 10px 20px;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  border-radius: 4px;\n  height: 50px;\n}\n.request-form-wrap button:hover {\n  background: var(--tg-white);\n  color: var(--tg-primary-color);\n}\n\n/*=============================\n\t20. Team\n===============================*/\n.team-bg {\n  background: url(\"../img/bg/team_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0 90px;\n}\n.team-item {\n  border: 1px solid #dfe3ec;\n  border-radius: 10px;\n  background: var(--tg-white);\n  margin-bottom: 30px;\n  transition: 0.3s linear;\n}\n.team-item:hover {\n  filter: drop-shadow(0px 14px 30px #dde1eb);\n  border-color: var(--tg-white);\n}\n.team-thumb {\n  position: relative;\n}\n.team-thumb img {\n  border-radius: 8px 8px 180px;\n}\n.team-social .list-wrap {\n  display: flex;\n  flex-direction: column-reverse;\n  position: absolute;\n  border-radius: 0px 0px 50px 50px;\n  background: var(--tg-paragraph-color);\n  right: 17px;\n  top: 0;\n  padding: 16px 13px;\n  transition: 0.3s linear;\n}\n.team-social .list-wrap li a {\n  display: block;\n  transform: rotate(-90deg);\n  color: var(--tg-white);\n  font-size: 16px;\n}\n.team-item:hover .team-social .list-wrap {\n  background: var(--tg-primary-color);\n}\n.team-content {\n  padding: 20px 25px 25px;\n}\n.team-content .title {\n  font-weight: 600;\n  font-size: 22px;\n  margin-bottom: 3px;\n}\n.team-content span {\n  font-size: 13px;\n  display: block;\n  position: relative;\n  padding-bottom: 15px;\n  color: var(--tg-gray-four);\n}\n.team-content span::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 30px;\n  height: 4px;\n  border-radius: 4px;\n  background: var(--tg-primary-color);\n}\n\n/* team-two */\n.team-area-two {\n  padding: 120px 0 90px;\n  position: relative;\n  overflow: hidden;\n}\n.team-shape {\n  position: absolute;\n  left: 0;\n  top: 30%;\n  z-index: -1;\n}\n.section-top-content p {\n  margin-bottom: 0;\n  width: 90%;\n  margin-left: auto;\n  color: var(--tg-paragraph-color);\n}\n.team-item-two {\n  position: relative;\n  margin-bottom: 30px;\n  transition: 0.3s;\n}\n.team-item-two:hover {\n  transform: translateY(-5px);\n}\n.team-thumb-two {\n  position: relative;\n}\n.team-thumb-two img {\n  border-radius: 10px;\n}\n.team-social-two .list-wrap {\n  display: flex;\n  flex-direction: column-reverse;\n  background: #0045ce;\n  position: absolute;\n  left: 30px;\n  bottom: 25px;\n  border-radius: 50px;\n  padding: 16px 13px;\n}\n.team-social-two .list-wrap li a {\n  display: block;\n  transform: rotate(-90deg);\n  color: var(--tg-white);\n  font-size: 16px;\n  transition: 0.3s;\n}\n.team-social-two .list-wrap li a:hover {\n  transform: rotate(0);\n}\n.team-content-two {\n  position: absolute;\n  left: 30px;\n  top: 25px;\n  right: 30px;\n}\n.team-content-two .title {\n  font-size: 24px;\n  margin-bottom: 5px;\n  color: var(--tg-white);\n}\n.team-content-two .title a:hover {\n  color: var(--tg-secondary-color);\n}\n.team-content-two span {\n  font-weight: 500;\n  font-size: 14px;\n  display: block;\n  color: var(--tg-lavender);\n  position: relative;\n}\n.team-content-two span::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -10px;\n  width: 30px;\n  height: 4px;\n  background: var(--tg-white);\n  border-radius: 2px;\n}\n\n/* team-three */\n.team-area-three {\n  position: relative;\n  padding: 120px 0 90px;\n  overflow: hidden;\n}\n.team-area-three::before {\n  content: \"\";\n  position: absolute;\n  left: 50px;\n  bottom: 0;\n  width: 600px;\n  height: 600px;\n  background: #ced0ff;\n  opacity: 0.2;\n  filter: blur(75px);\n  z-index: -1;\n}\n.team-item-three {\n  background: var(--tg-section-background);\n  margin-bottom: 30px;\n  border-radius: 10px;\n  overflow: hidden;\n}\n.team-thumb-three {\n  position: relative;\n  z-index: 1;\n  padding-top: 25px;\n}\n.team-thumb-three::before {\n  content: \"\";\n  position: absolute;\n  width: 230px;\n  height: 450px;\n  background: var(--tg-lavender);\n  right: -68px;\n  bottom: -31px;\n  z-index: -1;\n  border-radius: 115px;\n  transform: rotate(45deg);\n  transition: 0.3s ease-in-out;\n}\n.team-item-three:hover .team-thumb-three::before {\n  background: var(--tg-primary-color);\n}\n.team-content-three {\n  padding: 20px 30px 25px;\n}\n.team-content-three .title {\n  margin-bottom: 8px;\n  font-size: 24px;\n}\n.team-content-three span {\n  display: block;\n  color: var(--tg-primary-color);\n}\n.team-social-three {\n  position: absolute;\n  left: 20px;\n  top: 20px;\n  background: var(--tg-lavender);\n  border-radius: 30px;\n  transition: all 0.3s;\n}\n.team-social-three .list-wrap {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  gap: 5px;\n  padding: 0 0 15px;\n  /* display: none; */\n  text-align: center;\n  transition: all 0.3s;\n}\n.team-social-three .social-toggle-icon {\n  width: 50px;\n  height: 50px;\n  flex: none;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  color: var(--tg-primary-color);\n  font-size: 20px;\n  line-height: 0;\n  cursor: pointer;\n  transition: all 0.3s ease-out 0s;\n}\n.team-social-three .list-wrap a {\n  font-size: 18px;\n}\n.team-social-three .list-wrap a:hover {\n  color: var(--tg-secondary-color);\n}\n\n/* team-four */\n.team-item-four {\n  margin-bottom: 30px;\n}\n.team-thumb-four {\n  position: relative;\n  margin-bottom: 20px;\n}\n.team-thumb-four img {\n  border-radius: 10px;\n}\n.team-content-four .title {\n  font-size: 24px;\n  margin-bottom: 5px;\n}\n.team-content-four span {\n  display: block;\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--tg-primary-color);\n}\n.team-item-four .team-social-three {\n  right: 20px;\n  bottom: 20px;\n  top: auto;\n  left: auto;\n  display: flex;\n  flex-direction: column-reverse;\n}\n.team-item-four .team-social-three .list-wrap {\n  padding: 15px 0 0;\n}\n\n/* team-five */\n.team-item-five {\n  border: 1px solid #d4dced;\n  border-radius: 30px;\n  text-align: center;\n  margin-bottom: 30px;\n  padding: 40px 40px 50px;\n}\n.team-thumb-five {\n  margin-bottom: 20px;\n}\n.team-thumb-five img {\n  border-radius: 50%;\n}\n.team-content-five .title {\n  font-size: 22px;\n  margin-bottom: 5px;\n}\n.team-content-five span {\n  display: block;\n  color: var(--tg-gray-four);\n  position: relative;\n  padding-bottom: 15px;\n  margin-bottom: 15px;\n}\n.team-content-five span::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  bottom: 0;\n  width: 30px;\n  height: 5px;\n  border-radius: 5px;\n  background: var(--tg-primary-color);\n}\n.team-social-four .list-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n}\n.team-social-four .list-wrap li a {\n  width: 45px;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: var(--tg-lavender);\n  font-size: 15px;\n}\n.team-social-four .list-wrap li a:hover {\n  color: var(--tg-white);\n  background: var(--tg-primary-color);\n}\n\n/* team-six */\n.team-area-six {\n  background: var(--tg-section-background);\n  padding: 220px 0 90px;\n  margin-top: -100px;\n}\n\n/* team-details */\n.team-details-info-wrap {\n  margin-right: 30px;\n}\n.team-details-thumb {\n  margin-bottom: 30px;\n}\n.team-details-thumb img {\n  border-radius: 10px;\n}\n.team-details-info .list-wrap {\n  margin-bottom: 30px;\n}\n.team-details-info .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  font-weight: 600;\n  font-size: 18px;\n  font-family: var(--tg-heading-font-family);\n  margin-bottom: 10px;\n}\n.team-details-info .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.team-details-info .list-wrap li i {\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  line-height: 0;\n  color: var(--tg-primary-color);\n  font-size: 20px;\n  background: var(--tg-lavender);\n  transform: translateY(-4px);\n  margin-right: 10px;\n}\n.td-info-bottom {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.td-info-bottom .share-btn {\n  background: var(--tg-lavender);\n  border-radius: 30px;\n  text-transform: uppercase;\n  padding: 13px 24px;\n  display: block;\n  height: 52px;\n}\n.td-info-bottom .share-btn img {\n  margin-right: 10px;\n  transition: all 0.3s ease-out 0s;\n}\n.td-info-bottom .share-btn:hover {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n}\n.td-info-bottom .share-btn:hover img {\n  filter: brightness(0) invert(1);\n}\n.team-details-content > .title {\n  margin-bottom: 8px;\n  font-size: 36px;\n  text-transform: capitalize;\n}\n.team-details-content > span {\n  display: block;\n  line-height: 1;\n  color: var(--tg-gray-four);\n  position: relative;\n  padding-bottom: 20px;\n  margin-bottom: 25px;\n}\n.team-details-content > span::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 30px;\n  height: 4px;\n  border-radius: 4px;\n  background: var(--tg-primary-color);\n}\n.team-details-content p {\n  margin-bottom: 0;\n}\n.team-skill-wrap {\n  margin-top: 45px;\n}\n.team-skill-wrap > .title-two {\n  margin-bottom: 15px;\n  font-size: 30px;\n  text-transform: capitalize;\n  position: relative;\n  padding-bottom: 20px;\n}\n.team-skill-wrap > .title-two::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 30px;\n  height: 4px;\n  border-radius: 4px;\n  background: var(--tg-primary-color);\n}\n.team-skill-wrap p {\n  margin-bottom: 0;\n}\n.team-skill-wrap .progress-wrap {\n  margin: 25px 0 40px;\n}\n\n/*=============================\n\t21. Testimonial\n===============================*/\n.testimonial-bg {\n  background: url(\"../img/bg/testimonial_bg.jpg\");\n  background-size: cover;\n  background-position: left center;\n  padding: 120px 0;\n}\n.testimonial-img {\n  position: relative;\n  text-align: center;\n}\n.testimonial-img > img {\n  border-radius: 30px 85px 30px 95px;\n  border: 6px solid var(--tg-white);\n  box-shadow: 0px 20px 50px rgba(0, 0, 0, 0.25);\n}\n.testimonial-img .review-wrap {\n  background: var(--tg-white);\n  max-width: 180px;\n  border-radius: 20px;\n  padding: 20px 25px 20px;\n  position: absolute;\n  left: -30px;\n  bottom: 17%;\n}\n.testimonial-img .review-wrap img {\n  margin-bottom: 15px;\n}\n.testimonial-img .review-wrap .content {\n  display: flex;\n  align-items: center;\n}\n.testimonial-img .review-wrap .content .title {\n  margin-bottom: 0;\n  font-size: 40px;\n  font-weight: 800;\n  line-height: 1;\n  color: var(--tg-primary-color);\n  margin-right: 10px;\n}\n.testimonial-img .review-wrap .content p {\n  margin-bottom: 0;\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--tg-secondary-color);\n  line-height: 1.2;\n}\n.testimonial-content {\n  width: 82%;\n}\n.testimonial-content .content-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.testimonial-content .content-top .rating {\n  display: flex;\n  align-items: center;\n  color: var(--tg-yellow);\n  font-size: 20px;\n  gap: 5px;\n}\n.testimonial-content p {\n  font-style: italic;\n  font-weight: 500;\n  font-size: 20px;\n  margin-bottom: 25px;\n  color: var(--tg-white);\n  font-family: var(--tg-heading-font-family);\n}\n.testimonial-info .title {\n  color: var(--tg-white);\n  font-size: 22px;\n  margin-bottom: 8px;\n}\n.testimonial-info span {\n  display: block;\n  font-family: var(--tg-heading-font-family);\n  color: var(--tg-lavender);\n  position: relative;\n  padding-bottom: 16px;\n  line-height: 1;\n}\n.testimonial-info span::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 40px;\n  height: 4px;\n  border-radius: 4px;\n  background: var(--tg-primary-color);\n}\n.testimonial-nav {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  margin-top: 40px;\n  position: absolute;\n  bottom: 0;\n}\n.testimonial-nav button {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  background: #0f2d6a !important;\n  color: var(--tg-white) !important;\n  font-size: 22px;\n  line-height: 0;\n  border-radius: 50%;\n}\n.testimonial-nav button.slick-prev {\n  transform: rotate(-180deg);\n}\n.testimonial-nav-prev {\n  transform: translate(25px, 50px);\n}\n.testimonial-nav-next {\n  transform: translate(85px, 75px);\n}\n.testimonial-nav .slick-arrow::before {\n  content: \"\";\n}\n.testimonial-nav button:hover {\n  background: var(--tg-primary-color);\n}\n\n/* testimonial-two */\n.testimonial-bg-two {\n  background: url(\"../img/bg/h2_testimonial_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0;\n}\n.section-title-two.white-title .sub-title {\n  background: #1e376a;\n  color: var(--tg-white);\n}\n.testimonial-item-wrap-two {\n  padding: 0 30px;\n  position: relative;\n}\n.testimonial-item-two {\n  background: var(--tg-white);\n  border-radius: 10px;\n  padding: 40px 40px;\n}\n.testimonial-content-two .rating {\n  display: flex;\n  align-items: center;\n  color: var(--tg-yellow);\n  font-size: 20px;\n  gap: 5px;\n  margin-bottom: 20px;\n}\n.testimonial-content-two > p {\n  font-style: italic;\n  font-weight: 500;\n  font-size: 20px;\n  margin-bottom: 20px;\n  color: var(--tg-paragraph-color);\n  font-family: var(--tg-heading-font-family);\n  line-height: 1.5;\n}\n.testimonial-avatar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n}\n.testimonial-avatar .avatar-thumb {\n  width: 65px;\n  flex: 0 0 auto;\n  margin-right: 30px;\n}\n.testimonial-avatar .avatar-thumb img {\n  border-radius: 50%;\n}\n.testimonial-avatar .avatar-info {\n  position: relative;\n}\n.testimonial-avatar .avatar-info::before {\n  content: \"\";\n  position: absolute;\n  left: -15px;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 4px;\n  height: 36px;\n  border-radius: 2px;\n  background: var(--tg-primary-color);\n}\n.testimonial-avatar .avatar-info .title {\n  font-size: 22px;\n  margin-bottom: 5px;\n  color: var(--tg-paragraph-color);\n}\n.testimonial-avatar .avatar-info span {\n  font-family: var(--tg-heading-font-family);\n  line-height: 1;\n  display: block;\n  font-weight: 400;\n}\n.testimonial-active-two [class*=\"col-\"] {\n  padding: 0 15px;\n}\n.testimonial-nav-two .slick-arrow {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: none;\n  border-radius: 50px;\n  line-height: 0;\n  color: var(--tg-white);\n  font-size: 22px;\n  background: #0f2d6a;\n  position: absolute;\n  left: -40px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n.testimonial-nav-two .slick-arrow::before {\n  content: \"\";\n}\n.testimonial-nav-two .slick-arrow.slick-next {\n  left: auto;\n  right: -40px;\n}\n.testimonial-nav-two .slick-arrow.slick-prev i {\n  transform: rotate(-180deg);\n}\n.testimonial-nav-two .slick-arrow:hover {\n  color: #0f2d6a;\n  background: var(--tg-white);\n}\n\n/* testimonial-three */\n.testimonial-area-three .row .col-37 {\n  width: 37%;\n  flex: 0 0 auto;\n}\n.testimonial-area-three .row .col-63 {\n  width: 63%;\n  flex: 0 0 auto;\n}\n.testimonial-img-three img {\n  clip-path: polygon(0 0, 85% 0, 100% 15%, 100% 100%, 15% 100%, 0 85%);\n  width: 100%;\n}\n.testimonial-item-wrap-three {\n  background: url(\"../img/bg/h3_testimonial_bg.png\"),\n    var(--tg-section-background);\n  border-radius: 10px;\n  padding: 100px 80px;\n  background-size: cover;\n  background-position: center;\n  position: relative;\n}\n.testimonial-content-three .rating {\n  display: flex;\n  align-items: center;\n  font-size: 20px;\n  gap: 5px;\n  color: var(--tg-yellow);\n  margin-bottom: 30px;\n}\n.testimonial-content-three p {\n  font-weight: 600;\n  font-size: 20px;\n  color: var(--tg-secondary-color);\n  font-style: italic;\n  font-family: var(--tg-heading-font-family);\n  line-height: 1.5;\n  margin-bottom: 35px;\n}\n.testimonial-content-three .testimonial-info .title {\n  color: var(--tg-secondary-color);\n}\n.testimonial-content-three .testimonial-info span {\n  color: var(--tg-paragraph-color);\n}\n.testimonial-nav-three {\n  position: absolute;\n  display: flex;\n  align-items: center;\n  left: 45%;\n  bottom: 25%;\n  gap: 10px;\n}\n.testimonial-nav-three-prev {\n  /* left: 45%; */\n}\n.testimonial-nav-three-next {\n  transform: translate(62px, 25px) !important;\n}\n.testimonial-nav-three .slick-arrow {\n  border: none;\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--tg-white);\n  background: var(--tg-secondary-color);\n  line-height: 0;\n  font-size: 22px;\n  z-index: 1;\n}\n.testimonial-nav-three .slick-arrow::before {\n  content: \"\";\n}\n.testimonial-nav-three .slick-arrow:hover {\n  background: var(--tg-primary-color);\n}\n.testimonial-nav-three .slick-arrow.slick-prev {\n  transform: rotate(-180deg);\n}\n\n/* testimonial-four */\n.testimonial-bg-four {\n  background: url(\"../img/bg/h4_testimonial_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0;\n  position: relative;\n  z-index: 1;\n  overflow: hidden;\n}\n.testimonial-img-four {\n  position: relative;\n  z-index: 1;\n  padding-left: 42px;\n}\n.testimonial-img-four::before {\n  content: \"\";\n  position: absolute;\n  width: 335px;\n  height: 335px;\n  left: 10.2%;\n  bottom: 1px;\n  background: #fff9e4;\n  border-radius: 50%;\n  z-index: -1;\n}\n.testimonial-img-four .icon {\n  position: absolute;\n  left: 7%;\n  top: 18%;\n  width: 80px;\n  height: 80px;\n  background: var(--tg-primary-color);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 59% 41% 28% 72% / 38% 37% 63% 62%;\n}\n.testimonial-img-four .shape {\n  position: absolute;\n  left: 0;\n  bottom: -20px;\n  z-index: -2;\n}\n.testimonial-item-wrap-four {\n  position: relative;\n  padding-right: 125px;\n}\n.testimonial-content-four .rating {\n  display: flex;\n  align-items: center;\n  color: var(--tg-yellow);\n  gap: 5px;\n  margin-bottom: 35px;\n}\n.testimonial-content-four > p {\n  font-weight: 500;\n  font-size: 22px;\n  margin-bottom: 30px;\n  font-style: italic;\n  color: var(--tg-white);\n  font-family: var(--tg-heading-font-family);\n}\n.testimonial-content-four .testimonial-info span::before {\n  display: none;\n}\n.testimonial-content-four .testimonial-info span {\n  padding-bottom: 0;\n}\n.testimonial-content-four .testimonial-info {\n  position: relative;\n  padding-left: 16px;\n}\n.testimonial-content-four .testimonial-info::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 4px;\n  height: 40px;\n  border-radius: 4px;\n  background: var(--tg-primary-color);\n}\n.testimonial-nav-four {\n  display: flex;\n  flex-direction: column;\n  position: absolute;\n  right: 0;\n  top: 50%;\n  transform: translate(60px, -50%);\n  gap: 15px;\n}\n.testimonial-nav-four-prev {\n  transform: translate(60px, 40px);\n}\n.testimonial-nav-four .slick-arrow {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #0f2d6a;\n  border: none;\n  border-radius: 50%;\n  color: var(--tg-white);\n  font-size: 22px;\n  line-height: 0;\n}\n.testimonial-nav-four .slick-arrow::before {\n  content: \"\";\n}\n.testimonial-nav-four .slick-arrow:hover {\n  background: var(--tg-primary-color);\n}\n.testimonial-nav-four .slick-arrow.slick-prev {\n  transform: rotate(180deg);\n}\n.testimonial-shape-wrap-four img {\n  position: absolute;\n  z-index: -1;\n}\n.testimonial-shape-wrap-four img:nth-child(1) {\n  left: 0;\n  bottom: 0;\n}\n.testimonial-shape-wrap-four img:nth-child(2) {\n  right: 0;\n  top: 0;\n}\n\n/* testimonial-five */\n.testimonial-area-five {\n  position: relative;\n  padding: 120px 0;\n  overflow: hidden;\n}\n.testimonial-area-five::before {\n  content: \"\";\n  position: absolute;\n  right: 22%;\n  bottom: 22%;\n  width: 350px;\n  height: 350px;\n  background: #fae7ff;\n  filter: blur(200px);\n  z-index: -1;\n  border-radius: 50%;\n}\n.testimonial-img-five {\n  position: relative;\n  text-align: center;\n}\n.testimonial-img-five img:not(:nth-child(1)) {\n  position: absolute;\n  z-index: -1;\n}\n.testimonial-img-five .shape-one {\n  left: 3%;\n  bottom: 7px;\n}\n.testimonial-img-five .shape-two {\n  left: 17%;\n  top: 35%;\n  animation: alltuchtopdown 8s infinite linear;\n}\n.testimonial-img-five .shape-three {\n  left: 11%;\n  bottom: 12%;\n  animation: rotateme 8s infinite linear;\n}\n.testimonial-content-five {\n  padding-right: 112px;\n}\n.testimonial-item-wrap-five {\n  position: relative;\n}\n.testimonial-item-wrap-five .testimonial-content p {\n  color: var(--tg-paragraph-color);\n}\n.testimonial-item-wrap-five .testimonial-content {\n  width: 100%;\n}\n.testimonial-item-wrap-five .testimonial-quote img {\n  opacity: 0.4;\n}\n.testimonial-active-five {\n  margin: -15px 0;\n}\n.testimonial-active-five .testimonial-item {\n  padding: 15px 0;\n}\n.testimonial-nav-five {\n  display: flex;\n  align-items: center;\n  flex-direction: column;\n  position: absolute;\n  right: -120px;\n  top: 50%;\n  transform: translateY(-50%) translateX(-50px);\n  justify-content: center;\n  gap: 15px;\n}\n.testimonial-nav-five-prev {\n  transform: translateY(-70px) translateX(-50px);\n}\n.testimonial-nav-five .slick-arrow {\n  width: 50px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 1px solid #c2c2c2;\n  transform: rotate(-90deg);\n  color: var(--tg-primary-color);\n  font-size: 20px;\n  line-height: 0;\n  background: transparent;\n  border-radius: 50%;\n}\n.testimonial-nav-five .slick-arrow::before {\n  content: \"\";\n}\n.testimonial-nav-five .slick-arrow.slick-next {\n  transform: rotate(90deg);\n}\n.testimonial-nav-five .slick-arrow:hover {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  border-color: var(--tg-primary-color);\n}\n\n/*=============================\n\t22. Pricing\n===============================*/\n.pricing-area {\n  position: relative;\n  overflow: hidden;\n  padding: 120px 0 90px;\n}\n.pricing-area::before {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  top: -35%;\n  width: 760px;\n  height: 760px;\n  background: linear-gradient(154.68deg, #8894ff 11.62%, #ff8585 90.47%);\n  opacity: 0.1;\n  filter: blur(75px);\n  border-radius: 50%;\n  z-index: -1;\n}\n.pricing-item-wrap .pricing-tab {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  margin-bottom: 40px;\n}\n.pricing-item-wrap .pricing-tab .tab-btn {\n  cursor: pointer;\n  color: var(--tg-paragraph-color);\n  font-weight: 600;\n  font-size: 18px;\n  user-select: none;\n  font-family: var(--tg-heading-font-family);\n  transition: 0.3s;\n}\n.pricing-item-wrap .pricing-tab .tab-btn.monthly_tab_title {\n  color: var(--tg-primary-color);\n}\n.pricing-item-wrap .pricing-tab .tab-btn.monthly_tab_title.active {\n  color: var(--tg-paragraph-color);\n}\n.pricing-item-wrap .pricing-tab .annual_tab_title.active {\n  color: var(--tg-primary-color);\n}\n.pricing-tab .pricing-tab-switcher {\n  height: 30px;\n  width: 70px;\n  display: inline-block;\n  border-radius: 30px;\n  position: relative;\n  margin: 0 15px;\n  -webkit-transform: translateY(0px);\n  -ms-transform: translateY(0px);\n  transform: translateY(0px);\n  cursor: pointer;\n  background: var(--tg-primary-color);\n}\n.pricing-tab .pricing-tab-switcher:before {\n  content: \"\";\n  position: absolute;\n  left: 2px;\n  top: 2px;\n  bottom: 2px;\n  width: 26px;\n  border-radius: 50%;\n  background: var(--tg-white);\n  transition: 0.3s;\n}\n.pricing-tab .pricing-tab-switcher.active:before {\n  left: calc(100% - 28px);\n}\n.pricing-price.change-subs-duration .monthly_price {\n  display: none;\n}\n.pricing-price.change-subs-duration .annual_price {\n  display: flex;\n}\n.pricing-box {\n  border: 1px solid #e1e1e9;\n  border-radius: 10px;\n  text-align: center;\n  padding: 40px 40px;\n  background: var(--tg-white);\n  margin-bottom: 30px;\n  position: relative;\n  margin-top: 16px;\n}\n.pricing-box .popular-tag {\n  display: inline-block;\n  font-weight: 600;\n  font-size: 15px;\n  background: var(--tg-red);\n  color: var(--tg-white);\n  line-height: 1.2;\n  padding: 7px 18px;\n  border-radius: 30px;\n  position: absolute;\n  top: -16px;\n  left: 50%;\n  transform: translateX(-50%);\n}\n.pricing-head .title {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n.pricing-head p {\n  margin-bottom: 24px;\n  color: var(--tg-gray-four);\n}\n.pricing-price {\n  margin-bottom: 25px;\n}\n.pricing-price .price {\n  margin-bottom: 0;\n  font-size: 30px;\n  line-height: 1;\n  display: flex;\n  justify-content: center;\n  align-items: flex-end;\n  background: #f3f6fe;\n  border-radius: 30px;\n  padding: 15px 20px;\n}\n.pricing-price .price strong {\n  font-weight: 500;\n  font-size: 16px;\n  font-family: var(--tg-body-font-family);\n  margin: 4px 3px auto 0;\n}\n.pricing-price .price span {\n  color: #798eb9;\n  text-transform: lowercase;\n  font-weight: 500;\n  font-size: 13px;\n  font-family: var(--tg-body-font-family);\n  margin-left: 5px;\n  margin-bottom: 7px;\n}\n.pricing-price .annual_price {\n  /* display: none; */\n}\n.pricing-list .list-wrap {\n  margin-bottom: 25px;\n}\n.pricing-list .list-wrap li {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--tg-paragraph-color);\n  margin-bottom: 15px;\n}\n.pricing-list .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.pricing-list .list-wrap li img {\n  margin-right: 10px;\n}\n.pricing-btn .btn {\n  background: var(--tg-lavender);\n  color: var(--tg-primary-color);\n}\n.pricing-btn .btn::before {\n  background: var(--tg-cornflower-blue);\n}\n.pricing-box.active .pricing-btn .btn {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n}\n.pricing-box.active .pricing-btn .btn::before {\n  background: var(--tg-blue);\n}\n\n/* pricing-two */\n.pricing-area-two {\n  position: relative;\n  padding: 120px 0 90px;\n  overflow: hidden;\n}\n.pricing-shape {\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: -1;\n}\n.pricing-box-two {\n  border: 1px solid #e1e1e9;\n  border-radius: 10px;\n  margin-bottom: 30px;\n  position: relative;\n}\n.pricing-box-two .popular {\n  font-weight: 600;\n  font-size: 15px;\n  background: var(--tg-red);\n  color: var(--tg-white);\n  display: block;\n  line-height: 1;\n  position: absolute;\n  right: 0;\n  top: 80px;\n  border-radius: 30px 0 0 30px;\n  padding: 8px 18px;\n  z-index: -1;\n}\n.pricing-head-two {\n  padding: 50px 50px 40px;\n  border-bottom: 1px solid #e1e1e9;\n}\n.pricing-head-two .title {\n  font-weight: 600;\n  font-size: 20px;\n  margin-bottom: 10px;\n}\n.pricing-price-two .price {\n  font-weight: 800;\n  font-size: 40px;\n  margin-bottom: 0;\n  display: flex;\n  align-items: flex-end;\n  line-height: 1;\n}\n.pricing-price-two .price strong {\n  font-weight: 600;\n  font-size: 20px;\n  margin: 4px 3px auto 0;\n}\n.pricing-price-two .price span {\n  color: #798eb9;\n  text-transform: lowercase;\n  font-weight: 500;\n  font-size: 13px;\n  font-family: var(--tg-body-font-family);\n  margin-left: 2px;\n  margin-bottom: 7px;\n}\n/* .pricing-price-two .annual_price {\n  display: none;\n} */\n.pricing-price-two.change-subs-duration .annual_price {\n  display: flex;\n}\n.pricing-price-two.change-subs-duration .monthly_price {\n  /* display: none; */\n}\n.pricing-bottom {\n  padding: 30px 50px 50px;\n}\n.pricing-box-two .pricing-list .list-wrap {\n  margin-bottom: 30px;\n}\n.pricing-box-two .pricing-list .list-wrap li {\n  justify-content: left;\n}\n.pricing-btn-two {\n  text-align: center;\n}\n\n/* pricing-three */\n.pricing-area-three {\n  position: relative;\n  padding: 120px 0 90px;\n  overflow: hidden;\n  background: #f8f8fa;\n  z-index: 1;\n}\n.pricing-box-three {\n  border: 1px solid #e1e1e9;\n  border-radius: 20px;\n  padding: 50px 50px 60px;\n  text-align: center;\n  background: var(--tg-white);\n  margin-bottom: 30px;\n}\n.pricing-box-three .pricing-icon {\n  font-size: 65px;\n  line-height: 0;\n  color: var(--tg-primary-color);\n  margin-bottom: 20px;\n}\n.pricing-box-three .pricing-plan .title {\n  color: var(--tg-gray-four);\n  margin-bottom: 20px;\n  font-weight: 500;\n  font-size: 20px;\n}\n.pricing-box-three .pricing-price-two {\n  margin-bottom: 30px;\n}\n.pricing-box-three .pricing-price-two .price {\n  justify-content: center;\n}\n.pricing-box-three .pricing-list .list-wrap {\n  margin-bottom: 35px;\n}\n\n/*=============================\n\t23. Contact\n===============================*/\n.contact-bg {\n  background: url(\"../img/bg/contact_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0;\n  position: relative;\n  z-index: 1;\n}\n.contact-content p {\n  margin-bottom: 0;\n}\n.contact-form {\n  margin: 0 30px 0 80px;\n}\n.contact-form .form-grp {\n  margin-bottom: 15px;\n}\n.contact-form .form-grp textarea,\n.contact-form .form-grp input {\n  width: 100%;\n  border: 1px solid #d5dae4;\n  border-radius: 4px;\n  background: var(--tg-white);\n  color: var(--tg-secondary-color);\n  font-weight: 500;\n  font-size: 13px;\n  padding: 14px 18px;\n  height: 50px;\n  display: block;\n}\n.contact-form .form-grp textarea::placeholder,\n.contact-form .form-grp input::placeholder {\n  color: var(--tg-paragraph-color);\n  font-weight: 500;\n  font-size: 13px;\n}\n.contact-form .form-grp textarea {\n  min-height: 96px;\n  max-height: 96px;\n}\n.contact-form form button {\n  border: none;\n  width: 100%;\n  text-align: center;\n  font-weight: 600;\n  font-size: 16px;\n  color: var(--tg-white);\n  text-transform: uppercase;\n  background: var(--tg-primary-color);\n  border-radius: 30px;\n  padding: 14px 20px;\n}\n.contact-form form button:hover {\n  background: var(--tg-secondary-color);\n}\n.contact-shape {\n  position: absolute;\n  z-index: -1;\n  top: 10%;\n  left: 31%;\n  animation: animationFramesOne 15s linear infinite;\n}\n\n/* inner-contact */\n.inner-contact-info {\n  padding-left: 80px;\n}\n.inner-contact-info .title {\n  margin-bottom: 25px;\n  position: relative;\n  font-weight: 800;\n  font-size: 36px;\n  padding-bottom: 20px;\n}\n.inner-contact-info .title::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 30px;\n  height: 4px;\n  background: var(--tg-primary-color);\n  border-radius: 4px;\n}\n.contact-info-item {\n  margin-bottom: 50px;\n}\n.contact-info-item:last-child {\n  margin-bottom: 0;\n}\n.contact-info-item .title-two {\n  font-size: 24px;\n  margin-bottom: 20px;\n}\n.contact-info-item .list-wrap li {\n  font-size: 18px;\n  margin-bottom: 10px;\n  line-height: 1.33;\n  font-family: var(--tg-heading-font-family);\n}\n.contact-info-item .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.contact-map {\n  width: 100%;\n  height: 500px;\n}\n.contact-map iframe {\n  width: 100%;\n  height: 100%;\n  mix-blend-mode: luminosity;\n}\n\n/*=============================\n\t24. Blog\n===============================*/\n.blog-post-area {\n  position: relative;\n  z-index: 1;\n  padding: 120px 0 90px;\n}\n.blog-post-area .blog-bg {\n  background: url(\"../img/bg/blog_bg.jpg\");\n}\n.blog-post-area .blog-bg {\n  background-size: cover;\n  background-position: center;\n  width: 100%;\n  height: 62%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: -1;\n}\n.blog-post-item {\n  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);\n  background: var(--tg-white);\n  border-radius: 10px;\n  margin-bottom: 30px;\n}\n.blog-post-thumb {\n  position: relative;\n  border-radius: 10px 10px 0 0;\n  overflow: hidden;\n}\n.blog-post-thumb img {\n  width: 100%;\n  transform: scale(1);\n}\n.blog-post-item:hover .blog-post-thumb img {\n  transform: scale(1.1);\n}\n.blog-post-thumb .date {\n  background: var(--tg-primary-color);\n  display: block;\n  font-weight: 500;\n  font-size: 16px;\n  color: var(--tg-white);\n  line-height: 1;\n  position: absolute;\n  left: 30px;\n  top: 0;\n  padding: 15px 20px;\n  border-radius: 0 0 30px 30px;\n  text-align: center;\n}\n.blog-post-thumb .date strong {\n  font-weight: 700;\n  font-size: 24px;\n  font-family: var(--tg-heading-font-family);\n  display: block;\n  line-height: 1;\n}\n.blog-post-content {\n  padding: 25px 30px 30px;\n  border-radius: 0 0 10px 10px;\n}\n.blog-post-content .tag {\n  font-size: 14px;\n  display: inline-block;\n  margin-bottom: 8px;\n}\n.blog-post-content .tag:hover {\n  color: var(--tg-secondary-color);\n}\n.blog-post-content .title {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n.blog-post-content p {\n  margin-bottom: 20px;\n}\n.blog-post-content .link-btn {\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  display: inline-flex;\n  align-items: center;\n  color: var(--tg-paragraph-color);\n}\n.blog-post-content .link-btn i {\n  line-height: 0;\n  font-size: 22px;\n  margin-left: 10px;\n  color: var(--tg-primary-color);\n}\n.blog-post-content .link-btn:hover {\n  color: var(--tg-primary-color);\n}\n\n/* blog-two */\n.blog-bg-two {\n  background: url(\"../img/bg/h2_blog_bg.jpg\");\n  background-size: cover;\n  background-position: center;\n  padding: 120px 0 90px;\n}\n.section-title-two p {\n  color: var(--tg-paragraph-color);\n  width: 90%;\n  margin: 15px auto 0;\n}\n.blog-post-item-two {\n  margin-bottom: 30px;\n}\n.blog-post-thumb-two {\n  position: relative;\n  border-radius: 10px 10px 0 0;\n  overflow: hidden;\n}\n.blog-post-thumb-two img {\n  transition: 0.3s linear;\n  width: 100%;\n  min-height: 275px;\n}\n.blog-post-item-two:hover .blog-post-thumb-two img {\n  transform: scale(1.1);\n}\n.blog-post-thumb-two .tag {\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  font-weight: 700;\n  font-size: 14px;\n  color: var(--tg-white);\n  background: var(--tg-primary-color);\n  padding: 9px 16px;\n  display: block;\n}\n.blog-post-thumb-two .tag:hover {\n  background: var(--tg-secondary-color);\n}\n.blog-post-content-two {\n  border: 1px solid #e7e7e7;\n  border-top: none;\n  border-radius: 0 0 10px 10px;\n  padding: 35px 30px;\n  background: var(--tg-white);\n}\n.blog-post-content-two .title {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n.blog-post-content-two p {\n  margin-bottom: 25px;\n}\n.blog-meta .list-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 15px 10px;\n}\n.blog-meta .list-wrap li {\n  color: var(--tg-paragraph-color);\n  font-size: 13px;\n  display: flex;\n  align-items: center;\n}\n.blog-meta .list-wrap li i {\n  font-size: 20px;\n  color: var(--tg-primary-color);\n  margin-right: 8px;\n}\n.blog-meta .list-wrap li a {\n  color: var(--tg-paragraph-color);\n  font-size: 16px;\n}\n.blog-meta .list-wrap li a:hover {\n  color: var(--tg-primary-color);\n}\n.blog-meta .list-wrap li a img {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  object-fit: cover;\n  margin-right: 10px;\n  flex: 0 0 auto;\n}\n\n/* blog-three */\n.blog-post-thumb-two .tag-two {\n  position: absolute;\n  left: 30px;\n  top: 25px;\n  bottom: auto;\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--tg-white);\n  background: var(--tg-primary-color);\n  padding: 6px 16px;\n  display: block;\n  border-radius: 30px;\n}\n.blog-post-thumb-two .tag-two:hover {\n  background: var(--tg-secondary-color);\n}\n\n/* blog-four */\n.blog-post-thumb-four {\n  border-radius: 10px 10px 0 0;\n  overflow: hidden;\n}\n.blog-post-thumb-four img {\n  width: 100%;\n}\n.blog-post-content-four {\n  border: 1px solid #e7e7e7;\n  border-radius: 0 0 10px 10px;\n  border-top: none;\n  padding: 40px 35px 35px;\n  position: relative;\n  margin-bottom: 30px;\n}\n.blog-post-content-four .tag {\n  font-size: 14px;\n  font-weight: 700;\n  display: block;\n  text-transform: capitalize;\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n  position: absolute;\n  left: 30px;\n  top: -18px;\n  padding: 8px 16px;\n  border-radius: 30px;\n}\n.blog-post-content-four .tag:hover {\n  background: var(--tg-secondary-color);\n}\n.blog-meta-two .list-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px 25px;\n  margin-bottom: 20px;\n}\n.blog-meta-two .list-wrap li {\n  font-weight: 600;\n  font-size: 13px;\n  text-transform: capitalize;\n  display: flex;\n  align-items: center;\n}\n.blog-meta-two .list-wrap li i {\n  font-size: 20px;\n  margin-right: 8px;\n  color: var(--tg-primary-color);\n}\n.blog-meta-two .list-wrap li a {\n  color: var(--tg-paragraph-color);\n  margin-left: 5px;\n}\n.blog-meta-two .list-wrap li a:hover {\n  color: var(--tg-primary-color);\n}\n.blog-post-content-four .title {\n  font-size: 24px;\n  margin-bottom: 15px;\n}\n.blog-post-content-four .link-btn {\n  display: inline-flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 15px;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: var(--tg-paragraph-color);\n}\n.blog-post-content-four .link-btn i {\n  line-height: 0;\n  font-size: 20px;\n  color: var(--tg-primary-color);\n  margin-left: 10px;\n}\n.blog-post-content-four .link-btn:hover {\n  color: var(--tg-primary-color);\n}\n\n/* inner-blog */\n.inner-blog-wrap .row .col-71 {\n  width: 71%;\n  flex: 0 0 auto;\n}\n.inner-blog-wrap .row .col-29 {\n  width: 29%;\n  flex: 0 0 auto;\n}\n.pagination-wrap .pagination {\n  gap: 10px;\n  justify-content: center;\n  flex-wrap: wrap;\n}\n.pagination-wrap .pagination .page-link {\n  margin-left: 0;\n  padding: 0 0;\n  color: var(--tg-gray-four);\n  font-weight: 500;\n  font-size: 20px;\n  line-height: 1;\n  width: 52px;\n  height: 50px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  border: 1px solid #e0e0e0;\n  border-radius: 3px;\n  background: transparent;\n  font-family: var(--tg-heading-font-family);\n}\n.pagination-wrap .pagination .page-item.active .page-link,\n.pagination-wrap .pagination .page-link:hover {\n  background: var(--tg-primary-color);\n  border-color: var(--tg-primary-color);\n  color: var(--tg-white);\n}\n.pagination-wrap .pagination .page-link:focus {\n  color: var(--tg-white);\n  background-color: var(--tg-primary-color);\n  border-color: var(--tg-primary-color);\n  outline: 0;\n  box-shadow: none;\n}\n.blog-sidebar {\n  margin-left: 15px;\n}\n.sidebar-search {\n  margin-bottom: 30px;\n}\n.sidebar-search form {\n  position: relative;\n}\n.sidebar-search form input {\n  width: 100%;\n  background: transparent;\n  border: 1px solid #e0e6f2;\n  border-radius: 10px;\n  padding: 20px 55px 20px 28px;\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--tg-paragraph-color);\n  height: 65px;\n}\n.sidebar-search form input::placeholder {\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--tg-gray-four);\n}\n.sidebar-search form button {\n  position: absolute;\n  right: 24px;\n  top: 50%;\n  transform: translateY(-50%);\n  border: none;\n  background: transparent;\n  padding: 0;\n  font-size: 24px;\n  color: var(--tg-primary-color);\n  line-height: 0;\n}\n.blog-widget {\n  border: 1px solid #e0e6f2;\n  border-radius: 10px;\n  padding: 25px 30px 30px;\n  margin-bottom: 30px;\n}\n.blog-widget:last-child {\n  margin-bottom: 0;\n}\n.blog-widget .bw-title {\n  margin-bottom: 25px;\n  font-size: 22px;\n  position: relative;\n  padding-bottom: 12px;\n}\n.blog-widget .bw-title::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 30px;\n  height: 4px;\n  border-radius: 4px;\n  background: var(--tg-primary-color);\n}\n.bs-cat-list .list-wrap li {\n  border-bottom: 1px solid #d9d9d9;\n  margin-bottom: 15px;\n  padding-bottom: 12px;\n}\n.bs-cat-list .list-wrap li:last-child {\n  margin-bottom: 0;\n  padding-bottom: 0;\n  border: none;\n}\n.bs-cat-list .list-wrap li a {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  font-weight: 500;\n  font-size: 16px;\n  color: var(--tg-paragraph-color);\n}\n.bs-cat-list .list-wrap li a span {\n  font-size: 14px;\n  color: var(--tg-gray-four);\n  transition: all 0.3s ease-out 0s;\n}\n.bs-cat-list .list-wrap li a:hover span,\n.bs-cat-list .list-wrap li a:hover {\n  color: var(--tg-primary-color);\n}\n.rc-post-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 25px;\n}\n.rc-post-item:last-child {\n  margin-bottom: 0;\n}\n.rc-post-item .thumb {\n  width: 75px;\n  flex: 0 0 auto;\n  margin-right: 15px;\n}\n.rc-post-item .thumb img {\n  border-radius: 8px;\n}\n.rc-post-item .content .date {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 13px;\n  color: var(--tg-gray-four);\n  margin-bottom: 8px;\n}\n.rc-post-item .content .date i {\n  margin-right: 8px;\n  color: var(--tg-primary-color);\n  font-size: 20px;\n}\n.rc-post-item .content .title {\n  margin-bottom: 0;\n  font-weight: 600;\n  font-size: 16px;\n  text-transform: capitalize;\n  color: var(--tg-paragraph-color);\n}\n.bs-tag-list .list-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.bs-tag-list .list-wrap li a {\n  font-weight: 500;\n  font-size: 16px;\n  background: var(--tg-lavender);\n  display: block;\n  border-radius: 4px;\n  padding: 5px 15px;\n}\n.bs-tag-list .list-wrap li a:hover {\n  color: var(--tg-white);\n  background: var(--tg-primary-color);\n}\n\n/* blog-details */\n.blog-details-wrap .row .col-71 {\n  width: 71%;\n  flex: 0 0 auto;\n}\n.blog-details-wrap .row .col-29 {\n  width: 29%;\n  flex: 0 0 auto;\n}\n.blog-details-thumb {\n  margin-bottom: 30px;\n}\n.blog-details-thumb img {\n  border-radius: 10px;\n}\n.blog-details-content > .title {\n  font-size: 36px;\n  margin-bottom: 20px;\n  text-transform: capitalize;\n}\n.blog-meta-three .list-wrap {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 20px;\n  margin-bottom: 25px;\n}\n.blog-meta-three .list-wrap li {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 16px;\n  color: var(--tg-paragraph-color);\n  gap: 5px;\n}\n.blog-meta-three .list-wrap li i {\n  line-height: 0;\n  color: var(--tg-primary-color);\n  font-size: 20px;\n  margin-right: 5px;\n}\n.blog-meta-three .list-wrap li img {\n  border-radius: 50%;\n  margin-right: 5px;\n}\n.blog-meta-three .list-wrap li a {\n  color: var(--tg-paragraph-color);\n}\n.blog-meta-three .list-wrap li a:hover {\n  color: var(--tg-primary-color);\n}\n.blog-details-content > p {\n  margin-bottom: 15px;\n}\n.blog-details-content blockquote {\n  margin: 50px 50px 60px;\n  background: var(--tg-section-background);\n  padding: 50px 120px 50px 50px;\n  position: relative;\n  z-index: 1;\n}\n.blog-details-content blockquote::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 6px;\n  height: 100%;\n  background: var(--tg-primary-color);\n}\n.blog-details-content blockquote::after {\n  content: \"\\f10e\";\n  font-weight: 700;\n  font-size: 52px;\n  color: #e2e5f7;\n  line-height: 1;\n  font-family: \"Font Awesome 5 Free\";\n  position: absolute;\n  right: 33px;\n  top: 27px;\n  z-index: -1;\n}\n.blog-details-content blockquote p {\n  margin-bottom: 0;\n  font-style: italic;\n  font-weight: 500;\n  font-size: 20px;\n  font-family: var(--tg-heading-font-family);\n}\n.blog-details-content .title-two {\n  font-size: 30px;\n  margin-bottom: 20px;\n  text-transform: capitalize;\n}\n.bd-inner-wrap {\n  margin: 35px 0;\n}\n.bd-inner-wrap .row .col-46 {\n  width: 46%;\n  flex: 0 0 auto;\n}\n.bd-inner-wrap .row .col-54 {\n  width: 54%;\n  flex: 0 0 auto;\n}\n.bd-inner-wrap .thumb {\n  position: relative;\n}\n.bd-inner-wrap .thumb img {\n  width: 100%;\n  border-radius: 10px;\n}\n.bd-inner-wrap .thumb .play-btn {\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 62px;\n  height: 62px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: var(--tg-white);\n  border-radius: 50%;\n}\n.bd-inner-wrap .thumb .play-btn::after {\n  content: \"\";\n  position: absolute;\n  left: 50%;\n  top: 50%;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--tg-white);\n  border-radius: 50%;\n  transform: translateX(-50%) translateY(-50%) translateZ(0) scale(1);\n  animation: pulse-border 1500ms ease-out infinite;\n}\n.bd-inner-wrap .content p {\n  margin-bottom: 15px;\n}\n.bd-inner-wrap .content .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  font-weight: 600;\n  font-size: 18px;\n  font-family: var(--tg-heading-font-family);\n  color: var(--tg-secondary-color);\n  line-height: 1.3;\n  margin-bottom: 15px;\n}\n.bd-inner-wrap .content .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.bd-inner-wrap .content .list-wrap li img {\n  margin-right: 10px;\n}\n.bd-content-bottom {\n  border-top: 1px solid #e7e7e7;\n  border-bottom: 1px solid #e7e7e7;\n  padding: 15px 0;\n  margin-top: 40px;\n  margin-bottom: 70px;\n}\n.bd-content-bottom .post-tags {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 10px;\n}\n.bd-content-bottom .post-tags .title {\n  margin-bottom: 0;\n  font-size: 18px;\n  color: var(--tg-paragraph-color);\n}\n.bd-content-bottom .post-tags .list-wrap {\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n.bd-content-bottom .post-tags .list-wrap li a {\n  background: var(--tg-lavender);\n  padding: 9px 22px;\n  display: block;\n  border-radius: 4px;\n}\n.bd-content-bottom .post-tags .list-wrap li a:hover {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n}\n.bd-content-bottom .blog-post-share {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 10px;\n}\n.bd-content-bottom .blog-post-share .title {\n  margin-bottom: 0;\n  font-size: 18px;\n  color: var(--tg-paragraph-color);\n}\n.bd-content-bottom .blog-post-share .list-wrap {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n.bd-content-bottom .blog-post-share .list-wrap li a {\n  color: var(--tg-gray-four);\n}\n.bd-content-bottom .blog-post-share .list-wrap li a:hover {\n  color: var(--tg-primary-color);\n}\n.blog-avatar-wrap {\n  border: 1px solid #e6eeff;\n  border-radius: 6px;\n  display: flex;\n  align-items: flex-start;\n  padding: 42px 42px;\n  background: var(--tg-section-background);\n}\n.blog-avatar-img {\n  width: 115px;\n  flex: 0 0 auto;\n  margin-right: 30px;\n}\n.blog-avatar-img img {\n  border-radius: 50%;\n}\n.blog-avatar-info .designation {\n  display: block;\n  font-weight: 500;\n  font-size: 15px;\n  color: var(--tg-primary-color);\n  line-height: 1;\n  margin-bottom: 10px;\n}\n.blog-avatar-info .name {\n  margin-bottom: 10px;\n  font-size: 20px;\n}\n.blog-avatar-info p {\n  margin-bottom: 0;\n}\n.latest-comments {\n  margin-bottom: 80px;\n}\n.comments-wrap-title {\n  font-size: 24px;\n  margin-bottom: 25px;\n}\n.comments-box {\n  display: flex;\n  align-items: flex-start;\n  border-bottom: 1px solid #d6dce9;\n  padding-bottom: 30px;\n  margin-bottom: 35px;\n}\n.latest-comments .children {\n  margin: 0 0 0 45px;\n  padding: 0;\n}\n.comments-avatar {\n  width: 115px;\n  flex: 0 0 auto;\n  margin-right: 25px;\n}\n.comments-avatar img {\n  border-radius: 50%;\n}\n.comments-text .avatar-name {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 10px;\n}\n.comments-text .avatar-name .name {\n  margin-bottom: 0;\n  font-size: 20px;\n  font-weight: 600;\n}\n.comments-text .avatar-name span {\n  font-weight: 500;\n  font-size: 15px;\n  display: block;\n  color: var(--tg-primary-color);\n}\n.comments-text p {\n  margin-bottom: 15px;\n}\n.comments-text .reply-btn {\n  background: var(--tg-lavender);\n  font-weight: 500;\n  font-size: 14px;\n  display: inline-block;\n  padding: 6px 17px;\n  text-transform: uppercase;\n  border-radius: 5px;\n}\n.comments-text .reply-btn:hover {\n  background: var(--tg-primary-color);\n  color: var(--tg-white);\n}\n.comment-respond {\n  border: 1px solid #b3ccff;\n  border-radius: 8px;\n  padding: 35px 40px 50px;\n  background: var(--tg-section-background);\n}\n.comment-reply-title {\n  font-size: 24px;\n  margin-bottom: 10px;\n}\n.comment-form .comment-notes {\n  margin-bottom: 15px;\n}\n.comment-form .form-grp {\n  margin-bottom: 15px;\n}\n.comment-form .form-grp textarea,\n.comment-form .form-grp input {\n  width: 100%;\n  border: 1px solid var(--tg-lavender);\n  background: var(--tg-white);\n  font-weight: 400;\n  font-size: 15px;\n  color: var(--tg-paragraph-color);\n  padding: 12px 15px;\n  height: 50px;\n  display: block;\n  border-radius: 5px;\n}\n.comment-form .form-grp textarea::placeholder,\n.comment-form .form-grp input::placeholder {\n  font-weight: 400;\n  font-size: 15px;\n  color: var(--tg-gray-four);\n}\n.comment-form .form-grp textarea {\n  min-height: 130px;\n  max-height: 130px;\n}\n.comment-form .checkbox-grp {\n  display: flex;\n  align-items: center;\n  margin: 25px 0;\n}\n.comment-form .checkbox-grp input {\n  width: 22px;\n  margin-right: 9px;\n  height: 22px;\n  cursor: pointer;\n}\n.comment-form .checkbox-grp label {\n  font-weight: 400;\n  font-size: 14px;\n  color: var(--tg-paragraph-color);\n  user-select: none;\n}\n.comment-form .submit-btn {\n  width: auto;\n  text-transform: uppercase;\n  border-radius: 30px;\n  letter-spacing: 0.02em;\n  padding: 13px 25px;\n}\n.comment-form .row {\n  margin: 0 -10px;\n}\n.comment-form .row [class*=\"col-\"] {\n  padding: 0 10px;\n}\n\n/*=============================\n\t25. Brand\n===============================*/\n.brand-active [class*=\"col-\"] {\n  padding: 0 15px;\n}\n.brand-item {\n  min-height: 86px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.brand-item img {\n  cursor: pointer;\n  filter: grayscale(100%);\n  opacity: 0.5;\n}\n.brand-item:hover img {\n  filter: grayscale(0);\n  opacity: 1;\n}\n\n/* brand-two */\n.brand-item-wrap {\n  border-bottom: 1px solid #dee4f0;\n  padding-bottom: 40px;\n}\n.brand-item-wrap .title {\n  font-weight: 600;\n  font-size: 13px;\n  margin-bottom: 25px;\n  color: var(--tg-paragraph-color);\n  font-family: var(--tg-body-font-family);\n}\n\n.brand-item-wrap-two {\n  border-top: 1px solid #dee4f0;\n  padding: 70px 0;\n}\n\n.brand-area-seven {\n  border-top: 1px solid #dee4f0;\n  padding: 70px 0;\n}\n\n/*=============================\n\t26. Error\n===============================*/\n.error-area {\n  padding: 210px 0;\n}\n.error-content {\n  text-align: center;\n}\n.error-content .error-404 {\n  font-size: 400px;\n  margin-bottom: 50px;\n  line-height: 0.74;\n  font-weight: 800;\n}\n.error-content .error-404 span {\n  color: var(--tg-primary-color);\n}\n.error-content .title {\n  margin-bottom: 20px;\n  font-weight: 600;\n  font-size: 36px;\n  text-transform: capitalize;\n}\n.error-content p {\n  margin-bottom: 35px;\n  color: var(--tg-gray-four);\n  font-weight: 400;\n}\n\n/*=============================\n\t27. Footer\n===============================*/\n.footer-bg {\n  background: #0A1628;\n}\n.footer-top {\n  padding: 100px 0 40px;\n}\n.footer-widget {\n  margin-bottom: 40px;\n}\n.footer-widget .fw-title {\n  font-size: 24px;\n  margin-bottom: 0;\n  color: var(--tg-white);\n  position: relative;\n  padding-bottom: 18px;\n  margin-bottom: 16px;\n}\n.footer-widget .fw-title::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: 0;\n  width: 30px;\n  height: 4px;\n  border-radius: 4px;\n  background: var(--tg-accent-color);\n}\n.footer-info .list-wrap li {\n  display: flex;\n  align-items: flex-start;\n  margin-bottom: 25px;\n}\n.footer-info .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.footer-info .list-wrap li .icon {\n  font-size: 22px;\n  line-height: 0;\n  color: var(--tg-lavender);\n  margin-top: 3px;\n  margin-right: 12px;\n}\n.footer-info .list-wrap li .content a,\n.footer-info .list-wrap li .content p {\n  color: var(--tg-gray-three);\n  margin-bottom: 0;\n}\n.footer-info .list-wrap li .content p span {\n  font-weight: 700;\n  color: var(--tg-white);\n}\n.footer-info .list-wrap li .content a:hover {\n  color: var(--tg-white);\n}\n.footer-link .list-wrap li {\n  margin-bottom: 10px;\n}\n.footer-link .list-wrap li:last-child {\n  margin-bottom: 0;\n}\n.footer-link .list-wrap li a {\n  color: var(--tg-gray-three);\n  position: relative;\n}\n.footer-link .list-wrap li a:hover {\n  color: var(--tg-white);\n}\n.footer-link .list-wrap li a::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  width: 100%;\n  height: 1px;\n  background: var(--tg-white);\n  -webkit-transform-origin: right top;\n  -ms-transform-origin: right top;\n  transform-origin: right top;\n  -webkit-transform: scale(0, 1);\n  -ms-transform: scale(0, 1);\n  transform: scale(0, 1);\n  transition: transform 0.4s cubic-bezier(0.74, 0.72, 0.27, 0.24);\n}\n.footer-link .list-wrap li a:hover::before {\n  -webkit-transform-origin: left top;\n  -ms-transform-origin: left top;\n  transform-origin: left top;\n  -webkit-transform: scale(1, 1);\n  -ms-transform: scale(1, 1);\n  transform: scale(1, 1);\n}\n.footer-top .row [class*=\"col-\"]:nth-child(3) .footer-widget {\n  margin-left: 40px;\n}\n.footer-newsletter p {\n  margin-bottom: 20px;\n  color: var(--tg-gray-three);\n  width: 90%;\n}\n.footer-newsletter form {\n  position: relative;\n  margin-bottom: 15px;\n}\n.footer-newsletter form input {\n  width: 100%;\n  border: none;\n  background: #1e2e4e;\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--tg-white);\n  border-radius: 30px;\n  padding: 12px 125px 12px 22px;\n  height: 46px;\n}\n.footer-newsletter form input::placeholder {\n  font-weight: 500;\n  font-size: 14px;\n  color: var(--tg-white);\n  text-transform: capitalize;\n}\n.footer-newsletter form button {\n  border: none;\n  background: var(--tg-accent-color);\n  color: var(--tg-primary-color);\n  font-weight: 700;\n  font-size: 14px;\n  border-radius: 30px;\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 12px 23px;\n  height: 46px;\n  transition: all 0.3s ease;\n}\n.footer-newsletter form button:hover {\n  background: var(--tg-accent-light);\n}\n.footer-newsletter span {\n  display: block;\n  color: var(--tg-gray-three);\n  font-size: 15px;\n}\n.footer-bottom {\n  border-top: 1px solid #253352;\n  padding: 48px 0;\n}\n.footer-bottom .f-logo {\n  margin-bottom: 10px;\n}\n.copyright-text p {\n  margin-bottom: 0px;\n  font-size: 14px;\n  color: #7c8db1;\n}\n.footer-social .list-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n}\n.footer-social .list-wrap li a {\n  width: 45px;\n  height: 45px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #1a2948;\n  border-radius: 50%;\n  color: var(--tg-white);\n  font-size: 20px;\n}\n.footer-social .list-wrap li a:hover {\n  background: var(--tg-primary-color);\n}\n\n/* footer-two */\n.footer-bg-two {\n  background: #0A1628;\n}\n.footer-top-two {\n  padding: 100px 0 40px;\n}\n.footer-top-two .fw-logo {\n  margin-bottom: 30px;\n}\n.footer-content > p {\n  margin-bottom: 20px;\n  width: 90%;\n}\n.footer-top-two .footer-info .list-wrap li .icon {\n  color: var(--tg-primary-color);\n}\n.footer-top-two .footer-info .list-wrap li .content a,\n.footer-top-two .footer-info .list-wrap li .content p {\n  color: var(--tg-paragraph-color);\n}\n.footer-top-two .footer-info .list-wrap li .content a:hover {\n  color: var(--tg-primary-color);\n}\n.footer-top-two .footer-info .list-wrap li .content p span {\n  color: var(--tg-primary-color);\n}\n.footer-top-two .footer-widget .fw-title {\n  color: var(--tg-secondary-color);\n}\n.footer-top-two .footer-link .list-wrap li a {\n  color: var(--tg-paragraph-color);\n}\n.footer-top-two .footer-link .list-wrap li a:hover {\n  color: var(--tg-primary-color);\n}\n.footer-top-two .footer-link .list-wrap li a::before {\n  background: var(--tg-primary-color);\n}\n.footer-top-two .footer-newsletter p {\n  color: var(--tg-paragraph-color);\n}\n.footer-top-two .footer-newsletter form input {\n  background: #eef1f5;\n  color: var(--tg-paragraph-color);\n}\n.footer-top-two .footer-newsletter form input::placeholder {\n  color: var(--tg-paragraph-color);\n}\n.footer-top-two .footer-newsletter form {\n  margin-bottom: 20px;\n}\n.footer-social.footer-social-two .list-wrap {\n  justify-content: flex-start;\n}\n.footer-social.footer-social-two .list-wrap li a {\n  background: #f1f1f1;\n  color: var(--tg-paragraph-color);\n}\n.footer-social.footer-social-two .list-wrap li a:hover {\n  background: var(--tg-paragraph-color);\n  color: var(--tg-white);\n}\n.footer-bottom-two {\n  border-top: 1px solid #eaeaea;\n  padding: 27px 0;\n}\n.copyright-text-two p {\n  margin-bottom: 0;\n  font-size: 14px;\n}\n\n/* footer-three */\n.footer-area-three {\n  background: #051433;\n}\n.footer-top-three {\n  padding: 100px 0 55px;\n}\n.footer-top-three .fw-logo {\n  margin-bottom: 30px;\n}\n.footer-top-three .footer-content > p {\n  color: #96a1b8;\n}\n.footer-social.footer-social-three .list-wrap {\n  justify-content: flex-start;\n}\n.footer-bottom-three {\n  border-top: 1px solid #1a264f;\n  padding: 27px 0;\n}\n\n/*=============================\n\t28. Preloader\n===============================*/\n#preloader {\n  background-color: var(--tg-white);\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  margin-top: 0px;\n  top: 0px;\n  z-index: 999;\n}\n#loading-center {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.loader {\n  position: relative;\n  width: 60px;\n  height: 60px;\n  border-radius: 50%;\n  margin: 75px;\n  display: inline-block;\n  vertical-align: middle;\n}\n.loader .loader-outter {\n  position: absolute;\n  border: 4px solid var(--tg-primary-color);\n  border-left-color: transparent;\n  border-bottom: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  -webkit-animation: loader-outter 1s cubic-bezier(0.42, 0.61, 0.58, 0.41)\n    infinite;\n  animation: loader-outter 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite;\n}\n.loader .loader-inner {\n  position: absolute;\n  border: 4px solid var(--tg-primary-color);\n  border-radius: 50%;\n  width: 40px;\n  height: 40px;\n  left: calc(50% - 20px);\n  top: calc(50% - 20px);\n  border-right: 0;\n  border-top-color: transparent;\n  -webkit-animation: loader-inner 1s cubic-bezier(0.42, 0.61, 0.58, 0.41)\n    infinite;\n  animation: loader-inner 1s cubic-bezier(0.42, 0.61, 0.58, 0.41) infinite;\n}\n@-webkit-keyframes loader-outter {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loader-outter {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@-webkit-keyframes loader-inner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(-360deg);\n    transform: rotate(-360deg);\n  }\n}\n\n@keyframes loader-inner {\n  0% {\n    -webkit-transform: rotate(0deg);\n    transform: rotate(0deg);\n  }\n  100% {\n    -webkit-transform: rotate(-360deg);\n    transform: rotate(-360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
